"use client";
var rx = Object.defineProperty;
var ox = (e, t, n) => t in e ? rx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var J = (e, t, n) => ox(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as f, Fragment as ke, jsxs as L } from "react/jsx-runtime";
import * as m from "react";
import Y, { useState as de, createContext as je, useContext as Te, useLayoutEffect as cr, useEffect as fe, useRef as me, useCallback as Ie, useMemo as ve, useId as ix, Fragment as ys, createElement as Le, useInsertionEffect as sx, forwardRef as Ke, Component as ax, Children as Gn, isValidElement as Xi, cloneElement as Cc, useReducer as lx } from "react";
import { Loader2 as cx, X as Sc, Loader2Icon as Om, ChevronDown as Im, ChevronUp as ux, CircleMinusIcon as dx, CirclePlusIcon as fx, MinusIcon as hx, Check as Tc, SearchCheckIcon as mx, SearchIcon as ll, ArrowUpDown as px, ArrowDown as gx, ArrowUp as vx, TriangleAlertIcon as yx, EyeOffIcon as bx, MoveRightIcon as wx, MoveLeftIcon as xx, DotIcon as Id, MoveUpIcon as Cx, MoveDownIcon as Sx, LockIcon as Tx, LockOpenIcon as Px, ChevronRightIcon as Br, FilterIcon as Ex, GripVertical as Dx, FileUpIcon as kx, ChevronRight as Nx, ChevronLeft as Rx, Calendar as Pc, CalendarIcon as Mx, Search as Ax, ChevronLeftIcon as Ao } from "lucide-react";
import * as Qo from "react-dom";
import _m, { flushSync as Ec } from "react-dom";
import { from as $m, escape as Kn, op as qi } from "arquero";
const Ox = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: t,
  minimumFractionDigits: t
}).format(e), Ix = [
  // Percentage mask x 100
  {
    mask: /100#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e, e *= 100;
      const n = t.match(/100#\.(#+)%$/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Percentage mask
  {
    mask: /#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/#\.(#+)%/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Dollar mask
  {
    mask: /\$#(\.#*)?$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/\$#(\.(#*))?$/)[2], r = n ? n.length : 0;
      return Ox(e, r);
    }
  },
  // Millions mask,
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e6).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" M");
      }
      return "";
    }
  },
  // TODO: Validate this
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e12).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" T");
      }
      return "";
    }
  },
  // Thousands mask,
  {
    mask: /#\.#+K$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e3).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" K");
      }
      return "";
    }
  },
  // Standard format: full number with commas as thousands separators
  {
    mask: ["#.#", "#.##", "#.###", "#.####"],
    apply: (e, t) => {
      if (e !== "" && e !== null && e !== void 0) {
        e = Number(e);
        const n = t.split("."), r = n && n[1] ? n[1].length : 0;
        return new Intl.NumberFormat("en-US", {
          maximumFractionDigits: r,
          minimumFractionDigits: r
        }).format(e);
      }
      return "";
    }
  },
  {
    mask: ["#"],
    apply: (e) => e !== "" && e !== null && e !== void 0 ? (e = Number(e), new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(e)) : ""
  },
  {
    mask: ["#th"],
    // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    apply: (e, t) => {
      e = Number(e);
      const n = e % 10, r = e % 100;
      return n === 1 && r !== 11 ? e + "st" : n === 2 && r !== 12 ? e + "nd" : n === 3 && r !== 13 ? e + "rd" : e + "th";
    }
  }
];
function cl(e, t) {
  const n = Ix.find(
    (r) => Array.isArray(r.mask) && r.mask.includes(t) || !Array.isArray(r.mask) && t.match(r.mask)
  );
  return n ? n.apply(e, t) : "Invalid Mask";
}
const pV = (e) => e >= 1e6 ? `${(e / 1e6).toFixed(0)}M` : e >= 1e3 ? `${(e / 1e3).toFixed(0)}k` : e.toString(), _x = (e, t = 0) => {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
};
function Lm(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Lm(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function We() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Lm(e)) && (r && (r += " "), r += t);
  return r;
}
const Dc = "-", $x = (e) => {
  const t = Fx(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(Dc);
      return a[0] === "" && a.length !== 1 && a.shift(), Fm(a, t) || Lx(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const l = n[s] || [];
      return a && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, Fm = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Fm(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Dc);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}, _d = /^\[(.+)\]$/, Lx = (e) => {
  if (_d.test(e)) {
    const t = _d.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Fx = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Bx(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    ul(s, r, i, t);
  }), r;
}, ul = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : $d(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Vx(o)) {
        ul(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      ul(s, $d(t, i), n, r);
    });
  });
}, $d = (e, t) => {
  let n = e;
  return t.split(Dc).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Vx = (e) => e.isThemeGetter, Bx = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
  return [n, o];
}) : e, Wx = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, Vm = "!", zx = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, s = (a) => {
    const l = [];
    let u = 0, c = 0, d;
    for (let v = 0; v < a.length; v++) {
      let b = a[v];
      if (u === 0) {
        if (b === o && (r || a.slice(v, v + i) === t)) {
          l.push(a.slice(c, v)), c = v + i;
          continue;
        }
        if (b === "/") {
          d = v;
          continue;
        }
      }
      b === "[" ? u++ : b === "]" && u--;
    }
    const h = l.length === 0 ? a : a.substring(c), p = h.startsWith(Vm), y = p ? h.substring(1) : h, g = d && d > c ? d - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: y,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, jx = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Hx = (e) => ({
  cache: Wx(e.cacheSize),
  parseClassName: zx(e),
  ...$x(e)
}), Ux = /\s+/, Yx = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(Ux);
  let a = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const u = s[l], {
      modifiers: c,
      hasImportantModifier: d,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = n(u);
    let y = !!p, g = r(y ? h.substring(0, p) : h);
    if (!g) {
      if (!y) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (g = r(h), !g) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      y = !1;
    }
    const v = jx(c).join(":"), b = d ? v + Vm : v, x = b + g;
    if (i.includes(x))
      continue;
    i.push(x);
    const w = o(g, y);
    for (let C = 0; C < w.length; ++C) {
      const S = w[C];
      i.push(b + S);
    }
    a = u + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function Gx() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Bm(t)) && (r && (r += " "), r += n);
  return r;
}
const Bm = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Bm(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Kx(e, ...t) {
  let n, r, o, i = s;
  function s(l) {
    const u = t.reduce((c, d) => d(c), e());
    return n = Hx(u), r = n.cache.get, o = n.cache.set, i = a, a(l);
  }
  function a(l) {
    const u = r(l);
    if (u)
      return u;
    const c = Yx(l, n);
    return o(l, c), c;
  }
  return function() {
    return i(Gx.apply(null, arguments));
  };
}
const Ve = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Wm = /^\[(?:([a-z-]+):)?(.+)\]$/i, Xx = /^\d+\/\d+$/, qx = /* @__PURE__ */ new Set(["px", "full", "screen"]), Qx = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Zx = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Jx = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, eC = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, tC = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, fn = (e) => _r(e) || qx.has(e) || Xx.test(e), Cn = (e) => Qr(e, "length", cC), _r = (e) => !!e && !Number.isNaN(Number(e)), ca = (e) => Qr(e, "number", _r), co = (e) => !!e && Number.isInteger(Number(e)), nC = (e) => e.endsWith("%") && _r(e.slice(0, -1)), ge = (e) => Wm.test(e), Sn = (e) => Qx.test(e), rC = /* @__PURE__ */ new Set(["length", "size", "percentage"]), oC = (e) => Qr(e, rC, zm), iC = (e) => Qr(e, "position", zm), sC = /* @__PURE__ */ new Set(["image", "url"]), aC = (e) => Qr(e, sC, dC), lC = (e) => Qr(e, "", uC), uo = () => !0, Qr = (e, t, n) => {
  const r = Wm.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, cC = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Zx.test(e) && !Jx.test(e)
), zm = () => !1, uC = (e) => eC.test(e), dC = (e) => tC.test(e), fC = () => {
  const e = Ve("colors"), t = Ve("spacing"), n = Ve("blur"), r = Ve("brightness"), o = Ve("borderColor"), i = Ve("borderRadius"), s = Ve("borderSpacing"), a = Ve("borderWidth"), l = Ve("contrast"), u = Ve("grayscale"), c = Ve("hueRotate"), d = Ve("invert"), h = Ve("gap"), p = Ve("gradientColorStops"), y = Ve("gradientColorStopPositions"), g = Ve("inset"), v = Ve("margin"), b = Ve("opacity"), x = Ve("padding"), w = Ve("saturate"), C = Ve("scale"), S = Ve("sepia"), T = Ve("skew"), P = Ve("space"), E = Ve("translate"), D = () => ["auto", "contain", "none"], A = () => ["auto", "hidden", "clip", "visible", "scroll"], R = () => ["auto", ge, t], O = () => [ge, t], F = () => ["", fn, Cn], $ = () => ["auto", _r, ge], W = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], V = () => ["solid", "dashed", "dotted", "double", "none"], k = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], N = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], M = () => ["", "0", ge], B = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], G = () => [_r, ge];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [uo],
      spacing: [fn, Cn],
      blur: ["none", "", Sn, ge],
      brightness: G(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Sn, ge],
      borderSpacing: O(),
      borderWidth: F(),
      contrast: G(),
      grayscale: M(),
      hueRotate: G(),
      invert: M(),
      gap: O(),
      gradientColorStops: [e],
      gradientColorStopPositions: [nC, Cn],
      inset: R(),
      margin: R(),
      opacity: G(),
      padding: O(),
      saturate: G(),
      scale: G(),
      sepia: M(),
      skew: G(),
      space: O(),
      translate: O()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ge]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Sn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": B()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": B()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...W(), ge]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", co, ge]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: R()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ge]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", co, ge]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [uo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", co, ge]
        }, ge]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": $()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": $()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [uo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [co, ge]
        }, ge]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": $()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": $()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ge]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ge]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...N()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...N(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...N(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ge, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ge, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ge, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Sn]
        }, Sn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ge, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ge, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ge, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ge, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Sn, Cn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ca]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [uo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ge]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", _r, ca]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", fn, ge]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ge]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ge]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...V(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", fn, Cn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", fn, ge]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ge]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ge]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...W(), iC]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", oC]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, aC]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [y]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...V(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: V()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...V()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [fn, ge]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [fn, Cn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: F()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [fn, Cn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Sn, lC]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [uo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...k(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": k()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Sn, ge]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ge]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: G()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ge]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: G()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ge]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [co, ge]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [E]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [E]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [T]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [T]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ge]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ge]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ge]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [fn, Cn, ca]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, hC = /* @__PURE__ */ Kx(fC);
function q(...e) {
  return hC(We(e));
}
function Ld(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function bs(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Ld(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Ld(e[o], null);
        }
      };
  };
}
function ye(...e) {
  return m.useCallback(bs(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Nn(e) {
  const t = /* @__PURE__ */ pC(e), n = m.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = m.Children.toArray(i), l = a.find(vC);
    if (l) {
      const u = l.props.children, c = a.map((d) => d === l ? m.Children.count(u) > 1 ? m.Children.only(null) : m.isValidElement(u) ? u.props.children : null : d);
      return /* @__PURE__ */ f(t, { ...s, ref: o, children: m.isValidElement(u) ? m.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ f(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var mC = /* @__PURE__ */ Nn("Slot");
// @__NO_SIDE_EFFECTS__
function pC(e) {
  const t = m.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (m.isValidElement(o)) {
      const s = bC(o), a = yC(i, o.props);
      return o.type !== m.Fragment && (a.ref = r ? bs(r, s) : s), m.cloneElement(o, a);
    }
    return m.Children.count(o) > 1 ? m.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var jm = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function gC(e) {
  const t = ({ children: n }) => /* @__PURE__ */ f(ke, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = jm, t;
}
function vC(e) {
  return m.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === jm;
}
function yC(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function bC(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const Fd = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Vd = We, ur = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Vd(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((u) => {
    const c = n == null ? void 0 : n[u], d = i == null ? void 0 : i[u];
    if (c === null) return null;
    const h = Fd(c) || Fd(d);
    return o[u][h];
  }), a = n && Object.entries(n).reduce((u, c) => {
    let [d, h] = c;
    return h === void 0 || (u[d] = h), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: d, className: h, ...p } = c;
    return Object.entries(p).every((y) => {
      let [g, v] = y;
      return Array.isArray(v) ? v.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === v;
    }) ? [
      ...u,
      d,
      h
    ] : u;
  }, []);
  return Vd(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, dl = ur(
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm text-bold ring-offset-background transition-colors h-fit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-100",
  {
    variants: {
      variant: {
        default: "border border-button-primary-bg text-button-primary-txt bg-button-primary-bg hover:bg-button-primary-hover hover:border-button-primary-hover active:bg-button-primary-active active:border-button-primary-active disabled:bg-button-primary-disabled disabled:border-button-primary-disabled disabled:text-button-primary-disabled-txt",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        danger: "bg-red-500 text-button-primary-txt hover:bg-red-600",
        warning: "bg-yellow-500 text-button-primary-txt hover:bg-yellow-600",
        outline: "border border-button-primary-outline-default text-button-primary-outline-default bg-button-primary-outline-bg hover:border-button-primary-outline-hover hover:text-button-primary-outline-hover active:border-button-primary-outline-active active:text-button-primary-outline-active disabled:border-button-primary-outline-disabled disabled:text-button-primary-outline-disabled",
        minimal: "border border-transparent text-button-primary-outline-default bg-transparent hover:text-button-primary-outline-hover active:text-button-primary-outline-active disabled:text-button-primary-outline-disabled",
        secondary: "border border-button-secondary-bg text-button-secondary-txt bg-button-secondary-bg hover:bg-button-secondary-hover hover:border-button-secondary-hover active:bg-button-secondary-active active:border-button-secondary-active disabled:bg-button-secondary-disabled disabled:border-button-secondary-disabled disabled:text-button-secondary-disabled-txt",
        secondaryOutline: "border border-button-secondary-outline-default text-button-secondary-outline-default bg-button-secondary-outline-bg hover:border-button-secondary-outline-hover hover:text-button-secondary-outline-hover active:border-button-secondary-outline-active active:text-button-secondary-outline-active disabled:border-button-secondary-outline-disabled disabled:text-button-secondary-outline-disabled",
        secondaryMinimal: "border border-transparent text-button-secondary-outline-default bg-transparent hover:text-button-secondary-outline-hover active:text-button-secondary-outline-active disabled:text-button-secondary-outline-disabled",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        // link: 'text-primary underline-offset-4 hover:underline',
        link: "text-primary"
      },
      size: {
        default: "control rounded-md",
        // xxs: 'control-xxs',
        xs: "control-xs",
        sm: "control-sm",
        md: "control-md rounded-lg",
        lg: "control-lg rounded-lg"
        // icon: 'h-10 w-10',
        // input: 'min-h-10 px-3 py-2',
        // 'icon-sm': 'h-6 w-6 p-1',
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Pe = m.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, children: o, loading: i, ...s }, a) => {
    const l = r ? mC : "button";
    return s.type = s.type || "button", /* @__PURE__ */ L(l, { className: q("relative", dl({ variant: t, size: n, className: e })), ref: a, ...s, children: [
      i && /* @__PURE__ */ f(
        "div",
        {
          className: q(
            "absolute top-0 bottom-0 left-0 right-0 flex justify-center",
            "items-center bg-button-primary-disabled/50 rounded-md"
          ),
          children: /* @__PURE__ */ f(cx, { className: "animate-spin size-6" })
        }
      ),
      o
    ] });
  }
);
Pe.displayName = "Button";
const gV = () => /* @__PURE__ */ f(Pe, { children: "Btn!" });
function j(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function wC(e, t) {
  const n = m.createContext(t), r = (i) => {
    const { children: s, ...a } = i, l = m.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ f(n.Provider, { value: l, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = m.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Bt(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = m.createContext(s), l = n.length;
    n = [...n, s];
    const u = (d) => {
      var b;
      const { scope: h, children: p, ...y } = d, g = ((b = h == null ? void 0 : h[e]) == null ? void 0 : b[l]) || a, v = m.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ f(g.Provider, { value: v, children: p });
    };
    u.displayName = i + "Provider";
    function c(d, h) {
      var g;
      const p = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || a, y = m.useContext(p);
      if (y) return y;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [u, c];
  }
  const o = () => {
    const i = n.map((s) => m.createContext(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return m.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = e, [r, xC(o, ...t)];
}
function xC(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: u }) => {
        const d = l(i)[`__scope${u}`];
        return { ...a, ...d };
      }, {});
      return m.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var it = globalThis != null && globalThis.document ? m.useLayoutEffect : () => {
}, CC = m[" useId ".trim().toString()] || (() => {
}), SC = 0;
function mn(e) {
  const [t, n] = m.useState(CC());
  return it(() => {
    n((r) => r ?? String(SC++));
  }, [e]), t ? `radix-${t}` : "";
}
var TC = m[" useInsertionEffect ".trim().toString()] || it;
function Rn({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, s] = PC({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, l = a ? e : o;
  {
    const c = m.useRef(e !== void 0);
    m.useEffect(() => {
      const d = c.current;
      d !== a && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), c.current = a;
    }, [a, r]);
  }
  const u = m.useCallback(
    (c) => {
      var d;
      if (a) {
        const h = EC(c) ? c(e) : c;
        h !== e && ((d = s.current) == null || d.call(s, h));
      } else
        i(c);
    },
    [a, e, i, s]
  );
  return [l, u];
}
function PC({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = m.useState(e), o = m.useRef(n), i = m.useRef(t);
  return TC(() => {
    i.current = t;
  }, [t]), m.useEffect(() => {
    var s;
    o.current !== n && ((s = i.current) == null || s.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function EC(e) {
  return typeof e == "function";
}
var DC = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], se = DC.reduce((e, t) => {
  const n = /* @__PURE__ */ Nn(`Primitive.${t}`), r = m.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function kc(e, t) {
  e && Qo.flushSync(() => e.dispatchEvent(t));
}
function Je(e) {
  const t = m.useRef(e);
  return m.useEffect(() => {
    t.current = e;
  }), m.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function kC(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Je(e);
  m.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var NC = "DismissableLayer", fl = "dismissableLayer.update", RC = "dismissableLayer.pointerDownOutside", MC = "dismissableLayer.focusOutside", Bd, Hm = m.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), dr = m.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...l
    } = e, u = m.useContext(Hm), [c, d] = m.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = m.useState({}), y = ye(t, (P) => d(P)), g = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(v), x = c ? g.indexOf(c) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= b, S = OC((P) => {
      const E = P.target, D = [...u.branches].some((A) => A.contains(E));
      !C || D || (o == null || o(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, h), T = IC((P) => {
      const E = P.target;
      [...u.branches].some((A) => A.contains(E)) || (i == null || i(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, h);
    return kC((P) => {
      x === u.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && a && (P.preventDefault(), a()));
    }, h), m.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Bd = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), Wd(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Bd);
        };
    }, [c, h, n, u]), m.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), Wd());
    }, [c, u]), m.useEffect(() => {
      const P = () => p({});
      return document.addEventListener(fl, P), () => document.removeEventListener(fl, P);
    }, []), /* @__PURE__ */ f(
      se.div,
      {
        ...l,
        ref: y,
        style: {
          pointerEvents: w ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: j(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: j(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: j(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
dr.displayName = NC;
var AC = "DismissableLayerBranch", Um = m.forwardRef((e, t) => {
  const n = m.useContext(Hm), r = m.useRef(null), o = ye(t, r);
  return m.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ f(se.div, { ...e, ref: o });
});
Um.displayName = AC;
function OC(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Je(e), r = m.useRef(!1), o = m.useRef(() => {
  });
  return m.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          Ym(
            RC,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function IC(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Je(e), r = m.useRef(!1);
  return m.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Ym(MC, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Wd() {
  const e = new CustomEvent(fl);
  document.dispatchEvent(e);
}
function Ym(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? kc(o, i) : o.dispatchEvent(i);
}
var _C = dr, $C = Um, ua = "focusScope.autoFocusOnMount", da = "focusScope.autoFocusOnUnmount", zd = { bubbles: !1, cancelable: !0 }, LC = "FocusScope", Zo = m.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, l] = m.useState(null), u = Je(o), c = Je(i), d = m.useRef(null), h = ye(t, (g) => l(g)), p = m.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  m.useEffect(() => {
    if (r) {
      let g = function(w) {
        if (p.paused || !a) return;
        const C = w.target;
        a.contains(C) ? d.current = C : Pn(d.current, { select: !0 });
      }, v = function(w) {
        if (p.paused || !a) return;
        const C = w.relatedTarget;
        C !== null && (a.contains(C) || Pn(d.current, { select: !0 }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const S of w)
            S.removedNodes.length > 0 && Pn(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const x = new MutationObserver(b);
      return a && x.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), x.disconnect();
      };
    }
  }, [r, a, p.paused]), m.useEffect(() => {
    if (a) {
      Hd.add(p);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(ua, zd);
        a.addEventListener(ua, u), a.dispatchEvent(b), b.defaultPrevented || (FC(jC(Gm(a)), { select: !0 }), document.activeElement === g && Pn(a));
      }
      return () => {
        a.removeEventListener(ua, u), setTimeout(() => {
          const b = new CustomEvent(da, zd);
          a.addEventListener(da, c), a.dispatchEvent(b), b.defaultPrevented || Pn(g ?? document.body, { select: !0 }), a.removeEventListener(da, c), Hd.remove(p);
        }, 0);
      };
    }
  }, [a, u, c, p]);
  const y = m.useCallback(
    (g) => {
      if (!n && !r || p.paused) return;
      const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (v && b) {
        const x = g.currentTarget, [w, C] = VC(x);
        w && C ? !g.shiftKey && b === C ? (g.preventDefault(), n && Pn(w, { select: !0 })) : g.shiftKey && b === w && (g.preventDefault(), n && Pn(C, { select: !0 })) : b === x && g.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ f(se.div, { tabIndex: -1, ...s, ref: h, onKeyDown: y });
});
Zo.displayName = LC;
function FC(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Pn(r, { select: t }), document.activeElement !== n) return;
}
function VC(e) {
  const t = Gm(e), n = jd(t, e), r = jd(t.reverse(), e);
  return [n, r];
}
function Gm(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function jd(e, t) {
  for (const n of e)
    if (!BC(n, { upTo: t })) return n;
}
function BC(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function WC(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Pn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && WC(e) && t && e.select();
  }
}
var Hd = zC();
function zC() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ud(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ud(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Ud(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function jC(e) {
  return e.filter((t) => t.tagName !== "A");
}
var HC = "Portal", Zr = m.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = m.useState(!1);
  it(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? _m.createPortal(/* @__PURE__ */ f(se.div, { ...r, ref: t }), s) : null;
});
Zr.displayName = HC;
function UC(e, t) {
  return m.useReducer((n, r) => t[n][r] ?? n, e);
}
var ct = (e) => {
  const { present: t, children: n } = e, r = YC(t), o = typeof n == "function" ? n({ present: r.isPresent }) : m.Children.only(n), i = ye(r.ref, GC(o));
  return typeof n == "function" || r.isPresent ? m.cloneElement(o, { ref: i }) : null;
};
ct.displayName = "Presence";
function YC(e) {
  const [t, n] = m.useState(), r = m.useRef(null), o = m.useRef(e), i = m.useRef("none"), s = e ? "mounted" : "unmounted", [a, l] = UC(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return m.useEffect(() => {
    const u = Si(r.current);
    i.current = a === "mounted" ? u : "none";
  }, [a]), it(() => {
    const u = r.current, c = o.current;
    if (c !== e) {
      const h = i.current, p = Si(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), it(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, d = (p) => {
        const g = Si(r.current).includes(p.animationName);
        if (p.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, h = (p) => {
        p.target === t && (i.current = Si(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: m.useCallback((u) => {
      r.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function Si(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function GC(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var fa = 0;
function ws() {
  m.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Yd()), document.body.insertAdjacentElement("beforeend", e[1] ?? Yd()), fa++, () => {
      fa === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), fa--;
    };
  }, []);
}
function Yd() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ft = function() {
  return ft = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ft.apply(this, arguments);
};
function Nc(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Km(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var So = "right-scroll-bar-position", To = "width-before-scroll-bar", KC = "with-scroll-bars-hidden", XC = "--removed-body-scroll-bar-size";
function ha(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function qC(e, t) {
  var n = de(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var QC = typeof window < "u" ? m.useLayoutEffect : m.useEffect, Gd = /* @__PURE__ */ new WeakMap();
function Xm(e, t) {
  var n = qC(null, function(r) {
    return e.forEach(function(o) {
      return ha(o, r);
    });
  });
  return QC(function() {
    var r = Gd.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || ha(a, null);
      }), i.forEach(function(a) {
        o.has(a) || ha(a, s);
      });
    }
    Gd.set(n, e);
  }, [e]), n;
}
function ZC(e) {
  return e;
}
function JC(e, t) {
  t === void 0 && (t = ZC);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var c = s;
        s = [], c.forEach(i);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(c) {
          s.push(c), u();
        },
        filter: function(c) {
          return s = s.filter(c), n;
        }
      };
    }
  };
  return o;
}
function qm(e) {
  e === void 0 && (e = {});
  var t = JC(null);
  return t.options = ft({ async: !0, ssr: !1 }, e), t;
}
var Qm = function(e) {
  var t = e.sideCar, n = Nc(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return m.createElement(r, ft({}, n));
};
Qm.isSideCarExport = !0;
function Zm(e, t) {
  return e.useMedium(t), Qm;
}
var Jm = qm(), ma = function() {
}, xs = m.forwardRef(function(e, t) {
  var n = m.useRef(null), r = m.useState({
    onScrollCapture: ma,
    onWheelCapture: ma,
    onTouchMoveCapture: ma
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, d = e.shards, h = e.sideCar, p = e.noIsolation, y = e.inert, g = e.allowPinchZoom, v = e.as, b = v === void 0 ? "div" : v, x = e.gapMode, w = Nc(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = h, S = Xm([n, t]), T = ft(ft({}, w), o);
  return m.createElement(
    m.Fragment,
    null,
    c && m.createElement(C, { sideCar: Jm, removeScrollBar: u, shards: d, noIsolation: p, inert: y, setCallbacks: i, allowPinchZoom: !!g, lockRef: n, gapMode: x }),
    s ? m.cloneElement(m.Children.only(a), ft(ft({}, T), { ref: S })) : m.createElement(b, ft({}, T, { className: l, ref: S }), a)
  );
});
xs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
xs.classNames = {
  fullWidth: To,
  zeroRight: So
};
var eS = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function tS() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = eS();
  return t && e.setAttribute("nonce", t), e;
}
function nS(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function rS(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var oS = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = tS()) && (nS(t, n), rS(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, iS = function() {
  var e = oS();
  return function(t, n) {
    m.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Rc = function() {
  var e = iS(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, sS = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, pa = function(e) {
  return parseInt(e || "", 10) || 0;
}, aS = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [pa(n), pa(r), pa(o)];
}, lS = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return sS;
  var t = aS(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, cS = Rc(), $r = "data-scroll-locked", uS = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(KC, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat($r, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(So, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(To, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(So, " .").concat(So, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(To, " .").concat(To, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat($r, `] {
    `).concat(XC, ": ").concat(a, `px;
  }
`);
}, Kd = function() {
  var e = parseInt(document.body.getAttribute($r) || "0", 10);
  return isFinite(e) ? e : 0;
}, dS = function() {
  m.useEffect(function() {
    return document.body.setAttribute($r, (Kd() + 1).toString()), function() {
      var e = Kd() - 1;
      e <= 0 ? document.body.removeAttribute($r) : document.body.setAttribute($r, e.toString());
    };
  }, []);
}, ep = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  dS();
  var i = m.useMemo(function() {
    return lS(o);
  }, [o]);
  return m.createElement(cS, { styles: uS(i, !t, o, n ? "" : "!important") });
}, hl = !1;
if (typeof window < "u")
  try {
    var Ti = Object.defineProperty({}, "passive", {
      get: function() {
        return hl = !0, !0;
      }
    });
    window.addEventListener("test", Ti, Ti), window.removeEventListener("test", Ti, Ti);
  } catch {
    hl = !1;
  }
var br = hl ? { passive: !1 } : !1, fS = function(e) {
  return e.tagName === "TEXTAREA";
}, tp = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !fS(e) && n[t] === "visible")
  );
}, hS = function(e) {
  return tp(e, "overflowY");
}, mS = function(e) {
  return tp(e, "overflowX");
}, Xd = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = np(e, r);
    if (o) {
      var i = rp(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, pS = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, gS = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, np = function(e, t) {
  return e === "v" ? hS(t) : mS(t);
}, rp = function(e, t) {
  return e === "v" ? pS(t) : gS(t);
}, vS = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, yS = function(e, t, n, r, o) {
  var i = vS(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), u = !1, c = s > 0, d = 0, h = 0;
  do {
    var p = rp(e, a), y = p[0], g = p[1], v = p[2], b = g - v - i * y;
    (y || b) && np(e, a) && (d += b, h += y), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (c && Math.abs(d) < 1 || !c && Math.abs(h) < 1) && (u = !0), u;
}, Pi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, qd = function(e) {
  return [e.deltaX, e.deltaY];
}, Qd = function(e) {
  return e && "current" in e ? e.current : e;
}, bS = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, wS = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, xS = 0, wr = [];
function CS(e) {
  var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), o = m.useState(xS++)[0], i = m.useState(Rc)[0], s = m.useRef(e);
  m.useEffect(function() {
    s.current = e;
  }, [e]), m.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = Km([e.lockRef.current], (e.shards || []).map(Qd), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = m.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var b = Pi(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - b[0], C = "deltaY" in g ? g.deltaY : x[1] - b[1], S, T = g.target, P = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && P === "h" && T.type === "range")
      return !1;
    var E = Xd(P, T);
    if (!E)
      return !0;
    if (E ? S = P : (S = P === "v" ? "h" : "v", E = Xd(P, T)), !E)
      return !1;
    if (!r.current && "changedTouches" in g && (w || C) && (r.current = S), !S)
      return !0;
    var D = r.current || S;
    return yS(D, v, g, D === "h" ? w : C);
  }, []), l = m.useCallback(function(g) {
    var v = g;
    if (!(!wr.length || wr[wr.length - 1] !== i)) {
      var b = "deltaY" in v ? qd(v) : Pi(v), x = t.current.filter(function(S) {
        return S.name === v.type && (S.target === v.target || v.target === S.shadowParent) && bS(S.delta, b);
      })[0];
      if (x && x.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(Qd).filter(Boolean).filter(function(S) {
          return S.contains(v.target);
        }), C = w.length > 0 ? a(v, w[0]) : !s.current.noIsolation;
        C && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = m.useCallback(function(g, v, b, x) {
    var w = { name: g, delta: v, target: b, should: x, shadowParent: SS(b) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), c = m.useCallback(function(g) {
    n.current = Pi(g), r.current = void 0;
  }, []), d = m.useCallback(function(g) {
    u(g.type, qd(g), g.target, a(g, e.lockRef.current));
  }, []), h = m.useCallback(function(g) {
    u(g.type, Pi(g), g.target, a(g, e.lockRef.current));
  }, []);
  m.useEffect(function() {
    return wr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, br), document.addEventListener("touchmove", l, br), document.addEventListener("touchstart", c, br), function() {
      wr = wr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, br), document.removeEventListener("touchmove", l, br), document.removeEventListener("touchstart", c, br);
    };
  }, []);
  var p = e.removeScrollBar, y = e.inert;
  return m.createElement(
    m.Fragment,
    null,
    y ? m.createElement(i, { styles: wS(o) }) : null,
    p ? m.createElement(ep, { gapMode: e.gapMode }) : null
  );
}
function SS(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const TS = Zm(Jm, CS);
var Jo = m.forwardRef(function(e, t) {
  return m.createElement(xs, ft({}, e, { ref: t, sideCar: TS }));
});
Jo.classNames = xs.classNames;
var PS = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, xr = /* @__PURE__ */ new WeakMap(), Ei = /* @__PURE__ */ new WeakMap(), Di = {}, ga = 0, op = function(e) {
  return e && (e.host || op(e.parentNode));
}, ES = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = op(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, DS = function(e, t, n, r) {
  var o = ES(t, Array.isArray(e) ? e : [e]);
  Di[n] || (Di[n] = /* @__PURE__ */ new WeakMap());
  var i = Di[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), u = function(d) {
    !d || a.has(d) || (a.add(d), u(d.parentNode));
  };
  o.forEach(u);
  var c = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (a.has(h))
        c(h);
      else
        try {
          var p = h.getAttribute(r), y = p !== null && p !== "false", g = (xr.get(h) || 0) + 1, v = (i.get(h) || 0) + 1;
          xr.set(h, g), i.set(h, v), s.push(h), g === 1 && y && Ei.set(h, !0), v === 1 && h.setAttribute(n, "true"), y || h.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", h, b);
        }
    });
  };
  return c(t), a.clear(), ga++, function() {
    s.forEach(function(d) {
      var h = xr.get(d) - 1, p = i.get(d) - 1;
      xr.set(d, h), i.set(d, p), h || (Ei.has(d) || d.removeAttribute(r), Ei.delete(d)), p || d.removeAttribute(n);
    }), ga--, ga || (xr = /* @__PURE__ */ new WeakMap(), xr = /* @__PURE__ */ new WeakMap(), Ei = /* @__PURE__ */ new WeakMap(), Di = {});
  };
}, ei = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = PS(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), DS(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Cs = "Dialog", [ip, vV] = Bt(Cs), [kS, qt] = ip(Cs), sp = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = m.useRef(null), l = m.useRef(null), [u, c] = Rn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Cs
  });
  return /* @__PURE__ */ f(
    kS,
    {
      scope: t,
      triggerRef: a,
      contentRef: l,
      contentId: mn(),
      titleId: mn(),
      descriptionId: mn(),
      open: u,
      onOpenChange: c,
      onOpenToggle: m.useCallback(() => c((d) => !d), [c]),
      modal: s,
      children: n
    }
  );
};
sp.displayName = Cs;
var ap = "DialogTrigger", lp = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qt(ap, n), i = ye(t, o.triggerRef);
    return /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Oc(o.open),
        ...r,
        ref: i,
        onClick: j(e.onClick, o.onOpenToggle)
      }
    );
  }
);
lp.displayName = ap;
var Mc = "DialogPortal", [NS, cp] = ip(Mc, {
  forceMount: void 0
}), up = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = qt(Mc, t);
  return /* @__PURE__ */ f(NS, { scope: t, forceMount: n, children: m.Children.map(r, (s) => /* @__PURE__ */ f(ct, { present: n || i.open, children: /* @__PURE__ */ f(Zr, { asChild: !0, container: o, children: s }) })) });
};
up.displayName = Mc;
var Qi = "DialogOverlay", dp = m.forwardRef(
  (e, t) => {
    const n = cp(Qi, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = qt(Qi, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ f(ct, { present: r || i.open, children: /* @__PURE__ */ f(MS, { ...o, ref: t }) }) : null;
  }
);
dp.displayName = Qi;
var RS = /* @__PURE__ */ Nn("DialogOverlay.RemoveScroll"), MS = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qt(Qi, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ f(Jo, { as: RS, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ f(
        se.div,
        {
          "data-state": Oc(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Qn = "DialogContent", fp = m.forwardRef(
  (e, t) => {
    const n = cp(Qn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = qt(Qn, e.__scopeDialog);
    return /* @__PURE__ */ f(ct, { present: r || i.open, children: i.modal ? /* @__PURE__ */ f(AS, { ...o, ref: t }) : /* @__PURE__ */ f(OS, { ...o, ref: t }) });
  }
);
fp.displayName = Qn;
var AS = m.forwardRef(
  (e, t) => {
    const n = qt(Qn, e.__scopeDialog), r = m.useRef(null), o = ye(t, n.contentRef, r);
    return m.useEffect(() => {
      const i = r.current;
      if (i) return ei(i);
    }, []), /* @__PURE__ */ f(
      hp,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: j(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: j(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: j(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), OS = m.forwardRef(
  (e, t) => {
    const n = qt(Qn, e.__scopeDialog), r = m.useRef(!1), o = m.useRef(!1);
    return /* @__PURE__ */ f(
      hp,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), hp = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = qt(Qn, n), l = m.useRef(null), u = ye(t, l);
    return ws(), /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ f(
        Zo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ f(
            dr,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": Oc(a.open),
              ...s,
              ref: u,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ L(ke, { children: [
        /* @__PURE__ */ f(IS, { titleId: a.titleId }),
        /* @__PURE__ */ f($S, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), Ac = "DialogTitle", mp = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qt(Ac, n);
    return /* @__PURE__ */ f(se.h2, { id: o.titleId, ...r, ref: t });
  }
);
mp.displayName = Ac;
var pp = "DialogDescription", gp = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qt(pp, n);
    return /* @__PURE__ */ f(se.p, { id: o.descriptionId, ...r, ref: t });
  }
);
gp.displayName = pp;
var vp = "DialogClose", yp = m.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = qt(vp, n);
    return /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: j(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
yp.displayName = vp;
function Oc(e) {
  return e ? "open" : "closed";
}
var bp = "DialogTitleWarning", [yV, wp] = wC(bp, {
  contentName: Qn,
  titleName: Ac,
  docsSlug: "dialog"
}), IS = ({ titleId: e }) => {
  const t = wp(bp), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return m.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, _S = "DialogDescriptionWarning", $S = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${wp(_S).contentName}}.`;
  return m.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, xp = sp, Cp = lp, Sp = up, Ic = dp, _c = fp, $c = mp, Lc = gp, Fc = yp;
const Tp = xp, bV = Cp, LS = Sp, wV = Fc, Pp = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ic,
  {
    ref: n,
    className: q(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Pp.displayName = Ic.displayName;
const Vc = m.forwardRef(({ className: e, children: t, showCloseButton: n = !0, ...r }, o) => /* @__PURE__ */ L(LS, { children: [
  /* @__PURE__ */ f(Pp, {}),
  /* @__PURE__ */ L(
    _c,
    {
      ref: o,
      className: q(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-4 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        n && /* @__PURE__ */ L(Fc, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ f(Sc, { className: "h-4 w-4" }),
          /* @__PURE__ */ f("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Vc.displayName = _c.displayName;
const FS = ({ className: e, ...t }) => /* @__PURE__ */ f("div", { className: q("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
FS.displayName = "DialogHeader";
const Ep = ({ className: e, ...t }) => /* @__PURE__ */ f("div", { className: q("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e), ...t });
Ep.displayName = "DialogFooter";
const Dp = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  $c,
  {
    ref: n,
    className: q("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Dp.displayName = $c.displayName;
const VS = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(Lc, { ref: n, className: q("text-sm text-muted-foreground", e), ...t }));
VS.displayName = Lc.displayName;
function Zn({ transparent: e, className: t, cover: n, iconSize: r }) {
  return /* @__PURE__ */ f(
    "div",
    {
      className: We(
        "w-full h-full flex justify-center items-center",
        t,
        n && "absolute top-0 left-0 right-0 bottom-0 rounded-lg ",
        !e && "bg-neutral-container/75"
      ),
      children: /* @__PURE__ */ f(Om, { className: We("animate-spin text-button-primary-bg", !r && "h-10 w-10 "), size: r })
    }
  );
}
const kp = je(void 0), xV = () => {
  const e = Te(kp);
  if (!e)
    throw new Error("useConfirmationModal must be used within a ConfirmationModalProvider");
  return e;
}, CV = ({ children: e }) => {
  const [t, n] = de(!1), [r, o] = de(!1), [i, s] = de(null), a = () => {
    setTimeout(() => {
      s(null);
    }, 500);
  }, l = (p) => {
    s(p), n(!0);
  }, u = (p) => {
    s((y) => y ? { ...y, message: p } : null);
  }, c = async () => {
    o(!0);
    try {
      i != null && i.onConfirm && await i.onConfirm();
    } finally {
      n(!1), a(), o(!1);
    }
  }, d = () => {
    i != null && i.onCancel && i.onCancel(), n(!1), a();
  }, h = (p) => {
    i != null && i.isCancelDisabled || (!p && (i != null && i.onCancel) && (i == null || i.onCancel()), n(p), a());
  };
  return /* @__PURE__ */ L(kp.Provider, { value: { showConfirmation: l, updateMessage: u }, children: [
    e,
    /* @__PURE__ */ f(Tp, { open: t, onOpenChange: h, children: /* @__PURE__ */ L(Vc, { onEscapeKeyDown: d, showCloseButton: i == null ? void 0 : i.showCloseButton, children: [
      /* @__PURE__ */ f(Dp, { children: i == null ? void 0 : i.title }),
      r && /* @__PURE__ */ f(Zn, { cover: !0 }),
      i == null ? void 0 : i.message,
      /* @__PURE__ */ L(Ep, { children: [
        !(i != null && i.hideCancelButton) && /* @__PURE__ */ f(Pe, { onClick: d, variant: "outline", disabled: (i == null ? void 0 : i.isCancelDisabled) || r, children: (i == null ? void 0 : i.cancelText) || "Cancel" }),
        /* @__PURE__ */ f(
          Pe,
          {
            onClick: c,
            variant: i == null ? void 0 : i.variant,
            autoFocus: !0,
            disabled: (i == null ? void 0 : i.isConfirmDisabled) || r,
            children: (i == null ? void 0 : i.confirmText) || "Confirm"
          }
        )
      ] })
    ] }) })
  ] });
};
var BS = "Separator", Zd = "horizontal", WS = ["horizontal", "vertical"], Np = m.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Zd, ...o } = e, i = zS(r) ? r : Zd, a = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ f(
    se.div,
    {
      "data-orientation": i,
      ...a,
      ...o,
      ref: t
    }
  );
});
Np.displayName = BS;
function zS(e) {
  return WS.includes(e);
}
var Rp = Np;
const Oo = m.forwardRef(({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ f(
  Rp,
  {
    ref: o,
    decorative: n,
    orientation: t,
    className: q(
      "shrink-0 bg-neutral-borders",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...r
  }
));
Oo.displayName = Rp.displayName;
const va = "grow min-w-8", ya = "overflow-hidden text-ellipsis", jS = ({
  datatableHooks: e,
  expandAll: t,
  contractAll: n,
  filters: r,
  clearFilters: o,
  colapsableTable: i
}) => {
  const s = r ? Object.values(r).flat().length : 0, a = !!((s || !i) && o);
  return /* @__PURE__ */ L(
    "div",
    {
      className: We(
        "flex shrink flex-row  text-button-primary-outline-default space-x-1 text-sm justify-end ml-4 overflow-hidden",
        a ? "min-w-48" : "min-w-32"
      ),
      children: [
        i && /* @__PURE__ */ L(ke, { children: [
          /* @__PURE__ */ f(Pe, { variant: "ghost", onClick: t || (e == null ? void 0 : e.expandAllGroups), size: "sm", className: va, children: /* @__PURE__ */ f("span", { className: ya, children: "Expand all" }) }),
          /* @__PURE__ */ f(Oo, { orientation: "vertical", className: "h-auto" }),
          /* @__PURE__ */ f(Pe, { variant: "ghost", onClick: n || (e == null ? void 0 : e.contractAllGroups), size: "sm", className: va, children: /* @__PURE__ */ f("span", { className: ya, children: "Collapse all" }) })
        ] }),
        a ? /* @__PURE__ */ L(ke, { children: [
          i && /* @__PURE__ */ f(Oo, { orientation: "vertical", className: "h-auto" }),
          /* @__PURE__ */ f(Pe, { variant: "ghost", onClick: o, size: "sm", className: va, disabled: !s, children: /* @__PURE__ */ f("span", { className: ya, children: " Clear filters" }) })
        ] }) : void 0
      ]
    }
  );
};
function fr(e) {
  const { negativeFormat: t = "brackets" } = e.column;
  let n, r;
  return e.value === 1 / 0 || e.value === -1 / 0 ? n = "" : e.column.lookup ? e.value === null || e.value === void 0 || e.value === "" ? n = "-" : typeof e.column.lookup == "function" ? n = e.column.lookup(`${e.value}`, e.record) || `${e.value}` : n = e.column.lookup[`${e.value}`] || `${e.value}` : (n = e.value, r = e.column.dataType === "number" ? e.value && e.value < 0 : !1, e.value ? e.column.conditionalMask && (typeof e.value == "number" || typeof e.value == "string") && n !== "-" ? n = cl(
    Math.abs(+e.value),
    e.column.conditionalMask(e.column.key, e.column.name, e.record)
  ) : e.column.mask && (typeof e.value == "number" || typeof e.value == "string") && n !== "-" && (n = cl(Math.abs(+e.value), e.column.mask), n = `${e.column.prefix ?? ""}${n}${e.column.suffix ?? ""}`) : n = "-", t === "brackets" && r && n !== "-" && (n = `(${n})`), t === "minus" && r && n !== "-" && (n = `-${n}`)), /* @__PURE__ */ f("div", { className: We("overflow-x-hidden text-ellipsis grow w-0", r && "text-red-500"), children: n });
}
const HS = ["top", "right", "bottom", "left"], Mn = Math.min, Pt = Math.max, Zi = Math.round, ki = Math.floor, on = (e) => ({
  x: e,
  y: e
}), US = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, YS = {
  start: "end",
  end: "start"
};
function ml(e, t, n) {
  return Pt(e, Mn(t, n));
}
function pn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function gn(e) {
  return e.split("-")[0];
}
function Jr(e) {
  return e.split("-")[1];
}
function Bc(e) {
  return e === "x" ? "y" : "x";
}
function Wc(e) {
  return e === "y" ? "height" : "width";
}
function An(e) {
  return ["top", "bottom"].includes(gn(e)) ? "y" : "x";
}
function zc(e) {
  return Bc(An(e));
}
function GS(e, t, n) {
  n === void 0 && (n = !1);
  const r = Jr(e), o = zc(e), i = Wc(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Ji(s)), [s, Ji(s)];
}
function KS(e) {
  const t = Ji(e);
  return [pl(e), t, pl(t)];
}
function pl(e) {
  return e.replace(/start|end/g, (t) => YS[t]);
}
function XS(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function qS(e, t, n, r) {
  const o = Jr(e);
  let i = XS(gn(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(pl)))), i;
}
function Ji(e) {
  return e.replace(/left|right|bottom|top/g, (t) => US[t]);
}
function QS(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Mp(e) {
  return typeof e != "number" ? QS(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function es(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Jd(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = An(t), s = zc(t), a = Wc(s), l = gn(t), u = i === "y", c = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, h = r[a] / 2 - o[a] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: c,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Jr(t)) {
    case "start":
      p[s] -= h * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += h * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const ZS = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: d
  } = Jd(u, r, l), h = r, p = {}, y = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: v,
      fn: b
    } = a[g], {
      x,
      y: w,
      data: C,
      reset: S
    } = await b({
      x: c,
      y: d,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: p,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = x ?? c, d = w ?? d, p = {
      ...p,
      [v]: {
        ...p[v],
        ...C
      }
    }, S && y <= 50 && (y++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (u = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: c,
      y: d
    } = Jd(u, h, l)), g = -1);
  }
  return {
    x: c,
    y: d,
    placement: h,
    strategy: o,
    middlewareData: p
  };
};
async function Io(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = pn(t, e), y = Mp(p), v = a[h ? d === "floating" ? "reference" : "floating" : d], b = es(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), x = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), C = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = es(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (b.top - S.top + y.top) / C.y,
    bottom: (S.bottom - b.bottom + y.bottom) / C.y,
    left: (b.left - S.left + y.left) / C.x,
    right: (S.right - b.right + y.right) / C.x
  };
}
const JS = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: u,
      padding: c = 0
    } = pn(e, t) || {};
    if (u == null)
      return {};
    const d = Mp(c), h = {
      x: n,
      y: r
    }, p = zc(o), y = Wc(p), g = await s.getDimensions(u), v = p === "y", b = v ? "top" : "left", x = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", C = i.reference[y] + i.reference[p] - h[p] - i.floating[y], S = h[p] - i.reference[p], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let P = T ? T[w] : 0;
    (!P || !await (s.isElement == null ? void 0 : s.isElement(T))) && (P = a.floating[w] || i.floating[y]);
    const E = C / 2 - S / 2, D = P / 2 - g[y] / 2 - 1, A = Mn(d[b], D), R = Mn(d[x], D), O = A, F = P - g[y] - R, $ = P / 2 - g[y] / 2 + E, W = ml(O, $, F), V = !l.arrow && Jr(o) != null && $ !== W && i.reference[y] / 2 - ($ < O ? A : R) - g[y] / 2 < 0, k = V ? $ < O ? $ - O : $ - F : 0;
    return {
      [p]: h[p] + k,
      data: {
        [p]: W,
        centerOffset: $ - W - k,
        ...V && {
          alignmentOffset: k
        }
      },
      reset: V
    };
  }
}), eT = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: g = !0,
        ...v
      } = pn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = gn(o), x = An(a), w = gn(a) === a, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), S = h || (w || !g ? [Ji(a)] : KS(a)), T = y !== "none";
      !h && T && S.push(...qS(a, g, y, C));
      const P = [a, ...S], E = await Io(t, v), D = [];
      let A = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (c && D.push(E[b]), d) {
        const $ = GS(o, s, C);
        D.push(E[$[0]], E[$[1]]);
      }
      if (A = [...A, {
        placement: o,
        overflows: D
      }], !D.every(($) => $ <= 0)) {
        var R, O;
        const $ = (((R = i.flip) == null ? void 0 : R.index) || 0) + 1, W = P[$];
        if (W)
          return {
            data: {
              index: $,
              overflows: A
            },
            reset: {
              placement: W
            }
          };
        let V = (O = A.filter((k) => k.overflows[0] <= 0).sort((k, N) => k.overflows[1] - N.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!V)
          switch (p) {
            case "bestFit": {
              var F;
              const k = (F = A.filter((N) => {
                if (T) {
                  const M = An(N.placement);
                  return M === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((M) => M > 0).reduce((M, B) => M + B, 0)]).sort((N, M) => N[1] - M[1])[0]) == null ? void 0 : F[0];
              k && (V = k);
              break;
            }
            case "initialPlacement":
              V = a;
              break;
          }
        if (o !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function ef(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function tf(e) {
  return HS.some((t) => e[t] >= 0);
}
const tT = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = pn(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await Io(t, {
            ...o,
            elementContext: "reference"
          }), s = ef(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: tf(s)
            }
          };
        }
        case "escaped": {
          const i = await Io(t, {
            ...o,
            altBoundary: !0
          }), s = ef(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: tf(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function nT(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = gn(n), a = Jr(n), l = An(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, c = i && l ? -1 : 1, d = pn(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: y
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof y == "number" && (p = a === "end" ? y * -1 : y), l ? {
    x: p * c,
    y: h * u
  } : {
    x: h * u,
    y: p * c
  };
}
const rT = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await nT(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, oT = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: b,
              y: x
            } = v;
            return {
              x: b,
              y: x
            };
          }
        },
        ...l
      } = pn(e, t), u = {
        x: n,
        y: r
      }, c = await Io(t, l), d = An(gn(o)), h = Bc(d);
      let p = u[h], y = u[d];
      if (i) {
        const v = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", x = p + c[v], w = p - c[b];
        p = ml(x, p, w);
      }
      if (s) {
        const v = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", x = y + c[v], w = y - c[b];
        y = ml(x, y, w);
      }
      const g = a.fn({
        ...t,
        [h]: p,
        [d]: y
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [h]: i,
            [d]: s
          }
        }
      };
    }
  };
}, iT = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = pn(e, t), c = {
        x: n,
        y: r
      }, d = An(o), h = Bc(d);
      let p = c[h], y = c[d];
      const g = pn(a, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const w = h === "y" ? "height" : "width", C = i.reference[h] - i.floating[w] + v.mainAxis, S = i.reference[h] + i.reference[w] - v.mainAxis;
        p < C ? p = C : p > S && (p = S);
      }
      if (u) {
        var b, x;
        const w = h === "y" ? "width" : "height", C = ["top", "left"].includes(gn(o)), S = i.reference[d] - i.floating[w] + (C && ((b = s.offset) == null ? void 0 : b[d]) || 0) + (C ? 0 : v.crossAxis), T = i.reference[d] + i.reference[w] + (C ? 0 : ((x = s.offset) == null ? void 0 : x[d]) || 0) - (C ? v.crossAxis : 0);
        y < S ? y = S : y > T && (y = T);
      }
      return {
        [h]: p,
        [d]: y
      };
    }
  };
}, sT = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...u
      } = pn(e, t), c = await Io(t, u), d = gn(o), h = Jr(o), p = An(o) === "y", {
        width: y,
        height: g
      } = i.floating;
      let v, b;
      d === "top" || d === "bottom" ? (v = d, b = h === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = d, v = h === "end" ? "top" : "bottom");
      const x = g - c.top - c.bottom, w = y - c.left - c.right, C = Mn(g - c[v], x), S = Mn(y - c[b], w), T = !t.middlewareData.shift;
      let P = C, E = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (E = w), (r = t.middlewareData.shift) != null && r.enabled.y && (P = x), T && !h) {
        const A = Pt(c.left, 0), R = Pt(c.right, 0), O = Pt(c.top, 0), F = Pt(c.bottom, 0);
        p ? E = y - 2 * (A !== 0 || R !== 0 ? A + R : Pt(c.left, c.right)) : P = g - 2 * (O !== 0 || F !== 0 ? O + F : Pt(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: P
      });
      const D = await s.getDimensions(a.floating);
      return y !== D.width || g !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ss() {
  return typeof window < "u";
}
function eo(e) {
  return Ap(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Dt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function cn(e) {
  var t;
  return (t = (Ap(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ap(e) {
  return Ss() ? e instanceof Node || e instanceof Dt(e).Node : !1;
}
function Yt(e) {
  return Ss() ? e instanceof Element || e instanceof Dt(e).Element : !1;
}
function ln(e) {
  return Ss() ? e instanceof HTMLElement || e instanceof Dt(e).HTMLElement : !1;
}
function nf(e) {
  return !Ss() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Dt(e).ShadowRoot;
}
function ti(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Gt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function aT(e) {
  return ["table", "td", "th"].includes(eo(e));
}
function Ts(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function jc(e) {
  const t = Hc(), n = Yt(e) ? Gt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function lT(e) {
  let t = On(e);
  for (; ln(t) && !Wr(t); ) {
    if (jc(t))
      return t;
    if (Ts(t))
      return null;
    t = On(t);
  }
  return null;
}
function Hc() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Wr(e) {
  return ["html", "body", "#document"].includes(eo(e));
}
function Gt(e) {
  return Dt(e).getComputedStyle(e);
}
function Ps(e) {
  return Yt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function On(e) {
  if (eo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    nf(e) && e.host || // Fallback.
    cn(e)
  );
  return nf(t) ? t.host : t;
}
function Op(e) {
  const t = On(e);
  return Wr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ln(t) && ti(t) ? t : Op(t);
}
function _o(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Op(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Dt(o);
  if (i) {
    const a = gl(s);
    return t.concat(s, s.visualViewport || [], ti(o) ? o : [], a && n ? _o(a) : []);
  }
  return t.concat(o, _o(o, [], n));
}
function gl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ip(e) {
  const t = Gt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = ln(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = Zi(n) !== i || Zi(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Uc(e) {
  return Yt(e) ? e : e.contextElement;
}
function Lr(e) {
  const t = Uc(e);
  if (!ln(t))
    return on(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Ip(t);
  let s = (i ? Zi(n.width) : n.width) / r, a = (i ? Zi(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const cT = /* @__PURE__ */ on(0);
function _p(e) {
  const t = Dt(e);
  return !Hc() || !t.visualViewport ? cT : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function uT(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Dt(e) ? !1 : t;
}
function Jn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Uc(e);
  let s = on(1);
  t && (r ? Yt(r) && (s = Lr(r)) : s = Lr(e));
  const a = uT(i, n, r) ? _p(i) : on(0);
  let l = (o.left + a.x) / s.x, u = (o.top + a.y) / s.y, c = o.width / s.x, d = o.height / s.y;
  if (i) {
    const h = Dt(i), p = r && Yt(r) ? Dt(r) : r;
    let y = h, g = gl(y);
    for (; g && r && p !== y; ) {
      const v = Lr(g), b = g.getBoundingClientRect(), x = Gt(g), w = b.left + (g.clientLeft + parseFloat(x.paddingLeft)) * v.x, C = b.top + (g.clientTop + parseFloat(x.paddingTop)) * v.y;
      l *= v.x, u *= v.y, c *= v.x, d *= v.y, l += w, u += C, y = Dt(g), g = gl(y);
    }
  }
  return es({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function Yc(e, t) {
  const n = Ps(e).scrollLeft;
  return t ? t.left + n : Jn(cn(e)).left + n;
}
function $p(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Yc(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function dT(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = cn(r), a = t ? Ts(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = on(1);
  const c = on(0), d = ln(r);
  if ((d || !d && !i) && ((eo(r) !== "body" || ti(s)) && (l = Ps(r)), ln(r))) {
    const p = Jn(r);
    u = Lr(r), c.x = p.x + r.clientLeft, c.y = p.y + r.clientTop;
  }
  const h = s && !d && !i ? $p(s, l, !0) : on(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + c.x + h.x,
    y: n.y * u.y - l.scrollTop * u.y + c.y + h.y
  };
}
function fT(e) {
  return Array.from(e.getClientRects());
}
function hT(e) {
  const t = cn(e), n = Ps(e), r = e.ownerDocument.body, o = Pt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Pt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Yc(e);
  const a = -n.scrollTop;
  return Gt(r).direction === "rtl" && (s += Pt(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function mT(e, t) {
  const n = Dt(e), r = cn(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const u = Hc();
    (!u || u && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function pT(e, t) {
  const n = Jn(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = ln(e) ? Lr(e) : on(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, u = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: u
  };
}
function rf(e, t, n) {
  let r;
  if (t === "viewport")
    r = mT(e, n);
  else if (t === "document")
    r = hT(cn(e));
  else if (Yt(t))
    r = pT(t, n);
  else {
    const o = _p(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return es(r);
}
function Lp(e, t) {
  const n = On(e);
  return n === t || !Yt(n) || Wr(n) ? !1 : Gt(n).position === "fixed" || Lp(n, t);
}
function gT(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = _o(e, [], !1).filter((a) => Yt(a) && eo(a) !== "body"), o = null;
  const i = Gt(e).position === "fixed";
  let s = i ? On(e) : e;
  for (; Yt(s) && !Wr(s); ) {
    const a = Gt(s), l = jc(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ti(s) && !l && Lp(e, s)) ? r = r.filter((c) => c !== s) : o = a, s = On(s);
  }
  return t.set(e, r), r;
}
function vT(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Ts(t) ? [] : gT(t, this._c) : [].concat(n), r], a = s[0], l = s.reduce((u, c) => {
    const d = rf(t, c, o);
    return u.top = Pt(d.top, u.top), u.right = Mn(d.right, u.right), u.bottom = Mn(d.bottom, u.bottom), u.left = Pt(d.left, u.left), u;
  }, rf(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function yT(e) {
  const {
    width: t,
    height: n
  } = Ip(e);
  return {
    width: t,
    height: n
  };
}
function bT(e, t, n) {
  const r = ln(t), o = cn(t), i = n === "fixed", s = Jn(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = on(0);
  if (r || !r && !i)
    if ((eo(t) !== "body" || ti(o)) && (a = Ps(t)), r) {
      const h = Jn(t, !0, i, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else o && (l.x = Yc(o));
  const u = o && !r && !i ? $p(o, a) : on(0), c = s.left + a.scrollLeft - l.x - u.x, d = s.top + a.scrollTop - l.y - u.y;
  return {
    x: c,
    y: d,
    width: s.width,
    height: s.height
  };
}
function ba(e) {
  return Gt(e).position === "static";
}
function of(e, t) {
  if (!ln(e) || Gt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return cn(e) === n && (n = n.ownerDocument.body), n;
}
function Fp(e, t) {
  const n = Dt(e);
  if (Ts(e))
    return n;
  if (!ln(e)) {
    let o = On(e);
    for (; o && !Wr(o); ) {
      if (Yt(o) && !ba(o))
        return o;
      o = On(o);
    }
    return n;
  }
  let r = of(e, t);
  for (; r && aT(r) && ba(r); )
    r = of(r, t);
  return r && Wr(r) && ba(r) && !jc(r) ? n : r || lT(e) || n;
}
const wT = async function(e) {
  const t = this.getOffsetParent || Fp, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: bT(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function xT(e) {
  return Gt(e).direction === "rtl";
}
const CT = {
  convertOffsetParentRelativeRectToViewportRelativeRect: dT,
  getDocumentElement: cn,
  getClippingRect: vT,
  getOffsetParent: Fp,
  getElementRects: wT,
  getClientRects: fT,
  getDimensions: yT,
  getScale: Lr,
  isElement: Yt,
  isRTL: xT
};
function Vp(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function ST(e, t) {
  let n = null, r;
  const o = cn(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: d,
      width: h,
      height: p
    } = u;
    if (a || t(), !h || !p)
      return;
    const y = ki(d), g = ki(o.clientWidth - (c + h)), v = ki(o.clientHeight - (d + p)), b = ki(c), w = {
      rootMargin: -y + "px " + -g + "px " + -v + "px " + -b + "px",
      threshold: Pt(0, Mn(1, l)) || 1
    };
    let C = !0;
    function S(T) {
      const P = T[0].intersectionRatio;
      if (P !== l) {
        if (!C)
          return s();
        P ? s(!1, P) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !Vp(u, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, w);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function TT(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = Uc(e), c = o || i ? [...u ? _o(u) : [], ..._o(t)] : [];
  c.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const d = u && a ? ST(u, n) : null;
  let h = -1, p = null;
  s && (p = new ResizeObserver((b) => {
    let [x] = b;
    x && x.target === u && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(t);
    })), n();
  }), u && !l && p.observe(u), p.observe(t));
  let y, g = l ? Jn(e) : null;
  l && v();
  function v() {
    const b = Jn(e);
    g && !Vp(g, b) && n(), g = b, y = requestAnimationFrame(v);
  }
  return n(), () => {
    var b;
    c.forEach((x) => {
      o && x.removeEventListener("scroll", n), i && x.removeEventListener("resize", n);
    }), d == null || d(), (b = p) == null || b.disconnect(), p = null, l && cancelAnimationFrame(y);
  };
}
const PT = rT, ET = oT, DT = eT, kT = sT, NT = tT, sf = JS, RT = iT, MT = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: CT,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return ZS(e, t, {
    ...o,
    platform: i
  });
};
var Wi = typeof document < "u" ? cr : fe;
function ts(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!ts(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !ts(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Bp(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function af(e, t) {
  const n = Bp(e);
  return Math.round(t * n) / n;
}
function wa(e) {
  const t = m.useRef(e);
  return Wi(() => {
    t.current = e;
  }), t;
}
function AT(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, d] = m.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = m.useState(r);
  ts(h, r) || p(r);
  const [y, g] = m.useState(null), [v, b] = m.useState(null), x = m.useCallback((N) => {
    N !== T.current && (T.current = N, g(N));
  }, []), w = m.useCallback((N) => {
    N !== P.current && (P.current = N, b(N));
  }, []), C = i || y, S = s || v, T = m.useRef(null), P = m.useRef(null), E = m.useRef(c), D = l != null, A = wa(l), R = wa(o), O = wa(u), F = m.useCallback(() => {
    if (!T.current || !P.current)
      return;
    const N = {
      placement: t,
      strategy: n,
      middleware: h
    };
    R.current && (N.platform = R.current), MT(T.current, P.current, N).then((M) => {
      const B = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: O.current !== !1
      };
      $.current && !ts(E.current, B) && (E.current = B, Qo.flushSync(() => {
        d(B);
      }));
    });
  }, [h, t, n, R, O]);
  Wi(() => {
    u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [u]);
  const $ = m.useRef(!1);
  Wi(() => ($.current = !0, () => {
    $.current = !1;
  }), []), Wi(() => {
    if (C && (T.current = C), S && (P.current = S), C && S) {
      if (A.current)
        return A.current(C, S, F);
      F();
    }
  }, [C, S, F, A, D]);
  const W = m.useMemo(() => ({
    reference: T,
    floating: P,
    setReference: x,
    setFloating: w
  }), [x, w]), V = m.useMemo(() => ({
    reference: C,
    floating: S
  }), [C, S]), k = m.useMemo(() => {
    const N = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return N;
    const M = af(V.floating, c.x), B = af(V.floating, c.y);
    return a ? {
      ...N,
      transform: "translate(" + M + "px, " + B + "px)",
      ...Bp(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: B
    };
  }, [n, a, V.floating, c.x, c.y]);
  return m.useMemo(() => ({
    ...c,
    update: F,
    refs: W,
    elements: V,
    floatingStyles: k
  }), [c, F, W, V, k]);
}
const OT = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? sf({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? sf({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, IT = (e, t) => ({
  ...PT(e),
  options: [e, t]
}), _T = (e, t) => ({
  ...ET(e),
  options: [e, t]
}), $T = (e, t) => ({
  ...RT(e),
  options: [e, t]
}), LT = (e, t) => ({
  ...DT(e),
  options: [e, t]
}), FT = (e, t) => ({
  ...kT(e),
  options: [e, t]
}), VT = (e, t) => ({
  ...NT(e),
  options: [e, t]
}), BT = (e, t) => ({
  ...OT(e),
  options: [e, t]
});
var WT = "Arrow", Wp = m.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ f(
    se.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ f("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Wp.displayName = WT;
var zT = Wp;
function zp(e) {
  const [t, n] = m.useState(void 0);
  return it(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          s = u.inlineSize, a = u.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Gc = "Popper", [jp, _n] = Bt(Gc), [jT, Hp] = jp(Gc), Up = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = m.useState(null);
  return /* @__PURE__ */ f(jT, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Up.displayName = Gc;
var Yp = "PopperAnchor", Gp = m.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Hp(Yp, n), s = m.useRef(null), a = ye(t, s);
    return m.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ f(se.div, { ...o, ref: a });
  }
);
Gp.displayName = Yp;
var Kc = "PopperContent", [HT, UT] = jp(Kc), Kp = m.forwardRef(
  (e, t) => {
    var H, oe, he, ne, be, xe;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: d = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: y,
      ...g
    } = e, v = Hp(Kc, n), [b, x] = m.useState(null), w = ye(t, (re) => x(re)), [C, S] = m.useState(null), T = zp(C), P = (T == null ? void 0 : T.width) ?? 0, E = (T == null ? void 0 : T.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), A = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, R = Array.isArray(u) ? u : [u], O = R.length > 0, F = {
      padding: A,
      boundary: R.filter(GT),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: O
    }, { refs: $, floatingStyles: W, placement: V, isPositioned: k, middlewareData: N } = AT({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...re) => TT(...re, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        IT({ mainAxis: o + E, alignmentAxis: s }),
        l && _T({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? $T() : void 0,
          ...F
        }),
        l && LT({ ...F }),
        FT({
          ...F,
          apply: ({ elements: re, rects: ot, availableWidth: St, availableHeight: At }) => {
            const { width: Zt, height: vr } = ot.reference, I = re.floating.style;
            I.setProperty("--radix-popper-available-width", `${St}px`), I.setProperty("--radix-popper-available-height", `${At}px`), I.setProperty("--radix-popper-anchor-width", `${Zt}px`), I.setProperty("--radix-popper-anchor-height", `${vr}px`);
          }
        }),
        C && BT({ element: C, padding: a }),
        KT({ arrowWidth: P, arrowHeight: E }),
        h && VT({ strategy: "referenceHidden", ...F })
      ]
    }), [M, B] = Qp(V), G = Je(y);
    it(() => {
      k && (G == null || G());
    }, [k, G]);
    const _ = (H = N.arrow) == null ? void 0 : H.x, U = (oe = N.arrow) == null ? void 0 : oe.y, te = ((he = N.arrow) == null ? void 0 : he.centerOffset) !== 0, [X, Q] = m.useState();
    return it(() => {
      b && Q(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ f(
      "div",
      {
        ref: $.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: k ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: X,
          "--radix-popper-transform-origin": [
            (ne = N.transformOrigin) == null ? void 0 : ne.x,
            (be = N.transformOrigin) == null ? void 0 : be.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((xe = N.hide) == null ? void 0 : xe.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f(
          HT,
          {
            scope: n,
            placedSide: M,
            onArrowChange: S,
            arrowX: _,
            arrowY: U,
            shouldHideArrow: te,
            children: /* @__PURE__ */ f(
              se.div,
              {
                "data-side": M,
                "data-align": B,
                ...g,
                ref: w,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: k ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Kp.displayName = Kc;
var Xp = "PopperArrow", YT = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, qp = m.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = UT(Xp, r), s = YT[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f(
          zT,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
qp.displayName = Xp;
function GT(e) {
  return e !== null;
}
var KT = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, b, x;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [u, c] = Qp(n), d = { start: "0%", center: "50%", end: "100%" }[c], h = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + a / 2, p = (((x = o.arrow) == null ? void 0 : x.y) ?? 0) + l / 2;
    let y = "", g = "";
    return u === "bottom" ? (y = s ? d : `${h}px`, g = `${-l}px`) : u === "top" ? (y = s ? d : `${h}px`, g = `${r.floating.height + l}px`) : u === "right" ? (y = `${-l}px`, g = s ? d : `${p}px`) : u === "left" && (y = `${r.floating.width + l}px`, g = s ? d : `${p}px`), { data: { x: y, y: g } };
  }
});
function Qp(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Xc = Up, ni = Gp, Es = Kp, Ds = qp, Zp = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), XT = "VisuallyHidden", ks = m.forwardRef(
  (e, t) => /* @__PURE__ */ f(
    se.span,
    {
      ...e,
      ref: t,
      style: { ...Zp, ...e.style }
    }
  )
);
ks.displayName = XT;
var qT = ks, [Ns, SV] = Bt("Tooltip", [
  _n
]), Rs = _n(), Jp = "TooltipProvider", QT = 700, vl = "tooltip.open", [ZT, qc] = Ns(Jp), eg = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = QT,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, s = m.useRef(!0), a = m.useRef(!1), l = m.useRef(0);
  return m.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ f(
    ZT,
    {
      scope: t,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: m.useCallback(() => {
        window.clearTimeout(l.current), s.current = !1;
      }, []),
      onClose: m.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: m.useCallback((u) => {
        a.current = u;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
eg.displayName = Jp;
var $o = "Tooltip", [JT, ri] = Ns($o), tg = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: a
  } = e, l = qc($o, e.__scopeTooltip), u = Rs(t), [c, d] = m.useState(null), h = mn(), p = m.useRef(0), y = s ?? l.disableHoverableContent, g = a ?? l.delayDuration, v = m.useRef(!1), [b, x] = Rn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (P) => {
      P ? (l.onOpen(), document.dispatchEvent(new CustomEvent(vl))) : l.onClose(), i == null || i(P);
    },
    caller: $o
  }), w = m.useMemo(() => b ? v.current ? "delayed-open" : "instant-open" : "closed", [b]), C = m.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, v.current = !1, x(!0);
  }, [x]), S = m.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, x(!1);
  }, [x]), T = m.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      v.current = !0, x(!0), p.current = 0;
    }, g);
  }, [g, x]);
  return m.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ f(Xc, { ...u, children: /* @__PURE__ */ f(
    JT,
    {
      scope: t,
      contentId: h,
      open: b,
      stateAttribute: w,
      trigger: c,
      onTriggerChange: d,
      onTriggerEnter: m.useCallback(() => {
        l.isOpenDelayedRef.current ? T() : C();
      }, [l.isOpenDelayedRef, T, C]),
      onTriggerLeave: m.useCallback(() => {
        y ? S() : (window.clearTimeout(p.current), p.current = 0);
      }, [S, y]),
      onOpen: C,
      onClose: S,
      disableHoverableContent: y,
      children: n
    }
  ) });
};
tg.displayName = $o;
var yl = "TooltipTrigger", ng = m.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = ri(yl, n), i = qc(yl, n), s = Rs(n), a = m.useRef(null), l = ye(t, a, o.onTriggerChange), u = m.useRef(!1), c = m.useRef(!1), d = m.useCallback(() => u.current = !1, []);
    return m.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ f(ni, { asChild: !0, ...s, children: /* @__PURE__ */ f(
      se.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: j(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !c.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), c.current = !0);
        }),
        onPointerLeave: j(e.onPointerLeave, () => {
          o.onTriggerLeave(), c.current = !1;
        }),
        onPointerDown: j(e.onPointerDown, () => {
          o.open && o.onClose(), u.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: j(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: j(e.onBlur, o.onClose),
        onClick: j(e.onClick, o.onClose)
      }
    ) });
  }
);
ng.displayName = yl;
var Qc = "TooltipPortal", [eP, tP] = Ns(Qc, {
  forceMount: void 0
}), rg = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = ri(Qc, t);
  return /* @__PURE__ */ f(eP, { scope: t, forceMount: n, children: /* @__PURE__ */ f(ct, { present: n || i.open, children: /* @__PURE__ */ f(Zr, { asChild: !0, container: o, children: r }) }) });
};
rg.displayName = Qc;
var zr = "TooltipContent", og = m.forwardRef(
  (e, t) => {
    const n = tP(zr, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, s = ri(zr, e.__scopeTooltip);
    return /* @__PURE__ */ f(ct, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ f(ig, { side: o, ...i, ref: t }) : /* @__PURE__ */ f(nP, { side: o, ...i, ref: t }) });
  }
), nP = m.forwardRef((e, t) => {
  const n = ri(zr, e.__scopeTooltip), r = qc(zr, e.__scopeTooltip), o = m.useRef(null), i = ye(t, o), [s, a] = m.useState(null), { trigger: l, onClose: u } = n, c = o.current, { onPointerInTransitChange: d } = r, h = m.useCallback(() => {
    a(null), d(!1);
  }, [d]), p = m.useCallback(
    (y, g) => {
      const v = y.currentTarget, b = { x: y.clientX, y: y.clientY }, x = aP(b, v.getBoundingClientRect()), w = lP(b, x), C = cP(g.getBoundingClientRect()), S = dP([...w, ...C]);
      a(S), d(!0);
    },
    [d]
  );
  return m.useEffect(() => () => h(), [h]), m.useEffect(() => {
    if (l && c) {
      const y = (v) => p(v, c), g = (v) => p(v, l);
      return l.addEventListener("pointerleave", y), c.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", y), c.removeEventListener("pointerleave", g);
      };
    }
  }, [l, c, p, h]), m.useEffect(() => {
    if (s) {
      const y = (g) => {
        const v = g.target, b = { x: g.clientX, y: g.clientY }, x = (l == null ? void 0 : l.contains(v)) || (c == null ? void 0 : c.contains(v)), w = !uP(b, s);
        x ? h() : w && (h(), u());
      };
      return document.addEventListener("pointermove", y), () => document.removeEventListener("pointermove", y);
    }
  }, [l, c, s, u, h]), /* @__PURE__ */ f(ig, { ...e, ref: i });
}), [rP, oP] = Ns($o, { isInside: !1 }), iP = /* @__PURE__ */ gC("TooltipContent"), ig = m.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      ...a
    } = e, l = ri(zr, n), u = Rs(n), { onClose: c } = l;
    return m.useEffect(() => (document.addEventListener(vl, c), () => document.removeEventListener(vl, c)), [c]), m.useEffect(() => {
      if (l.trigger) {
        const d = (h) => {
          const p = h.target;
          p != null && p.contains(l.trigger) && c();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, c]), /* @__PURE__ */ f(
      dr,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: c,
        children: /* @__PURE__ */ L(
          Es,
          {
            "data-state": l.stateAttribute,
            ...u,
            ...a,
            ref: t,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ f(iP, { children: r }),
              /* @__PURE__ */ f(rP, { scope: n, isInside: !0, children: /* @__PURE__ */ f(qT, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
og.displayName = zr;
var sg = "TooltipArrow", sP = m.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Rs(n);
    return oP(
      sg,
      n
    ).isInside ? null : /* @__PURE__ */ f(Ds, { ...o, ...r, ref: t });
  }
);
sP.displayName = sg;
function aP(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function lP(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function cP(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function uP(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], l = t[s], u = a.x, c = a.y, d = l.x, h = l.y;
    c > r != h > r && n < (d - u) * (r - c) / (h - c) + u && (o = !o);
  }
  return o;
}
function dP(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), fP(t);
}
function fP(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var hP = eg, mP = tg, pP = ng, gP = rg, ag = og;
const Zc = hP, Ms = mP, As = pP, oi = m.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ f(
  ag,
  {
    ref: r,
    sideOffset: t,
    className: q(
      "z-50 overflow-hidden rounded-lg border bg-neutral-bg px-2 py-0.5 text-xxs text-neutral-text-secondary shadow-sm animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
oi.displayName = ag.displayName;
function lg({ text: e, className: t = "" }) {
  const n = /* @__PURE__ */ f("span", { className: t, children: e });
  return e ? /* @__PURE__ */ L(Ms, { children: [
    /* @__PURE__ */ f(As, { asChild: !0, children: n }),
    /* @__PURE__ */ f(gP, { children: /* @__PURE__ */ f(oi, { side: "top", className: "z-[9999] max-w-xs break-words text-xs dark:text-white", children: e }) })
  ] }) : n;
}
function vP(e, t, n) {
  return yP(e, { column: t, row: n });
}
function yP(e, t) {
  return !e || !t ? !1 : e.column === t.column && e.row === t.row;
}
const TV = () => ({
  split: !0
}), PV = (e) => ({
  split: !0,
  key: e,
  isLocked: !0
}), bP = (e, t) => {
  const n = `${e.map((r) => r.key).join("_").toLowerCase()}_${t}_group`;
  return {
    key: n,
    name: n,
    group: e,
    groupColumn: !0,
    _dfColIndex: -1
  };
};
function Cr(e, t, n) {
  let r = n.initialDeps ?? [], o;
  function i() {
    var s, a, l, u;
    let c;
    n.key && ((s = n.debug) != null && s.call(n)) && (c = Date.now());
    const d = e();
    if (!(d.length !== r.length || d.some((y, g) => r[g] !== y)))
      return o;
    r = d;
    let p;
    if (n.key && ((a = n.debug) != null && a.call(n)) && (p = Date.now()), o = t(...d), n.key && ((l = n.debug) != null && l.call(n))) {
      const y = Math.round((Date.now() - c) * 100) / 100, g = Math.round((Date.now() - p) * 100) / 100, v = g / 16, b = (x, w) => {
        for (x = String(x); x.length < w; )
          x = " " + x;
        return x;
      };
      console.info(
        `%c⏱ ${b(g, 5)} /${b(y, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * v, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (u = n == null ? void 0 : n.onChange) == null || u.call(n, o), o;
  }
  return i.updateDeps = (s) => {
    r = s;
  }, i;
}
function xa(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const wP = (e, t) => Math.abs(e - t) < 1, xP = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, CP = (e) => e, SP = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, TP = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (s) => {
    const { width: a, height: l } = s;
    t({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((s) => {
    const a = () => {
      const l = s[0];
      if (l != null && l.borderBoxSize) {
        const u = l.borderBoxSize[0];
        if (u) {
          o({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      o(n.getBoundingClientRect());
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, lf = {
  passive: !0
}, cf = typeof window > "u" ? !0 : "onscrollend" in window, PP = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = e.options.useScrollendEvent && cf ? () => {
  } : xP(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (c) => () => {
    const { horizontal: d, isRtl: h } = e.options;
    o = d ? n.scrollLeft * (h && -1 || 1) : n.scrollTop, i(), t(o, c);
  }, a = s(!0), l = s(!1);
  l(), n.addEventListener("scroll", a, lf);
  const u = e.options.useScrollendEvent && cf;
  return u && n.addEventListener("scrollend", l, lf), () => {
    n.removeEventListener("scroll", a), u && n.removeEventListener("scrollend", l);
  };
}, EP = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, DP = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const s = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class kP {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          const s = () => {
            this._measureElement(i.target, i);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: CP,
        rangeExtractor: SP,
        onChange: () => {
        },
        measureElement: EP,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = Cr(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (o.has(a.lane))
          continue;
        const l = i.get(
          a.lane
        );
        if (l == null || a.end > l.end ? i.set(a.lane, a) : a.end < l.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Cr(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Cr(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: s }, a) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((c) => {
          this.itemSizeCache.set(c.key, c.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, l);
        for (let c = l; c < n; c++) {
          const d = i(c), h = this.options.lanes === 1 ? u[c - 1] : this.getFurthestMeasurement(u, c), p = h ? h.end + this.options.gap : r + o, y = a.get(d), g = typeof y == "number" ? y : this.options.estimateSize(c), v = p + g, b = h ? h.lane : c % this.options.lanes;
          u[c] = {
            index: c,
            start: p,
            size: g,
            end: v,
            key: d,
            lane: b
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Cr(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, o, i) => this.range = n.length > 0 && r > 0 ? NP({
        measurements: n,
        outerSize: r,
        scrollOffset: o,
        lanes: i
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Cr(
      () => {
        let n = null, r = null;
        const o = this.calculateRange();
        return o && (n = o.startIndex, r = o.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, o, i, s) => i === null || s === null ? [] : n({
        startIndex: i,
        endIndex: s,
        overscan: r,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.measurementsCache[o];
      if (!i)
        return;
      const s = i.key, a = this.elementsCache.get(s);
      a !== n && (a && this.observer.unobserve(a), this.observer.observe(n), this.elementsCache.set(s, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, s = r - i;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, s, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Cr(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return xa(
          r[cg(
            0,
            r.length - 1,
            (o) => xa(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r, o = 0) => {
      const i = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (r = n >= s + i ? "end" : "start"), r === "center" ? n += (o - i) / 2 : r === "end" && (n -= i);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", u = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - i;
      return Math.max(Math.min(u, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= s + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(a, r, o.size),
        r
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i) return;
      const [s, a] = i;
      this._scrollToOffset(s, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [u] = xa(
            this.getOffsetForIndex(n, a)
          );
          wP(u, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      if (r.length === 0)
        o = this.options.paddingStart;
      else if (this.options.lanes === 1)
        o = ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0;
      else {
        const i = Array(this.options.lanes).fill(null);
        let s = r.length - 1;
        for (; s >= 0 && i.some((a) => a === null); ) {
          const a = r[s];
          i[a.lane] === null && (i[a.lane] = a.end), s--;
        }
        o = Math.max(...i.filter((a) => a !== null));
      }
      return Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const cg = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function NP({
  measurements: e,
  outerSize: t,
  scrollOffset: n,
  lanes: r
}) {
  const o = e.length - 1, i = (l) => e[l].start;
  if (e.length <= r)
    return {
      startIndex: 0,
      endIndex: o
    };
  let s = cg(
    0,
    o,
    i,
    n
  ), a = s;
  if (r === 1)
    for (; a < o && e[a].end < n + t; )
      a++;
  else if (r > 1) {
    const l = Array(r).fill(0);
    for (; a < o && l.some((c) => c < n + t); ) {
      const c = e[a];
      l[c.lane] = c.end, a++;
    }
    const u = Array(r).fill(n + t);
    for (; s >= 0 && u.some((c) => c >= n); ) {
      const c = e[s];
      u[c.lane] = c.start, s--;
    }
    s = Math.max(0, s - s % r), a = Math.min(o, a + (r - 1 - a % r));
  }
  return { startIndex: s, endIndex: a };
}
const uf = typeof document < "u" ? m.useLayoutEffect : m.useEffect;
function RP(e) {
  const t = m.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var s;
      i ? Ec(t) : t(), (s = e.onChange) == null || s.call(e, o, i);
    }
  }, [r] = m.useState(
    () => new kP(n)
  );
  return r.setOptions(n), uf(() => r._didMount(), []), uf(() => r._willUpdate()), r;
}
function MP(e) {
  return RP({
    observeElementRect: TP,
    observeElementOffset: PP,
    scrollToFn: DP,
    ...e
  });
}
function AP({
  column: e,
  columns: t,
  id: n,
  children: r,
  state: o,
  hooks: i,
  aditionalClasses: s,
  topPosition: a,
  leftSection: l,
  rightSection: u,
  infoRow: c,
  showInfoRow: d,
  cfg: h,
  disableResize: p,
  hasActiveFilter: y
}) {
  const g = (x) => {
    if (p)
      return;
    const C = x.target.parentElement.getBoundingClientRect().x;
    x.preventDefault();
    const S = (P) => {
      const E = P.x - C + 6;
      i.changeColumnSize({ key: e.key, width: E });
    }, T = () => {
      document.removeEventListener("mouseup", T), document.removeEventListener("mousemove", S);
    };
    document.addEventListener("mouseup", T), document.addEventListener("mousemove", S);
  }, v = !!e.isLocked, b = {
    position: "sticky",
    top: `${a}px`,
    zIndex: 20
  };
  return v && (b.left = `${h.stickyOffsets[e.key]}px`, b.zIndex = 30), /* @__PURE__ */ f("th", { className: "relative", style: b, "attr-column-key": e.key, children: /* @__PURE__ */ L("div", { className: We(s, y && "!bg-blue-100 dark:!bg-blue-900"), children: [
    /* @__PURE__ */ L("div", { className: "flex flex-col grow", children: [
      /* @__PURE__ */ f("div", { className: "flex grow", children: /* @__PURE__ */ L("div", { className: "overlay flex flex-row grow px-2 py-1 w-0 items-center justify-center", children: [
        l && /* @__PURE__ */ f("div", { children: l }),
        /* @__PURE__ */ f(
          lg,
          {
            text: e.name,
            className: "overflow-hidden text-ellipsis whitespace-nowrap text-xs font-medium min-w-0"
          }
        ),
        u && /* @__PURE__ */ f("div", { children: u }),
        /* @__PURE__ */ f("div", { className: "th-controls", children: r })
      ] }) }),
      d && /* @__PURE__ */ f(
        "div",
        {
          className: We(
            "bg-neutral-container border-y border-table-borders-header",
            " px-1 h-5 flex items-center whitespace-nowrap bg-table-bg-fixed font-bold text-neutral-text-secondary",
            e.dataType === "number" && "is-numeric"
          ),
          children: /* @__PURE__ */ f(fr, { column: e, record: {}, state: {}, value: c })
        }
      )
    ] }),
    !p && /* @__PURE__ */ f("div", { className: "hover-handle", onMouseDown: (x) => g(x) })
  ] }) }, `${n}-column`);
}
function bl(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Os(e) {
  const t = e + "CollectionProvider", [n, r] = Bt(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: b } = g, x = Y.useRef(null), w = Y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(o, { scope: v, itemMap: w, collectionRef: x, children: b });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", l = /* @__PURE__ */ Nn(a), u = Y.forwardRef(
    (g, v) => {
      const { scope: b, children: x } = g, w = i(a, b), C = ye(v, w.collectionRef);
      return /* @__PURE__ */ f(l, { ref: C, children: x });
    }
  );
  u.displayName = a;
  const c = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ Nn(c), p = Y.forwardRef(
    (g, v) => {
      const { scope: b, children: x, ...w } = g, C = Y.useRef(null), S = ye(v, C), T = i(c, b);
      return Y.useEffect(() => (T.itemMap.set(C, { ref: C, ...w }), () => void T.itemMap.delete(C))), /* @__PURE__ */ f(h, { [d]: "", ref: S, children: x });
    }
  );
  p.displayName = c;
  function y(g) {
    const v = i(e + "CollectionConsumer", g);
    return Y.useCallback(() => {
      const x = v.collectionRef.current;
      if (!x) return [];
      const w = Array.from(x.querySelectorAll(`[${d}]`));
      return Array.from(v.itemMap.values()).sort(
        (T, P) => w.indexOf(T.ref.current) - w.indexOf(P.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: p },
    y,
    r
  ];
}
var OP = m.createContext(void 0);
function Jc(e) {
  const t = m.useContext(OP);
  return e || t || "ltr";
}
function ug(e) {
  const t = m.useRef({ value: e, previous: e });
  return m.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var IP = [" ", "Enter", "ArrowUp", "ArrowDown"], _P = [" ", "Enter"], er = "Select", [Is, _s, $P] = Os(er), [to, EV] = Bt(er, [
  $P,
  _n
]), $s = _n(), [LP, $n] = to(er), [FP, VP] = to(er), dg = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: s,
    defaultValue: a,
    onValueChange: l,
    dir: u,
    name: c,
    autoComplete: d,
    disabled: h,
    required: p,
    form: y
  } = e, g = $s(t), [v, b] = m.useState(null), [x, w] = m.useState(null), [C, S] = m.useState(!1), T = Jc(u), [P, E] = Rn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: er
  }), [D, A] = Rn({
    prop: s,
    defaultProp: a,
    onChange: l,
    caller: er
  }), R = m.useRef(null), O = v ? y || !!v.closest("form") : !0, [F, $] = m.useState(/* @__PURE__ */ new Set()), W = Array.from(F).map((V) => V.props.value).join(";");
  return /* @__PURE__ */ f(Xc, { ...g, children: /* @__PURE__ */ L(
    LP,
    {
      required: p,
      scope: t,
      trigger: v,
      onTriggerChange: b,
      valueNode: x,
      onValueNodeChange: w,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: S,
      contentId: mn(),
      value: D,
      onValueChange: A,
      open: P,
      onOpenChange: E,
      dir: T,
      triggerPointerDownPosRef: R,
      disabled: h,
      children: [
        /* @__PURE__ */ f(Is.Provider, { scope: t, children: /* @__PURE__ */ f(
          FP,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: m.useCallback((V) => {
              $((k) => new Set(k).add(V));
            }, []),
            onNativeOptionRemove: m.useCallback((V) => {
              $((k) => {
                const N = new Set(k);
                return N.delete(V), N;
              });
            }, []),
            children: n
          }
        ) }),
        O ? /* @__PURE__ */ L(
          Mg,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: c,
            autoComplete: d,
            value: D,
            onChange: (V) => A(V.target.value),
            disabled: h,
            form: y,
            children: [
              D === void 0 ? /* @__PURE__ */ f("option", { value: "" }) : null,
              Array.from(F)
            ]
          },
          W
        ) : null
      ]
    }
  ) });
};
dg.displayName = er;
var fg = "SelectTrigger", eu = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = $s(n), s = $n(fg, n), a = s.disabled || r, l = ye(t, s.onTriggerChange), u = _s(n), c = m.useRef("touch"), [d, h, p] = Og((g) => {
      const v = u().filter((w) => !w.disabled), b = v.find((w) => w.value === s.value), x = Ig(v, g, b);
      x !== void 0 && s.onValueChange(x.value);
    }), y = (g) => {
      a || (s.onOpenChange(!0), p()), g && (s.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ f(ni, { asChild: !0, ...i, children: /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": Ag(s.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: j(o.onClick, (g) => {
          g.currentTarget.focus(), c.current !== "mouse" && y(g);
        }),
        onPointerDown: j(o.onPointerDown, (g) => {
          c.current = g.pointerType;
          const v = g.target;
          v.hasPointerCapture(g.pointerId) && v.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (y(g), g.preventDefault());
        }),
        onKeyDown: j(o.onKeyDown, (g) => {
          const v = d.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && h(g.key), !(v && g.key === " ") && IP.includes(g.key) && (y(), g.preventDefault());
        })
      }
    ) });
  }
);
eu.displayName = fg;
var hg = "SelectValue", tu = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: s = "", ...a } = e, l = $n(hg, n), { onValueNodeHasChildrenChange: u } = l, c = i !== void 0, d = ye(t, l.onValueNodeChange);
    return it(() => {
      u(c);
    }, [u, c]), /* @__PURE__ */ f(
      se.span,
      {
        ...a,
        ref: d,
        style: { pointerEvents: "none" },
        children: Ag(l.value) ? /* @__PURE__ */ f(ke, { children: s }) : i
      }
    );
  }
);
tu.displayName = hg;
var BP = "SelectIcon", mg = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ f(se.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
mg.displayName = BP;
var WP = "SelectPortal", pg = (e) => /* @__PURE__ */ f(Zr, { asChild: !0, ...e });
pg.displayName = WP;
var tr = "SelectContent", nu = m.forwardRef(
  (e, t) => {
    const n = $n(tr, e.__scopeSelect), [r, o] = m.useState();
    if (it(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Qo.createPortal(
        /* @__PURE__ */ f(gg, { scope: e.__scopeSelect, children: /* @__PURE__ */ f(Is.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ f("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ f(vg, { ...e, ref: t });
  }
);
nu.displayName = tr;
var jt = 10, [gg, Ln] = to(tr), zP = "SelectContentImpl", jP = /* @__PURE__ */ Nn("SelectContent.RemoveScroll"), vg = m.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: a,
      sideOffset: l,
      align: u,
      alignOffset: c,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: y,
      hideWhenDetached: g,
      avoidCollisions: v,
      //
      ...b
    } = e, x = $n(tr, n), [w, C] = m.useState(null), [S, T] = m.useState(null), P = ye(t, (H) => C(H)), [E, D] = m.useState(null), [A, R] = m.useState(
      null
    ), O = _s(n), [F, $] = m.useState(!1), W = m.useRef(!1);
    m.useEffect(() => {
      if (w) return ei(w);
    }, [w]), ws();
    const V = m.useCallback(
      (H) => {
        const [oe, ...he] = O().map((xe) => xe.ref.current), [ne] = he.slice(-1), be = document.activeElement;
        for (const xe of H)
          if (xe === be || (xe == null || xe.scrollIntoView({ block: "nearest" }), xe === oe && S && (S.scrollTop = 0), xe === ne && S && (S.scrollTop = S.scrollHeight), xe == null || xe.focus(), document.activeElement !== be)) return;
      },
      [O, S]
    ), k = m.useCallback(
      () => V([E, w]),
      [V, E, w]
    );
    m.useEffect(() => {
      F && k();
    }, [F, k]);
    const { onOpenChange: N, triggerPointerDownPosRef: M } = x;
    m.useEffect(() => {
      if (w) {
        let H = { x: 0, y: 0 };
        const oe = (ne) => {
          var be, xe;
          H = {
            x: Math.abs(Math.round(ne.pageX) - (((be = M.current) == null ? void 0 : be.x) ?? 0)),
            y: Math.abs(Math.round(ne.pageY) - (((xe = M.current) == null ? void 0 : xe.y) ?? 0))
          };
        }, he = (ne) => {
          H.x <= 10 && H.y <= 10 ? ne.preventDefault() : w.contains(ne.target) || N(!1), document.removeEventListener("pointermove", oe), M.current = null;
        };
        return M.current !== null && (document.addEventListener("pointermove", oe), document.addEventListener("pointerup", he, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", oe), document.removeEventListener("pointerup", he, { capture: !0 });
        };
      }
    }, [w, N, M]), m.useEffect(() => {
      const H = () => N(!1);
      return window.addEventListener("blur", H), window.addEventListener("resize", H), () => {
        window.removeEventListener("blur", H), window.removeEventListener("resize", H);
      };
    }, [N]);
    const [B, G] = Og((H) => {
      const oe = O().filter((be) => !be.disabled), he = oe.find((be) => be.ref.current === document.activeElement), ne = Ig(oe, H, he);
      ne && setTimeout(() => ne.ref.current.focus());
    }), _ = m.useCallback(
      (H, oe, he) => {
        const ne = !W.current && !he;
        (x.value !== void 0 && x.value === oe || ne) && (D(H), ne && (W.current = !0));
      },
      [x.value]
    ), U = m.useCallback(() => w == null ? void 0 : w.focus(), [w]), te = m.useCallback(
      (H, oe, he) => {
        const ne = !W.current && !he;
        (x.value !== void 0 && x.value === oe || ne) && R(H);
      },
      [x.value]
    ), X = r === "popper" ? wl : yg, Q = X === wl ? {
      side: a,
      sideOffset: l,
      align: u,
      alignOffset: c,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: y,
      hideWhenDetached: g,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ f(
      gg,
      {
        scope: n,
        content: w,
        viewport: S,
        onViewportChange: T,
        itemRefCallback: _,
        selectedItem: E,
        onItemLeave: U,
        itemTextRefCallback: te,
        focusSelectedItem: k,
        selectedItemText: A,
        position: r,
        isPositioned: F,
        searchRef: B,
        children: /* @__PURE__ */ f(Jo, { as: jP, allowPinchZoom: !0, children: /* @__PURE__ */ f(
          Zo,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (H) => {
              H.preventDefault();
            },
            onUnmountAutoFocus: j(o, (H) => {
              var oe;
              (oe = x.trigger) == null || oe.focus({ preventScroll: !0 }), H.preventDefault();
            }),
            children: /* @__PURE__ */ f(
              dr,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (H) => H.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ f(
                  X,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (H) => H.preventDefault(),
                    ...b,
                    ...Q,
                    onPlaced: () => $(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: j(b.onKeyDown, (H) => {
                      const oe = H.ctrlKey || H.altKey || H.metaKey;
                      if (H.key === "Tab" && H.preventDefault(), !oe && H.key.length === 1 && G(H.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(H.key)) {
                        let ne = O().filter((be) => !be.disabled).map((be) => be.ref.current);
                        if (["ArrowUp", "End"].includes(H.key) && (ne = ne.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(H.key)) {
                          const be = H.target, xe = ne.indexOf(be);
                          ne = ne.slice(xe + 1);
                        }
                        setTimeout(() => V(ne)), H.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
vg.displayName = zP;
var HP = "SelectItemAlignedPosition", yg = m.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = $n(tr, n), s = Ln(tr, n), [a, l] = m.useState(null), [u, c] = m.useState(null), d = ye(t, (P) => c(P)), h = _s(n), p = m.useRef(!1), y = m.useRef(!0), { viewport: g, selectedItem: v, selectedItemText: b, focusSelectedItem: x } = s, w = m.useCallback(() => {
    if (i.trigger && i.valueNode && a && u && g && v && b) {
      const P = i.trigger.getBoundingClientRect(), E = u.getBoundingClientRect(), D = i.valueNode.getBoundingClientRect(), A = b.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const be = A.left - E.left, xe = D.left - be, re = P.left - xe, ot = P.width + re, St = Math.max(ot, E.width), At = window.innerWidth - jt, Zt = bl(xe, [
          jt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(jt, At - St)
        ]);
        a.style.minWidth = ot + "px", a.style.left = Zt + "px";
      } else {
        const be = E.right - A.right, xe = window.innerWidth - D.right - be, re = window.innerWidth - P.right - xe, ot = P.width + re, St = Math.max(ot, E.width), At = window.innerWidth - jt, Zt = bl(xe, [
          jt,
          Math.max(jt, At - St)
        ]);
        a.style.minWidth = ot + "px", a.style.right = Zt + "px";
      }
      const R = h(), O = window.innerHeight - jt * 2, F = g.scrollHeight, $ = window.getComputedStyle(u), W = parseInt($.borderTopWidth, 10), V = parseInt($.paddingTop, 10), k = parseInt($.borderBottomWidth, 10), N = parseInt($.paddingBottom, 10), M = W + V + F + N + k, B = Math.min(v.offsetHeight * 5, M), G = window.getComputedStyle(g), _ = parseInt(G.paddingTop, 10), U = parseInt(G.paddingBottom, 10), te = P.top + P.height / 2 - jt, X = O - te, Q = v.offsetHeight / 2, H = v.offsetTop + Q, oe = W + V + H, he = M - oe;
      if (oe <= te) {
        const be = R.length > 0 && v === R[R.length - 1].ref.current;
        a.style.bottom = "0px";
        const xe = u.clientHeight - g.offsetTop - g.offsetHeight, re = Math.max(
          X,
          Q + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (be ? U : 0) + xe + k
        ), ot = oe + re;
        a.style.height = ot + "px";
      } else {
        const be = R.length > 0 && v === R[0].ref.current;
        a.style.top = "0px";
        const re = Math.max(
          te,
          W + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (be ? _ : 0) + Q
        ) + he;
        a.style.height = re + "px", g.scrollTop = oe - te + g.offsetTop;
      }
      a.style.margin = `${jt}px 0`, a.style.minHeight = B + "px", a.style.maxHeight = O + "px", r == null || r(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    a,
    u,
    g,
    v,
    b,
    i.dir,
    r
  ]);
  it(() => w(), [w]);
  const [C, S] = m.useState();
  it(() => {
    u && S(window.getComputedStyle(u).zIndex);
  }, [u]);
  const T = m.useCallback(
    (P) => {
      P && y.current === !0 && (w(), x == null || x(), y.current = !1);
    },
    [w, x]
  );
  return /* @__PURE__ */ f(
    YP,
    {
      scope: n,
      contentWrapper: a,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: T,
      children: /* @__PURE__ */ f(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ f(
            se.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
yg.displayName = HP;
var UP = "SelectPopperPosition", wl = m.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = jt,
    ...i
  } = e, s = $s(n);
  return /* @__PURE__ */ f(
    Es,
    {
      ...s,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
wl.displayName = UP;
var [YP, ru] = to(tr, {}), xl = "SelectViewport", bg = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = Ln(xl, n), s = ru(xl, n), a = ye(t, i.onViewportChange), l = m.useRef(0);
    return /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ f(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ f(Is.Slot, { scope: n, children: /* @__PURE__ */ f(
        se.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: j(o.onScroll, (u) => {
            const c = u.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: h } = s;
            if (h != null && h.current && d) {
              const p = Math.abs(l.current - c.scrollTop);
              if (p > 0) {
                const y = window.innerHeight - jt * 2, g = parseFloat(d.style.minHeight), v = parseFloat(d.style.height), b = Math.max(g, v);
                if (b < y) {
                  const x = b + p, w = Math.min(y, x), C = x - w;
                  d.style.height = w + "px", d.style.bottom === "0px" && (c.scrollTop = C > 0 ? C : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = c.scrollTop;
          })
        }
      ) })
    ] });
  }
);
bg.displayName = xl;
var wg = "SelectGroup", [GP, KP] = to(wg), xg = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = mn();
    return /* @__PURE__ */ f(GP, { scope: n, id: o, children: /* @__PURE__ */ f(se.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
xg.displayName = wg;
var Cg = "SelectLabel", Sg = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = KP(Cg, n);
    return /* @__PURE__ */ f(se.div, { id: o.id, ...r, ref: t });
  }
);
Sg.displayName = Cg;
var ns = "SelectItem", [XP, Tg] = to(ns), ou = m.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...s
    } = e, a = $n(ns, n), l = Ln(ns, n), u = a.value === r, [c, d] = m.useState(i ?? ""), [h, p] = m.useState(!1), y = ye(
      t,
      (x) => {
        var w;
        return (w = l.itemRefCallback) == null ? void 0 : w.call(l, x, r, o);
      }
    ), g = mn(), v = m.useRef("touch"), b = () => {
      o || (a.onValueChange(r), a.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ f(
      XP,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: g,
        isSelected: u,
        onItemTextChange: m.useCallback((x) => {
          d((w) => w || ((x == null ? void 0 : x.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ f(
          Is.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: c,
            children: /* @__PURE__ */ f(
              se.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": u && h,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: y,
                onFocus: j(s.onFocus, () => p(!0)),
                onBlur: j(s.onBlur, () => p(!1)),
                onClick: j(s.onClick, () => {
                  v.current !== "mouse" && b();
                }),
                onPointerUp: j(s.onPointerUp, () => {
                  v.current === "mouse" && b();
                }),
                onPointerDown: j(s.onPointerDown, (x) => {
                  v.current = x.pointerType;
                }),
                onPointerMove: j(s.onPointerMove, (x) => {
                  var w;
                  v.current = x.pointerType, o ? (w = l.onItemLeave) == null || w.call(l) : v.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: j(s.onPointerLeave, (x) => {
                  var w;
                  x.currentTarget === document.activeElement && ((w = l.onItemLeave) == null || w.call(l));
                }),
                onKeyDown: j(s.onKeyDown, (x) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && x.key === " " || (_P.includes(x.key) && b(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ou.displayName = ns;
var wo = "SelectItemText", Pg = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, s = $n(wo, n), a = Ln(wo, n), l = Tg(wo, n), u = VP(wo, n), [c, d] = m.useState(null), h = ye(
      t,
      (b) => d(b),
      l.onItemTextChange,
      (b) => {
        var x;
        return (x = a.itemTextRefCallback) == null ? void 0 : x.call(a, b, l.value, l.disabled);
      }
    ), p = c == null ? void 0 : c.textContent, y = m.useMemo(
      () => /* @__PURE__ */ f("option", { value: l.value, disabled: l.disabled, children: p }, l.value),
      [l.disabled, l.value, p]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: v } = u;
    return it(() => (g(y), () => v(y)), [g, v, y]), /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ f(se.span, { id: l.textId, ...i, ref: h }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? Qo.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
Pg.displayName = wo;
var Eg = "SelectItemIndicator", qP = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return Tg(Eg, n).isSelected ? /* @__PURE__ */ f(se.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
qP.displayName = Eg;
var Cl = "SelectScrollUpButton", Dg = m.forwardRef((e, t) => {
  const n = Ln(Cl, e.__scopeSelect), r = ru(Cl, e.__scopeSelect), [o, i] = m.useState(!1), s = ye(t, r.onScrollButtonChange);
  return it(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const u = l.scrollTop > 0;
        i(u);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ f(
    Ng,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Dg.displayName = Cl;
var Sl = "SelectScrollDownButton", kg = m.forwardRef((e, t) => {
  const n = Ln(Sl, e.__scopeSelect), r = ru(Sl, e.__scopeSelect), [o, i] = m.useState(!1), s = ye(t, r.onScrollButtonChange);
  return it(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const u = l.scrollHeight - l.clientHeight, c = Math.ceil(l.scrollTop) < u;
        i(c);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ f(
    Ng,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
kg.displayName = Sl;
var Ng = m.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = Ln("SelectScrollButton", n), s = m.useRef(null), a = _s(n), l = m.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return m.useEffect(() => () => l(), [l]), it(() => {
    var c;
    const u = a().find((d) => d.ref.current === document.activeElement);
    (c = u == null ? void 0 : u.ref.current) == null || c.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ f(
    se.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: j(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: j(o.onPointerMove, () => {
        var u;
        (u = i.onItemLeave) == null || u.call(i), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: j(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), QP = "SelectSeparator", Rg = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ f(se.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Rg.displayName = QP;
var Tl = "SelectArrow", ZP = m.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = $s(n), i = $n(Tl, n), s = Ln(Tl, n);
    return i.open && s.position === "popper" ? /* @__PURE__ */ f(Ds, { ...o, ...r, ref: t }) : null;
  }
);
ZP.displayName = Tl;
var JP = "SelectBubbleInput", Mg = m.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = m.useRef(null), i = ye(r, o), s = ug(t);
    return m.useEffect(() => {
      const a = o.current;
      if (!a) return;
      const l = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== t && c) {
        const d = new Event("change", { bubbles: !0 });
        c.call(a, t), a.dispatchEvent(d);
      }
    }, [s, t]), /* @__PURE__ */ f(
      se.select,
      {
        ...n,
        style: { ...Zp, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
Mg.displayName = JP;
function Ag(e) {
  return e === "" || e === void 0;
}
function Og(e) {
  const t = Je(e), n = m.useRef(""), r = m.useRef(0), o = m.useCallback(
    (s) => {
      const a = n.current + s;
      t(a), function l(u) {
        n.current = u, window.clearTimeout(r.current), u !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(a);
    },
    [t]
  ), i = m.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return m.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function Ig(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = eE(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((u) => u !== n));
  const l = s.find(
    (u) => u.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function eE(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var tE = dg, _g = eu, nE = tu, rE = mg, oE = pg, $g = nu, iE = bg, sE = xg, Lg = Sg, Fg = ou, aE = Pg, Vg = Dg, Bg = kg, Wg = Rg;
const Ls = tE, zg = sE, iu = nE, Fs = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(
  _g,
  {
    ref: r,
    className: q(
      "group input flex w-full items-center justify-between rounded-md border border-neutral-borders ring-offset-background data-[placeholder]:text-input-text-secondary focus:outline-none focus:ring-2 focus:ring-input-active focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 text-left",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ f(rE, { asChild: !0, children: /* @__PURE__ */ f(Im, { className: "h-4 w-4 text-input-active group-data-[state=open]:rotate-180 shrink-0" }) })
    ]
  }
));
Fs.displayName = _g.displayName;
const jg = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Vg,
  {
    ref: n,
    className: q("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ f(ux, { className: "h-4 w-4" })
  }
));
jg.displayName = Vg.displayName;
const Hg = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Bg,
  {
    ref: n,
    className: q("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ f(Im, { className: "h-4 w-4" })
  }
));
Hg.displayName = Bg.displayName;
const Vs = m.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ f(oE, { children: /* @__PURE__ */ L(
  $g,
  {
    ref: o,
    align: "start",
    side: "bottom",
    className: q(
      "relative z-50 max-h-96 overflow-hidden rounded-md border bg-input-bg popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ f(jg, { className: "text-input-active" }),
      /* @__PURE__ */ f(
        iE,
        {
          className: q(
            "p-0",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ f(Hg, { className: "text-input-active" })
    ]
  }
) }));
Vs.displayName = $g.displayName;
const lE = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(Lg, { ref: n, className: q("py-1.5 px-2 text-sm font-semibold", e), ...t }));
lE.displayName = Lg.displayName;
const Bs = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f(
  Fg,
  {
    ref: r,
    className: q(
      "relative flex w-full cursor-default select-none border-b items-center control text-sm outline-none focus:bg-input-hover data-[state=checked]:bg-input-active data-[state=checked]:text-input-bg data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: /* @__PURE__ */ f(aE, { children: t })
  }
));
Bs.displayName = Fg.displayName;
const cE = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(Wg, { ref: n, className: q("-mx-1 my-1 h-px bg-muted", e), ...t }));
cE.displayName = Wg.displayName;
function rs(e) {
  var i;
  const t = me(null), n = typeof e.options == "function" ? e.options(e.record.key, e.column.key, e.record) : e.options, r = e.value ? (i = n.find((s) => s.key === e.value)) == null ? void 0 : i.label : "-", o = e.column.isLocked || !1;
  return fe(() => (e.isEditing && t.current && t.current.click(), () => {
    var s;
    e.isEditing && ((s = e.stopEditing) == null || s.call(e));
  }), [e.isEditing]), e.isEditing ? /* @__PURE__ */ f("div", { className: "overflow-x-hidden text-ellipsis relative w-full flex", children: /* @__PURE__ */ L(
    Ls,
    {
      onValueChange: (s) => {
        e.onChange && e.onChange(s);
      },
      value: e.value || "",
      children: [
        /* @__PURE__ */ f(
          Fs,
          {
            ref: t,
            className: We(
              "text-xs min-h-0 h-4 w-full p-0 w-0 bg-transparent flex-1 rounded-none border-0 data-[state=open]:[&>svg]:text-red-500"
            ),
            children: /* @__PURE__ */ f(iu, { placeholder: r })
          }
        ),
        /* @__PURE__ */ f(Vs, { className: We(o && "z-[100]"), children: /* @__PURE__ */ f(zg, { children: n.map((s) => /* @__PURE__ */ f(Bs, { value: s.key, children: s.label }, s.key)) }) })
      ]
    }
  ) }) : /* @__PURE__ */ f(fr, { ...e, value: r });
}
function uE(e, t, n, r, o) {
  switch (!0) {
    case (!e && r === "error"):
      return "bg-red-200 dark:bg-red-900 !outline-red-500";
    case (!e && r === "warning"):
      return "bg-yellow-200 dark:bg-yellow-900 !outline-yellow-400";
    case (!e && r === "neutral" && !n):
      return "bg-gray-300 dark:bg-gray-800 !outline-gray-500";
    case (!e && r === "neutral" && n):
      return "bg-gray-400 dark:bg-gray-900 !outline-gray-600";
    case (!e && !t && n):
      return "bg-neutral-container";
    case (!e && !t && !n):
      return "bg-[#F2F2F2] dark:bg-[#312E2F]";
    case (!e && t):
      return "bg-violet-200 dark:bg-stone-700";
    case (e && t):
      return "bg-violet-200 dark:bg-stone-500";
    case (e && !t && n):
      return "bg-color-greys-100 dark:bg-color-greys-800";
    case (e && !t && !n):
      return "bg-table-bg-fixed";
    default:
      return "bg-table-bg-editable";
  }
}
function dE({
  rowIndex: e,
  columns: t,
  record: n,
  rowSize: r,
  state: o,
  visibleColumns: i,
  // onRowChange,
  onRowsCommit: s,
  onToggleEdit: a,
  onCellSelect: l,
  hooks: u,
  cellValidations: c,
  onDrag: d,
  editingCell: h,
  onChangeEditCellValue: p,
  selectedCells: y,
  cfg: g
}) {
  function v(S, T, P, E, D) {
    vP(o.editCellRef, E, D) || a(void 0);
    const A = S.currentTarget.getBoundingClientRect();
    d("start", A.x, A.y, A.width, A.height, {
      column: T.key,
      row: n.key,
      rowIndex: e
    });
  }
  function b(S, T, P, E, D) {
    const A = S.currentTarget.getBoundingClientRect();
    d("end", A.x, A.y, A.width, A.height, {
      column: T.key,
      row: n.key,
      rowIndex: e
    });
  }
  function x(S, T, P, E, D) {
    if (S.buttons === 1) {
      const A = S.currentTarget.getBoundingClientRect();
      d("drag", A.x, A.y, A.width, A.height, {
        column: T.key,
        row: n.key,
        rowIndex: e
      });
    }
  }
  function w(S, T, P, E, D) {
    T.readOnly || a({
      column: E,
      row: D,
      rowIndex: e,
      value: P[E]
    });
  }
  const C = (S, T) => {
    let P;
    (S.ctrlKey || S.metaKey) && (P = "ctrl"), l(
      {
        column: T,
        row: n.key,
        value: n[T],
        rowIndex: e
      },
      P
    );
  };
  return /* @__PURE__ */ f(
    "tr",
    {
      style: {
        height: `${r}px`
      },
      children: t.map((S, T) => {
        if (!g.disableColumnVirtualization) {
          if (i[T] >= 1)
            return /* @__PURE__ */ f("td", { colSpan: i[T] }, S.key);
          if (i[T] === 0)
            return;
        }
        const P = `${n.key}${S.key}`;
        if (S.groupColumn)
          return /* @__PURE__ */ f("td", { className: "td-group-path" }, P);
        const E = !!S.isLocked, D = E ? {
          position: "sticky",
          left: `${g.stickyOffsets[S.key]}px`,
          zIndex: 20
        } : {}, A = S._dfColIndex, R = (h == null ? void 0 : h.column) === S.key && (h == null ? void 0 : h.row) === n.key, O = n[S.key], F = y.some((Q) => Q.column === S.key && Q.row === n.key), $ = y.length > 0 && y.filter((Q) => Q.row === n.key).length === y.length, W = { ...S.componentProps || {} };
        W.nullable = S.nullable;
        let V = T > 0 ? !!t[T - 1].readOnly && !S.split : !1, k = !1;
        T > 0 && t[T - 1].groupColumn && (V = !0);
        const N = c[`${T - 1}-${e}`], M = c[`${T}-${e - 1}`];
        (N == null ? void 0 : N.type) === "disable" && (V = !0), (M == null ? void 0 : M.type) === "disable" && (k = !0);
        const B = c[`${T}-${e}`];
        let G = S.readOnly, _ = !1;
        B && B.type === "disable" && (G = !0, _ = !0);
        let U = S.component, te = {};
        if (S.conditionalComponent) {
          const Q = S.conditionalComponent(S.key, n);
          Q && (U = Q.component, te = Q.props);
        }
        const X = /* @__PURE__ */ f("div", { className: "flex w-full", children: /* @__PURE__ */ f(
          U,
          {
            cellRef: { column: A, row: e },
            record: n,
            column: S,
            value: R ? h.newValue : O,
            state: o,
            stopEditing: () => a(void 0),
            onChange: R ? (Q) => p == null ? void 0 : p(Q, U === rs) : void 0,
            ...W,
            ...te,
            isEditing: R
          }
        ) });
        return /* @__PURE__ */ L(
          "td",
          {
            className: We(
              "overflow-hidden text-ellipsis whitespace-nowrap ",
              S.split && "td-new-splitter bg-gradient-to-r from-neutral-container to-transparent",
              R && "is-editing",
              E ? "z-20 dark:text-white" : "relative",
              V && "!border-l-table-borders-header",
              k && "!border-t-table-borders-header",
              G ? "read-only" : "cursor-cell",
              _ && (B == null ? void 0 : B.message) && "cursor-not-allowed",
              S.dataType === "number" && "is-numeric",
              !S.split && uE(
                !!G,
                $,
                e % 2 === 0,
                B == null ? void 0 : B.type
              ),
              F && "outline outline-2 outline-blue-400 outline-offset-[-1px]",
              S.conditionalFormatter && S.conditionalFormatter(n.key, O, S.key, n, e)
            ),
            onMouseDown: (Q) => !R && v(Q, S, n, S.key, n.key),
            onMouseUp: (Q) => !R && b(Q, S, n, S.key, n.key),
            onMouseMove: (Q) => x(Q, S, n, S.key, n.key),
            onDoubleClick: (Q) => !G && w(Q, S, n, S.key, n.key),
            onClick: (Q) => {
              C(Q, S.key), !G && !R && U === rs && w(Q, S, n, S.key, n.key);
            },
            style: D,
            "data-row-key": n.key,
            "data-col-key": S.key,
            children: [
              (B == null ? void 0 : B.type) === "note" && /* @__PURE__ */ f("div", { className: "absolute left-0 top-0 w-2 h-2 text-button-secondary-bg pointer-events-none", children: /* @__PURE__ */ f("svg", { viewBox: "0 0 1 1", fill: "currentColor", children: /* @__PURE__ */ f("path", { d: "M0 0 L1 0 L0 1 Z" }) }) }),
              B != null && B.message ? /* @__PURE__ */ L(Ms, { children: [
                /* @__PURE__ */ f(As, { asChild: !0, children: X }),
                /* @__PURE__ */ f(oi, { children: /* @__PURE__ */ f("div", { className: "font-medium text-xs text-neutral-text-primary whitespace-pre-line text-left", children: B == null ? void 0 : B.message }) })
              ] }) : X
            ]
          },
          P
        );
      })
    }
  );
}
function fE(e) {
  return e.children;
}
var Ug = Symbol.for("immer-nothing"), df = Symbol.for("immer-draftable"), kt = Symbol.for("immer-state"), hE = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function bt(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = hE[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var jr = Object.getPrototypeOf;
function Hr(e) {
  return !!e && !!e[kt];
}
function nr(e) {
  var t;
  return e ? Yg(e) || Array.isArray(e) || !!e[df] || !!((t = e.constructor) != null && t[df]) || zs(e) || js(e) : !1;
}
var mE = Object.prototype.constructor.toString();
function Yg(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = jr(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === mE;
}
function os(e, t) {
  Ws(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function Ws(e) {
  const t = e[kt];
  return t ? t.type_ : Array.isArray(e) ? 1 : zs(e) ? 2 : js(e) ? 3 : 0;
}
function Pl(e, t) {
  return Ws(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Gg(e, t, n) {
  const r = Ws(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function pE(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function zs(e) {
  return e instanceof Map;
}
function js(e) {
  return e instanceof Set;
}
function Wn(e) {
  return e.copy_ || e.base_;
}
function El(e, t) {
  if (zs(e))
    return new Map(e);
  if (js(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = Yg(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[kt];
    let o = Reflect.ownKeys(r);
    for (let i = 0; i < o.length; i++) {
      const s = o[i], a = r[s];
      a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (r[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: a.enumerable,
        value: e[s]
      });
    }
    return Object.create(jr(e), r);
  } else {
    const r = jr(e);
    if (r !== null && n)
      return { ...e };
    const o = Object.create(r);
    return Object.assign(o, e);
  }
}
function su(e, t = !1) {
  return Hs(e) || Hr(e) || !nr(e) || (Ws(e) > 1 && (e.set = e.add = e.clear = e.delete = gE), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => su(r, !0))), e;
}
function gE() {
  bt(2);
}
function Hs(e) {
  return Object.isFrozen(e);
}
var vE = {};
function rr(e) {
  const t = vE[e];
  return t || bt(0, e), t;
}
var Lo;
function Kg() {
  return Lo;
}
function yE(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function ff(e, t) {
  t && (rr("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Dl(e) {
  kl(e), e.drafts_.forEach(bE), e.drafts_ = null;
}
function kl(e) {
  e === Lo && (Lo = e.parent_);
}
function hf(e) {
  return Lo = yE(Lo, e);
}
function bE(e) {
  const t = e[kt];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function mf(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[kt].modified_ && (Dl(t), bt(4)), nr(e) && (e = is(t, e), t.parent_ || ss(t, e)), t.patches_ && rr("Patches").generateReplacementPatches_(
    n[kt].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = is(t, n, []), Dl(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Ug ? e : void 0;
}
function is(e, t, n) {
  if (Hs(t))
    return t;
  const r = t[kt];
  if (!r)
    return os(
      t,
      (o, i) => pf(e, r, t, o, i, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return ss(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const o = r.copy_;
    let i = o, s = !1;
    r.type_ === 3 && (i = new Set(o), o.clear(), s = !0), os(
      i,
      (a, l) => pf(e, r, o, a, l, n, s)
    ), ss(e, o, !1), n && e.patches_ && rr("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function pf(e, t, n, r, o, i, s) {
  if (process.env.NODE_ENV !== "production" && o === n && bt(5), Hr(o)) {
    const a = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Pl(t.assigned_, r) ? i.concat(r) : void 0, l = is(e, o, a);
    if (Gg(n, r, l), Hr(l))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else s && n.add(o);
  if (nr(o) && !Hs(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    is(e, o), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && ss(e, o);
  }
}
function ss(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && su(t, n);
}
function wE(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Kg(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = au;
  n && (o = [r], i = Fo);
  const { revoke: s, proxy: a } = Proxy.revocable(o, i);
  return r.draft_ = a, r.revoke_ = s, a;
}
var au = {
  get(e, t) {
    if (t === kt)
      return e;
    const n = Wn(e);
    if (!Pl(n, t))
      return xE(e, n, t);
    const r = n[t];
    return e.finalized_ || !nr(r) ? r : r === Ca(e.base_, t) ? (Sa(e), e.copy_[t] = Rl(r, e)) : r;
  },
  has(e, t) {
    return t in Wn(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Wn(e));
  },
  set(e, t, n) {
    const r = Xg(Wn(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = Ca(Wn(e), t), i = o == null ? void 0 : o[kt];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (pE(n, o) && (n !== void 0 || Pl(e.base_, t)))
        return !0;
      Sa(e), Nl(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ca(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Sa(e), Nl(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = Wn(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    bt(11);
  },
  getPrototypeOf(e) {
    return jr(e.base_);
  },
  setPrototypeOf() {
    bt(12);
  }
}, Fo = {};
os(au, (e, t) => {
  Fo[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Fo.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && bt(13), Fo.set.call(this, e, t, void 0);
};
Fo.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && bt(14), au.set.call(this, e[0], t, n, e[0]);
};
function Ca(e, t) {
  const n = e[kt];
  return (n ? Wn(n) : e)[t];
}
function xE(e, t, n) {
  var o;
  const r = Xg(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function Xg(e, t) {
  if (!(t in e))
    return;
  let n = jr(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = jr(n);
  }
}
function Nl(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Nl(e.parent_));
}
function Sa(e) {
  e.copy_ || (e.copy_ = El(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var CE = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const s = this;
        return function(l = i, ...u) {
          return s.produce(l, (c) => n.call(this, c, ...u));
        };
      }
      typeof n != "function" && bt(6), r !== void 0 && typeof r != "function" && bt(7);
      let o;
      if (nr(t)) {
        const i = hf(this), s = Rl(t, void 0);
        let a = !0;
        try {
          o = n(s), a = !1;
        } finally {
          a ? Dl(i) : kl(i);
        }
        return ff(i, r), mf(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === Ug && (o = void 0), this.autoFreeze_ && su(o, !0), r) {
          const i = [], s = [];
          rr("Patches").generateReplacementPatches_(t, o, i, s), r(i, s);
        }
        return o;
      } else
        bt(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...a) => this.produceWithPatches(s, (l) => t(l, ...a));
      let r, o;
      return [this.produce(t, n, (s, a) => {
        r = s, o = a;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    nr(e) || bt(8), Hr(e) && (e = SE(e));
    const t = hf(this), n = Rl(e, void 0);
    return n[kt].isManual_ = !0, kl(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[kt];
    (!n || !n.isManual_) && bt(9);
    const { scope_: r } = n;
    return ff(r, t), mf(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = rr("Patches").applyPatches_;
    return Hr(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function Rl(e, t) {
  const n = zs(e) ? rr("MapSet").proxyMap_(e, t) : js(e) ? rr("MapSet").proxySet_(e, t) : wE(e, t);
  return (t ? t.scope_ : Kg()).drafts_.push(n), n;
}
function SE(e) {
  return Hr(e) || bt(10, e), qg(e);
}
function qg(e) {
  if (!nr(e) || Hs(e))
    return e;
  const t = e[kt];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = El(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = El(e, !0);
  return os(n, (r, o) => {
    Gg(n, r, qg(o));
  }), t && (t.finalized_ = !1), n;
}
var Nt = new CE(), Et = Nt.produce;
Nt.produceWithPatches.bind(
  Nt
);
Nt.setAutoFreeze.bind(Nt);
Nt.setUseStrictShallowCopy.bind(Nt);
Nt.applyPatches.bind(Nt);
Nt.createDraft.bind(Nt);
Nt.finishDraft.bind(Nt);
var gf = function() {
}, Qg = typeof window < "u";
function TE(e, t) {
  var n = me(!1), r = me(), o = me(e), i = Ie(function() {
    return n.current;
  }, []), s = Ie(function() {
    n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
      n.current = !0, o.current();
    }, t);
  }, [t]), a = Ie(function() {
    n.current = null, r.current && clearTimeout(r.current);
  }, []);
  return fe(function() {
    o.current = e;
  }, [e]), fe(function() {
    return s(), a;
  }, [t]), [i, a, s];
}
function PE(e, t, n) {
  n === void 0 && (n = []);
  var r = TE(e, t), o = r[0], i = r[1], s = r[2];
  return fe(s, n), [o, i];
}
var vf = function(e, t, n) {
  if (!Qg)
    return [t, gf, gf];
  if (!e)
    throw new Error("useLocalStorage key may not be falsy");
  var r = JSON.parse, o = me(function(c) {
    try {
      var d = n ? n.raw ? String : n.serializer : JSON.stringify, h = localStorage.getItem(c);
      return h !== null ? r(h) : (t && localStorage.setItem(c, d(t)), t);
    } catch {
      return t;
    }
  }), i = de(function() {
    return o.current(e);
  }), s = i[0], a = i[1];
  cr(function() {
    return a(o.current(e));
  }, [e]);
  var l = Ie(function(c) {
    try {
      var d = typeof c == "function" ? c(s) : c;
      if (typeof d > "u")
        return;
      var h = void 0;
      n || (h = JSON.stringify(d)), localStorage.setItem(e, h), a(r(h));
    } catch {
    }
  }, [e, a]), u = Ie(function() {
    try {
      localStorage.removeItem(e), a(void 0);
    } catch {
    }
  }, [e, a]);
  return [s, l, u];
}, lu = function(e, t, n) {
  if (!Qg)
    return [t, function() {
    }];
  var r = de(function() {
    try {
      var s = sessionStorage.getItem(e);
      return typeof s != "string" ? (sessionStorage.setItem(e, n ? String(t) : JSON.stringify(t)), t) : n ? s : JSON.parse(s || "null");
    } catch {
      return t;
    }
  }), o = r[0], i = r[1];
  return fe(function() {
    try {
      var s = n ? String(o) : JSON.stringify(o);
      sessionStorage.setItem(e, s);
    } catch {
    }
  }), [o, i];
};
const EE = 70, DE = 1;
var kE = /* @__PURE__ */ ((e) => (e.Move = "move", e.Escape = "escape", e.Enter = "enter", e))(kE || {});
function DV(e = {}) {
  const [t, n] = de(e);
  function r(o, i) {
    n(
      Et((s) => {
        s[o.name] = i;
      })
    );
  }
  return [t, r];
}
const NE = (e, t) => {
  var r;
  const n = [];
  for (const o of e)
    if ((r = o.group) != null && r.length)
      for (let i = 1; i <= o.group.length; i++) {
        const s = o.group.slice(0, i);
        t && s[s.length - 1].uncollapsable || s[s.length - 1].label && n.push(s);
      }
  return n;
}, yf = (e, t) => {
  const n = {}, r = NE(e, t);
  for (const o of r) {
    const i = o.map((s) => s.key).join("_");
    n[i] = !1;
  }
  return n;
}, Zg = (e, t) => {
  var o;
  if (!((o = e.group) != null && o.length)) return;
  const n = [...e.group], r = [n.shift()];
  for (; r.length <= e.group.length; ) {
    const i = r.map((s) => s.key).join("_");
    if (t.groupCollapsedStatus[i])
      return r;
    r.push(n.shift());
  }
}, RE = (e, t) => !e || !t || e.length !== t.length ? !1 : e.every((n, r) => n.key === t[r].key), ME = (e, t, n) => {
  for (const r of t)
    if (r.group && r.group.length > e.length && e.every((o, i) => o.key === r.group[i].key)) {
      const o = r.group.slice(0, e.length + 1).map((i) => i.key).join("_");
      if (!n.groupCollapsedStatus[o])
        return !1;
    }
  return !0;
}, Jg = (e, t, n) => {
  var i;
  const r = ((i = e == null ? void 0 : e.name) == null ? void 0 : i.split(/[\s_]/).sort((s, a) => a.length - s.length)[0].length) || 0;
  let o = Math.max(12 + r * 12, t);
  return e.filterable && (o += 28), e.sortable && (o += 24), n !== void 0 && (o = Math.min(o, n)), o;
}, AE = (e, t, n) => {
  const r = {};
  return e.forEach((o, i) => {
    if (!("split" in o)) {
      const s = n ? `column-${i}` : o.key;
      r[s] = Jg(o, o.minWidth || t, o.maxWidth);
    }
  }), r;
};
function kV(e, t, n) {
  const r = {
    minColumnWidth: (n == null ? void 0 : n.minColumnWidth) || EE,
    usePositionalColumnSizing: (n == null ? void 0 : n.usePositionalColumnSizing) || !1,
    disableColumnVirtualization: (n == null ? void 0 : n.disableColumnVirtualization) || !1
  }, [o, i] = vf(
    `${e}-column-position-v2`,
    {}
  ), [s, a] = vf(`${e}-group-status`, {}), [l, u] = de({
    tableKey: e,
    columnPositions: o && Object.keys(o).length ? o : AE(t, r.minColumnWidth, r.usePositionalColumnSizing),
    // columnStickyOffset: {},
    editCellRef: null,
    lockedColumns: [],
    groupCollapsedStatus: s ?? yf(t)
  });
  fe(() => {
    const C = t.reduce(
      (S, T) => {
        const P = t.findIndex((D) => D.key === T.key), E = r.usePositionalColumnSizing ? `column-${P}` : T.key;
        return o && E in o ? S[E] = o[E] : S[E] = Jg(T, T.minWidth || r.minColumnWidth, T.maxWidth), S;
      },
      {}
    );
    u({
      ...l,
      columnPositions: C
    });
  }, [t]);
  function c(C) {
    u((S) => {
      var D;
      const T = (D = t.find((A) => A.key === C.key)) == null ? void 0 : D.minWidth, P = r.usePositionalColumnSizing ? `column-${t.findIndex((A) => A.key === C.key)}` : C.key, E = {
        ...S.columnPositions,
        [P]: Math.max(C.width, T || r.minColumnWidth)
      };
      return i(E), {
        ...S,
        columnPositions: E
      };
    });
  }
  function d(C, S) {
    let T = null;
    C !== null && S !== null && (T = { column: C, row: S }), u({
      ...l,
      editCellRef: T
    });
  }
  function h(C) {
    u(
      Et(l, (S) => {
        C.forEach((T) => !S.lockedColumns.includes(T) && S.lockedColumns.push(T));
      })
    );
  }
  function p(C) {
    u(
      Et(l, (S) => {
        S.lockedColumns = S.lockedColumns.filter((T) => !C.includes(T));
      })
    );
  }
  function y(C, S) {
    const T = C.map((D) => D.key).join("_"), P = S ?? (l.groupCollapsedStatus[T] || !1), E = {
      ...l,
      groupCollapsedStatus: {
        ...l.groupCollapsedStatus,
        [T]: !P
      }
    };
    u(E), a(E.groupCollapsedStatus);
  }
  const g = ve(() => {
    let C = 0;
    const S = {};
    return t.forEach((T, P) => {
      const E = !!Zg(T, l);
      if ((l.lockedColumns.includes(T.key) || T.isLocked) && !E) {
        const D = r.usePositionalColumnSizing ? `column-${P}` : T.key;
        S[T.key] = C, "split" in T ? C += 12 : C += Math.max(T.minWidth || r.minColumnWidth, l.columnPositions[D]);
      }
    }), S;
  }, [l.lockedColumns, l.columnPositions]), v = (C) => {
    const S = yf(t, !0);
    Object.entries(S).forEach(([T]) => {
      S[T] = C;
    }), u({
      ...l,
      groupCollapsedStatus: S
    }), a(S);
  };
  function b() {
    return {
      ...r,
      stickyOffsets: g
    };
  }
  function x(C) {
    var T;
    const S = [];
    for (let P = 0; P < C.size; P++) {
      const E = C.object(P);
      for (const D of t) {
        if (!D.validate) continue;
        const A = Array.isArray(D.validate) ? (T = D.validate.map((R) => R(E[D.key], E))) == null ? void 0 : T.find((R) => R) : D.validate(E[D.key], E);
        A && S.push(A);
      }
    }
    return S.length ? S : void 0;
  }
  return [l, {
    validate: x,
    getDatatableConfig: b,
    expandAllGroups: () => v(!1),
    contractAllGroups: () => v(!0),
    onMouseDown: () => {
    },
    // noop
    onToggleEdit: d,
    changeColumnSize: c,
    lockColumns: h,
    unlockColumns: p,
    // showColumns,
    // hideColumns,
    // reorderColumns,
    _setStateToBeRemoved: u,
    // changeColumnsStickyOffset,
    // hideGroups,
    // showGroups,
    toggleGroupCollapse: y
  }];
}
function OE({
  group: e,
  hooks: t,
  hidding: n = !0
}) {
  return /* @__PURE__ */ f(
    Pe,
    {
      variant: "ghost",
      size: "sm",
      className: "icon text-button-secondary-bg hover:bg-transparent align-middle shrink-0",
      onClick: () => t.toggleGroupCollapse(e),
      children: n ? /* @__PURE__ */ f(dx, {}) : /* @__PURE__ */ f(fx, {})
    }
  );
}
var Us = "Popover", [ev, NV] = Bt(Us, [
  _n
]), ii = _n(), [IE, Fn] = ev(Us), tv = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, a = ii(t), l = m.useRef(null), [u, c] = m.useState(!1), [d, h] = Rn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Us
  });
  return /* @__PURE__ */ f(Xc, { ...a, children: /* @__PURE__ */ f(
    IE,
    {
      scope: t,
      contentId: mn(),
      triggerRef: l,
      open: d,
      onOpenChange: h,
      onOpenToggle: m.useCallback(() => h((p) => !p), [h]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: m.useCallback(() => c(!0), []),
      onCustomAnchorRemove: m.useCallback(() => c(!1), []),
      modal: s,
      children: n
    }
  ) });
};
tv.displayName = Us;
var nv = "PopoverAnchor", no = m.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Fn(nv, n), i = ii(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = o;
    return m.useEffect(() => (s(), () => a()), [s, a]), /* @__PURE__ */ f(ni, { ...i, ...r, ref: t });
  }
);
no.displayName = nv;
var rv = "PopoverTrigger", ov = m.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Fn(rv, n), i = ii(n), s = ye(t, o.triggerRef), a = /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": cv(o.open),
        ...r,
        ref: s,
        onClick: j(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? a : /* @__PURE__ */ f(ni, { asChild: !0, ...i, children: a });
  }
);
ov.displayName = rv;
var cu = "PopoverPortal", [_E, $E] = ev(cu, {
  forceMount: void 0
}), iv = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = Fn(cu, t);
  return /* @__PURE__ */ f(_E, { scope: t, forceMount: n, children: /* @__PURE__ */ f(ct, { present: n || i.open, children: /* @__PURE__ */ f(Zr, { asChild: !0, container: o, children: r }) }) });
};
iv.displayName = cu;
var Ur = "PopoverContent", sv = m.forwardRef(
  (e, t) => {
    const n = $E(Ur, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = Fn(Ur, e.__scopePopover);
    return /* @__PURE__ */ f(ct, { present: r || i.open, children: i.modal ? /* @__PURE__ */ f(FE, { ...o, ref: t }) : /* @__PURE__ */ f(VE, { ...o, ref: t }) });
  }
);
sv.displayName = Ur;
var LE = /* @__PURE__ */ Nn("PopoverContent.RemoveScroll"), FE = m.forwardRef(
  (e, t) => {
    const n = Fn(Ur, e.__scopePopover), r = m.useRef(null), o = ye(t, r), i = m.useRef(!1);
    return m.useEffect(() => {
      const s = r.current;
      if (s) return ei(s);
    }, []), /* @__PURE__ */ f(Jo, { as: LE, allowPinchZoom: !0, children: /* @__PURE__ */ f(
      av,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: j(e.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), i.current || (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: j(
          e.onPointerDownOutside,
          (s) => {
            const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, u = a.button === 2 || l;
            i.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: j(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), VE = m.forwardRef(
  (e, t) => {
    const n = Fn(Ur, e.__scopePopover), r = m.useRef(!1), o = m.useRef(!1);
    return /* @__PURE__ */ f(
      av,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), av = m.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      onFocusOutside: u,
      onInteractOutside: c,
      ...d
    } = e, h = Fn(Ur, n), p = ii(n);
    return ws(), /* @__PURE__ */ f(
      Zo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ f(
          dr,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: c,
            onEscapeKeyDown: a,
            onPointerDownOutside: l,
            onFocusOutside: u,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ f(
              Es,
              {
                "data-state": cv(h.open),
                role: "dialog",
                id: h.contentId,
                ...p,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), lv = "PopoverClose", BE = m.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Fn(lv, n);
    return /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: j(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
BE.displayName = lv;
var WE = "PopoverArrow", zE = m.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ii(n);
    return /* @__PURE__ */ f(Ds, { ...o, ...r, ref: t });
  }
);
zE.displayName = WE;
function cv(e) {
  return e ? "open" : "closed";
}
var jE = tv, HE = ov, UE = iv, uv = sv;
const or = jE, ro = HE, hr = m.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, renderOnBody: r = !0, ...o }, i) => {
  const s = r ? UE : m.Fragment;
  return /* @__PURE__ */ f(s, { children: /* @__PURE__ */ f(
    uv,
    {
      ref: i,
      align: t,
      sideOffset: n,
      className: q(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...o
    }
  ) });
});
hr.displayName = uv.displayName;
const YE = ur(
  "flex w-full rounded-md border-neutral-borders text-base ring-offset-background file:border-0 file:bg-transparent file:text-base font-normal placeholder:text-input-text-secondary text-input-text focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-[errormessage]:border-red-500 aria-[errormessage]:ring-red-500",
  {
    variants: {
      variant: {
        default: "input-md",
        sm: "input-sm"
      },
      borderless: {
        true: "border-0",
        false: "border"
      }
    },
    defaultVariants: {
      variant: "default",
      borderless: !1
    }
  }
), si = m.forwardRef(
  ({ className: e, variant: t, borderless: n, type: r, ...o }, i) => /* @__PURE__ */ f("input", { type: r, className: q(YE({ variant: t, borderless: n, className: e })), ref: i, ...o })
);
si.displayName = "Input";
var GE = "Label", dv = m.forwardRef((e, t) => /* @__PURE__ */ f(
  se.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
dv.displayName = GE;
var fv = dv;
const KE = ur("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), hv = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(fv, { ref: n, className: q(KE(), e), ...t }));
hv.displayName = fv.displayName;
const Ft = ({
  label: e,
  children: t,
  error: n,
  disabled: r,
  className: o,
  hideOverflow: i = !0
}) => /* @__PURE__ */ L("div", { className: o, children: [
  /* @__PURE__ */ L(
    "fieldset",
    {
      "aria-errormessage": n,
      "aria-disabled": r,
      className: q(
        i && "overflow-hidden",
        "labeled-container relative bg-input-bg rounded-md border border-neutral-borders ring-offset-background focus-within:outline-none  aria-[errormessage]:border-red-500 focus-within:ring-offset-2 aria-[disabled]:cursor-not-allowed aria-[disabled]:border-neutral-borders/50 aria-[errormessage]:aria-[disabled]:border-red-500/50 focus-within:!border-input-active"
      ),
      children: [
        e && /* @__PURE__ */ f(
          "legend",
          {
            "aria-errormessage": n,
            "aria-disabled": r,
            className: "relative z-10 px-0.5 ml-2 h-0 text-xs text-neutral-text-secondary aria-disabled:text-neutral-text-secondary/50 aria-[errormessage]:text-red-500 aria-[errormessage]:aria-disabled:text-red-500/50",
            children: /* @__PURE__ */ f("span", { className: "block -mt-2", children: e })
          }
        ),
        t
      ]
    }
  ),
  n && /* @__PURE__ */ f(
    hv,
    {
      "aria-errormessage": n,
      "aria-disabled": r,
      className: "block z-10 text-xs text-red-500 aria-disabled:text-red-500/50",
      children: n
    }
  )
] }), XE = ({ content: e, children: t, tooltipContentProps: n, hide: r = !1 }) => r ? t : /* @__PURE__ */ f(Zc, { children: /* @__PURE__ */ L(Ms, { children: [
  /* @__PURE__ */ f(As, { asChild: !0, children: t }),
  /* @__PURE__ */ f(oi, { ...n, children: e })
] }) }), uu = ({ className: e, ...t }) => {
  var s;
  const n = { ...t };
  delete n.endIcon, delete n.starticon;
  const [r, o] = de(
    Number(t.maxLength) - ((s = t.value) == null ? void 0 : s.length)
  ), i = (a) => {
    console.log("handleOnChange");
    const l = a.target.value;
    t.maxLength && o(t.maxLength - l.length), t.onKeyUp && t.onKeyUp(a);
  };
  return /* @__PURE__ */ f(
    Ft,
    {
      label: t.label,
      error: t.error,
      disabled: t.disabled,
      className: q("-m-px", e),
      children: /* @__PURE__ */ L("div", { className: "flex items-center", children: [
        t.starticon && /* @__PURE__ */ f("div", { className: "pl-3", children: t.starticon }),
        /* @__PURE__ */ f(si, { onKeyUp: i, type: "text", ...n, className: "w-full", borderless: !0 }),
        t.maxLength && /* @__PURE__ */ f(XE, { content: "Remaining Characters", children: /* @__PURE__ */ f("div", { className: q("pr-3 text-sm", r < 0 && "text-red-500"), children: r }) }),
        t.endIcon && /* @__PURE__ */ f("div", { className: "pr-3", children: t.endIcon })
      ] })
    }
  );
};
var Ys = "Checkbox", [qE, RV] = Bt(Ys), [QE, ZE] = qE(Ys), mv = m.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: a,
      value: l = "on",
      onCheckedChange: u,
      form: c,
      ...d
    } = e, [h, p] = m.useState(null), y = ye(t, (C) => p(C)), g = m.useRef(!1), v = h ? c || !!h.closest("form") : !0, [b, x] = Rn({
      prop: o,
      defaultProp: i ?? !1,
      onChange: u,
      caller: Ys
    }), w = m.useRef(b);
    return m.useEffect(() => {
      const C = h == null ? void 0 : h.form;
      if (C) {
        const S = () => x(w.current);
        return C.addEventListener("reset", S), () => C.removeEventListener("reset", S);
      }
    }, [h, x]), /* @__PURE__ */ L(QE, { scope: n, state: b, disabled: a, children: [
      /* @__PURE__ */ f(
        se.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": kn(b) ? "mixed" : b,
          "aria-required": s,
          "data-state": yv(b),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: l,
          ...d,
          ref: y,
          onKeyDown: j(e.onKeyDown, (C) => {
            C.key === "Enter" && C.preventDefault();
          }),
          onClick: j(e.onClick, (C) => {
            x((S) => kn(S) ? !0 : !S), v && (g.current = C.isPropagationStopped(), g.current || C.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ f(
        vv,
        {
          control: h,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: b,
          required: s,
          disabled: a,
          form: c,
          style: { transform: "translateX(-100%)" },
          defaultChecked: kn(i) ? !1 : i
        }
      )
    ] });
  }
);
mv.displayName = Ys;
var pv = "CheckboxIndicator", gv = m.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = ZE(pv, n);
    return /* @__PURE__ */ f(ct, { present: r || kn(i.state) || i.state === !0, children: /* @__PURE__ */ f(
      se.span,
      {
        "data-state": yv(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
gv.displayName = pv;
var JE = "CheckboxBubbleInput", vv = m.forwardRef(
  ({
    __scopeCheckbox: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    defaultChecked: o,
    ...i
  }, s) => {
    const a = m.useRef(null), l = ye(a, s), u = ug(n), c = zp(t);
    m.useEffect(() => {
      const h = a.current;
      if (!h) return;
      const p = window.HTMLInputElement.prototype, g = Object.getOwnPropertyDescriptor(
        p,
        "checked"
      ).set;
      if (u !== n && g) {
        const v = new Event("click", { bubbles: r });
        h.indeterminate = kn(n), g.call(h, kn(n) ? !1 : n), h.dispatchEvent(v);
      }
    }, [u, n, r]);
    const d = m.useRef(kn(n) ? !1 : n);
    return /* @__PURE__ */ f(
      se.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o ?? d.current,
        ...i,
        tabIndex: -1,
        ref: l,
        style: {
          ...i.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
vv.displayName = JE;
function kn(e) {
  return e === "indeterminate";
}
function yv(e) {
  return kn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var du = mv, bv = gv;
const fu = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  du,
  {
    ref: n,
    className: q(
      "peer h-4 w-4 shrink-0 rounded border border-checkbox-border bg-checkbox-bg ring-offset-checkbox-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 group-hover:bg-checkbox-hover group-hover:border-checkbox-hover-border disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-checkbox-active data-[state=checked]:border-checkbox-active data-[state=checked]:text-checkbox-icon data-[state=indeterminate]:bg-checkbox-active data-[state=indeterminate]:border-checkbox-active  data-[state=indeterminate]:text-checkbox-icon",
      e
    ),
    ...t,
    children: /* @__PURE__ */ L(bv, { className: q("flex items-center justify-center text-current"), children: [
      t.checked === "indeterminate" && /* @__PURE__ */ f(hx, { className: "h-4 w-4 pb-[1px]" }),
      t.checked === !0 && /* @__PURE__ */ f(Tc, { className: "h-4 w-4" })
    ] })
  }
));
fu.displayName = "TriStateCheckbox";
const Gs = (e, t, n) => t ? (typeof t == "function" ? t(e) : t[e]) || e : n ? cl(e, n) : e, MV = (e, t, n) => {
  const r = t.field;
  console.log("[onSortColumn] field:", r, "| order:", t.order, "| columnExists:", e.columnNames().includes(r), "| tableSize:", e.size);
  const o = n == null ? void 0 : n.find((c) => c.key === r), i = o == null ? void 0 : o.lookup, s = (c) => c == null || !i ? c : typeof i == "function" ? i(String(c)) || c : i[String(c)] || c, a = [];
  for (let c = 0; c < e.size; c++)
    a.push(e.object(c));
  const l = t.order === "asc" ? 1 : -1;
  a.sort((c, d) => {
    const h = s(c[r]), p = s(d[r]);
    return h == null && p == null ? 0 : h == null ? 1 : p == null ? -1 : typeof h == "number" && typeof p == "number" ? (h - p) * l : String(h).localeCompare(String(p)) * l;
  });
  const u = $m(a);
  return console.log("[onSortColumn] result first 3:", a.slice(0, 3).map((c) => ({ [r]: c[r] }))), u;
}, e1 = async (e, t, n, r = "", o, i, s, a) => {
  if (!(e != null && e.columnNames().includes(n))) return [];
  r = r.toLowerCase();
  let l = e;
  if (a != null && a[n]) {
    const c = a[n];
    l = e.orderby(
      Kn((d) => {
        const h = c.indexOf(d[n]);
        return h === -1 ? 999999 : h;
      })
    );
  }
  return l.select(n).params({ textToFilter: r, columnKey: n }).derive({
    textToMatch: Kn((c, d) => c[d.columnKey] + "|" + Gs(c[d.columnKey], o, i)),
    textToReturn: Kn(
      (c, d) => c[d.columnKey]
      // !useLookupOnlyToMatch ? formatText(row[p.columnKey], lookup, mask) : row[p.columnKey]
    )
  }).filter(
    (c, d) => (
      // @ts-expect-error aq likes overloads :)
      qi.includes(qi.lower(c.textToMatch), d.textToFilter, 0) && !!c[d.columnKey]
    )
  ).select("textToReturn").dedupe().slice(0, t).array("textToReturn");
}, t1 = (e, t, n) => {
  for (const [r, o] of Object.entries(e)) {
    if (!o.length || !t.columnNames().includes(r))
      continue;
    const i = n == null ? void 0 : n[r];
    t = t.params({ filters: e, rowKey: r }).filter(
      Kn((s, a) => {
        const l = Gs(s[a.rowKey], i == null ? void 0 : i.lookup, i == null ? void 0 : i.mask), u = a.filters[a.rowKey].map((d) => d.label), c = a.filters[a.rowKey].map((d) => d.key);
        return qi.includes(u, l, 0) || qi.includes(c, s[a.rowKey], 0);
      })
    );
  }
  return t;
}, bf = (e, t, n, r) => {
  const [o, i] = [
    n.findIndex((u) => u.key === e.column),
    n.findIndex((u) => u.key === t.column)
  ].sort((u, c) => u - c), [s, a] = [e.rowIndex, t.rowIndex].sort((u, c) => u - c), l = [];
  for (let u = s; u <= a; u++) {
    const c = r.object(u);
    for (let d = o; d <= i; d++) {
      const h = n[d];
      h.split || h.groupColumn || l.push({
        column: h.key,
        row: c.key,
        rowIndex: u,
        value: c[h.key]
      });
    }
  }
  return l;
}, wv = (e, t) => {
  var o;
  if (!t.validate) return !1;
  const n = e, r = Array.isArray(t.validate) ? (o = t.validate.map((i) => i(n[t.key], n))) == null ? void 0 : o.find((i) => i) : t.validate(n[t.key], n);
  return (r == null ? void 0 : r.type) === "disable";
}, fo = (e, t, n) => {
  if (!n.validate) return !1;
  const r = t.object(e.rowIndex);
  return wv(r, n);
}, Sr = (e, t, n, r) => {
  const o = n1(r), i = t === "arrowdown" ? 1 : t === "arrowup" ? -1 : 0, s = t === "arrowright" ? 1 : t === "arrowleft" ? -1 : 0;
  if (i !== 0) {
    const a = e.rowIndex + i;
    if (a >= 0 && a < o) {
      const l = Ml(r, a);
      return {
        column: e.column,
        row: l.key,
        rowIndex: a,
        value: l[e.column]
      };
    } else
      return e;
  }
  if (s !== 0) {
    let a = n.findIndex((u) => u.key === e.column) + s, l;
    for (; !l && a >= 0 && a < n.length; ) {
      const u = n[a];
      !u.split && !u.groupColumn && (l = u), a += s;
    }
    if (l) {
      const u = Ml(r, e.rowIndex);
      return {
        column: l.key,
        row: e.row,
        rowIndex: e.rowIndex,
        value: u[l.key]
      };
    } else
      return e;
  }
}, ho = (e, t, n) => {
  const r = Ml(t, e.rowIndex), o = n.find((l) => l.key === e.column), i = (o == null ? void 0 : o.dataType) || "string", s = (e.newValue ?? null) === null;
  if (e.newValue === e.value)
    return [];
  if (s && !(o != null && o.nullable))
    return [];
  const a = i === "number" && !s ? Number(e.newValue) : e.newValue;
  return [
    {
      cells: [
        {
          ...e,
          value: a
        }
      ],
      oldRecord: r,
      newRecord: { ...r, [e.column]: a }
    }
  ];
}, Ml = (e, t) => "length" in e ? e[t] : e.object(t), n1 = (e) => "length" in e ? e.length : e.size, r1 = (e) => e >= "0" && e <= "9" || e >= "a" && e <= "z" || e === "-" || e === ".";
function o1(e, t) {
  const n = e.findIndex((r) => r.rowspan && r.rowspan > 1);
  if (n >= 0 && t !== n) {
    const r = e[n].rowspan;
    return t < n + r;
  }
  return !1;
}
function AV(e, t) {
  return (n) => {
    if (n > e)
      return {
        type: "error",
        message: t || `Max allowed value is ${e}`
      };
  };
}
function OV(e, t) {
  return (n) => {
    if (n < e)
      return {
        type: "error",
        message: t || `Min allowed value is ${e}`
      };
  };
}
function IV(e) {
  return e.reduce((t, n) => (t[n.key] = {
    lookup: n.lookup,
    mask: n.mask
  }, t), {});
}
function _V(e, t, n) {
  return (r, o, i, s) => {
    const a = t == null ? void 0 : t[r];
    return e1(
      e,
      100,
      r,
      o,
      i,
      s,
      !!a,
      n
    );
  };
}
const Ni = (e, t) => [...e].sort((n, r) => {
  const o = t ? t(n.keyText) : n.keyText, i = t ? t(r.keyText) : r.keyText;
  return o.localeCompare(i, void 0, { sensitivity: "base" });
}), xv = ({
  onApply: e,
  onLoadFilters: t,
  activeFilters: n,
  showApplyCancel: r,
  column: o,
  onOpenPopover: i,
  openedPopover: s,
  trigger: a,
  lookup: l,
  onClose: u,
  renderOnBody: c = !0,
  disabled: d = !1
}) => {
  const [h, p] = de([]), [y, g] = de([]), [v, b] = de(""), [x, w] = de(!1), [C, S] = de(!1), T = Ie(
    (k) => o != null && o.mask ? Gs(k, l, o.mask) : `${(l ? typeof l == "function" ? l(k) : l[k] : void 0) || k}`,
    [l, o]
  );
  PE(
    async () => {
      const k = h.filter((G) => G.checked), M = [...y.filter((G) => G.checked), ...k];
      let B = await P(v);
      B = B.filter((G) => !M.some((_) => _.keyText === G)), p(
        Ni(
          B.map((G) => ({ keyText: G, checked: !1 })),
          T
        )
      ), g(Ni(M, T));
    },
    500,
    [v, l]
  );
  const P = async (k) => {
    S(!0);
    const N = await t(k || v);
    return S(!1), N;
  }, E = (k) => {
    if (d) return;
    const N = Et(h, (M) => {
      M[k].checked = !M[k].checked;
    });
    p(N), r || R(void 0, N);
  }, D = (k) => {
    if (d) return;
    const N = Et(y, (M) => {
      M[k].checked = !M[k].checked;
    });
    g(N), r || R(N, void 0);
  }, A = (k) => {
    if (d) return;
    const N = Et(h, (B) => {
      B.forEach((G) => G.checked = k);
    }), M = Et(y, (B) => {
      B.forEach((G) => G.checked = k);
    });
    p(N), g(M), r || R(M, N);
  }, R = (k, N) => {
    if (d) return;
    const M = [
      ...(k || y).filter((B) => B.checked).map((B) => B.keyText),
      ...(N || h).filter((B) => B.checked).map((B) => B.keyText)
    ];
    w(M.length > 0), e(M.map((B) => ({ key: B, label: T(B) })));
  }, O = async () => {
    let k = await P();
    k = k.filter((N) => !(n || []).some((M) => M.key === N)), g(
      Ni(
        (n || []).map((N) => ({ keyText: N.key, checked: !0 })),
        T
      )
    ), p(
      Ni(
        k.map((N) => ({ keyText: N, checked: !1 })),
        T
      )
    );
  }, F = a ? /* @__PURE__ */ f("div", { onClick: O, children: a }) : /* @__PURE__ */ f(Pe, { onClick: O, variant: "ghost", className: "icon hover:bg-transparent text-input-icons", size: "sm", children: n != null && n.length ? /* @__PURE__ */ f(mx, {}) : /* @__PURE__ */ f(ll, {}) }), $ = (k, N, M) => /* @__PURE__ */ f(
    "div",
    {
      className: "flex items-center px-3 py-1.5 rounded-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors",
      children: /* @__PURE__ */ L("label", { className: "flex items-center gap-2.5 cursor-pointer w-full", children: [
        /* @__PURE__ */ f(
          fu,
          {
            className: "shrink-0",
            onCheckedChange: M,
            checked: !!k.checked,
            disabled: d
          }
        ),
        /* @__PURE__ */ f("span", { className: "text-xs font-normal leading-normal text-neutral-text-primary truncate", children: T(k.keyText) })
      ] })
    },
    N
  ), W = /* @__PURE__ */ L(ke, { children: [
    /* @__PURE__ */ f(ro, { asChild: !0, children: F }),
    /* @__PURE__ */ f(hr, { renderOnBody: c, align: "start", className: "w-72 p-0 pointer-events-auto", children: /* @__PURE__ */ L("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ f("div", { className: "px-3 pt-3 pb-2", children: /* @__PURE__ */ f(
        uu,
        {
          label: "",
          placeholder: "Search",
          value: v,
          onChange: (k) => b(k.currentTarget.value),
          starticon: /* @__PURE__ */ f(ll, { size: 14, className: "text-neutral-400" }),
          disabled: d
        }
      ) }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-3 px-3 py-2 border-b border-neutral-200 dark:border-neutral-700", children: [
        /* @__PURE__ */ f(
          "span",
          {
            className: `text-xs font-medium ${d ? "text-neutral-400" : "text-button-primary-bg hover:text-button-primary-bg/80 cursor-pointer"}`,
            onClick: () => A(!0),
            children: "Select All"
          }
        ),
        /* @__PURE__ */ f("span", { className: "text-neutral-300 dark:text-neutral-600 text-xs", children: "|" }),
        /* @__PURE__ */ f(
          "span",
          {
            className: `text-xs font-medium ${d ? "text-neutral-400" : "text-button-primary-bg hover:text-button-primary-bg/80 cursor-pointer"}`,
            onClick: () => A(!1),
            children: "Deselect All"
          }
        )
      ] }),
      /* @__PURE__ */ f("div", { className: "flex flex-col py-1 h-64 overflow-y-auto overflow-x-hidden pretty-scrollbar", children: C ? /* @__PURE__ */ f("div", { className: "w-full flex justify-center py-4", children: /* @__PURE__ */ f("span", { className: "loading loading-spinner loading-sm" }) }) : /* @__PURE__ */ L(ke, { children: [
        y.map((k, N) => $(k, N, () => D(N))),
        y.length > 0 && h.length > 0 && /* @__PURE__ */ f("div", { className: "border-t border-neutral-200 dark:border-neutral-700 mx-3 my-1" }),
        h.map((k, N) => $(k, N, () => E(N)))
      ] }) }),
      r && /* @__PURE__ */ f("div", { className: "flex flex-row-reverse p-2", children: /* @__PURE__ */ f(Pe, { onClick: () => R(), variant: "ghost", size: "sm", color: "primary", disabled: d, children: "Apply" }) })
    ] }) })
  ] }), V = (k) => {
    k ? document.body.classList.add("filter-popover-open") : document.body.classList.remove("filter-popover-open"), o && i ? i(k ? o.key : null) : !k && u && u();
  };
  return o && i ? /* @__PURE__ */ f(or, { open: o.key === s, onOpenChange: V, children: W }) : /* @__PURE__ */ f(or, { onOpenChange: V, children: W });
};
function i1(e) {
  const t = e.column.filterable && e.onFilterChange, n = (r) => e.onFilterChange && e.onFilterChange(e.column, r);
  return t && e.onLoadFilters ? /* @__PURE__ */ f(
    xv,
    {
      activeFilters: e.filters,
      onApply: n,
      onLoadFilters: e.onLoadFilters,
      column: e.column,
      lookup: e.column.lookup,
      onOpenPopover: e.onOpenPopover,
      openedPopover: e.openedPopover
    }
  ) : void 0;
}
function s1({ id: e, topPosition: t }) {
  return /* @__PURE__ */ f("th", { className: "th-group-path sticky", style: { top: `${t}px` }, children: /* @__PURE__ */ f("div", {}) }, `${e}-column`);
}
function a1({ id: e, column: t, state: n, topPosition: r, cfg: o }) {
  const i = t.isLocked ? {
    left: `${o.stickyOffsets[t.key]}px`,
    top: `${r}px`,
    zIndex: 25,
    position: "sticky"
  } : void 0;
  return /* @__PURE__ */ f(
    "th",
    {
      className: "th-new-splitter !bg-gradient-to-r !from-neutral-container !to-transparent",
      style: i
    },
    `${e}-column`
  );
}
function l1(e, t) {
  var n = me(null), r = me(null);
  r.current = t;
  var o = me(null);
  fe(function() {
    i();
  });
  var i = Ie(function() {
    var s = o.current, a = r.current, l = s || (a ? a instanceof Element ? a : a.current : null);
    n.current && n.current.element === l && n.current.subscriber === e || (n.current && n.current.cleanup && n.current.cleanup(), n.current = {
      element: l,
      subscriber: e,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: l ? e(l) : void 0
    });
  }, [e]);
  return fe(function() {
    return function() {
      n.current && n.current.cleanup && (n.current.cleanup(), n.current = null);
    };
  }, []), Ie(function(s) {
    o.current = s, i();
  }, [i]);
}
function wf(e, t, n) {
  return e[t] ? e[t][0] ? e[t][0][n] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    e[t][n]
  ) : t === "contentBoxSize" ? e.contentRect[n === "inlineSize" ? "width" : "height"] : void 0;
}
function c1(e) {
  e === void 0 && (e = {});
  var t = e.onResize, n = me(void 0);
  n.current = t;
  var r = e.round || Math.round, o = me(), i = de({
    width: void 0,
    height: void 0
  }), s = i[0], a = i[1], l = me(!1);
  fe(function() {
    return l.current = !1, function() {
      l.current = !0;
    };
  }, []);
  var u = me({
    width: void 0,
    height: void 0
  }), c = l1(Ie(function(d) {
    return (!o.current || o.current.box !== e.box || o.current.round !== r) && (o.current = {
      box: e.box,
      round: r,
      instance: new ResizeObserver(function(h) {
        var p = h[0], y = e.box === "border-box" ? "borderBoxSize" : e.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", g = wf(p, y, "inlineSize"), v = wf(p, y, "blockSize"), b = g ? r(g) : void 0, x = v ? r(v) : void 0;
        if (u.current.width !== b || u.current.height !== x) {
          var w = {
            width: b,
            height: x
          };
          u.current.width = b, u.current.height = x, n.current ? n.current(w) : l.current || a(w);
        }
      })
    }), o.current.instance.observe(d, {
      box: e.box
    }), function() {
      o.current && o.current.instance.unobserve(d);
    };
  }, [e.box, r]), e.ref);
  return ve(function() {
    return {
      ref: c,
      width: s.width,
      height: s.height
    };
  }, [c, s.width, s.height]);
}
const xf = ({ children: e, onChangeHeight: t }) => {
  const n = me(null);
  return c1({
    ref: n,
    onResize: (r) => {
      r.height && t && t && t(r.height);
    }
  }), /* @__PURE__ */ f("tr", { ref: n, children: e });
};
var Cv = /* @__PURE__ */ ((e) => (e.LOADING = "LOADING", e.ERROR = "ERROR", e))(Cv || {});
const u1 = ({ scroll: e, rowVirtualizer: t, columns: n, visibleColumns: r, table: o }) => ve(() => {
  const s = {}, a = t.getVirtualItems();
  return !o || "length" in o ? {} : (n.forEach((l, u) => {
    var c;
    if (r[u] === -1)
      for (const d of a) {
        const h = d.index, p = o.object(h);
        let y;
        l.validate && (y = Array.isArray(l.validate) ? (c = l.validate.map((g) => g(p[l.key], p))) == null ? void 0 : c.find(Boolean) : l.validate(p[l.key], p)), y && (s[`${u}-${h}`] = y);
      }
  }), s);
}, [e, o, n, r]), Cf = (e) => {
  if (!(e != null && e.length)) return [];
  const t = [...new Set(e.map((o) => o.rowIndex))].sort((o, i) => o - i), n = [...new Set(e.map((o) => o.colIndex))].sort((o, i) => o - i), r = new Map(e.map((o) => [`${o.rowIndex}-${o.colIndex}`, o]));
  return t.map((o) => n.map((i) => r.get(`${o}-${i}`)));
}, Sf = (e, t) => e.map((r) => ({
  ...r,
  colIndex: t.findIndex((o) => o.key === r.column)
})), Sv = (e, t, n) => {
  var s;
  const r = e.filter((a) => {
    const l = n.find((c) => c.key === a.column);
    let u = (l == null ? void 0 : l.readOnly) || (l == null ? void 0 : l.split) || a.pasteValue === null && (l == null ? void 0 : l.nullable) === !1 || (l == null ? void 0 : l.dataType) === "number" && isNaN(Number(a.pasteValue));
    if (!u && (l != null && l.validate)) {
      const c = t.object(a.rowIndex);
      u = wv(c, l);
    }
    return !u;
  }), o = [...new Set(r.map((a) => a.rowIndex))], i = [];
  for (const a of o) {
    const l = t == null ? void 0 : t.object(a);
    if (l && "key" in l) {
      const u = r.filter((h) => h.row === l.key), c = { ...l }, d = [];
      for (const h of u) {
        const p = ((s = n.find((y) => y.key === h.column)) == null ? void 0 : s.dataType) || (typeof c[h.column] == "number" ? "number" : "string");
        c[h.column] = p === "number" && h.pasteValue !== null ? Number(h.pasteValue) : h.pasteValue, d.push({
          ...h,
          value: c[h.column]
        });
      }
      i.push({
        newRecord: c,
        oldRecord: l,
        cells: d
      });
    }
  }
  return i;
}, d1 = (e, t, n, r) => ({
  copy: async () => {
    if (!n || !(t != null && t.end) && !e.length)
      return;
    const s = t != null && t.end ? bf(t.start.cell, t.end.cell, r, n) : [e[0]], a = Sf(s, r), u = Cf(a).map((c) => c.map((d) => d.value).join("	")).join(`
`);
    await navigator.clipboard.writeText(u);
  },
  paste: async (s) => {
    if (!n || !(t != null && t.end) && !e.length)
      return [];
    const l = (await navigator.clipboard.readText()).trim().split(`
`).map((v) => v.split("	")), [u, c] = [l.length, l[0].length], d = !!(t != null && t.end), h = t != null && t.end ? bf(t.start.cell, t.end.cell, r, n) : e, p = Sf(h, r), y = Cf(p).map(
      (v) => v.map((b) => ({ ...b, pasteValue: null }))
    );
    for (let v = 0; v < y.length; v++) {
      const b = y[v];
      for (let x = 0; x < b.length; x++) {
        const w = b[x];
        s ? w.pasteValue = null : d ? w.pasteValue = s ? null : l[v % u][x % c] : w.pasteValue = l[0][0];
      }
    }
    return Sv(y.flat(), n, r);
  }
}), f1 = (e) => {
  const [t, n] = lu(
    `selection-status-${e}`,
    []
  );
  return {
    selectedCells: t,
    setSelectedCells: n,
    clearSelectedCells: () => {
      n([]);
    },
    cellClicked: (i, s) => {
      !s || s === "replace" ? n(
        Et(t, () => [i])
      ) : s === "add" && n(
        Et(t, (a) => {
          a.some((u) => u.column === i.column && u.row === i.row) || a.push(i);
        })
      );
    }
  };
};
function h1({ columns: e, height: t, cfg: n }) {
  const r = 20 * t;
  return /* @__PURE__ */ f("tr", { children: e.map((o, i) => {
    var p, y;
    const s = `row-spacer-${o.key}`;
    if (o.groupColumn)
      return /* @__PURE__ */ f("td", { className: "td-group-path !border-b-table-borders-header !border-b" }, s);
    let a = !1;
    const l = i < e.length - 1 ? (p = e[i + 1]) == null ? void 0 : p.split : !0, u = i > 0 ? (y = e[i - 1]) == null ? void 0 : y.split : !0, c = !!(i > 0 && e[i - 1].groupColumn);
    (i > 0 && c && !o.split || i === 0 || u) && (a = !0);
    const h = !!o.isLocked ? {
      position: "sticky",
      left: `${n.stickyOffsets[o.key]}px`,
      zIndex: 20
    } : {};
    return /* @__PURE__ */ f(
      "td",
      {
        className: We(
          o.split ? "td-new-splitter bg-gradient-to-r from-neutral-container to-transparent" : "bg-color-greys-100 dark:bg-color-greys-800",
          a ? "!border-l-table-borders-header !border-l" : "!border-l-0",
          "!border-t-table-borders-header",
          "!border-b-table-borders-header",
          l && "!border-r-table-borders-header !border-r"
        ),
        style: {
          ...h,
          height: `${r}px`
        }
      },
      s
    );
  }) });
}
const m1 = ({ sortState: e }) => {
  switch (e) {
    case "asc":
      return /* @__PURE__ */ f(vx, { size: 16 });
    case "desc":
      return /* @__PURE__ */ f(gx, { size: 16 });
    default:
      return /* @__PURE__ */ f(px, { size: 16 });
  }
};
function p1({ column: e, sort: t, onSort: n }) {
  const r = t && e.key === t.field ? t.order : null;
  return /* @__PURE__ */ f(Pe, { onClick: () => {
    const i = (t == null ? void 0 : t.order) === "asc" ? "desc" : "asc";
    n({ field: e.key, order: i });
  }, variant: "ghost", className: "icon hover:bg-transparent text-input-icons", size: "sm", children: /* @__PURE__ */ f(m1, { sortState: r }) });
}
const Tv = je(void 0), $V = ({ children: e, lookups: t = {} }) => {
  const n = Ie(
    (o) => o.map((i) => i.lookup ? i : t[i.key] ? { ...i, lookup: t[i.key] } : i),
    [t]
  ), r = ve(
    () => ({
      lookups: t,
      applyLookups: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ f(Tv.Provider, { value: r, children: e });
}, hu = () => Te(Tv), LV = (e) => {
  var ot, St, At, Zt, vr;
  const t = hu(), n = ve(() => {
    if (Array.isArray(e.table)) {
      const I = e.table.length ? Object.keys(e.table[0]) : [], Z = e.columns.map((ae) => ae.key), K = [.../* @__PURE__ */ new Set([...I, ...Z])];
      return $m(e.table, K);
    }
    return e.table;
  }, [e.table]), r = ve(() => {
    const I = e.columns.some((K) => K.fixedPercentageWidth), Z = e.columns.every((K) => K.fixedPercentageWidth);
    if (I && !Z)
      throw new Error("Either all columns must have fixedPercentageWidth set or none of them should have it");
    return I;
  }, [e.columns]), o = e.hooks.getDatatableConfig(), i = me(null), { state: s, hooks: a } = e, [l, u] = de([]), [c, d] = de(null), [h, p] = lu(`scroll-position-${e.tablekey}`, { x: 0, y: 0 }), [y, g] = de(!1), v = (I) => {
    y && p(I);
  };
  fe(() => {
    i != null && i.current && n && (i.current.scrollLeft = h.x, i.current.scrollTop = h.y, g(!0));
  }, [n, e.columns]);
  const [b, x] = de(), [w, C] = de(), S = (I, Z) => {
    u((K) => Et(K, (ae) => {
      ae[I] = Z;
    }));
  }, [T, P, E] = ve(() => {
    var ht;
    const I = [];
    let Z = 0;
    const ae = [...(t == null ? void 0 : t.applyLookups(e.columns)) ?? e.columns];
    let pe = ae.map((le, Ne) => {
      var ut, _e;
      if ("split" in le)
        return {
          name: "",
          key: le.key || `sep-${Ne}`,
          component: () => /* @__PURE__ */ f(fE, {}),
          _dfColIndex: -1,
          sourceColIndex: -1,
          split: !0,
          isLocked: le.isLocked
        };
      let Ce = "";
      const ee = le.isLocked || s.lockedColumns.includes(le.key);
      ((ut = le.group) != null && ut.length && !le.group[le.group.length - 1].label || !((_e = le.group) != null && _e.length)) && ((Ne === 0 || "split" in ae[Ne - 1]) && (Ce += "rounded-tl "), (Ne === ae.length - 1 || "split" in ae[Ne + 1]) && (Ce += "rounded-tr "));
      const z = {
        ...le,
        component: le.component || fr,
        _dfColIndex: -1,
        sourceColIndex: Ne,
        isLocked: ee,
        aditionalClasses: Ce
      };
      return !le.onLoadFilters && le.filterable && e.onLoadFiltersByColumn && (z.onLoadFilters = (Jt) => e.onLoadFiltersByColumn(le.key, Jt, z.lookup, z.mask)), z;
    });
    const Ae = [];
    let et = 0;
    for (const le of pe) {
      const Ne = Zg(le, s);
      if (!Ne)
        !le.split && !le.groupColumn && (le._dfColIndex = et++), Ae.push(le);
      else {
        const Ce = Ae.length ? Ae[Ae.length - 1] : void 0;
        (!Ce || !RE(Ce.group, Ne)) && Ae.push(bP(Ne, le.key));
      }
    }
    pe = Ae;
    for (const le of pe)
      le.group && le.group.length > Z && (Z = le.group.length);
    for (let le = 0; le < Z; le++) {
      const Ne = [];
      for (let Ce = 0; Ce < pe.length; Ce++) {
        const ee = pe[Ce], z = ee.group && ee.group[le];
        if (ee.group && o1(ee.group, le))
          continue;
        const ut = Ce < pe.length - 1 ? pe[Ce + 1] : void 0, _e = ee.group && le > 0 ? ee.group[le - 1] : void 0, Jt = le === 0 || (_e == null ? void 0 : _e.label) === void 0 || (_e == null ? void 0 : _e.component), yr = ee.group && ee.groupColumn ? le > ((ht = ee.group) == null ? void 0 : ht.length) - 2 : void 0, xi = (ut == null ? void 0 : ut.split) || Ce === pe.length - 1, la = ee.group ? le === ee.group.length - 1 || le === 0 : !1, ie = Ce > 0 ? Ne[Ne.length - 1] : void 0, De = (z == null ? void 0 : z.label) === void 0 && !yr || !1, Me = z == null ? void 0 : z.label;
        if (ie && ie.key === (z == null ? void 0 : z.key))
          Ne[Ne.length - 1].colspan += 1, xi && Jt && (Ne[Ne.length - 1].aditionalClasses += "rounded-tr ");
        else {
          let Oe, Se = "";
          const dt = (ee.group || []).filter((pt, Tt) => Tt <= le);
          if (Me && !(z != null && z.uncollapsable)) {
            const pt = dt.map((Tt) => Tt.key).join("_");
            Oe = /* @__PURE__ */ f(
              OE,
              {
                hooks: a,
                group: dt,
                hidding: !s.groupCollapsedStatus[pt]
              }
            );
          }
          De && (Se += ie != null && ie.name && !ee.split ? "empty-cell-left-border " : "empty-cell "), (ie != null && ie.split || Ce === 0) && Jt && (Se += "rounded-tl "), xi && Jt && (Se += "rounded-tr ");
          let tt = dt;
          z && z.rowspan && (tt = (ee.group || []).filter((pt, Tt) => Tt <= le + z.rowspan - 1));
          const mt = tt.length ? ME(tt, ae, s) : !1;
          Ne.push({
            rowspan: z == null ? void 0 : z.rowspan,
            areSubgroupsCollapsed: mt,
            aditionalClasses: Se,
            viewComponent: z == null ? void 0 : z.component,
            key: (z == null ? void 0 : z.key) || `no-group-${le}`,
            name: Me || "",
            colspan: 1,
            split: ee.split,
            leftStickyOffset: z != null && z.isLocked || ee.split ? o.stickyOffsets[ee.key] : void 0,
            component: Oe,
            isPartOfGroup: yr,
            isHeadOfGroup: la
          });
        }
      }
      I.push(Ne);
    }
    return [pe, I, Z];
  }, [
    n,
    e.columns,
    s.lockedColumns,
    s.groupCollapsedStatus,
    s.columnPositions,
    o.stickyOffsets,
    t
  ]);
  fe(() => {
    x(void 0);
  }, [s.lockedColumns, s.groupCollapsedStatus, s.columnPositions, e.columns]);
  const D = ve(() => {
    const I = [];
    let Z = DE;
    for (let K = 0; K < E + 2; K++)
      I[K] = Z, Z += l[K] || 25;
    return I;
  }, [l, E]), { rowSize: A, cssClass: R } = ve(() => {
    let I = 32, Z = e.className ?? "";
    return e.isCompressed && (I = 20, Z += " is-compressed"), {
      rowSize: I,
      cssClass: Z
    };
  }, [e.isCompressed, e.className]), O = (n == null ? void 0 : n.size) || 0, F = MP({
    count: O,
    getScrollElement: () => i.current,
    estimateSize: () => A
  }), $ = F.getVirtualItems().find((I) => I !== void 0) || { size: A, start: 0 }, W = F.getTotalSize() - ($.start + F.getVirtualItems().length * $.size), V = ((ot = i.current) == null ? void 0 : ot.getBoundingClientRect().width) || 1, k = ve(() => {
    if (o.disableColumnVirtualization || r)
      return [];
    const I = [];
    let Z = 0, K = 0;
    for (let ae = 0; ae < T.length; ae++) {
      const pe = T[ae], Ae = o.usePositionalColumnSizing ? `column-${pe.sourceColIndex}` : pe.key;
      let et = Math.max(s.columnPositions[Ae] || 0, pe.minWidth || o.minColumnWidth);
      pe.groupColumn && (et = 24), pe.split && (et = 12), Z >= h.x - 200 && Z <= h.x + V + 200 || pe.isLocked ? (I.push(-1), K = ae + 1) : (I.push(0), I[K]++), Z += et;
    }
    return I;
  }, [h, s, V, o.disableColumnVirtualization]), N = (I) => {
    const K = i.current;
    if (K) {
      const ae = K.querySelector(`td[data-row-key="${I.row}"][data-col-key="${I.column}"]`);
      if (!ae) return;
      const pe = ae.getBoundingClientRect(), Ae = K.getBoundingClientRect(), et = K.scrollTop, ht = K.scrollLeft, le = D[D.length - 1], Ne = Object.keys(o.stickyOffsets).length ? Math.max(...Object.values(o.stickyOffsets)) : 0, Ce = {
        top: Ae.top + le,
        bottom: Ae.bottom,
        left: Ae.left + Ne,
        right: Ae.right
      };
      let ee = pe.top < Ce.top + 150 ? et - (Ce.top + 150 - pe.top) : void 0, z = pe.left < Ce.left + 150 ? ht - (Ce.left + 150 - pe.left) : void 0;
      ee = pe.bottom > Ce.bottom - 150 ? et + (pe.bottom - (Ce.bottom - 150)) : ee, z = pe.right > Ce.right - 150 ? ht + (pe.right - (Ce.right - 150)) : z, K.scrollTo({
        top: ee,
        left: z,
        behavior: "instant"
      });
    }
  }, { selectedCells: M, clearSelectedCells: B, cellClicked: G } = f1(e.tablekey), { copy: _, paste: U } = d1(M, b, n, T), te = (I, Z) => {
    const K = document.querySelector(`td[data-row-key="${I}"][data-col-key="${Z}"]`);
    if (K) {
      const ae = K.querySelector("input");
      ae && ae.type === "number" && (ae.focus(), ae.type = "text", ae.setSelectionRange(0, ae.value.length), ae.type = "number");
    }
  }, X = async (I) => {
    var Ae, et, ht, le, Ne, Ce;
    if (!n || c) return;
    let Z = I.key.toLocaleLowerCase();
    Z === "backspace" && w === void 0 && (Z = "delete");
    const K = I.ctrlKey || I.metaKey, ae = M.length ? M[0] : void 0, pe = ae ? T.find((ee) => ee.key === ae.column) : void 0;
    switch (!0) {
      case (Z.length === 1 && r1(Z) && !K && !w && !!ae):
        pe && !pe.readOnly && !pe.split && !fo(ae, n, pe) && C({
          ...M[0],
          newValue: "",
          editMode: "express"
        });
        break;
      case Z === "escape":
        w ? C(void 0) : (B(), x(void 0)), (Ae = i.current) == null || Ae.focus();
        break;
      case Z === "enter":
        if (w && e.onRowsCommit) {
          e.onRowsCommit(ho(w, n, T));
          const ee = Sr(w, "arrowdown", T, n);
          ee && ee.rowIndex !== w.rowIndex && !fo(ee, n, T.find((z) => z.key === ee.column)) ? (G(ee, "replace"), C({
            ...ee,
            newValue: ee == null ? void 0 : ee.value,
            editMode: "normal"
          }), N(ee)) : C(void 0), (et = i.current) == null || et.focus();
        } else if (!w && M.length) {
          const ee = M[0], z = T.find((ut) => ut.key === ee.column);
          z && !z.readOnly && !fo(ee, n, z) && C({
            ...M[0],
            newValue: M[0].value,
            editMode: "normal"
          });
        }
        break;
      case (Z === "v" && K):
        {
          const ee = await U();
          ee != null && ee.length && e.onRowsCommit && e.onRowsCommit(ee), I.preventDefault();
        }
        break;
      case Z === "delete":
        if (n && e.onRowsCommit) {
          const ee = await U(!0);
          ee != null && ee.length && e.onRowsCommit(ee), I.preventDefault();
        }
        break;
      case (Z === "c" && K):
        await _();
        break;
      case (Z === "tab" && !w && !!(M != null && M.length)):
        {
          const ee = M[0], z = Sr(ee, "arrowright", T, n);
          z && G(z, "replace");
        }
        I.preventDefault();
        break;
      case (Z === "tab" && !!w):
        {
          const ee = ho(w, n, T);
          ee.length && e.onRowsCommit && e.onRowsCommit(ee);
          const z = Sr(w, "arrowright", T, n);
          if (z && z.column !== w.column) {
            const ut = T.find((_e) => _e.key === z.column);
            (ht = T.find((_e) => _e.key === z.column)) != null && ht.readOnly || fo(z, n, ut) ? C(void 0) : C({
              ...z,
              newValue: z == null ? void 0 : z.value,
              editMode: "normal"
            }), G(z, "replace"), N(z);
          } else
            C(void 0);
          I.preventDefault(), (le = i.current) == null || le.focus();
        }
        break;
      case ((w == null ? void 0 : w.editMode) === "express" && ["arrowleft", "arrowup", "arrowright", "arrowdown"].includes(Z)):
        if (e.onRowsCommit) {
          const ee = ho(w, n, T);
          ee.length && e.onRowsCommit(ee);
          let z = Sr(w, Z, T, n), ut = !1;
          for (; z && ((Ne = T.find((_e) => _e.key === (z == null ? void 0 : z.column))) != null && Ne.readOnly) && !ut; ) {
            const _e = Sr(z, Z, T, n);
            (_e == null ? void 0 : _e.column) !== z.column || _e.row !== z.row ? z = _e : ut = !0;
          }
          if (z && (z.row !== w.row || z.column !== w.column)) {
            const _e = T.find((yr) => yr.key === z.column), Jt = _e.readOnly || fo(z, n, _e);
            G(z, "replace"), C(
              Jt ? void 0 : { ...z, newValue: z.value, editMode: "express" }
            ), setTimeout(() => {
              z && te(z.row, z.column);
            }, 0);
          } else
            C(void 0);
        }
        break;
      case ["arrowup", "arrowdown"].includes(Z):
      case (!w && ["arrowleft", "arrowright"].includes(Z)):
        {
          const ee = (b == null ? void 0 : b.start.cell) || M.length && M[0];
          if (ee && n) {
            const z = Sr(ee, Z, T, n);
            z && (x(void 0), G(z, "replace"), N(z), I.preventDefault());
          }
          ["arrowup", "arrowdown"].includes(Z) && (C(void 0), (Ce = i.current) == null || Ce.focus());
        }
        break;
    }
  }, Q = (I, Z) => {
    G(I, Z === "ctrl" ? "add" : "replace"), e.onCellSelect && e.onCellSelect(I, n.object(I.rowIndex));
  }, H = (I) => {
    w && w.value !== w.newValue && e.onRowsCommit && n && e.onRowsCommit(ho(w, n, T)), C(
      I ? {
        ...I,
        newValue: I.value,
        editMode: "normal"
      } : void 0
    );
  }, oe = (I, Z) => {
    if (w) {
      const K = { ...w, newValue: I };
      C(K), Z && e.onRowsCommit && n && (e.onRowsCommit(ho(K, n, T)), C(void 0));
    }
  }, he = (I, Z, K, ae, pe, Ae) => {
    var le, Ne, Ce, ee;
    const et = -(((le = i.current) == null ? void 0 : le.getBoundingClientRect().x) || 0) + Z + (((Ne = i.current) == null ? void 0 : Ne.scrollLeft) || 0), ht = -(((Ce = i.current) == null ? void 0 : Ce.getBoundingClientRect().y) || 0) + K + (((ee = i == null ? void 0 : i.current) == null ? void 0 : ee.scrollTop) || 0);
    I === "start" && x({
      start: {
        absX: et,
        absY: ht,
        width: ae,
        height: pe,
        cell: Ae
      }
    }), I === "drag" && b && x({
      ...b,
      end: {
        absX: et,
        absY: ht,
        width: ae,
        height: pe,
        cell: Ae
      }
    }), I === "end" && b && (b.start.cell.row !== Ae.row || b.start.cell.column !== Ae.column ? (C(void 0), B(), x({
      ...b,
      end: {
        absX: et,
        absY: ht,
        width: ae,
        height: pe,
        cell: Ae
      }
    })) : x(void 0));
  }, ne = ve(() => {
    const I = b;
    if (!I)
      return;
    if (!I.end)
      return {
        ...I.start
      };
    const [Z, K, ae] = I.start.absX < I.end.absX ? [I.start.absX, I.end.absX, I.end.width] : [I.end.absX, I.start.absX, I.start.width], [pe, Ae, et] = I.start.absY < I.end.absY ? [I.start.absY, I.end.absY, I.end.height] : [I.end.absY, I.start.absY, I.start.height];
    return {
      absX: Z,
      absY: pe,
      width: K - Z + ae,
      height: Ae - pe + et
    };
  }, [b]), be = (I) => {
    if (e.infoHeader)
      return e.infoHeader.columnNames().includes(I.key) ? e.infoHeader.get(I.key, 0) : " ";
  }, xe = u1({
    scroll: h,
    rowVirtualizer: F,
    columns: T,
    visibleColumns: k,
    table: n
  }), re = ve(() => {
    const I = Math.max((e.bottomRowsPaddingAmount ?? 6) - ((n == null ? void 0 : n.size) || 0), 0);
    return I ? /* @__PURE__ */ f(h1, { cfg: o, columns: T, height: I }) : void 0;
  }, [e.bottomRowsPaddingAmount, n == null ? void 0 : n.size, o, T]);
  return e.error ? /* @__PURE__ */ f(
    "div",
    {
      className: We(
        "w-full relative bg-red-200 text-red-800 text-sm text-center border rounded-md p-2",
        "border-red-700"
      ),
      children: "There was an error loading data. Please try again."
    }
  ) : !(n != null && n.size) && !(T != null && T.length) ? /* @__PURE__ */ f("div", { className: "h-32 w-full relative", children: /* @__PURE__ */ f(Zn, { cover: !0 }) }) : /* @__PURE__ */ f(Zc, { children: /* @__PURE__ */ f("div", { className: "flex overflow-hidden", children: /* @__PURE__ */ L(
    "div",
    {
      ref: i,
      onScroll: (I) => v({
        x: I.currentTarget.scrollLeft,
        y: I.currentTarget.scrollTop
      }),
      onKeyDownCapture: X,
      tabIndex: 0,
      className: We(" pretty-scrollbar w-0 grow outline-none relative", [
        e.disableScrolling ? "" : "overflow-y-auto overflow-x-auto"
      ]),
      children: [
        /* @__PURE__ */ L(
          "table",
          {
            className: We(`supertable ${R}`, r && "w-full"),
            style: { minHeight: e.minHeight ?? void 0 },
            children: [
              /* @__PURE__ */ f("colgroup", { children: T.map((I) => {
                const Z = o.usePositionalColumnSizing ? `column-${I.sourceColIndex}` : I.key, K = Math.max(
                  s.columnPositions[Z] || 0,
                  I.minWidth || o.minColumnWidth
                ), ae = r ? `${I.fixedPercentageWidth}%` : `${K}px`;
                return /* @__PURE__ */ f(
                  "col",
                  {
                    style: I.split ? {
                      width: "0.5rem",
                      minWidth: "0.5rem",
                      maxWidth: "0.5rem"
                    } : {
                      minWidth: I.groupColumn ? "24px" : K ? ae : "50px",
                      maxWidth: I.groupColumn ? "24px" : void 0,
                      width: I.groupColumn ? "24px" : ae
                    }
                  },
                  I.key
                );
              }) }),
              /* @__PURE__ */ L("thead", { className: e.theadClassName ?? "", children: [
                P.map((I, Z) => /* @__PURE__ */ f(
                  xf,
                  {
                    "attr-key": `${Z}-grp-row`,
                    onChangeHeight: (K) => S(Z, K),
                    children: I.map((K, ae) => {
                      const pe = !!(ae === I.length - 1 || I[ae + 1].split);
                      return /* @__PURE__ */ f(
                        "th",
                        {
                          "attr-key": `${ae}-th`,
                          rowSpan: K.rowspan,
                          className: We(
                            "sticky",
                            K.split && "th-new-splitter bg-gradient-to-r from-neutral-container to-transparent",
                            K.isPartOfGroup ? K.name ? "th-is-group" : "th-group-path" : void 0,
                            "font-medium"
                          ),
                          style: {
                            top: `${D[Z]}px`,
                            left: K.leftStickyOffset !== void 0 ? `${K.leftStickyOffset}px` : void 0,
                            // isHeadOfGroup should be on top of other groups (vertical text)
                            // and if the group is sticky, it should be on top of every other group
                            zIndex: K.leftStickyOffset !== void 0 ? 25 : K.isHeadOfGroup ? 18 : 15
                          },
                          colSpan: K.colspan,
                          children: /* @__PURE__ */ f("div", { className: K.aditionalClasses, children: K.isPartOfGroup && K.name ? /* @__PURE__ */ L(
                            "div",
                            {
                              className: We(
                                "text-xs bg-table-bg-header vertical-group",
                                pe && "border-r",
                                K.aditionalClasses
                              ),
                              style: {
                                minHeight: `${100 + P.length * 32}px`
                              },
                              children: [
                                K.component ? K.component : "",
                                K.name
                              ]
                            }
                          ) : /* @__PURE__ */ f(ke, { children: K.viewComponent ? /* @__PURE__ */ f("div", { className: "grow", children: /* @__PURE__ */ f(K.viewComponent, { isCollapsed: K.areSubgroupsCollapsed }) }) : /* @__PURE__ */ L("div", { className: "grow w-0 text-xs flex justify-center items-center px-2 whitespace-nowrap min-w-0", children: [
                            K.component ? K.component : "",
                            /* @__PURE__ */ f(
                              lg,
                              {
                                text: K.name,
                                className: "align-middle text-ellipsis overflow-hidden whitespace-nowrap min-w-0"
                              }
                            )
                          ] }) }) })
                        },
                        `${ae}-th`
                      );
                    })
                  },
                  `${Z}-grp-row`
                )),
                /* @__PURE__ */ f(xf, { children: T.map(
                  (I, Z) => {
                    var K;
                    return I.groupColumn ? /* @__PURE__ */ f(s1, { id: Z, topPosition: D[D.length - 1] }, I.key) : I.split ? /* @__PURE__ */ f(
                      a1,
                      {
                        id: Z,
                        column: I,
                        state: s,
                        topPosition: D[P.length],
                        cfg: o
                      },
                      I.key
                    ) : /* @__PURE__ */ f(
                      AP,
                      {
                        columns: T,
                        column: I,
                        id: Z,
                        state: s,
                        hooks: a,
                        cfg: o,
                        aditionalClasses: I.aditionalClasses,
                        leftSection: I.filterable && e.onFilterChange && /* @__PURE__ */ f(
                          i1,
                          {
                            column: I,
                            filters: e.filters ? e.filters[I.key] : [],
                            onLoadFilters: I.onLoadFilters,
                            onFilterChange: e.onFilterChange,
                            onOpenPopover: d,
                            openedPopover: c
                          }
                        ),
                        rightSection: I.sortable && e.onSort && /* @__PURE__ */ f(
                          p1,
                          {
                            column: I,
                            sort: e.sort ? e.sort : null,
                            onSort: e.onSort
                          }
                        ),
                        topPosition: D[P.length],
                        showInfoRow: !!e.infoHeader,
                        infoRow: e.infoHeader ? be(I) : void 0,
                        disableResize: r,
                        hasActiveFilter: !!(e.filters && ((K = e.filters[I.key]) != null && K.length))
                      },
                      I.key
                    );
                  }
                ) }, "column-row")
              ] }),
              /* @__PURE__ */ L("tbody", { children: [
                /* @__PURE__ */ f(
                  "tr",
                  {
                    style: {
                      height: `${$.start + A}px`,
                      display: `${$.start ? "table-row" : "none"}`
                    }
                  }
                ),
                F.getVirtualItems().map((I) => {
                  const Z = I.index, K = n.object(Z);
                  return /* @__PURE__ */ f(
                    dE,
                    {
                      onDrag: he,
                      hooks: a,
                      visibleColumns: k,
                      rowIndex: Z,
                      rowSize: I.size,
                      columns: T,
                      record: K,
                      state: s,
                      selectedCells: M,
                      cellValidations: xe,
                      onRowsCommit: (ae) => {
                        var pe;
                        e.onRowsCommit && e.onRowsCommit(ae), (pe = i.current) == null || pe.focus();
                      },
                      editingCell: w,
                      onToggleEdit: H,
                      onChangeEditCellValue: oe,
                      onCellSelect: Q,
                      cfg: o
                    },
                    K.key
                  );
                }),
                re,
                /* @__PURE__ */ f(
                  "tr",
                  {
                    className: "bottom-virtual-row",
                    style: {
                      height: `${W}px`,
                      display: `${W ? "table-row" : "none"}`
                    },
                    children: /* @__PURE__ */ f("td", { children: " " })
                  }
                )
              ] })
            ]
          }
        ),
        b && /* @__PURE__ */ f(
          "div",
          {
            className: "absolute outline outline-2 outline-blue-400 bg-blue-500/15 pointer-events-none",
            style: {
              left: `${ne.absX + 1}px`,
              top: `${ne.absY + 1}px`,
              width: `${ne.width - 2}px`,
              height: `${ne.height - 2}px`
            }
          }
        ),
        !n || e.status ? /* @__PURE__ */ f(
          "div",
          {
            className: "z-50 absolute bg-neutral-container/50  place-content-center place-items-center",
            style: {
              left: `${(St = i.current) == null ? void 0 : St.scrollLeft}px`,
              top: `${(At = i.current) == null ? void 0 : At.scrollTop}px`,
              width: `${(Zt = i.current) == null ? void 0 : Zt.clientWidth}px`,
              height: `${(vr = i.current) == null ? void 0 : vr.clientHeight}px`
            },
            children: e.status === Cv.ERROR ? /* @__PURE__ */ f("div", { className: "text-red-500", children: /* @__PURE__ */ f(yx, {}) }) : /* @__PURE__ */ f(Zn, { cover: !0, transparent: !0 })
          }
        ) : void 0
      ]
    }
  ) }) });
};
function FV() {
  return /* @__PURE__ */ f("div", { className: "w-full relative h-32", children: /* @__PURE__ */ f(Zn, { cover: !0 }) });
}
function VV(e) {
  const { trueLabel: t = "Yes", falseLabel: n = "No" } = e, r = e.value === !0 ? t : e.value === !1 ? n : "-", o = [
    {
      key: "true",
      label: t
    },
    {
      key: "false",
      label: n
    },
    e.nullable ? {
      key: "undefined",
      label: "Not defined"
    } : void 0
  ].filter(Boolean), i = (a) => a === "undefined" ? void 0 : a === "true", s = e.value === void 0 || e.value === null ? "undefined" : e.value ? "true" : "false";
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ f(
      "select",
      {
        value: s,
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0",
        onChange: (a) => e.onChange && e.onChange(i(a.currentTarget.value)),
        autoFocus: !0,
        children: o.map((a) => /* @__PURE__ */ f("option", { value: a.key, children: a.label }, a.key))
      }
    ),
    " "
  ] }) : /* @__PURE__ */ f(fr, { ...e, value: r });
}
function BV(e) {
  return /* @__PURE__ */ f("div", { className: "datatable-header-left flex items-center gap-2", children: e.children });
}
function WV(e) {
  return /* @__PURE__ */ f("div", { className: "datatable-header-left flex items-center gap-2", children: e.children });
}
function zV({
  search: e,
  onSearch: t,
  heading: n,
  hooks: r,
  children: o,
  filters: i,
  clearFilters: s,
  colapsableTable: a = !0
}) {
  return /* @__PURE__ */ L("div", { className: We("flex items-center justify-between mb-4"), children: [
    n && /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f("h2", { className: "text-xl font-semibold", children: n }) }),
    /* @__PURE__ */ f("div", { className: "flex items-center grow gap-2", children: o }),
    /* @__PURE__ */ L("div", { className: "flex items-center overflow-hidden", children: [
      t && /* @__PURE__ */ L("div", { className: "flex items-center py-4", children: [
        /* @__PURE__ */ f(
          si,
          {
            type: "search",
            placeholder: "Search",
            onInput: (l) => {
              t && t(l.target.value), l.preventDefault();
            },
            value: e,
            className: "max-w-sm pr-10"
          }
        ),
        /* @__PURE__ */ f(ll, { className: "relative right-7 top-3 transform -translate-y-1/2" })
      ] }),
      /* @__PURE__ */ f(
        jS,
        {
          datatableHooks: r,
          filters: i,
          clearFilters: s,
          colapsableTable: a
        }
      )
    ] })
  ] });
}
function jV(e) {
  let { value: t } = e;
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ f(
      "input",
      {
        value: t ?? "",
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0 disable-stepper",
        autoFocus: !0,
        onInput: (n) => e.onChange && e.onChange(n.currentTarget.value)
      }
    ),
    " "
  ] }) : /* @__PURE__ */ f(fr, { ...e });
}
function g1(e) {
  var r, o;
  const { mask: t } = e.column;
  let { value: n } = e;
  if (t) {
    const i = ((o = (r = t == null ? void 0 : t.split(".")) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0;
    n = n || n === 0 ? _x(n, i) : void 0;
  }
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ f(
      "input",
      {
        value: n ?? "",
        type: "number",
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0 disable-stepper",
        step: 0.01,
        autoFocus: !0,
        onInput: (i) => e.onChange && e.onChange(i.currentTarget.value)
      }
    ),
    " "
  ] }) : /* @__PURE__ */ f(fr, { ...e });
}
function v1(e) {
  const [t, n] = de(""), r = e.numDecimals ?? 2;
  fe(() => {
    e.isEditing ? n(e.value ? `${(+e.value * 100).toFixed(r)}` : "") : n("");
  }, [e.isEditing]);
  const o = (i) => {
    n(i), e.onChange && e.onChange(+i / 100);
  };
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ L("div", { className: "flex gap-2 absolute inset-0", children: [
      /* @__PURE__ */ f(
        "input",
        {
          value: t,
          type: "number",
          className: "bg-transparent outline-none disable-stepper shrink min-w-0",
          step: 0.01,
          autoFocus: !0,
          onInput: (i) => o(i.currentTarget.value)
        }
      ),
      /* @__PURE__ */ f("div", { className: "grow", children: "%" })
    ] }),
    " "
  ] }) : /* @__PURE__ */ f(fr, { ...e });
}
function HV(e) {
  return /* @__PURE__ */ f(ke, { children: /* @__PURE__ */ f("td", { ...e, className: `${e.className ?? ""} overflow-hidden text-ellipsis whitespace-nowrap`, children: e.children }) });
}
function UV(e) {
  return e.value;
}
function YV(e) {
  const t = (n) => {
  };
  return /* @__PURE__ */ f("div", { role: "button", className: "p-1", onClick: () => t(e.column), children: /* @__PURE__ */ f(bx, { className: "size-3" }) });
}
function GV({
  direction: e,
  column: t,
  hooks: n,
  state: r
}) {
  return /* @__PURE__ */ f("div", { role: "button", className: "p-1", onClick: () => {
  }, children: /* @__PURE__ */ f(e === 1 ? wx : xx, { className: "size-3", color: "gray" }) });
}
function KV({ column: e, sort: t, onSort: n }) {
  const r = e.key === (t == null ? void 0 : t.field), o = (t == null ? void 0 : t.order) === "asc";
  return /* @__PURE__ */ f(ke, { children: n && /* @__PURE__ */ f("div", { role: "button", className: "p-1", onClick: () => {
    n && n(r && !o ? void 0 : { field: e.key, order: r && o ? "desc" : "asc" });
  }, children: /* @__PURE__ */ f(t ? r ? o ? Cx : Sx : Id : Id, { className: "size-3", color: r ? "black" : "gray" }) }) });
}
function XV(e) {
  const t = e.state.lockedColumns.includes(e.column.key), n = (r) => {
    t ? e.hooks.unlockColumns([r.key]) : e.hooks.lockColumns([r.key]);
  };
  return /* @__PURE__ */ f("div", { role: "button", className: "p-1", onClick: () => n(e.column), children: t ? /* @__PURE__ */ f(Tx, { className: "size-3" }) : /* @__PURE__ */ f(Px, { className: "size-3" }) });
}
const y1 = ({ checkboxProps: e, labelProps: t, hasChildren: n }) => {
  const r = () => {
    if (n)
      return /* @__PURE__ */ f(Br, { className: "text-input-active -mr-2 peer-disabled:text-input-active/50" });
  };
  return /* @__PURE__ */ L(
    "div",
    {
      "aria-checked": !!e.checked || void 0,
      onClick: t.onOpenChange,
      className: "flex z-10 justify-between group w-full p-2 bg-table-bg border-b border-neutral-borders hover:bg-filters-hover items-center gap-2 has-[:disabled]:border-neutral-borders/50 aria-[checked]:bg-table-primary-highlight",
      children: [
        /* @__PURE__ */ L("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ f(fu, { ...e }),
          /* @__PURE__ */ f("label", { className: "text-md text-input-text font-medium leading-6 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", children: t.label })
        ] }),
        r()
      ]
    }
  );
}, Pv = ({
  nodes: e,
  ancestors: t,
  handleCheckboxChange: n,
  depth: r,
  useAutoWidth: o
}) => {
  var c;
  const [i, s] = de(), a = e.find(({ id: d }) => d === i), l = o ? {
    width: `${100 / r}%`
  } : {}, u = r !== t.length + 1;
  return /* @__PURE__ */ L(ke, { children: [
    /* @__PURE__ */ f("div", { className: We("flex flex-col border-neutral-borders h-full", { "border-r": u }), style: l, children: /* @__PURE__ */ f("div", { className: "overflow-y-auto pretty-scrollbar grow h-0", children: e.map((d, h) => {
      const { id: p, label: y, checked: g, childrenNodes: v, disabled: b } = d;
      return /* @__PURE__ */ f(
        y1,
        {
          checkboxProps: { checked: g, onClick: (w) => {
            w.stopPropagation(), n({ node: d, ancestors: t });
          }, disabled: b },
          labelProps: { id: p, label: y, onOpenChange: () => s(p) },
          hasChildren: !!(v != null && v.length)
        },
        h
      );
    }) }) }),
    !!((c = a == null ? void 0 : a.childrenNodes) != null && c.length) && /* @__PURE__ */ f(
      Pv,
      {
        depth: r,
        useAutoWidth: o,
        nodes: a.childrenNodes,
        handleCheckboxChange: n,
        ancestors: [...t, a.id]
      }
    )
  ] });
};
var Ta = "rovingFocusGroup.onEntryFocus", b1 = { bubbles: !1, cancelable: !0 }, ai = "RovingFocusGroup", [Al, Ev, w1] = Os(ai), [x1, Dv] = Bt(
  ai,
  [w1]
), [C1, S1] = x1(ai), kv = m.forwardRef(
  (e, t) => /* @__PURE__ */ f(Al.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(Al.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(T1, { ...e, ref: t }) }) })
);
kv.displayName = ai;
var T1 = m.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: c = !1,
    ...d
  } = e, h = m.useRef(null), p = ye(t, h), y = Jc(i), [g, v] = Rn({
    prop: s,
    defaultProp: a ?? null,
    onChange: l,
    caller: ai
  }), [b, x] = m.useState(!1), w = Je(u), C = Ev(n), S = m.useRef(!1), [T, P] = m.useState(0);
  return m.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(Ta, w), () => E.removeEventListener(Ta, w);
  }, [w]), /* @__PURE__ */ f(
    C1,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: g,
      onItemFocus: m.useCallback(
        (E) => v(E),
        [v]
      ),
      onItemShiftTab: m.useCallback(() => x(!0), []),
      onFocusableItemAdd: m.useCallback(
        () => P((E) => E + 1),
        []
      ),
      onFocusableItemRemove: m.useCallback(
        () => P((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ f(
        se.div,
        {
          tabIndex: b || T === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: j(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: j(e.onFocus, (E) => {
            const D = !S.current;
            if (E.target === E.currentTarget && D && !b) {
              const A = new CustomEvent(Ta, b1);
              if (E.currentTarget.dispatchEvent(A), !A.defaultPrevented) {
                const R = C().filter((V) => V.focusable), O = R.find((V) => V.active), F = R.find((V) => V.id === g), W = [O, F, ...R].filter(
                  Boolean
                ).map((V) => V.ref.current);
                Mv(W, c);
              }
            }
            S.current = !1;
          }),
          onBlur: j(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), Nv = "RovingFocusGroupItem", Rv = m.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: s,
      ...a
    } = e, l = mn(), u = i || l, c = S1(Nv, n), d = c.currentTabStopId === u, h = Ev(n), { onFocusableItemAdd: p, onFocusableItemRemove: y, currentTabStopId: g } = c;
    return m.useEffect(() => {
      if (r)
        return p(), () => y();
    }, [r, p, y]), /* @__PURE__ */ f(
      Al.ItemSlot,
      {
        scope: n,
        id: u,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ f(
          se.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": c.orientation,
            ...a,
            ref: t,
            onMouseDown: j(e.onMouseDown, (v) => {
              r ? c.onItemFocus(u) : v.preventDefault();
            }),
            onFocus: j(e.onFocus, () => c.onItemFocus(u)),
            onKeyDown: j(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const b = D1(v, c.orientation, c.dir);
              if (b !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = h().filter((C) => C.focusable).map((C) => C.ref.current);
                if (b === "last") w.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && w.reverse();
                  const C = w.indexOf(v.currentTarget);
                  w = c.loop ? k1(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => Mv(w));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: d, hasTabStop: g != null }) : s
          }
        )
      }
    );
  }
);
Rv.displayName = Nv;
var P1 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function E1(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function D1(e, t, n) {
  const r = E1(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return P1[r];
}
function Mv(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function k1(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var N1 = kv, R1 = Rv, Ol = ["Enter", " "], M1 = ["ArrowDown", "PageUp", "Home"], Av = ["ArrowUp", "PageDown", "End"], A1 = [...M1, ...Av], O1 = {
  ltr: [...Ol, "ArrowRight"],
  rtl: [...Ol, "ArrowLeft"]
}, I1 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ks = "Menu", [Vo, _1, $1] = Os(Ks), [mr, Ov] = Bt(Ks, [
  $1,
  _n,
  Dv
]), mu = _n(), Iv = Dv(), [qV, oo] = mr(Ks), [QV, li] = mr(Ks), L1 = "MenuAnchor", pu = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = mu(n);
    return /* @__PURE__ */ f(ni, { ...o, ...r, ref: t });
  }
);
pu.displayName = L1;
var F1 = "MenuPortal", [ZV, _v] = mr(F1, {
  forceMount: void 0
}), $t = "MenuContent", [V1, gu] = mr($t), $v = m.forwardRef(
  (e, t) => {
    const n = _v($t, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = oo($t, e.__scopeMenu), s = li($t, e.__scopeMenu);
    return /* @__PURE__ */ f(Vo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(ct, { present: r || i.open, children: /* @__PURE__ */ f(Vo.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ f(B1, { ...o, ref: t }) : /* @__PURE__ */ f(W1, { ...o, ref: t }) }) }) });
  }
), B1 = m.forwardRef(
  (e, t) => {
    const n = oo($t, e.__scopeMenu), r = m.useRef(null), o = ye(t, r);
    return m.useEffect(() => {
      const i = r.current;
      if (i) return ei(i);
    }, []), /* @__PURE__ */ f(
      vu,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: j(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), W1 = m.forwardRef((e, t) => {
  const n = oo($t, e.__scopeMenu);
  return /* @__PURE__ */ f(
    vu,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), z1 = /* @__PURE__ */ Nn("MenuContent.ScrollLock"), vu = m.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: c,
      onFocusOutside: d,
      onInteractOutside: h,
      onDismiss: p,
      disableOutsideScroll: y,
      ...g
    } = e, v = oo($t, n), b = li($t, n), x = mu(n), w = Iv(n), C = _1(n), [S, T] = m.useState(null), P = m.useRef(null), E = ye(t, P, v.onContentChange), D = m.useRef(0), A = m.useRef(""), R = m.useRef(0), O = m.useRef(null), F = m.useRef("right"), $ = m.useRef(0), W = y ? Jo : m.Fragment, V = y ? { as: z1, allowPinchZoom: !0 } : void 0, k = (M) => {
      var H, oe;
      const B = A.current + M, G = C().filter((he) => !he.disabled), _ = document.activeElement, U = (H = G.find((he) => he.ref.current === _)) == null ? void 0 : H.textValue, te = G.map((he) => he.textValue), X = eD(te, B, U), Q = (oe = G.find((he) => he.textValue === X)) == null ? void 0 : oe.ref.current;
      (function he(ne) {
        A.current = ne, window.clearTimeout(D.current), ne !== "" && (D.current = window.setTimeout(() => he(""), 1e3));
      })(B), Q && setTimeout(() => Q.focus());
    };
    m.useEffect(() => () => window.clearTimeout(D.current), []), ws();
    const N = m.useCallback((M) => {
      var G, _;
      return F.current === ((G = O.current) == null ? void 0 : G.side) && nD(M, (_ = O.current) == null ? void 0 : _.area);
    }, []);
    return /* @__PURE__ */ f(
      V1,
      {
        scope: n,
        searchRef: A,
        onItemEnter: m.useCallback(
          (M) => {
            N(M) && M.preventDefault();
          },
          [N]
        ),
        onItemLeave: m.useCallback(
          (M) => {
            var B;
            N(M) || ((B = P.current) == null || B.focus(), T(null));
          },
          [N]
        ),
        onTriggerLeave: m.useCallback(
          (M) => {
            N(M) && M.preventDefault();
          },
          [N]
        ),
        pointerGraceTimerRef: R,
        onPointerGraceIntentChange: m.useCallback((M) => {
          O.current = M;
        }, []),
        children: /* @__PURE__ */ f(W, { ...V, children: /* @__PURE__ */ f(
          Zo,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: j(i, (M) => {
              var B;
              M.preventDefault(), (B = P.current) == null || B.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ f(
              dr,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: u,
                onPointerDownOutside: c,
                onFocusOutside: d,
                onInteractOutside: h,
                onDismiss: p,
                children: /* @__PURE__ */ f(
                  N1,
                  {
                    asChild: !0,
                    ...w,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: T,
                    onEntryFocus: j(l, (M) => {
                      b.isUsingKeyboardRef.current || M.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ f(
                      Es,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Zv(v.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...x,
                        ...g,
                        ref: E,
                        style: { outline: "none", ...g.style },
                        onKeyDown: j(g.onKeyDown, (M) => {
                          const G = M.target.closest("[data-radix-menu-content]") === M.currentTarget, _ = M.ctrlKey || M.altKey || M.metaKey, U = M.key.length === 1;
                          G && (M.key === "Tab" && M.preventDefault(), !_ && U && k(M.key));
                          const te = P.current;
                          if (M.target !== te || !A1.includes(M.key)) return;
                          M.preventDefault();
                          const Q = C().filter((H) => !H.disabled).map((H) => H.ref.current);
                          Av.includes(M.key) && Q.reverse(), Z1(Q);
                        }),
                        onBlur: j(e.onBlur, (M) => {
                          M.currentTarget.contains(M.target) || (window.clearTimeout(D.current), A.current = "");
                        }),
                        onPointerMove: j(
                          e.onPointerMove,
                          Bo((M) => {
                            const B = M.target, G = $.current !== M.clientX;
                            if (M.currentTarget.contains(B) && G) {
                              const _ = M.clientX > $.current ? "right" : "left";
                              F.current = _, $.current = M.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
$v.displayName = $t;
var j1 = "MenuGroup", yu = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f(se.div, { role: "group", ...r, ref: t });
  }
);
yu.displayName = j1;
var H1 = "MenuLabel", Lv = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f(se.div, { ...r, ref: t });
  }
);
Lv.displayName = H1;
var as = "MenuItem", Tf = "menu.itemSelect", Xs = m.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = m.useRef(null), s = li(as, e.__scopeMenu), a = gu(as, e.__scopeMenu), l = ye(t, i), u = m.useRef(!1), c = () => {
      const d = i.current;
      if (!n && d) {
        const h = new CustomEvent(Tf, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Tf, (p) => r == null ? void 0 : r(p), { once: !0 }), kc(d, h), h.defaultPrevented ? u.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ f(
      Fv,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: j(e.onClick, c),
        onPointerDown: (d) => {
          var h;
          (h = e.onPointerDown) == null || h.call(e, d), u.current = !0;
        },
        onPointerUp: j(e.onPointerUp, (d) => {
          var h;
          u.current || (h = d.currentTarget) == null || h.click();
        }),
        onKeyDown: j(e.onKeyDown, (d) => {
          const h = a.searchRef.current !== "";
          n || h && d.key === " " || Ol.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
Xs.displayName = as;
var Fv = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = gu(as, n), a = Iv(n), l = m.useRef(null), u = ye(t, l), [c, d] = m.useState(!1), [h, p] = m.useState("");
    return m.useEffect(() => {
      const y = l.current;
      y && p((y.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ f(
      Vo.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? h,
        children: /* @__PURE__ */ f(R1, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ f(
          se.div,
          {
            role: "menuitem",
            "data-highlighted": c ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: u,
            onPointerMove: j(
              e.onPointerMove,
              Bo((y) => {
                r ? s.onItemLeave(y) : (s.onItemEnter(y), y.defaultPrevented || y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: j(
              e.onPointerLeave,
              Bo((y) => s.onItemLeave(y))
            ),
            onFocus: j(e.onFocus, () => d(!0)),
            onBlur: j(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), U1 = "MenuCheckboxItem", Vv = m.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ f(Hv, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ f(
      Xs,
      {
        role: "menuitemcheckbox",
        "aria-checked": ls(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": wu(n),
        onSelect: j(
          o.onSelect,
          () => r == null ? void 0 : r(ls(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Vv.displayName = U1;
var Bv = "MenuRadioGroup", [Y1, G1] = mr(
  Bv,
  { value: void 0, onValueChange: () => {
  } }
), Wv = m.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = Je(r);
    return /* @__PURE__ */ f(Y1, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ f(yu, { ...o, ref: t }) });
  }
);
Wv.displayName = Bv;
var zv = "MenuRadioItem", jv = m.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = G1(zv, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ f(Hv, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ f(
      Xs,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": wu(i),
        onSelect: j(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
jv.displayName = zv;
var bu = "MenuItemIndicator", [Hv, K1] = mr(
  bu,
  { checked: !1 }
), Uv = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = K1(bu, n);
    return /* @__PURE__ */ f(
      ct,
      {
        present: r || ls(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ f(
          se.span,
          {
            ...o,
            ref: t,
            "data-state": wu(i.checked)
          }
        )
      }
    );
  }
);
Uv.displayName = bu;
var X1 = "MenuSeparator", Yv = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f(
      se.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Yv.displayName = X1;
var q1 = "MenuArrow", Gv = m.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = mu(n);
    return /* @__PURE__ */ f(Ds, { ...o, ...r, ref: t });
  }
);
Gv.displayName = q1;
var Q1 = "MenuSub", [JV, Kv] = mr(Q1), xo = "MenuSubTrigger", Xv = m.forwardRef(
  (e, t) => {
    const n = oo(xo, e.__scopeMenu), r = li(xo, e.__scopeMenu), o = Kv(xo, e.__scopeMenu), i = gu(xo, e.__scopeMenu), s = m.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: l } = i, u = { __scopeMenu: e.__scopeMenu }, c = m.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return m.useEffect(() => c, [c]), m.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [a, l]), /* @__PURE__ */ f(pu, { asChild: !0, ...u, children: /* @__PURE__ */ f(
      Fv,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Zv(n.open),
        ...e,
        ref: bs(t, o.onTriggerChange),
        onClick: (d) => {
          var h;
          (h = e.onClick) == null || h.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: j(
          e.onPointerMove,
          Bo((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), c();
            }, 100));
          })
        ),
        onPointerLeave: j(
          e.onPointerLeave,
          Bo((d) => {
            var p, y;
            c();
            const h = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (h) {
              const g = (y = n.content) == null ? void 0 : y.dataset.side, v = g === "right", b = v ? -5 : 5, x = h[v ? "left" : "right"], w = h[v ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + b, y: d.clientY },
                  { x, y: h.top },
                  { x: w, y: h.top },
                  { x: w, y: h.bottom },
                  { x, y: h.bottom }
                ],
                side: g
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: j(e.onKeyDown, (d) => {
          var p;
          const h = i.searchRef.current !== "";
          e.disabled || h && d.key === " " || O1[r.dir].includes(d.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
Xv.displayName = xo;
var qv = "MenuSubContent", Qv = m.forwardRef(
  (e, t) => {
    const n = _v($t, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = oo($t, e.__scopeMenu), s = li($t, e.__scopeMenu), a = Kv(qv, e.__scopeMenu), l = m.useRef(null), u = ye(t, l);
    return /* @__PURE__ */ f(Vo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(ct, { present: r || i.open, children: /* @__PURE__ */ f(Vo.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(
      vu,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ref: u,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (c) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), c.preventDefault();
        },
        onCloseAutoFocus: (c) => c.preventDefault(),
        onFocusOutside: j(e.onFocusOutside, (c) => {
          c.target !== a.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: j(e.onEscapeKeyDown, (c) => {
          s.onClose(), c.preventDefault();
        }),
        onKeyDown: j(e.onKeyDown, (c) => {
          var p;
          const d = c.currentTarget.contains(c.target), h = I1[s.dir].includes(c.key);
          d && h && (i.onOpenChange(!1), (p = a.trigger) == null || p.focus(), c.preventDefault());
        })
      }
    ) }) }) });
  }
);
Qv.displayName = qv;
function Zv(e) {
  return e ? "open" : "closed";
}
function ls(e) {
  return e === "indeterminate";
}
function wu(e) {
  return ls(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Z1(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function J1(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function eD(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = J1(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((u) => u !== n));
  const l = s.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function tD(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], l = t[s], u = a.x, c = a.y, d = l.x, h = l.y;
    c > r != h > r && n < (d - u) * (r - c) / (h - c) + u && (o = !o);
  }
  return o;
}
function nD(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return tD(n, t);
}
function Bo(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var rD = pu, oD = $v, iD = yu, sD = Lv, aD = Xs, lD = Vv, cD = Wv, uD = jv, dD = Uv, fD = Yv, hD = Gv, mD = Xv, pD = Qv, Jv = "DropdownMenu", [gD, eB] = Bt(
  Jv,
  [Ov]
), Mt = Ov(), [tB, ey] = gD(Jv), ty = "DropdownMenuTrigger", vD = m.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = ey(ty, n), s = Mt(n);
    return /* @__PURE__ */ f(rD, { asChild: !0, ...s, children: /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: bs(t, i.triggerRef),
        onPointerDown: j(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
        }),
        onKeyDown: j(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
vD.displayName = ty;
var ny = "DropdownMenuContent", yD = m.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ey(ny, n), i = Mt(n), s = m.useRef(!1);
    return /* @__PURE__ */ f(
      oD,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: j(e.onCloseAutoFocus, (a) => {
          var l;
          s.current || (l = o.triggerRef.current) == null || l.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: j(e.onInteractOutside, (a) => {
          const l = a.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, c = l.button === 2 || u;
          (!o.modal || c) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
yD.displayName = ny;
var bD = "DropdownMenuGroup", wD = m.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
    return /* @__PURE__ */ f(iD, { ...o, ...r, ref: t });
  }
);
wD.displayName = bD;
var xD = "DropdownMenuLabel", ry = m.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
    return /* @__PURE__ */ f(sD, { ...o, ...r, ref: t });
  }
);
ry.displayName = xD;
var CD = "DropdownMenuItem", SD = m.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
    return /* @__PURE__ */ f(aD, { ...o, ...r, ref: t });
  }
);
SD.displayName = CD;
var TD = "DropdownMenuCheckboxItem", PD = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(lD, { ...o, ...r, ref: t });
});
PD.displayName = TD;
var ED = "DropdownMenuRadioGroup", DD = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(cD, { ...o, ...r, ref: t });
});
DD.displayName = ED;
var kD = "DropdownMenuRadioItem", ND = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(uD, { ...o, ...r, ref: t });
});
ND.displayName = kD;
var RD = "DropdownMenuItemIndicator", MD = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(dD, { ...o, ...r, ref: t });
});
MD.displayName = RD;
var AD = "DropdownMenuSeparator", OD = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(fD, { ...o, ...r, ref: t });
});
OD.displayName = AD;
var ID = "DropdownMenuArrow", _D = m.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
    return /* @__PURE__ */ f(hD, { ...o, ...r, ref: t });
  }
);
_D.displayName = ID;
var $D = "DropdownMenuSubTrigger", LD = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(mD, { ...o, ...r, ref: t });
});
LD.displayName = $D;
var FD = "DropdownMenuSubContent", VD = m.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Mt(n);
  return /* @__PURE__ */ f(
    pD,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
VD.displayName = FD;
var BD = ry;
const WD = (e, t) => {
  const n = me();
  return Ie(
    (...r) => {
      const o = () => {
        clearTimeout(n.current), e(...r);
      };
      clearTimeout(n.current), n.current = setTimeout(o, t);
    },
    [e, t]
  );
}, oy = (e) => !e || e.length === 0 ? 0 : 1 + Math.max(...e.map(({ childrenNodes: t }) => oy(t))), zD = ({ value: e, id: t, ancestors: n }) => {
  if (!n.length)
    return e.find((o) => o.id === t);
  let r;
  return n.forEach((o) => {
    r && r.childrenNodes ? r = r.childrenNodes.find((i) => i.id === o) : r = e.find((i) => i.id === o);
  }), r.childrenNodes.find((o) => o.id === t);
}, jD = ({ value: e, ancestors: t }) => {
  if (!t.length)
    return;
  const n = [];
  t.forEach((r) => {
    const o = n.length ? n[0].childrenNodes : e;
    if (o) {
      const i = o.find((s) => s.id === r);
      i && n.unshift(i);
    }
  }), n.forEach((r) => {
    var o, i;
    (o = r == null ? void 0 : r.childrenNodes) != null && o.every((s) => s.checked === !0) ? r.checked = !0 : (i = r == null ? void 0 : r.childrenNodes) != null && i.every((s) => !s.checked) ? r.checked = !1 : r.checked = "indeterminate";
  });
}, iy = (e) => {
  const t = e.checked;
  e.childrenNodes && e.childrenNodes.forEach((n) => {
    n.disabled || (n.checked = t, iy(n));
  });
}, sy = ({ node: e, search: t }) => {
  var r;
  if (!((r = e.childrenNodes) != null && r.length))
    return e.label.toLowerCase().includes(t.toLowerCase()) ? e : void 0;
  const n = e.childrenNodes.map((o) => sy({ node: o, search: t })).filter(Boolean);
  return n.length ? { ...e, childrenNodes: n } : void 0;
}, HD = (e) => ["indeterminate", !1].includes(e) || !1, UD = (e) => {
  var t, n;
  e.checked = ((t = e.childrenNodes) == null ? void 0 : t.every(({ checked: r }) => r === !0)) || !1, !e.checked && ((n = e.childrenNodes) != null && n.some(({ checked: r }) => [!0, "indeterminate"].includes(r))) && (e.checked = "indeterminate");
}, ay = ({
  filteredNodes: e,
  fullNodes: t,
  checked: n
}) => {
  e.forEach(({ id: r, childrenNodes: o }) => {
    var s;
    const i = t.find((a) => a.id === r);
    i && (o != null && o.length && ((s = i.childrenNodes) != null && s.length) ? (ay({
      filteredNodes: o,
      fullNodes: i.childrenNodes,
      checked: n
    }), UD(i)) : i.disabled || (i.checked = n));
  });
}, ly = ({ value: e = [], onChange: t, error: n, useAutoWidth: r }) => {
  const [o, i] = de(""), s = ve(() => o ? Et(e, (c) => (c = c.map((h) => sy({ node: h, search: o })).filter(Boolean), c)) : e, [e, o]), a = ({ node: { id: c, disabled: d }, ancestors: h }) => {
    if (!d) {
      const p = Et(e, (y) => {
        const g = zD({
          value: y,
          id: c,
          ancestors: h
        });
        g.checked = HD(g.checked), iy(g), jD({ value: y, ancestors: h });
      });
      t(p);
    }
  }, l = (c) => {
    const d = Et(e, (h) => {
      ay({
        filteredNodes: s,
        fullNodes: h,
        checked: c
      });
    });
    t(d);
  }, u = WD(({ target: { value: c } }) => {
    i(c);
  }, 500);
  return /* @__PURE__ */ L("div", { className: "flex flex-col h-full mb-4", children: [
    /* @__PURE__ */ L("div", { className: "flex align-end items-center justify-between mb-2", children: [
      /* @__PURE__ */ f(uu, { label: "Search", onChange: u }),
      /* @__PURE__ */ L("div", { className: "grow flex flex-row text-button-primary-outline-default space-x-2 text-sm justify-end", children: [
        /* @__PURE__ */ f(Pe, { onClick: () => l(!0), variant: "ghost", children: "Select all" }),
        /* @__PURE__ */ f(Oo, { orientation: "vertical", className: "h-auto" }),
        /* @__PURE__ */ f(Pe, { onClick: () => l(!1), variant: "ghost", children: "Deselect all" })
      ] })
    ] }),
    /* @__PURE__ */ f(
      "div",
      {
        "aria-errormessage": n || void 0,
        className: "grow flex flex-col border border-neutral-border rounded-md overflow-hidden aria-[errormessage]:border-red-500",
        children: /* @__PURE__ */ f("div", { className: "flex grow", children: /* @__PURE__ */ f(
          Pv,
          {
            depth: oy(e),
            useAutoWidth: r,
            nodes: s,
            ancestors: [],
            handleCheckboxChange: a
          }
        ) })
      }
    ),
    n && /* @__PURE__ */ f(
      BD,
      {
        "aria-errormessage": n,
        className: "block z-10 text-xs aria-disabled:text-neutral-text-secondary/50 text-red-500 aria-disabled:text-red-500/50",
        children: n
      }
    )
  ] });
}, cy = (e) => {
  switch (e) {
    case "large":
      return "min-h-[32rem]";
    case "medium":
      return "min-h-[24rem]";
    case "small":
    default:
      return "min-h-[16rem]";
  }
}, YD = [g1, v1, rs], GD = (e) => {
  var t;
  return [(t = e.group) == null ? void 0 : t.map((n) => n.label), e.name].filter(Boolean).join(" > ");
}, KD = ({ columns: e, value: t, onChange: n, size: r }) => {
  const o = ve(() => e.filter((a) => !a.readOnly && YD.includes(a.component)).map((a) => ({
    id: a.key,
    label: GD(a)
  })), [e]), i = ve(() => o.map((a) => ({
    ...a,
    checked: t.includes(a.id)
  })), [o, t]), s = (a) => {
    const l = a.filter((u) => u.checked === !0).map((u) => u.id);
    n(l);
  };
  return /* @__PURE__ */ L("div", { className: `p-2 py-4 ${cy(r)}`, children: [
    /* @__PURE__ */ f("div", { className: "text-neutral-text-primary font-bold text-xl pb-2", children: "Columns" }),
    /* @__PURE__ */ f(ly, { value: i, onChange: s, useAutoWidth: !0 })
  ] });
}, XD = ({
  column: e,
  value: t,
  onChange: n,
  table: r,
  size: o,
  sortValuesByLookupLabel: i = !1
}) => {
  const s = ve(() => {
    if (!r) return [];
    const c = r.select([e.key]).dedupe().array(e.key).map((d) => ({
      id: d,
      label: Gs(d, e.lookup, e.mask)
    }));
    return i ? [...c].sort(
      (d, h) => d.label.localeCompare(h.label, void 0, { sensitivity: "base", numeric: !0 })
    ) : c;
  }, [r, e.key, e.lookup, e.mask, i]), a = ve(() => s.map((u) => ({
    ...u,
    checked: t.includes(u.id)
  })), [s, t]), l = (u) => {
    const c = u.filter((d) => d.checked === !0).map((d) => d.id);
    n(c);
  };
  return /* @__PURE__ */ L("div", { className: `p-2 py-4 ${cy(o)}`, children: [
    /* @__PURE__ */ f("div", { className: "text-neutral-text-primary font-bold text-xl pb-2", children: e.name }),
    /* @__PURE__ */ f(ly, { value: a, onChange: l, useAutoWidth: !0 })
  ] });
}, Pf = (e) => {
  const t = e.size ? `input-${e.size}` : "input-md";
  return /* @__PURE__ */ f(Ft, { label: e.label, error: e.error, disabled: e.disabled, className: e.className, children: /* @__PURE__ */ L(Ls, { ...e, children: [
    /* @__PURE__ */ f(
      Fs,
      {
        "aria-errormessage": e.error,
        className: We("w-full0 border-0 data-[state=open]:[&>svg]:text-red-500", t),
        children: /* @__PURE__ */ f(iu, { placeholder: e.placeholder || "" })
      }
    ),
    /* @__PURE__ */ f(Vs, { children: /* @__PURE__ */ f(zg, { children: e.options.map(({ value: n, label: r }) => /* @__PURE__ */ f(Bs, { value: n, children: r }, n)) }) })
  ] }) });
};
function qD(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const uy = Y.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), ci = () => {
  const e = Y.useContext(uy);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
qD(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,100%,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,-100%,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(-100%,0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(100%,0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,100%,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,100%,0)}}@keyframes slideFromTop{from{transform:translate3d(0,-100%,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,-100%,0)}}@keyframes slideFromLeft{from{transform:translate3d(-100%,0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(-100%,0,0)}}@keyframes slideFromRight{from{transform:translate3d(100%,0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(100%,0,0)}}`);
const QD = 24, ZD = typeof window < "u" ? cr : fe;
function Ef(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
function JD() {
  return xu(/^Mac/);
}
function ek() {
  return xu(/^iPhone/);
}
function Df() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function tk() {
  return xu(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  JD() && navigator.maxTouchPoints > 1;
}
function dy() {
  return ek() || tk();
}
function xu(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Pa = typeof document < "u" && window.visualViewport;
function kf(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function fy(e) {
  for (kf(e) && (e = e.parentElement); e && !kf(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const nk = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Ri = 0, Ea;
function rk(e = {}) {
  let { isDisabled: t } = e;
  ZD(() => {
    if (!t)
      return Ri++, Ri === 1 && dy() && (Ea = ok()), () => {
        Ri--, Ri === 0 && (Ea == null || Ea());
      };
  }, [
    t
  ]);
}
function ok() {
  let e, t = 0, n = (d) => {
    e = fy(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let h = d.changedTouches[0].pageY, p = e.scrollTop, y = e.scrollHeight - e.clientHeight;
    y !== 0 && ((p <= 0 && h > t || p >= y && h < t) && d.preventDefault(), t = h);
  }, o = (d) => {
    let h = d.target;
    Il(h) && h !== document.activeElement && (d.preventDefault(), h.style.transform = "translateY(-2000px)", h.focus(), requestAnimationFrame(() => {
      h.style.transform = "";
    }));
  }, i = (d) => {
    let h = d.target;
    Il(h) && (h.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      h.style.transform = "", Pa && (Pa.height < window.innerHeight ? requestAnimationFrame(() => {
        Nf(h);
      }) : Pa.addEventListener("resize", () => Nf(h), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, u = Ef(ik(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let c = Ef(mo(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), mo(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), mo(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), mo(document, "focus", i, !0), mo(window, "scroll", s));
  return () => {
    u(), c(), window.scrollTo(a, l);
  };
}
function ik(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function mo(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Nf(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = fy(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + QD;
      i > s && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function Il(e) {
  return e instanceof HTMLInputElement && !nk.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function sk(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ak(...e) {
  return (t) => e.forEach((n) => sk(n, t));
}
function hy(...e) {
  return m.useCallback(ak(...e), e);
}
const my = /* @__PURE__ */ new WeakMap();
function nt(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && my.set(e, r);
}
function lk(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = my.get(e);
  n && (e.style[t] = n[t]);
}
const rt = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Mi(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[rt(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[rt(t) ? 5 : 4]) : null);
}
function ck(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Da(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function uk(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const He = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, py = 0.4, dk = 0.25, fk = 100, gy = 8, Ai = 16, _l = 26, ka = "vaul-dragging";
function vy(e) {
  const t = Y.useRef(e);
  return Y.useEffect(() => {
    t.current = e;
  }), Y.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function hk({ defaultProp: e, onChange: t }) {
  const n = Y.useState(e), [r] = n, o = Y.useRef(r), i = vy(t);
  return Y.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function yy({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = hk({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = vy(n), l = Y.useCallback((u) => {
    if (i) {
      const d = typeof u == "function" ? u(e) : u;
      d !== e && a(d);
    } else
      o(u);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function mk({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: s, direction: a = "bottom", container: l, snapToSequentialPoint: u }) {
  const [c, d] = yy({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [h, p] = Y.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  Y.useEffect(() => {
    function P() {
      p({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", P), () => window.removeEventListener("resize", P);
  }, []);
  const y = Y.useMemo(() => c === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    c
  ]), g = Y.useMemo(() => n == null ? void 0 : n.findIndex((P) => P === c), [
    n,
    c
  ]), v = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === c || !n, b = Y.useMemo(() => {
    const P = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var E;
    return (E = n == null ? void 0 : n.map((D) => {
      const A = typeof D == "string";
      let R = 0;
      if (A && (R = parseInt(D, 10)), rt(a)) {
        const F = A ? R : h ? D * P.height : 0;
        return h ? a === "bottom" ? P.height - F : -P.height + F : F;
      }
      const O = A ? R : h ? D * P.width : 0;
      return h ? a === "right" ? P.width - O : -P.width + O : O;
    })) != null ? E : [];
  }, [
    n,
    h,
    l
  ]), x = Y.useMemo(() => g !== null ? b == null ? void 0 : b[g] : null, [
    b,
    g
  ]), w = Y.useCallback((P) => {
    var E;
    const D = (E = b == null ? void 0 : b.findIndex((A) => A === P)) != null ? E : null;
    s(D), nt(r.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: rt(a) ? `translate3d(0, ${P}px, 0)` : `translate3d(${P}px, 0, 0)`
    }), b && D !== b.length - 1 && D !== i && D < i ? nt(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "0"
    }) : nt(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(D, 0)]);
  }, [
    r.current,
    n,
    b,
    i,
    o,
    d
  ]);
  Y.useEffect(() => {
    if (c || e) {
      var P;
      const E = (P = n == null ? void 0 : n.findIndex((D) => D === e || D === c)) != null ? P : -1;
      b && E !== -1 && typeof b[E] == "number" && w(b[E]);
    }
  }, [
    c,
    e,
    n,
    b,
    w
  ]);
  function C({ draggedDistance: P, closeDrawer: E, velocity: D, dismissible: A }) {
    if (i === void 0) return;
    const R = a === "bottom" || a === "right" ? (x ?? 0) - P : (x ?? 0) + P, O = g === i - 1, F = g === 0, $ = P > 0;
    if (O && nt(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`
    }), !u && D > 2 && !$) {
      A ? E() : w(b[0]);
      return;
    }
    if (!u && D > 2 && $ && b && n) {
      w(b[n.length - 1]);
      return;
    }
    const W = b == null ? void 0 : b.reduce((k, N) => typeof k != "number" || typeof N != "number" ? k : Math.abs(N - R) < Math.abs(k - R) ? N : k), V = rt(a) ? window.innerHeight : window.innerWidth;
    if (D > py && Math.abs(P) < V * 0.4) {
      const k = $ ? 1 : -1;
      if (k > 0 && y) {
        w(b[n.length - 1]);
        return;
      }
      if (F && k < 0 && A && E(), g === null) return;
      w(b[g + k]);
      return;
    }
    w(W);
  }
  function S({ draggedDistance: P }) {
    if (x === null) return;
    const E = a === "bottom" || a === "right" ? x - P : x + P;
    (a === "bottom" || a === "right") && E < b[b.length - 1] || (a === "top" || a === "left") && E > b[b.length - 1] || nt(r.current, {
      transform: rt(a) ? `translate3d(0, ${E}px, 0)` : `translate3d(${E}px, 0, 0)`
    });
  }
  function T(P, E) {
    if (!n || typeof g != "number" || !b || i === void 0) return null;
    const D = g === i - 1;
    if (g >= i && E)
      return 0;
    if (D && !E) return 1;
    if (!v && !D) return null;
    const R = D ? g + 1 : g - 1, O = D ? b[R] - b[R - 1] : b[R + 1] - b[R], F = P / Math.abs(O);
    return D ? 1 - F : F;
  }
  return {
    isLastSnapPoint: y,
    activeSnapPoint: c,
    shouldFade: v,
    getPercentageDragged: T,
    setActiveSnapPoint: d,
    activeSnapPointIndex: g,
    onRelease: C,
    onDrag: S,
    snapPointsOffset: b
  };
}
const pk = () => () => {
};
function gk() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = ci(), i = Y.useRef(null), s = ve(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - _l) / window.innerWidth;
  }
  Y.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      uk(r && !o ? Da(document.body, {
        background: "black"
      }) : pk, Da(l, {
        transformOrigin: rt(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${He.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${He.EASE.join(",")})`
      }));
      const u = Da(l, {
        borderRadius: `${gy}px`,
        overflow: "hidden",
        ...rt(e) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        u(), i.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, He.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let po = null;
function vk({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [s, a] = Y.useState(() => typeof window < "u" ? window.location.href : ""), l = Y.useRef(0), u = Y.useCallback(() => {
    if (Df() && po === null && e && !i) {
      po = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: h } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const p = h - window.innerHeight;
        p && l.current >= h && (document.body.style.top = `${-(l.current + p)}px`);
      }), 300);
    }
  }, [
    e
  ]), c = Y.useCallback(() => {
    if (Df() && po !== null && !i) {
      const d = -parseInt(document.body.style.top, 10), h = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, po), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(h, d);
      }), po = null;
    }
  }, [
    s
  ]);
  return Y.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), Y.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && u(), t || window.setTimeout(() => {
      c();
    }, 500)) : c());
  }, [
    e,
    r,
    s,
    t,
    n,
    u,
    c
  ]), {
    restorePositionSetting: c
  };
}
function yk({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: s = !1, setBackgroundColorOnScale: a = !0, closeThreshold: l = dk, scrollLockTimeout: u = fk, dismissible: c = !0, handleOnly: d = !1, fadeFromIndex: h = i && i.length - 1, activeSnapPoint: p, setActiveSnapPoint: y, fixed: g, modal: v = !0, onClose: b, nested: x, noBodyStyles: w, direction: C = "bottom", defaultOpen: S = !1, disablePreventScroll: T = !0, snapToSequentialPoint: P = !1, preventScrollRestoration: E = !1, repositionInputs: D = !0, onAnimationEnd: A, container: R, autoFocus: O = !1 }) {
  var F, $;
  const [W = !1, V] = yy({
    defaultProp: S,
    prop: e,
    onChange: (ie) => {
      t == null || t(ie), !ie && !x && ht(), setTimeout(() => {
        A == null || A(ie);
      }, He.DURATION * 1e3), ie && !v && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), ie || (document.body.style.pointerEvents = "auto");
    }
  }), [k, N] = Y.useState(!1), [M, B] = Y.useState(!1), [G, _] = Y.useState(!1), U = Y.useRef(null), te = Y.useRef(null), X = Y.useRef(null), Q = Y.useRef(null), H = Y.useRef(null), oe = Y.useRef(!1), he = Y.useRef(null), ne = Y.useRef(0), be = Y.useRef(!1), xe = Y.useRef(0), re = Y.useRef(null), ot = Y.useRef(((F = re.current) == null ? void 0 : F.getBoundingClientRect().height) || 0), St = Y.useRef((($ = re.current) == null ? void 0 : $.getBoundingClientRect().width) || 0), At = Y.useRef(0), Zt = Y.useCallback((ie) => {
    i && ie === ae.length - 1 && (te.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: vr, activeSnapPointIndex: I, setActiveSnapPoint: Z, onRelease: K, snapPointsOffset: ae, onDrag: pe, shouldFade: Ae, getPercentageDragged: et } = mk({
    snapPoints: i,
    activeSnapPointProp: p,
    setActiveSnapPointProp: y,
    drawerRef: re,
    fadeFromIndex: h,
    overlayRef: U,
    onSnapPointChange: Zt,
    direction: C,
    container: R,
    snapToSequentialPoint: P
  });
  rk({
    isDisabled: !W || M || !v || G || !k || !D || !T
  });
  const { restorePositionSetting: ht } = vk({
    isOpen: W,
    modal: v,
    nested: x,
    hasBeenOpened: k,
    preventScrollRestoration: E,
    noBodyStyles: w
  });
  function le() {
    return (window.innerWidth - _l) / window.innerWidth;
  }
  function Ne(ie) {
    var De, Me;
    !c && !i || re.current && !re.current.contains(ie.target) || (ot.current = ((De = re.current) == null ? void 0 : De.getBoundingClientRect().height) || 0, St.current = ((Me = re.current) == null ? void 0 : Me.getBoundingClientRect().width) || 0, B(!0), X.current = /* @__PURE__ */ new Date(), dy() && window.addEventListener("touchend", () => oe.current = !1, {
      once: !0
    }), ie.target.setPointerCapture(ie.pointerId), ne.current = rt(C) ? ie.pageY : ie.pageX);
  }
  function Ce(ie, De) {
    var Me, Oe;
    let Se = ie;
    const dt = (Me = window.getSelection()) == null ? void 0 : Me.toString(), tt = re.current ? Mi(re.current, C) : null, mt = /* @__PURE__ */ new Date();
    if (Se.hasAttribute("data-vaul-no-drag") || Se.closest("[data-vaul-no-drag]"))
      return !1;
    if (C === "right" || C === "left")
      return !0;
    if (te.current && mt.getTime() - te.current.getTime() < 500)
      return !1;
    if (tt !== null && (C === "bottom" ? tt > 0 : tt < 0))
      return !0;
    if (dt && dt.length > 0)
      return !1;
    if (mt.getTime() - ((Oe = H.current) == null ? void 0 : Oe.getTime()) < u && tt === 0 || De)
      return H.current = mt, !1;
    for (; Se; ) {
      if (Se.scrollHeight > Se.clientHeight) {
        if (Se.scrollTop !== 0)
          return H.current = /* @__PURE__ */ new Date(), !1;
        if (Se.getAttribute("role") === "dialog")
          return !0;
      }
      Se = Se.parentNode;
    }
    return !0;
  }
  function ee(ie) {
    if (re.current && M) {
      const De = C === "bottom" || C === "right" ? 1 : -1, Me = (ne.current - (rt(C) ? ie.pageY : ie.pageX)) * De, Oe = Me > 0, Se = i && !c && !Oe;
      if (Se && I === 0) return;
      const dt = Math.abs(Me), tt = document.querySelector("[data-vaul-drawer-wrapper]"), mt = C === "bottom" || C === "top" ? ot.current : St.current;
      let pt = dt / mt;
      const Tt = et(dt, Oe);
      if (Tt !== null && (pt = Tt), Se && pt >= 1 || !oe.current && !Ce(ie.target, Oe)) return;
      if (re.current.classList.add(ka), oe.current = !0, nt(re.current, {
        transition: "none"
      }), nt(U.current, {
        transition: "none"
      }), i && pe({
        draggedDistance: Me
      }), Oe && !i) {
        const en = ck(Me), Ci = Math.min(en * -1, 0) * De;
        nt(re.current, {
          transform: rt(C) ? `translate3d(0, ${Ci}px, 0)` : `translate3d(${Ci}px, 0, 0)`
        });
        return;
      }
      const xn = 1 - pt;
      if ((Ae || h && I === h - 1) && (r == null || r(ie, pt), nt(U.current, {
        opacity: `${xn}`,
        transition: "none"
      }, !0)), tt && U.current && s) {
        const en = Math.min(le() + pt * (1 - le()), 1), Ci = 8 - pt * 8, Od = Math.max(0, 14 - pt * 14);
        nt(tt, {
          borderRadius: `${Ci}px`,
          transform: rt(C) ? `scale(${en}) translate3d(0, ${Od}px, 0)` : `scale(${en}) translate3d(${Od}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const en = dt * De;
        nt(re.current, {
          transform: rt(C) ? `translate3d(0, ${en}px, 0)` : `translate3d(${en}px, 0, 0)`
        });
      }
    }
  }
  Y.useEffect(() => {
    var ie;
    function De() {
      if (!re.current || !D) return;
      const Me = document.activeElement;
      if (Il(Me) || be.current) {
        var Oe;
        const Se = ((Oe = window.visualViewport) == null ? void 0 : Oe.height) || 0, dt = window.innerHeight;
        let tt = dt - Se;
        const mt = re.current.getBoundingClientRect().height || 0, pt = mt > dt * 0.8;
        At.current || (At.current = mt);
        const Tt = re.current.getBoundingClientRect().top;
        if (Math.abs(xe.current - tt) > 60 && (be.current = !be.current), i && i.length > 0 && ae && I) {
          const xn = ae[I] || 0;
          tt += xn;
        }
        if (xe.current = tt, mt > Se || be.current) {
          const xn = re.current.getBoundingClientRect().height;
          let en = xn;
          xn > Se && (en = Se - (pt ? Tt : _l)), g ? re.current.style.height = `${xn - Math.max(tt, 0)}px` : re.current.style.height = `${Math.max(en, Se - Tt)}px`;
        } else
          re.current.style.height = `${At.current}px`;
        i && i.length > 0 && !be.current ? re.current.style.bottom = "0px" : re.current.style.bottom = `${Math.max(tt, 0)}px`;
      }
    }
    return (ie = window.visualViewport) == null || ie.addEventListener("resize", De), () => {
      var Me;
      return (Me = window.visualViewport) == null ? void 0 : Me.removeEventListener("resize", De);
    };
  }, [
    I,
    i,
    ae
  ]);
  function z(ie) {
    _e(), b == null || b(), ie || V(!1), setTimeout(() => {
      i && Z(i[0]);
    }, He.DURATION * 1e3);
  }
  function ut() {
    if (!re.current) return;
    const ie = document.querySelector("[data-vaul-drawer-wrapper]"), De = Mi(re.current, C);
    nt(re.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`
    }), nt(U.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "1"
    }), s && De && De > 0 && W && nt(ie, {
      borderRadius: `${gy}px`,
      overflow: "hidden",
      ...rt(C) ? {
        transform: `scale(${le()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${le()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${He.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${He.EASE.join(",")})`
    }, !0);
  }
  function _e() {
    !M || !re.current || (re.current.classList.remove(ka), oe.current = !1, B(!1), Q.current = /* @__PURE__ */ new Date());
  }
  function Jt(ie) {
    if (!M || !re.current) return;
    re.current.classList.remove(ka), oe.current = !1, B(!1), Q.current = /* @__PURE__ */ new Date();
    const De = Mi(re.current, C);
    if (!Ce(ie.target, !1) || !De || Number.isNaN(De) || X.current === null) return;
    const Me = Q.current.getTime() - X.current.getTime(), Oe = ne.current - (rt(C) ? ie.pageY : ie.pageX), Se = Math.abs(Oe) / Me;
    if (Se > 0.05 && (_(!0), setTimeout(() => {
      _(!1);
    }, 200)), i) {
      K({
        draggedDistance: Oe * (C === "bottom" || C === "right" ? 1 : -1),
        closeDrawer: z,
        velocity: Se,
        dismissible: c
      }), o == null || o(ie, !0);
      return;
    }
    if (C === "bottom" || C === "right" ? Oe > 0 : Oe < 0) {
      ut(), o == null || o(ie, !0);
      return;
    }
    if (Se > py) {
      z(), o == null || o(ie, !1);
      return;
    }
    var dt;
    const tt = Math.min((dt = re.current.getBoundingClientRect().height) != null ? dt : 0, window.innerHeight);
    var mt;
    const pt = Math.min((mt = re.current.getBoundingClientRect().width) != null ? mt : 0, window.innerWidth), Tt = C === "left" || C === "right";
    if (Math.abs(De) >= (Tt ? pt : tt) * l) {
      z(), o == null || o(ie, !1);
      return;
    }
    o == null || o(ie, !0), ut();
  }
  Y.useEffect(() => (W && (nt(document.documentElement, {
    scrollBehavior: "auto"
  }), te.current = /* @__PURE__ */ new Date()), () => {
    lk(document.documentElement, "scrollBehavior");
  }), [
    W
  ]);
  function yr(ie) {
    const De = ie ? (window.innerWidth - Ai) / window.innerWidth : 1, Me = ie ? -16 : 0;
    he.current && window.clearTimeout(he.current), nt(re.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: `scale(${De}) translate3d(0, ${Me}px, 0)`
    }), !ie && re.current && (he.current = setTimeout(() => {
      const Oe = Mi(re.current, C);
      nt(re.current, {
        transition: "none",
        transform: rt(C) ? `translate3d(0, ${Oe}px, 0)` : `translate3d(${Oe}px, 0, 0)`
      });
    }, 500));
  }
  function xi(ie, De) {
    if (De < 0) return;
    const Me = (window.innerWidth - Ai) / window.innerWidth, Oe = Me + De * (1 - Me), Se = -16 + De * Ai;
    nt(re.current, {
      transform: rt(C) ? `scale(${Oe}) translate3d(0, ${Se}px, 0)` : `scale(${Oe}) translate3d(${Se}px, 0, 0)`,
      transition: "none"
    });
  }
  function la(ie, De) {
    const Me = rt(C) ? window.innerHeight : window.innerWidth, Oe = De ? (Me - Ai) / Me : 1, Se = De ? -16 : 0;
    De && nt(re.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: rt(C) ? `scale(${Oe}) translate3d(0, ${Se}px, 0)` : `scale(${Oe}) translate3d(${Se}px, 0, 0)`
    });
  }
  return /* @__PURE__ */ Y.createElement(xp, {
    defaultOpen: S,
    onOpenChange: (ie) => {
      !c && !ie || (ie ? N(!0) : z(!0), V(ie));
    },
    open: W
  }, /* @__PURE__ */ Y.createElement(uy.Provider, {
    value: {
      activeSnapPoint: vr,
      snapPoints: i,
      setActiveSnapPoint: Z,
      drawerRef: re,
      overlayRef: U,
      onOpenChange: t,
      onPress: Ne,
      onRelease: Jt,
      onDrag: ee,
      dismissible: c,
      handleOnly: d,
      isOpen: W,
      isDragging: M,
      shouldFade: Ae,
      closeDrawer: z,
      onNestedDrag: xi,
      onNestedOpenChange: yr,
      onNestedRelease: la,
      keyboardIsOpen: be,
      modal: v,
      snapPointsOffset: ae,
      direction: C,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: a,
      noBodyStyles: w,
      container: R,
      autoFocus: O
    }
  }, n));
}
const by = /* @__PURE__ */ Y.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: s, modal: a } = ci(), l = hy(t, n), u = r && r.length > 0;
  return a ? /* @__PURE__ */ Y.createElement(Ic, {
    onMouseUp: o,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && u ? "true" : "false",
    "data-vaul-snap-points-overlay": s && i ? "true" : "false",
    ...e
  }) : (typeof window < "u" && window.requestAnimationFrame(() => {
    document.body.style.pointerEvents = "auto";
  }), null);
});
by.displayName = "Drawer.Overlay";
const wy = /* @__PURE__ */ Y.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: s, onRelease: a, onDrag: l, keyboardIsOpen: u, snapPointsOffset: c, modal: d, isOpen: h, direction: p, snapPoints: y, container: g, handleOnly: v, autoFocus: b } = ci(), [x, w] = Y.useState(!1), C = hy(o, i), S = Y.useRef(null), T = Y.useRef(null), P = Y.useRef(!1), E = y && y.length > 0;
  gk();
  const D = (R, O, F = 0) => {
    if (P.current) return !0;
    const $ = Math.abs(R.y), W = Math.abs(R.x), V = W > $, k = [
      "bottom",
      "right"
    ].includes(O) ? 1 : -1;
    if (O === "left" || O === "right") {
      if (!(R.x * k < 0) && W >= 0 && W <= F)
        return V;
    } else if (!(R.y * k < 0) && $ >= 0 && $ <= F)
      return !V;
    return P.current = !0, !0;
  };
  Y.useEffect(() => {
    E && window.requestAnimationFrame(() => {
      w(!0);
    });
  }, []);
  function A(R) {
    S.current = null, P.current = !1, a(R);
  }
  return /* @__PURE__ */ Y.createElement(_c, {
    "data-vaul-drawer-direction": p,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": x ? "true" : "false",
    "data-vaul-snap-points": h && E ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    ...r,
    ref: C,
    style: c && c.length > 0 ? {
      "--snap-point-height": `${c[0]}px`,
      ...t
    } : t,
    onPointerDown: (R) => {
      v || (r.onPointerDown == null || r.onPointerDown.call(r, R), S.current = {
        x: R.pageX,
        y: R.pageY
      }, s(R));
    },
    onOpenAutoFocus: (R) => {
      n == null || n(R), b || R.preventDefault();
    },
    onPointerDownOutside: (R) => {
      if (e == null || e(R), !d || R.defaultPrevented) {
        R.preventDefault();
        return;
      }
      u.current && (u.current = !1);
    },
    onFocusOutside: (R) => {
      if (!d) {
        R.preventDefault();
        return;
      }
    },
    onPointerMove: (R) => {
      if (T.current = R, v || (r.onPointerMove == null || r.onPointerMove.call(r, R), !S.current)) return;
      const O = R.pageY - S.current.y, F = R.pageX - S.current.x, $ = R.pointerType === "touch" ? 10 : 2;
      D({
        x: F,
        y: O
      }, p, $) ? l(R) : (Math.abs(F) > $ || Math.abs(O) > $) && (S.current = null);
    },
    onPointerUp: (R) => {
      r.onPointerUp == null || r.onPointerUp.call(r, R), S.current = null, P.current = !1, a(R);
    },
    onPointerOut: (R) => {
      r.onPointerOut == null || r.onPointerOut.call(r, R), A(T.current);
    },
    onContextMenu: (R) => {
      r.onContextMenu == null || r.onContextMenu.call(r, R), A(T.current);
    }
  });
});
wy.displayName = "Drawer.Content";
const bk = 250, wk = 120, xk = /* @__PURE__ */ Y.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: s, activeSnapPoint: a, setActiveSnapPoint: l, dismissible: u, handleOnly: c, isOpen: d, onPress: h, onDrag: p } = ci(), y = Y.useRef(null), g = Y.useRef(!1);
  function v() {
    if (g.current) {
      w();
      return;
    }
    window.setTimeout(() => {
      b();
    }, wk);
  }
  function b() {
    if (i || e || g.current) {
      w();
      return;
    }
    if (w(), (!s || s.length === 0) && u) {
      o();
      return;
    }
    if (a === s[s.length - 1] && u) {
      o();
      return;
    }
    const S = s.findIndex((P) => P === a);
    if (S === -1) return;
    const T = s[S + 1];
    l(T);
  }
  function x() {
    y.current = window.setTimeout(() => {
      g.current = !0;
    }, bk);
  }
  function w() {
    window.clearTimeout(y.current), g.current = !1;
  }
  return /* @__PURE__ */ Y.createElement("div", {
    onClick: v,
    onPointerCancel: w,
    onPointerDown: (C) => {
      c && h(C), x();
    },
    onPointerMove: (C) => {
      c && p(C);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ Y.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
xk.displayName = "Drawer.Handle";
function Ck(e) {
  const t = ci(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ Y.createElement(Sp, {
    container: n,
    ...r
  });
}
const Qt = {
  Root: yk,
  Content: wy,
  Overlay: by,
  Trigger: Cp,
  Portal: Ck,
  Close: Fc,
  Title: $c,
  Description: Lc
}, xy = ({ shouldScaleBackground: e = !0, ...t }) => /* @__PURE__ */ f(Qt.Root, { shouldScaleBackground: e, ...t });
xy.displayName = "Drawer";
const nB = Qt.Trigger, Sk = Qt.Portal, rB = Qt.Close, Cy = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(Qt.Overlay, { ref: n, className: q("fixed inset-0 z-50 bg-black/80", e), ...t }));
Cy.displayName = Qt.Overlay.displayName;
const Sy = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(Sk, { children: [
  /* @__PURE__ */ f(Cy, {}),
  /* @__PURE__ */ f(
    Qt.Content,
    {
      ref: r,
      className: q(
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-l-2xl border bg-background",
        e
      ),
      ...n,
      children: t
    }
  )
] }));
Sy.displayName = "DrawerContent";
const Tk = ({ className: e, ...t }) => /* @__PURE__ */ f("div", { className: q("grid gap-1.5 p-4 text-center sm:text-left", e), ...t });
Tk.displayName = "DrawerHeader";
const Pk = ({ className: e, ...t }) => /* @__PURE__ */ f("div", { className: q("mt-auto flex flex-col gap-2 p-4", e), ...t });
Pk.displayName = "DrawerFooter";
const Ty = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Qt.Title,
  {
    ref: n,
    className: q("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Ty.displayName = Qt.Title.displayName;
const Ek = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(Qt.Description, { ref: n, className: q("text-sm text-muted-foreground", e), ...t }));
Ek.displayName = Qt.Description.displayName;
const Dk = ur(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Py = m.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f("div", { ref: r, role: "alert", className: q(Dk({ variant: t }), e), ...n }));
Py.displayName = "Alert";
const Ey = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ f("h5", { ref: n, className: q("mb-1 font-medium leading-none tracking-tight", e), ...t })
);
Ey.displayName = "AlertTitle";
const Dy = m.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { ref: n, className: q("text-sm [&_p]:leading-relaxed", e), ...t })
);
Dy.displayName = "AlertDescription";
const kk = ({
  isOpen: e,
  close: t,
  columns: n,
  onRowsCommit: r,
  onRowsSkipped: o,
  table: i,
  valueFormatter: s,
  size: a,
  columnsToHide: l = [],
  maxLength: u = 20,
  sortUsingLookup: c
}) => {
  const [d, h] = de({}), [p, y] = de([]), [g, v] = de("delta"), [b, x] = de("0"), w = hu(), C = ve(() => {
    let D = n.filter((A) => A.filterable && !(l != null && l.includes(A.key)));
    return w && (D = w.applyLookups(D)), D;
  }, [n, l]), S = Ie(
    (D) => {
      var O;
      const A = n.find((F) => F.key === D);
      if (!A) return [];
      const R = (O = A.componentProps) == null ? void 0 : O.options;
      if (!R) return [];
      if (Array.isArray(R))
        return R.map((F) => ({ key: F.key, label: F.label }));
      if (typeof R == "function" && i) {
        const F = /* @__PURE__ */ new Map();
        for (const $ of i.objects())
          try {
            const W = R($.key, D, $);
            Array.isArray(W) && W.forEach((V) => {
              F.has(V.key) || F.set(V.key, { key: V.key, label: V.label });
            });
          } catch (W) {
            console.warn(`Error getting options for row ${$.key}:`, W);
          }
        return Array.from(F.values());
      }
      return [];
    },
    [n, i]
  ), T = ve(() => {
    const D = p.filter((R) => {
      var O;
      return ((O = n.find((F) => F.key === R)) == null ? void 0 : O.component) === rs;
    }).map((R) => {
      const O = S(R);
      return {
        key: R,
        optStr: O.map((F) => F.key).sort().join(",")
      };
    }), A = p.filter(
      (R) => {
        var O;
        return ((O = n.find((F) => F.key === R)) == null ? void 0 : O.dataType) === "number";
      }
    );
    return D.length && A.length ? "error_mixed" : D.length ? D.every((O) => O.optStr === D[0].optStr) ? "select" : "error_mixed" : A.length ? "number" : "none";
  }, [p, n, S]);
  fe(() => {
    x("");
  }, [T]), fe(() => {
    e || (h({}), y([]), x("0"));
  }, [e]);
  const P = ve(() => !(!i || T === "error_mixed" || !p.length || !Object.values(d).some((D) => D.length) || T === "number" && isNaN(Number(b)) || T === "select" && !b || b.length > u), [i, p, d, T, b]), E = () => {
    var F;
    if (!P) return;
    const D = t1(d, i), A = [];
    let R = 0;
    for (const $ of p) {
      const W = n.find((k) => k.key === $);
      let V = 0;
      for (const k of D.objects()) {
        const N = k[$];
        let M;
        if (T === "select") {
          M = b;
          const B = (F = W == null ? void 0 : W.componentProps) == null ? void 0 : F.options;
          if (typeof B == "function")
            try {
              const G = B(k.key, $, k);
              if (Array.isArray(G) && !G.some((U) => U.key === M)) {
                R++, V++;
                continue;
              }
            } catch (G) {
              console.warn(`Error validating option for row ${k.key}:`, G), R++, V++;
              continue;
            }
        } else
          W && W.dataType === "number" && W.mask === "100#.##%" ? M = Number(b) / 100 : M = b, M = s ? s(Number(M)) : Number(M);
        A.push({
          value: M,
          column: $,
          pasteValue: T === "select" ? M : g === "delta" ? (N || 0) + M : M,
          row: k.key,
          rowIndex: V
        }), V++;
      }
    }
    const O = Sv(A, D, n);
    O.length && r(O), R > 0 && o && o(R), t();
  };
  return /* @__PURE__ */ L(xy, { open: e, onOpenChange: (D) => !D && t(), direction: "right", children: [
    /* @__PURE__ */ f(Ty, {}),
    /* @__PURE__ */ f(
      Sy,
      {
        className: q("h-screen top-0 right-0 left-auto mt-0 p-4 xl:p-8 min-w-150 focus-visible:outline-0"),
        "data-vaul-no-drag": !0,
        style: {
          width: "60vw",
          borderTopRightRadius: "0",
          borderBottomRightRadius: "0"
        },
        children: /* @__PURE__ */ L("div", { className: "flex flex-col gap-4 grow", children: [
          /* @__PURE__ */ L("div", { className: "flex flex-col gap-2 grow pretty-scrollbar h-0 overflow-y-scroll", children: [
            C.map((D) => {
              var A;
              return /* @__PURE__ */ f(
                XD,
                {
                  column: D,
                  table: i,
                  value: ((A = d == null ? void 0 : d[D.key]) == null ? void 0 : A.map((R) => R.key)) || [],
                  onChange: (R) => {
                    h({
                      ...d,
                      [D.key]: R.map((O) => ({ key: O, label: O }))
                    });
                  },
                  size: a,
                  sortValuesByLookupLabel: c != null && c.includes(D.key)
                },
                D.key
              );
            }),
            /* @__PURE__ */ f(
              KD,
              {
                columns: n,
                value: p,
                onChange: (D) => {
                  y(D);
                },
                size: a
              }
            )
          ] }),
          /* @__PURE__ */ L("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ L("div", { className: "grow flex gap-2", children: [
              T === "error_mixed" && /* @__PURE__ */ L(
                Py,
                {
                  variant: "destructive",
                  className: "p-1 pl-2 text-sm bg-red-100 dark:bg-red-900 dark:text-white mb-2",
                  children: [
                    /* @__PURE__ */ f(Ey, { children: "Mixed Input Types" }),
                    /* @__PURE__ */ f(Dy, { children: "Mixed input types are not allowed. Please select only one type of input." })
                  ]
                }
              ),
              T === "select" && /* @__PURE__ */ f(
                Pf,
                {
                  label: "Value",
                  className: "w-full",
                  options: S(p[0]).map((D) => ({
                    label: D.label,
                    value: D.key
                  })) || [],
                  value: b,
                  onValueChange: (D) => x(D || "")
                }
              ),
              T === "number" && /* @__PURE__ */ L(ke, { children: [
                /* @__PURE__ */ f(
                  Pf,
                  {
                    label: "Mode",
                    className: "w-full",
                    options: [
                      {
                        label: "Delta",
                        value: "delta"
                      },
                      {
                        label: "Absolute",
                        value: "absolute"
                      }
                    ],
                    value: g,
                    onValueChange: (D) => v(D || "delta")
                  }
                ),
                /* @__PURE__ */ f(
                  uu,
                  {
                    className: "w-full",
                    maxLength: u,
                    label: "Value",
                    value: b,
                    onChange: (D) => x(D.currentTarget.value)
                  }
                )
              ] })
            ] }),
            T !== "error_mixed" && /* @__PURE__ */ f(Pe, { disabled: !P, onClick: E, children: "Apply" })
          ] })
        ] })
      }
    )
  ] });
}, oB = ({
  trigger: e,
  columns: t,
  onRowsCommit: n,
  onRowsSkipped: r,
  table: o,
  valueFormatter: i,
  size: s,
  columnsToHide: a,
  sortUsingLookup: l
}) => {
  const [u, c] = de(!1);
  return /* @__PURE__ */ L(ke, { children: [
    e ? /* @__PURE__ */ f("div", { onClick: () => c(!0), children: e }) : /* @__PURE__ */ L(Pe, { className: "icon-left", variant: "outline", disabled: !o, onClick: () => c(!0), children: [
      /* @__PURE__ */ f(Ex, {}),
      "Bulk Update"
    ] }),
    /* @__PURE__ */ f(
      kk,
      {
        isOpen: u,
        close: () => c(!1),
        columns: t,
        onRowsCommit: n,
        onRowsSkipped: r,
        table: o,
        valueFormatter: i,
        size: s,
        columnsToHide: a,
        sortUsingLookup: l
      }
    )
  ] });
}, iB = (e) => {
  const [t, n] = lu(e, {});
  return {
    filters: t,
    setFilters: (i, s) => {
      n({
        ...t,
        [i.key]: s
      });
    },
    clearFilters: () => {
      n({});
    }
  };
};
function Nk() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ve(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const Rk = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Mk(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function Ak(e) {
  return "nodeType" in e;
}
function ky(e) {
  var t, n;
  return e ? Mk(e) ? e : Ak(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
const qs = Rk ? cr : fe;
function Ny(e) {
  const t = me(e);
  return qs(() => {
    t.current = e;
  }), Ie(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function $l(e, t) {
  t === void 0 && (t = [e]);
  const n = me(e);
  return qs(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function Ll(e) {
  const t = Ny(e), n = me(null), r = Ie(
    (o) => {
      o !== n.current && (t == null || t(o, n.current)), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
let Na = {};
function Ry(e, t) {
  return ve(() => {
    const n = Na[e] == null ? 0 : Na[e] + 1;
    return Na[e] = n, e + "-" + n;
  }, [e, t]);
}
function Ok(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = ky(e.target);
  return t && e instanceof t;
}
const Wo = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Wo.Translate.toString(e), Wo.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
});
var Po;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Po || (Po = {}));
function Rf() {
}
const Ik = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function _k(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function $k(e, t, n) {
  const r = _k(t);
  if (!r)
    return e;
  const {
    scaleX: o,
    scaleY: i,
    x: s,
    y: a
  } = r, l = e.left - s - (1 - o) * parseFloat(n), u = e.top - a - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), c = o ? e.width / o : e.width, d = i ? e.height / i : e.height;
  return {
    width: c,
    height: d,
    top: u,
    right: l + c,
    bottom: u + d,
    left: l
  };
}
const Lk = {
  ignoreTransform: !1
};
function Fk(e, t) {
  t === void 0 && (t = Lk);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: u,
      transformOrigin: c
    } = ky(e).getComputedStyle(e);
    u && (n = $k(n, u, c));
  }
  const {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  } = n;
  return {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  };
}
var kr;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(kr || (kr = {}));
var Mf;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Mf || (Mf = {}));
var _t;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(_t || (_t = {}));
_t.Space, _t.Enter, _t.Esc, _t.Space, _t.Enter, _t.Tab;
var Af;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Af || (Af = {}));
var Of;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Of || (Of = {}));
var If;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(If || (If = {}));
kr.Backward + "", kr.Forward + "", kr.Backward + "", kr.Forward + "";
var Fl;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Fl || (Fl = {}));
var Vl;
(function(e) {
  e.Optimized = "optimized";
})(Vl || (Vl = {}));
function Vk(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Ny(t), o = ve(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: i
      } = window;
      return new i(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return fe(() => () => o == null ? void 0 : o.disconnect(), [o]), o;
}
function Bk(e, t) {
  return ve(() => e.reduce((n, r) => {
    let {
      eventName: o,
      handler: i
    } = r;
    return n[o] = (s) => {
      i(s, t);
    }, n;
  }, {}), [e, t]);
}
Fl.WhileDragging, Vl.Optimized;
const Wk = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Rf,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Rf
}, My = /* @__PURE__ */ je(Wk), zk = /* @__PURE__ */ je({
  ...Ik,
  scaleX: 1,
  scaleY: 1
});
var _f;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(_f || (_f = {}));
const jk = /* @__PURE__ */ je(null), $f = "button", Hk = "Draggable";
function Uk(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: o
  } = e;
  const i = Ry(Hk), {
    activators: s,
    activatorEvent: a,
    active: l,
    activeNodeRect: u,
    ariaDescribedById: c,
    draggableNodes: d,
    over: h
  } = Te(My), {
    role: p = $f,
    roleDescription: y = "draggable",
    tabIndex: g = 0
  } = o ?? {}, v = (l == null ? void 0 : l.id) === t, b = Te(v ? zk : jk), [x, w] = Ll(), [C, S] = Ll(), T = Bk(s, t), P = $l(n);
  qs(
    () => (d.set(t, {
      id: t,
      key: i,
      node: x,
      activatorNode: C,
      data: P
    }), () => {
      const D = d.get(t);
      D && D.key === i && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const E = ve(() => ({
    role: p,
    tabIndex: g,
    "aria-disabled": r,
    "aria-pressed": v && p === $f ? !0 : void 0,
    "aria-roledescription": y,
    "aria-describedby": c.draggable
  }), [r, p, g, v, y, c.draggable]);
  return {
    active: l,
    activatorEvent: a,
    activeNodeRect: u,
    attributes: E,
    isDragging: v,
    listeners: r ? void 0 : T,
    node: x,
    over: h,
    setNodeRef: w,
    setActivatorNodeRef: S,
    transform: b
  };
}
const Yk = "Droppable", Gk = {
  timeout: 25
};
function Kk(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: o
  } = e;
  const i = Ry(Yk), {
    active: s,
    dispatch: a,
    over: l,
    measureDroppableContainers: u
  } = Te(My), c = me({
    disabled: n
  }), d = me(!1), h = me(null), p = me(null), {
    disabled: y,
    updateMeasurementsFor: g,
    timeout: v
  } = {
    ...Gk,
    ...o
  }, b = $l(g ?? r), x = Ie(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      p.current != null && clearTimeout(p.current), p.current = setTimeout(() => {
        u(Array.isArray(b.current) ? b.current : [b.current]), p.current = null;
      }, v);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), w = Vk({
    callback: x,
    disabled: y || !s
  }), C = Ie((E, D) => {
    w && (D && (w.unobserve(D), d.current = !1), E && w.observe(E));
  }, [w]), [S, T] = Ll(C), P = $l(t);
  return fe(() => {
    !w || !S.current || (w.disconnect(), d.current = !1, w.observe(S.current));
  }, [S, w]), fe(
    () => (a({
      type: Po.RegisterDroppable,
      element: {
        id: r,
        key: i,
        disabled: n,
        node: S,
        rect: h,
        data: P
      }
    }), () => a({
      type: Po.UnregisterDroppable,
      key: i,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), fe(() => {
    n !== c.current.disabled && (a({
      type: Po.SetDroppableDisabled,
      id: r,
      key: i,
      disabled: n
    }), c.current.disabled = n);
  }, [r, i, n, a]), {
    active: s,
    rect: h,
    isOver: (l == null ? void 0 : l.id) === r,
    node: S,
    over: l,
    setNodeRef: T
  };
}
function Ay(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function Oi(e) {
  return e !== null && e >= 0;
}
const Xk = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: o
  } = e;
  const i = Ay(t, r, n), s = t[o], a = i[o];
  return !a || !s ? null : {
    x: a.left - s.left,
    y: a.top - s.top,
    scaleX: a.width / s.width,
    scaleY: a.height / s.height
  };
}, qk = "Sortable", Qk = /* @__PURE__ */ Y.createContext({
  activeIndex: -1,
  containerId: qk,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: Xk,
  disabled: {
    draggable: !1,
    droppable: !1
  }
}), Zk = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: o
  } = e;
  return Ay(n, r, o).indexOf(t);
}, Jk = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: o,
    items: i,
    newIndex: s,
    previousItems: a,
    previousContainerId: l,
    transition: u
  } = e;
  return !u || !r || a !== i && o === s ? !1 : n ? !0 : s !== o && t === l;
}, eN = {
  duration: 200,
  easing: "ease"
}, Oy = "transform", tN = /* @__PURE__ */ Wo.Transition.toString({
  property: Oy,
  duration: 0,
  easing: "linear"
}), nN = {
  roleDescription: "sortable"
};
function rN(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: o
  } = e;
  const [i, s] = de(null), a = me(n);
  return qs(() => {
    if (!t && n !== a.current && r.current) {
      const l = o.current;
      if (l) {
        const u = Fk(r.current, {
          ignoreTransform: !0
        }), c = {
          x: l.left - u.left,
          y: l.top - u.top,
          scaleX: l.width / u.width,
          scaleY: l.height / u.height
        };
        (c.x || c.y) && s(c);
      }
    }
    n !== a.current && (a.current = n);
  }, [t, n, r, o]), fe(() => {
    i && s(null);
  }, [i]), i;
}
function oN(e) {
  let {
    animateLayoutChanges: t = Jk,
    attributes: n,
    disabled: r,
    data: o,
    getNewIndex: i = Zk,
    id: s,
    strategy: a,
    resizeObserverConfig: l,
    transition: u = eN
  } = e;
  const {
    items: c,
    containerId: d,
    activeIndex: h,
    disabled: p,
    disableTransforms: y,
    sortedRects: g,
    overIndex: v,
    useDragOverlay: b,
    strategy: x
  } = Te(Qk), w = iN(r, p), C = c.indexOf(s), S = ve(() => ({
    sortable: {
      containerId: d,
      index: C,
      items: c
    },
    ...o
  }), [d, o, C, c]), T = ve(() => c.slice(c.indexOf(s)), [c, s]), {
    rect: P,
    node: E,
    isOver: D,
    setNodeRef: A
  } = Kk({
    id: s,
    data: S,
    disabled: w.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: T,
      ...l
    }
  }), {
    active: R,
    activatorEvent: O,
    activeNodeRect: F,
    attributes: $,
    setNodeRef: W,
    listeners: V,
    isDragging: k,
    over: N,
    setActivatorNodeRef: M,
    transform: B
  } = Uk({
    id: s,
    data: S,
    attributes: {
      ...nN,
      ...n
    },
    disabled: w.draggable
  }), G = Nk(A, W), _ = !!R, U = _ && !y && Oi(h) && Oi(v), te = !b && k, X = te && U ? B : null, H = U ? X ?? (a ?? x)({
    rects: g,
    activeNodeRect: F,
    activeIndex: h,
    overIndex: v,
    index: C
  }) : null, oe = Oi(h) && Oi(v) ? i({
    id: s,
    items: c,
    activeIndex: h,
    overIndex: v
  }) : C, he = R == null ? void 0 : R.id, ne = me({
    activeId: he,
    items: c,
    newIndex: oe,
    containerId: d
  }), be = c !== ne.current.items, xe = t({
    active: R,
    containerId: d,
    isDragging: k,
    isSorting: _,
    id: s,
    index: C,
    items: c,
    newIndex: ne.current.newIndex,
    previousItems: ne.current.items,
    previousContainerId: ne.current.containerId,
    transition: u,
    wasDragging: ne.current.activeId != null
  }), re = rN({
    disabled: !xe,
    index: C,
    node: E,
    rect: P
  });
  return fe(() => {
    _ && ne.current.newIndex !== oe && (ne.current.newIndex = oe), d !== ne.current.containerId && (ne.current.containerId = d), c !== ne.current.items && (ne.current.items = c);
  }, [_, oe, d, c]), fe(() => {
    if (he === ne.current.activeId)
      return;
    if (he != null && ne.current.activeId == null) {
      ne.current.activeId = he;
      return;
    }
    const St = setTimeout(() => {
      ne.current.activeId = he;
    }, 50);
    return () => clearTimeout(St);
  }, [he]), {
    active: R,
    activeIndex: h,
    attributes: $,
    data: S,
    rect: P,
    index: C,
    newIndex: oe,
    items: c,
    isOver: D,
    isSorting: _,
    isDragging: k,
    listeners: V,
    node: E,
    overIndex: v,
    over: N,
    setNodeRef: G,
    setActivatorNodeRef: M,
    setDroppableNodeRef: A,
    setDraggableNodeRef: W,
    transform: re ?? H,
    transition: ot()
  };
  function ot() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      re || // Or to prevent items jumping to back to their "new" position when items change
      be && ne.current.newIndex === C
    )
      return tN;
    if (!(te && !Ok(O) || !u) && (_ || xe))
      return Wo.Transition.toString({
        ...u,
        property: Oy
      });
  }
}
function iN(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
_t.Down, _t.Right, _t.Up, _t.Left;
const Iy = je({});
function ui(e) {
  const t = me(null);
  return t.current === null && (t.current = e()), t.current;
}
const Cu = typeof window < "u", _y = Cu ? cr : fe, Su = /* @__PURE__ */ je(null);
function Tu(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Pu(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
function sN([...e], t, n) {
  const r = t < 0 ? e.length + t : t;
  if (r >= 0 && r < e.length) {
    const o = n < 0 ? e.length + n : n, [i] = e.splice(t, 1);
    e.splice(o, 0, i);
  }
  return e;
}
const vn = (e, t, n) => n > t ? t : n < e ? e : n;
function Bl(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let io = () => {
}, Kt = () => {
};
process.env.NODE_ENV !== "production" && (io = (e, t, n) => {
  !e && typeof console < "u" && console.warn(Bl(t, n));
}, Kt = (e, t, n) => {
  if (!e)
    throw new Error(Bl(t, n));
});
const yn = {}, $y = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function Ly(e) {
  return typeof e == "object" && e !== null;
}
const Fy = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function Eu(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Lt = /* @__NO_SIDE_EFFECTS__ */ (e) => e, aN = (e, t) => (n) => t(e(n)), di = (...e) => e.reduce(aN), zo = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
class Du {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Tu(this.subscriptions, t), () => Pu(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const s = this.subscriptions[i];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Ut = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, sn = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function Vy(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Lf = /* @__PURE__ */ new Set();
function ku(e, t, n) {
  e || Lf.has(t) || (console.warn(Bl(t, n)), Lf.add(t));
}
const By = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, lN = 1e-7, cN = 12;
function uN(e, t, n, r, o) {
  let i, s, a = 0;
  do
    s = t + (n - t) / 2, i = By(s, r, o) - e, i > 0 ? n = s : t = s;
  while (Math.abs(i) > lN && ++a < cN);
  return s;
}
function fi(e, t, n, r) {
  if (e === t && n === r)
    return Lt;
  const o = (i) => uN(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : By(o(i), t, r);
}
const Wy = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, zy = (e) => (t) => 1 - e(1 - t), jy = /* @__PURE__ */ fi(0.33, 1.53, 0.69, 0.99), Nu = /* @__PURE__ */ zy(jy), Hy = /* @__PURE__ */ Wy(Nu), Uy = (e) => (e *= 2) < 1 ? 0.5 * Nu(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ru = (e) => 1 - Math.sin(Math.acos(e)), Yy = zy(Ru), Gy = Wy(Ru), dN = /* @__PURE__ */ fi(0.42, 0, 1, 1), fN = /* @__PURE__ */ fi(0, 0, 0.58, 1), Ky = /* @__PURE__ */ fi(0.42, 0, 0.58, 1), hN = (e) => Array.isArray(e) && typeof e[0] != "number", Xy = (e) => Array.isArray(e) && typeof e[0] == "number", Ff = {
  linear: Lt,
  easeIn: dN,
  easeInOut: Ky,
  easeOut: fN,
  circIn: Ru,
  circInOut: Gy,
  circOut: Yy,
  backIn: Nu,
  backInOut: Hy,
  backOut: jy,
  anticipate: Uy
}, mN = (e) => typeof e == "string", Vf = (e) => {
  if (Xy(e)) {
    Kt(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, o] = e;
    return fi(t, n, r, o);
  } else if (mN(e))
    return Kt(Ff[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), Ff[e];
  return e;
}, Ii = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function pN(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), o = !1, i = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    s.has(c) && (u.schedule(c), e()), c(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, d = !1, h = !1) => {
      const y = h && o ? n : r;
      return d && s.add(c), y.has(c) || y.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      r.delete(c), s.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, o) {
        i = !0;
        return;
      }
      o = !0, [n, r] = [r, n], n.forEach(l), n.clear(), o = !1, i && (i = !1, u.process(c));
    }
  };
  return u;
}
const gN = 40;
function qy(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, s = Ii.reduce((w, C) => (w[C] = pN(i), w), {}), { setup: a, read: l, resolveKeyframes: u, preUpdate: c, update: d, preRender: h, render: p, postRender: y } = s, g = () => {
    const w = yn.useManualTiming ? o.timestamp : performance.now();
    n = !1, yn.useManualTiming || (o.delta = r ? 1e3 / 60 : Math.max(Math.min(w - o.timestamp, gN), 1)), o.timestamp = w, o.isProcessing = !0, a.process(o), l.process(o), u.process(o), c.process(o), d.process(o), h.process(o), p.process(o), y.process(o), o.isProcessing = !1, n && t && (r = !1, e(g));
  }, v = () => {
    n = !0, r = !0, o.isProcessing || e(g);
  };
  return { schedule: Ii.reduce((w, C) => {
    const S = s[C];
    return w[C] = (T, P = !1, E = !1) => (n || v(), S.schedule(T, P, E)), w;
  }, {}), cancel: (w) => {
    for (let C = 0; C < Ii.length; C++)
      s[Ii[C]].cancel(w);
  }, state: o, steps: s };
}
const { schedule: Be, cancel: bn, state: st, steps: Ra } = /* @__PURE__ */ qy(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Lt, !0);
let zi;
function vN() {
  zi = void 0;
}
const wt = {
  now: () => (zi === void 0 && wt.set(st.isProcessing || yn.useManualTiming ? st.timestamp : performance.now()), zi),
  set: (e) => {
    zi = e, queueMicrotask(vN);
  }
}, Qy = (e) => (t) => typeof t == "string" && t.startsWith(e), Mu = /* @__PURE__ */ Qy("--"), yN = /* @__PURE__ */ Qy("var(--"), Au = (e) => yN(e) ? bN.test(e.split("/*")[0].trim()) : !1, bN = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, so = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, jo = {
  ...so,
  transform: (e) => vn(0, 1, e)
}, _i = {
  ...so,
  default: 1
}, Eo = (e) => Math.round(e * 1e5) / 1e5, Ou = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function wN(e) {
  return e == null;
}
const xN = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Iu = (e, t) => (n) => !!(typeof n == "string" && xN.test(n) && n.startsWith(e) || t && !wN(n) && Object.prototype.hasOwnProperty.call(n, t)), Zy = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, i, s, a] = r.match(Ou);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, CN = (e) => vn(0, 255, e), Ma = {
  ...so,
  transform: (e) => Math.round(CN(e))
}, Un = {
  test: /* @__PURE__ */ Iu("rgb", "red"),
  parse: /* @__PURE__ */ Zy("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Ma.transform(e) + ", " + Ma.transform(t) + ", " + Ma.transform(n) + ", " + Eo(jo.transform(r)) + ")"
};
function SN(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const Wl = {
  test: /* @__PURE__ */ Iu("#"),
  parse: SN,
  transform: Un.transform
}, hi = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), En = /* @__PURE__ */ hi("deg"), an = /* @__PURE__ */ hi("%"), ce = /* @__PURE__ */ hi("px"), TN = /* @__PURE__ */ hi("vh"), PN = /* @__PURE__ */ hi("vw"), Bf = {
  ...an,
  parse: (e) => an.parse(e) / 100,
  transform: (e) => an.transform(e * 100)
}, Nr = {
  test: /* @__PURE__ */ Iu("hsl", "hue"),
  parse: /* @__PURE__ */ Zy("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + an.transform(Eo(t)) + ", " + an.transform(Eo(n)) + ", " + Eo(jo.transform(r)) + ")"
}, Ze = {
  test: (e) => Un.test(e) || Wl.test(e) || Nr.test(e),
  parse: (e) => Un.test(e) ? Un.parse(e) : Nr.test(e) ? Nr.parse(e) : Wl.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Un.transform(e) : Nr.transform(e),
  getAnimatableNone: (e) => {
    const t = Ze.parse(e);
    return t.alpha = 0, Ze.transform(t);
  }
}, EN = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function DN(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(Ou)) == null ? void 0 : t.length) || 0) + (((n = e.match(EN)) == null ? void 0 : n.length) || 0) > 0;
}
const Jy = "number", eb = "color", kN = "var", NN = "var(", Wf = "${}", RN = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Ho(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const a = t.replace(RN, (l) => (Ze.test(l) ? (r.color.push(i), o.push(eb), n.push(Ze.parse(l))) : l.startsWith(NN) ? (r.var.push(i), o.push(kN), n.push(l)) : (r.number.push(i), o.push(Jy), n.push(parseFloat(l))), ++i, Wf)).split(Wf);
  return { values: n, split: a, indexes: r, types: o };
}
function tb(e) {
  return Ho(e).values;
}
function nb(e) {
  const { split: t, types: n } = Ho(e), r = t.length;
  return (o) => {
    let i = "";
    for (let s = 0; s < r; s++)
      if (i += t[s], o[s] !== void 0) {
        const a = n[s];
        a === Jy ? i += Eo(o[s]) : a === eb ? i += Ze.transform(o[s]) : i += o[s];
      }
    return i;
  };
}
const MN = (e) => typeof e == "number" ? 0 : Ze.test(e) ? Ze.getAnimatableNone(e) : e;
function AN(e) {
  const t = tb(e);
  return nb(e)(t.map(MN));
}
const In = {
  test: DN,
  parse: tb,
  createTransformer: nb,
  getAnimatableNone: AN
};
function Aa(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function ON({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, s = 0;
  if (!t)
    o = i = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - a;
    o = Aa(l, a, e + 1 / 3), i = Aa(l, a, e), s = Aa(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function cs(e, t) {
  return (n) => n > 0 ? t : e;
}
const ze = (e, t, n) => e + (t - e) * n, Oa = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, IN = [Wl, Un, Nr], _N = (e) => IN.find((t) => t.test(e));
function zf(e) {
  const t = _N(e);
  if (io(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === Nr && (n = ON(n)), n;
}
const jf = (e, t) => {
  const n = zf(e), r = zf(t);
  if (!n || !r)
    return cs(e, t);
  const o = { ...n };
  return (i) => (o.red = Oa(n.red, r.red, i), o.green = Oa(n.green, r.green, i), o.blue = Oa(n.blue, r.blue, i), o.alpha = ze(n.alpha, r.alpha, i), Un.transform(o));
}, zl = /* @__PURE__ */ new Set(["none", "hidden"]);
function $N(e, t) {
  return zl.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function LN(e, t) {
  return (n) => ze(e, t, n);
}
function _u(e) {
  return typeof e == "number" ? LN : typeof e == "string" ? Au(e) ? cs : Ze.test(e) ? jf : BN : Array.isArray(e) ? rb : typeof e == "object" ? Ze.test(e) ? jf : FN : cs;
}
function rb(e, t) {
  const n = [...e], r = n.length, o = e.map((i, s) => _u(i)(i, t[s]));
  return (i) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](i);
    return n;
  };
}
function FN(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = _u(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}
function VN(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const i = t.types[o], s = e.indexes[i][r[i]], a = e.values[s] ?? 0;
    n[o] = a, r[i]++;
  }
  return n;
}
const BN = (e, t) => {
  const n = In.createTransformer(t), r = Ho(e), o = Ho(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? zl.has(e) && !o.values.length || zl.has(t) && !r.values.length ? $N(e, t) : di(rb(VN(r, o), o.values), n) : (io(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), cs(e, t));
};
function ob(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? ze(e, t, n) : _u(e)(e, t);
}
const WN = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => Be.update(t, n),
    stop: () => bn(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => st.isProcessing ? st.timestamp : wt.now()
  };
}, ib = (e, t, n = 10) => {
  let r = "";
  const o = Math.max(Math.round(t / n), 2);
  for (let i = 0; i < o; i++)
    r += Math.round(e(i / (o - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, us = 2e4;
function $u(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < us; )
    t += n, r = e.next(t);
  return t >= us ? 1 / 0 : t;
}
function zN(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), o = Math.min($u(r), us);
  return {
    type: "keyframes",
    ease: (i) => r.next(o * i).value / t,
    duration: /* @__PURE__ */ sn(o)
  };
}
const jN = 5;
function sb(e, t, n) {
  const r = Math.max(t - jN, 0);
  return Vy(n - e(r), t - r);
}
const Ue = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Hf = 1e-3;
function HN({ duration: e = Ue.duration, bounce: t = Ue.bounce, velocity: n = Ue.velocity, mass: r = Ue.mass }) {
  let o, i;
  io(e <= /* @__PURE__ */ Ut(Ue.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let s = 1 - t;
  s = vn(Ue.minDamping, Ue.maxDamping, s), e = vn(Ue.minDuration, Ue.maxDuration, /* @__PURE__ */ sn(e)), s < 1 ? (o = (u) => {
    const c = u * s, d = c * e, h = c - n, p = jl(u, s), y = Math.exp(-d);
    return Hf - h / p * y;
  }, i = (u) => {
    const d = u * s * e, h = d * n + n, p = Math.pow(s, 2) * Math.pow(u, 2) * e, y = Math.exp(-d), g = jl(Math.pow(u, 2), s);
    return (-o(u) + Hf > 0 ? -1 : 1) * ((h - p) * y) / g;
  }) : (o = (u) => {
    const c = Math.exp(-u * e), d = (u - n) * e + 1;
    return -1e-3 + c * d;
  }, i = (u) => {
    const c = Math.exp(-u * e), d = (n - u) * (e * e);
    return c * d;
  });
  const a = 5 / e, l = YN(o, i, a);
  if (e = /* @__PURE__ */ Ut(e), isNaN(l))
    return {
      stiffness: Ue.stiffness,
      damping: Ue.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: s * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const UN = 12;
function YN(e, t, n) {
  let r = n;
  for (let o = 1; o < UN; o++)
    r = r - e(r) / t(r);
  return r;
}
function jl(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const GN = ["duration", "bounce"], KN = ["stiffness", "damping", "mass"];
function Uf(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function XN(e) {
  let t = {
    velocity: Ue.velocity,
    stiffness: Ue.stiffness,
    damping: Ue.damping,
    mass: Ue.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Uf(e, KN) && Uf(e, GN))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), o = r * r, i = 2 * vn(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(o);
      t = {
        ...t,
        mass: Ue.mass,
        stiffness: o,
        damping: i
      };
    } else {
      const n = HN(e);
      t = {
        ...t,
        ...n,
        mass: Ue.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function ds(e = Ue.visualDuration, t = Ue.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: o } = n;
  const i = n.keyframes[0], s = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: i }, { stiffness: l, damping: u, mass: c, duration: d, velocity: h, isResolvedFromDuration: p } = XN({
    ...n,
    velocity: -/* @__PURE__ */ sn(n.velocity || 0)
  }), y = h || 0, g = u / (2 * Math.sqrt(l * c)), v = s - i, b = /* @__PURE__ */ sn(Math.sqrt(l / c)), x = Math.abs(v) < 5;
  r || (r = x ? Ue.restSpeed.granular : Ue.restSpeed.default), o || (o = x ? Ue.restDelta.granular : Ue.restDelta.default);
  let w;
  if (g < 1) {
    const S = jl(b, g);
    w = (T) => {
      const P = Math.exp(-g * b * T);
      return s - P * ((y + g * b * v) / S * Math.sin(S * T) + v * Math.cos(S * T));
    };
  } else if (g === 1)
    w = (S) => s - Math.exp(-b * S) * (v + (y + b * v) * S);
  else {
    const S = b * Math.sqrt(g * g - 1);
    w = (T) => {
      const P = Math.exp(-g * b * T), E = Math.min(S * T, 300);
      return s - P * ((y + g * b * v) * Math.sinh(E) + S * v * Math.cosh(E)) / S;
    };
  }
  const C = {
    calculatedDuration: p && d || null,
    next: (S) => {
      const T = w(S);
      if (p)
        a.done = S >= d;
      else {
        let P = S === 0 ? y : 0;
        g < 1 && (P = S === 0 ? /* @__PURE__ */ Ut(y) : sb(w, S, T));
        const E = Math.abs(P) <= r, D = Math.abs(s - T) <= o;
        a.done = E && D;
      }
      return a.value = a.done ? s : T, a;
    },
    toString: () => {
      const S = Math.min($u(C), us), T = ib((P) => C.next(S * P).value, S, 30);
      return S + "ms " + T;
    },
    toTransition: () => {
    }
  };
  return C;
}
ds.applyToOptions = (e) => {
  const t = zN(e, 100, ds);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Ut(t.duration), e.type = "keyframes", e;
};
function Hl({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: s, min: a, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const d = e[0], h = {
    done: !1,
    value: d
  }, p = (E) => a !== void 0 && E < a || l !== void 0 && E > l, y = (E) => a === void 0 ? l : l === void 0 || Math.abs(a - E) < Math.abs(l - E) ? a : l;
  let g = n * t;
  const v = d + g, b = s === void 0 ? v : s(v);
  b !== v && (g = b - d);
  const x = (E) => -g * Math.exp(-E / r), w = (E) => b + x(E), C = (E) => {
    const D = x(E), A = w(E);
    h.done = Math.abs(D) <= u, h.value = h.done ? b : A;
  };
  let S, T;
  const P = (E) => {
    p(h.value) && (S = E, T = ds({
      keyframes: [h.value, y(h.value)],
      velocity: sb(w, E, h.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: u,
      restSpeed: c
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (E) => {
      let D = !1;
      return !T && S === void 0 && (D = !0, C(E), P(E)), S !== void 0 && E >= S ? T.next(E - S) : (!D && C(E), h);
    }
  };
}
function qN(e, t, n) {
  const r = [], o = n || yn.mix || ob, i = e.length - 1;
  for (let s = 0; s < i; s++) {
    let a = o(e[s], e[s + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[s] || Lt : t;
      a = di(l, a);
    }
    r.push(a);
  }
  return r;
}
function ab(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (Kt(i === t.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const s = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = qN(t, r, o), l = a.length, u = (c) => {
    if (s && c < e[0])
      return t[0];
    let d = 0;
    if (l > 1)
      for (; d < e.length - 2 && !(c < e[d + 1]); d++)
        ;
    const h = /* @__PURE__ */ zo(e[d], e[d + 1], c);
    return a[d](h);
  };
  return n ? (c) => u(vn(e[0], e[i - 1], c)) : u;
}
function QN(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = /* @__PURE__ */ zo(0, t, r);
    e.push(ze(n, 1, o));
  }
}
function ZN(e) {
  const t = [0];
  return QN(t, e.length - 1), t;
}
function JN(e, t) {
  return e.map((n) => n * t);
}
function eR(e, t) {
  return e.map(() => t || Ky).splice(0, e.length - 1);
}
function Rr({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = hN(r) ? r.map(Vf) : Vf(r), i = {
    done: !1,
    value: t[0]
  }, s = JN(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : ZN(t),
    e
  ), a = ab(s, t, {
    ease: Array.isArray(o) ? o : eR(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = a(l), i.done = l >= e, i)
  };
}
const tR = (e) => e !== null;
function Lu(e, { repeat: t, repeatType: n = "loop" }, r, o = 1) {
  const i = e.filter(tR), a = o < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !a || r === void 0 ? i[a] : r;
}
const nR = {
  decay: Hl,
  inertia: Hl,
  tween: Rr,
  keyframes: Rr,
  spring: ds
};
function lb(e) {
  typeof e.type == "string" && (e.type = nR[e.type]);
}
class Fu {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const rR = (e) => e / 100;
class Vu extends Fu {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, o;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== wt.now() && this.tick(wt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (o = (r = this.options).onStop) == null || o.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    lb(t);
    const { type: n = Rr, repeat: r = 0, repeatDelay: o = 0, repeatType: i, velocity: s = 0 } = t;
    let { keyframes: a } = t;
    const l = n || Rr;
    process.env.NODE_ENV !== "production" && l !== Rr && Kt(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== Rr && typeof a[0] != "number" && (this.mixKeyframes = di(rR, ob(a[0], a[1])), a = [0, 100]);
    const u = l({ ...t, keyframes: a });
    i === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -s
    })), u.calculatedDuration === null && (u.calculatedDuration = $u(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + o, this.totalDuration = this.resolvedDuration * (r + 1) - o, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: o, mixKeyframes: i, mirroredGenerator: s, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: c, repeat: d, repeatType: h, repeatDelay: p, type: y, onUpdate: g, finalKeyframe: v } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - o / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const b = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), x = this.playbackSpeed >= 0 ? b < 0 : b > o;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = o);
    let w = this.currentTime, C = r;
    if (d) {
      const E = Math.min(this.currentTime, o) / a;
      let D = Math.floor(E), A = E % 1;
      !A && E >= 1 && (A = 1), A === 1 && D--, D = Math.min(D, d + 1), !!(D % 2) && (h === "reverse" ? (A = 1 - A, p && (A -= p / a)) : h === "mirror" && (C = s)), w = vn(0, 1, A) * a;
    }
    const S = x ? { done: !1, value: c[0] } : C.next(w);
    i && (S.value = i(S.value));
    let { done: T } = S;
    !x && l !== null && (T = this.playbackSpeed >= 0 ? this.currentTime >= o : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && T);
    return P && y !== Hl && (S.value = Lu(c, this.options, v, this.speed)), g && g(S.value), P && this.finish(), S;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ sn(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ sn(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ Ut(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(wt.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ sn(this.currentTime));
  }
  play() {
    var o, i;
    if (this.isStopped)
      return;
    const { driver: t = WN, startTime: n } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), (i = (o = this.options).onPlay) == null || i.call(o);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(wt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function oR(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const Yn = (e) => e * 180 / Math.PI, Ul = (e) => {
  const t = Yn(Math.atan2(e[1], e[0]));
  return Yl(t);
}, iR = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: Ul,
  rotateZ: Ul,
  skewX: (e) => Yn(Math.atan(e[1])),
  skewY: (e) => Yn(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, Yl = (e) => (e = e % 360, e < 0 && (e += 360), e), Yf = Ul, Gf = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Kf = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), sR = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Gf,
  scaleY: Kf,
  scale: (e) => (Gf(e) + Kf(e)) / 2,
  rotateX: (e) => Yl(Yn(Math.atan2(e[6], e[5]))),
  rotateY: (e) => Yl(Yn(Math.atan2(-e[2], e[0]))),
  rotateZ: Yf,
  rotate: Yf,
  skewX: (e) => Yn(Math.atan(e[4])),
  skewY: (e) => Yn(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Gl(e) {
  return e.includes("scale") ? 1 : 0;
}
function Kl(e, t) {
  if (!e || e === "none")
    return Gl(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, o;
  if (n)
    r = sR, o = n;
  else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = iR, o = a;
  }
  if (!o)
    return Gl(t);
  const i = r[t], s = o[1].split(",").map(lR);
  return typeof i == "function" ? i(s) : s[i];
}
const aR = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return Kl(n, t);
};
function lR(e) {
  return parseFloat(e.trim());
}
const ao = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], lo = new Set(ao), Xf = (e) => e === so || e === ce, cR = /* @__PURE__ */ new Set(["x", "y", "z"]), uR = ao.filter((e) => !cR.has(e));
function dR(e) {
  const t = [];
  return uR.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Xn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => Kl(t, "x"),
  y: (e, { transform: t }) => Kl(t, "y")
};
Xn.translateX = Xn.x;
Xn.translateY = Xn.y;
const qn = /* @__PURE__ */ new Set();
let Xl = !1, ql = !1, Ql = !1;
function cb() {
  if (ql) {
    const e = Array.from(qn).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = dR(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([i, s]) => {
        var a;
        (a = r.getValue(i)) == null || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  ql = !1, Xl = !1, qn.forEach((e) => e.complete(Ql)), qn.clear();
}
function ub() {
  qn.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (ql = !0);
  });
}
function fR() {
  Ql = !0, ub(), cb(), Ql = !1;
}
class Bu {
  constructor(t, n, r, o, i, s = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = i, this.isAsync = s;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (qn.add(this), Xl || (Xl = !0, Be.read(ub), Be.resolveKeyframes(cb))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    if (t[0] === null) {
      const i = o == null ? void 0 : o.get(), s = t[t.length - 1];
      if (i !== void 0)
        t[0] = i;
      else if (r && n) {
        const a = r.readValue(n, s);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = s), o && i === void 0 && o.set(t[0]);
    }
    oR(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), qn.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (qn.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const hR = (e) => e.startsWith("--");
function mR(e, t, n) {
  hR(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const pR = /* @__PURE__ */ Eu(() => window.ScrollTimeline !== void 0), gR = {};
function vR(e, t) {
  const n = /* @__PURE__ */ Eu(e);
  return () => gR[t] ?? n();
}
const db = /* @__PURE__ */ vR(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Co = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, qf = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Co([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Co([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Co([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Co([0.33, 1.53, 0.69, 0.99])
};
function fb(e, t) {
  if (e)
    return typeof e == "function" ? db() ? ib(e, t) : "ease-out" : Xy(e) ? Co(e) : Array.isArray(e) ? e.map((n) => fb(n, t) || qf.easeOut) : qf[e];
}
function yR(e, t, n, { delay: r = 0, duration: o = 300, repeat: i = 0, repeatType: s = "loop", ease: a = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [t]: n
  };
  l && (c.offset = l);
  const d = fb(a, o);
  Array.isArray(d) && (c.easing = d);
  const h = {
    delay: r,
    duration: o,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: i + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  };
  return u && (h.pseudoElement = u), e.animate(c, h);
}
function hb(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function bR({ type: e, ...t }) {
  return hb(e) && db() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class wR extends Fu {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: o, pseudoElement: i, allowFlatten: s = !1, finalKeyframe: a, onComplete: l } = t;
    this.isPseudoElement = !!i, this.allowFlatten = s, this.options = t, Kt(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = bR(t);
    this.animation = yR(n, r, o, u, i), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const c = Lu(o, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : mR(n, r, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ sn(Number(t));
  }
  get time() {
    return /* @__PURE__ */ sn(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Ut(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && pR() ? (this.animation.timeline = t, Lt) : n(this);
  }
}
const mb = {
  anticipate: Uy,
  backInOut: Hy,
  circInOut: Gy
};
function xR(e) {
  return e in mb;
}
function CR(e) {
  typeof e.ease == "string" && xR(e.ease) && (e.ease = mb[e.ease]);
}
const Qf = 10;
class SR extends wR {
  constructor(t) {
    CR(t), lb(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: o, element: i, ...s } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const a = new Vu({
      ...s,
      autoplay: !1
    }), l = /* @__PURE__ */ Ut(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - Qf).value, a.sample(l).value, Qf), a.stop();
  }
}
const Zf = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(In.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function TR(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function PR(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], s = Zf(o, t), a = Zf(i, t);
  return io(s === a, `You are trying to animate ${t} from "${o}" to "${i}". "${s ? i : o}" is not an animatable value.`, "value-not-animatable"), !s || !a ? !1 : TR(e) || (n === "spring" || hb(n)) && r;
}
function Zl(e) {
  e.duration = 0, e.type;
}
const ER = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), DR = /* @__PURE__ */ Eu(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function kR(e) {
  var c;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: o, damping: i, type: s } = e;
  if (!(((c = t == null ? void 0 : t.owner) == null ? void 0 : c.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: u } = t.owner.getProps();
  return DR() && n && ER.has(n) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !r && o !== "mirror" && i !== 0 && s !== "inertia";
}
const NR = 40;
class RR extends Fu {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: s = "loop", keyframes: a, name: l, motionValue: u, element: c, ...d }) {
    var y;
    super(), this.stop = () => {
      var g, v;
      this._animation && (this._animation.stop(), (g = this.stopTimeline) == null || g.call(this)), (v = this.keyframeResolver) == null || v.cancel();
    }, this.createdAt = wt.now();
    const h = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: i,
      repeatType: s,
      name: l,
      motionValue: u,
      element: c,
      ...d
    }, p = (c == null ? void 0 : c.KeyframeResolver) || Bu;
    this.keyframeResolver = new p(a, (g, v, b) => this.onKeyframesResolved(g, v, h, !b), l, u, c), (y = this.keyframeResolver) == null || y.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, o) {
    this.keyframeResolver = void 0;
    const { name: i, type: s, velocity: a, delay: l, isHandoff: u, onUpdate: c } = r;
    this.resolvedAt = wt.now(), PR(t, i, s, a) || ((yn.instantAnimations || !l) && (c == null || c(Lu(t, r, n))), t[0] = t[t.length - 1], Zl(r), r.repeat = 0);
    const h = {
      startTime: o ? this.resolvedAt ? this.resolvedAt - this.createdAt > NR ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, p = !u && kR(h) ? new SR({
      ...h,
      element: h.motionValue.owner.current
    }) : new Vu(h);
    p.finished.then(() => this.notifyFinished()).catch(Lt), this.pendingTimeline && (this.stopTimeline = p.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = p;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), fR()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const MR = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function AR(e) {
  const t = MR.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const OR = 4;
function pb(e, t, n = 1) {
  Kt(n <= OR, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, o] = AR(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const s = i.trim();
    return $y(s) ? parseFloat(s) : s;
  }
  return Au(o) ? pb(o, t, n + 1) : o;
}
function Wu(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const gb = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...ao
]), IR = {
  test: (e) => e === "auto",
  parse: (e) => e
}, vb = (e) => (t) => t.test(e), yb = [so, ce, an, En, PN, TN, IR], Jf = (e) => yb.find(vb(e));
function _R(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Fy(e) : !0;
}
const $R = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function LR(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Ou) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = $R.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const FR = /\b([a-z-]*)\(.*?\)/gu, Jl = {
  ...In,
  getAnimatableNone: (e) => {
    const t = e.match(FR);
    return t ? t.map(LR).join(" ") : e;
  }
}, eh = {
  ...so,
  transform: Math.round
}, VR = {
  rotate: En,
  rotateX: En,
  rotateY: En,
  rotateZ: En,
  scale: _i,
  scaleX: _i,
  scaleY: _i,
  scaleZ: _i,
  skew: En,
  skewX: En,
  skewY: En,
  distance: ce,
  translateX: ce,
  translateY: ce,
  translateZ: ce,
  x: ce,
  y: ce,
  z: ce,
  perspective: ce,
  transformPerspective: ce,
  opacity: jo,
  originX: Bf,
  originY: Bf,
  originZ: ce
}, zu = {
  // Border props
  borderWidth: ce,
  borderTopWidth: ce,
  borderRightWidth: ce,
  borderBottomWidth: ce,
  borderLeftWidth: ce,
  borderRadius: ce,
  radius: ce,
  borderTopLeftRadius: ce,
  borderTopRightRadius: ce,
  borderBottomRightRadius: ce,
  borderBottomLeftRadius: ce,
  // Positioning props
  width: ce,
  maxWidth: ce,
  height: ce,
  maxHeight: ce,
  top: ce,
  right: ce,
  bottom: ce,
  left: ce,
  // Spacing props
  padding: ce,
  paddingTop: ce,
  paddingRight: ce,
  paddingBottom: ce,
  paddingLeft: ce,
  margin: ce,
  marginTop: ce,
  marginRight: ce,
  marginBottom: ce,
  marginLeft: ce,
  // Misc
  backgroundPositionX: ce,
  backgroundPositionY: ce,
  ...VR,
  zIndex: eh,
  // SVG
  fillOpacity: jo,
  strokeOpacity: jo,
  numOctaves: eh
}, BR = {
  ...zu,
  // Color props
  color: Ze,
  backgroundColor: Ze,
  outlineColor: Ze,
  fill: Ze,
  stroke: Ze,
  // Border props
  borderColor: Ze,
  borderTopColor: Ze,
  borderRightColor: Ze,
  borderBottomColor: Ze,
  borderLeftColor: Ze,
  filter: Jl,
  WebkitFilter: Jl
}, bb = (e) => BR[e];
function wb(e, t) {
  let n = bb(e);
  return n !== Jl && (n = In), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const WR = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function zR(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const i = e[r];
    typeof i == "string" && !WR.has(i) && Ho(i).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const i of t)
      e[i] = wb(n, o);
}
class jR extends Bu {
  constructor(t, n, r, o, i) {
    super(t, n, r, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let u = t[l];
      if (typeof u == "string" && (u = u.trim(), Au(u))) {
        const c = pb(u, n.current);
        c !== void 0 && (t[l] = c), l === t.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !gb.has(r) || t.length !== 2)
      return;
    const [o, i] = t, s = Jf(o), a = Jf(i);
    if (s !== a)
      if (Xf(s) && Xf(a))
        for (let l = 0; l < t.length; l++) {
          const u = t[l];
          typeof u == "string" && (t[l] = parseFloat(u));
        }
      else Xn[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      (t[o] === null || _R(t[o])) && r.push(o);
    r.length && zR(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Xn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var a;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const o = t.getValue(n);
    o && o.jump(this.measuredOrigin, !1);
    const i = r.length - 1, s = r[i];
    r[i] = Xn[n](t.measureViewportBox(), window.getComputedStyle(t.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, u]) => {
      t.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function HR(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const o = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return o ? Array.from(o) : [];
  }
  return Array.from(e);
}
const xb = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function UR(e) {
  return Ly(e) && "offsetHeight" in e;
}
const th = 30, YR = (e) => !isNaN(parseFloat(e)), Do = {
  current: void 0
};
class GR {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var i;
      const o = wt.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const s of this.dependents)
          s.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = wt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = YR(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && ku(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Du());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Be.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return Do.current && Do.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = wt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > th)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, th);
    return Vy(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ir(e, t) {
  return new GR(e, t);
}
const { schedule: ju } = /* @__PURE__ */ qy(queueMicrotask, !1), Ht = {
  x: !1,
  y: !1
};
function Cb() {
  return Ht.x || Ht.y;
}
function KR(e) {
  return e === "x" || e === "y" ? Ht[e] ? null : (Ht[e] = !0, () => {
    Ht[e] = !1;
  }) : Ht.x || Ht.y ? null : (Ht.x = Ht.y = !0, () => {
    Ht.x = Ht.y = !1;
  });
}
function Sb(e, t) {
  const n = HR(e), r = new AbortController(), o = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, o, () => r.abort()];
}
function nh(e) {
  return !(e.pointerType === "touch" || Cb());
}
function XR(e, t, n = {}) {
  const [r, o, i] = Sb(e, n), s = (a) => {
    if (!nh(a))
      return;
    const { target: l } = a, u = t(l, a);
    if (typeof u != "function" || !l)
      return;
    const c = (d) => {
      nh(d) && (u(d), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, o);
  };
  return r.forEach((a) => {
    a.addEventListener("pointerenter", s, o);
  }), i;
}
const Tb = (e, t) => t ? e === t ? !0 : Tb(e, t.parentElement) : !1, Hu = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, qR = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function QR(e) {
  return qR.has(e.tagName) || e.tabIndex !== -1;
}
const ji = /* @__PURE__ */ new WeakSet();
function rh(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function Ia(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const ZR = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = rh(() => {
    if (ji.has(n))
      return;
    Ia(n, "down");
    const o = rh(() => {
      Ia(n, "up");
    }), i = () => Ia(n, "cancel");
    n.addEventListener("keyup", o, t), n.addEventListener("blur", i, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function oh(e) {
  return Hu(e) && !Cb();
}
function JR(e, t, n = {}) {
  const [r, o, i] = Sb(e, n), s = (a) => {
    const l = a.currentTarget;
    if (!oh(a))
      return;
    ji.add(l);
    const u = t(l, a), c = (p, y) => {
      window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", h), ji.has(l) && ji.delete(l), oh(p) && typeof u == "function" && u(p, { success: y });
    }, d = (p) => {
      c(p, l === window || l === document || n.useGlobalTarget || Tb(l, p.target));
    }, h = (p) => {
      c(p, !1);
    };
    window.addEventListener("pointerup", d, o), window.addEventListener("pointercancel", h, o);
  };
  return r.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", s, o), UR(a) && (a.addEventListener("focus", (u) => ZR(u, o)), !QR(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), i;
}
function Pb(e) {
  return Ly(e) && "ownerSVGElement" in e;
}
function eM(e) {
  return Pb(e) && e.tagName === "svg";
}
function tM(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], o = e[1 + n], i = e[2 + n], s = e[3 + n], a = ab(o, i, s);
  return t ? a(r) : a;
}
const lt = (e) => !!(e && e.getVelocity), nM = [...yb, Ze, In], rM = (e) => nM.find(vb(e)), Uu = je({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function oM(e = !0) {
  const t = Te(Su);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: o } = t, i = ix();
  fe(() => {
    if (e)
      return o(i);
  }, [e]);
  const s = Ie(() => e && r && r(i), [i, r, e]);
  return !n && r ? [!1, s] : [!0];
}
const Eb = je({ strict: !1 }), ih = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Yr = {};
for (const e in ih)
  Yr[e] = {
    isEnabled: (t) => ih[e].some((n) => !!t[n])
  };
function iM(e) {
  for (const t in e)
    Yr[t] = {
      ...Yr[t],
      ...e[t]
    };
}
const sM = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function fs(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || sM.has(e);
}
let Db = (e) => !fs(e);
function aM(e) {
  typeof e == "function" && (Db = (t) => t.startsWith("on") ? !fs(t) : e(t));
}
try {
  aM(require("@emotion/is-prop-valid").default);
} catch {
}
function lM(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (Db(o) || n === !0 && fs(o) || !t && !fs(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
const Qs = /* @__PURE__ */ je({});
function Zs(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Uo(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Yu = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Gu = ["initial", ...Yu];
function Js(e) {
  return Zs(e.animate) || Gu.some((t) => Uo(e[t]));
}
function kb(e) {
  return !!(Js(e) || e.variants);
}
function cM(e, t) {
  if (Js(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Uo(n) ? n : void 0,
      animate: Uo(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function uM(e) {
  const { initial: t, animate: n } = cM(e, Te(Qs));
  return ve(() => ({ initial: t, animate: n }), [sh(t), sh(n)]);
}
function sh(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Yo = {};
function dM(e) {
  for (const t in e)
    Yo[t] = e[t], Mu(t) && (Yo[t].isCSSVariable = !0);
}
function Nb(e, { layout: t, layoutId: n }) {
  return lo.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Yo[e] || e === "opacity");
}
const fM = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, hM = ao.length;
function mM(e, t, n) {
  let r = "", o = !0;
  for (let i = 0; i < hM; i++) {
    const s = ao[i], a = e[s];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (s.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const u = xb(a, zu[s]);
      if (!l) {
        o = !1;
        const c = fM[s] || s;
        r += `${c}(${u}) `;
      }
      n && (t[s] = u);
    }
  }
  return r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function Ku(e, t, n) {
  const { style: r, vars: o, transformOrigin: i } = e;
  let s = !1, a = !1;
  for (const l in t) {
    const u = t[l];
    if (lo.has(l)) {
      s = !0;
      continue;
    } else if (Mu(l)) {
      o[l] = u;
      continue;
    } else {
      const c = xb(u, zu[l]);
      l.startsWith("origin") ? (a = !0, i[l] = c) : r[l] = c;
    }
  }
  if (t.transform || (s || n ? r.transform = mM(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = i;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
const Xu = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Rb(e, t, n) {
  for (const r in t)
    !lt(t[r]) && !Nb(r, n) && (e[r] = t[r]);
}
function pM({ transformTemplate: e }, t) {
  return ve(() => {
    const n = Xu();
    return Ku(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function gM(e, t) {
  const n = e.style || {}, r = {};
  return Rb(r, n, e), Object.assign(r, pM(e, t)), r;
}
function vM(e, t) {
  const n = {}, r = gM(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const yM = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, bM = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function wM(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? yM : bM;
  e[i.offset] = ce.transform(-r);
  const s = ce.transform(t), a = ce.transform(n);
  e[i.array] = `${s} ${a}`;
}
function Mb(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: o,
  pathSpacing: i = 1,
  pathOffset: s = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, u, c) {
  if (Ku(e, a, u), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: d, style: h } = e;
  d.transform && (h.transform = d.transform, delete d.transform), (h.transform || d.transformOrigin) && (h.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), h.transform && (h.transformBox = (c == null ? void 0 : c.transformBox) ?? "fill-box", delete d.transformBox), t !== void 0 && (d.x = t), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), o !== void 0 && wM(d, o, i, s, !1);
}
const Ab = () => ({
  ...Xu(),
  attrs: {}
}), Ob = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function xM(e, t, n, r) {
  const o = ve(() => {
    const i = Ab();
    return Mb(i, t, Ob(r), e.transformTemplate, e.style), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Rb(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
const CM = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function qu(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(CM.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function SM(e, t, n, { latestValues: r }, o, i = !1) {
  const a = (qu(e) ? xM : vM)(t, r, o, e), l = lM(t, typeof e == "string", i), u = e !== ys ? { ...l, ...a, ref: n } : {}, { children: c } = t, d = ve(() => lt(c) ? c.get() : c, [c]);
  return Le(e, {
    ...u,
    children: d
  });
}
function ah(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Qu(e, t, n, r) {
  if (typeof t == "function") {
    const [o, i] = ah(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = ah(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  return t;
}
function Hi(e) {
  return lt(e) ? e.get() : e;
}
function TM({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, o) {
  return {
    latestValues: PM(n, r, o, e),
    renderState: t()
  };
}
function PM(e, t, n, r) {
  const o = {}, i = r(e, {});
  for (const h in i)
    o[h] = Hi(i[h]);
  let { initial: s, animate: a } = e;
  const l = Js(e), u = kb(e);
  t && u && !l && e.inherit !== !1 && (s === void 0 && (s = t.initial), a === void 0 && (a = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || s === !1;
  const d = c ? a : s;
  if (d && typeof d != "boolean" && !Zs(d)) {
    const h = Array.isArray(d) ? d : [d];
    for (let p = 0; p < h.length; p++) {
      const y = Qu(e, h[p]);
      if (y) {
        const { transitionEnd: g, transition: v, ...b } = y;
        for (const x in b) {
          let w = b[x];
          if (Array.isArray(w)) {
            const C = c ? w.length - 1 : 0;
            w = w[C];
          }
          w !== null && (o[x] = w);
        }
        for (const x in g)
          o[x] = g[x];
      }
    }
  }
  return o;
}
const Ib = (e) => (t, n) => {
  const r = Te(Qs), o = Te(Su), i = () => TM(e, t, r, o);
  return n ? i() : ui(i);
};
function Zu(e, t, n) {
  var i;
  const { style: r } = e, o = {};
  for (const s in r)
    (lt(r[s]) || t.style && lt(t.style[s]) || Nb(s, e) || ((i = n == null ? void 0 : n.getValue(s)) == null ? void 0 : i.liveStyle) !== void 0) && (o[s] = r[s]);
  return o;
}
const EM = /* @__PURE__ */ Ib({
  scrapeMotionValuesFromProps: Zu,
  createRenderState: Xu
});
function _b(e, t, n) {
  const r = Zu(e, t, n);
  for (const o in e)
    if (lt(e[o]) || lt(t[o])) {
      const i = ao.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[i] = e[o];
    }
  return r;
}
const DM = /* @__PURE__ */ Ib({
  scrapeMotionValuesFromProps: _b,
  createRenderState: Ab
}), kM = Symbol.for("motionComponentSymbol");
function Mr(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function NM(e, t, n) {
  return Ie(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Mr(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const Ju = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), RM = "framerAppearId", $b = "data-" + Ju(RM), Lb = je({});
function MM(e, t, n, r, o) {
  var g, v;
  const { visualElement: i } = Te(Qs), s = Te(Eb), a = Te(Su), l = Te(Uu).reducedMotion, u = me(null);
  r = r || s.renderer, !u.current && r && (u.current = r(e, {
    visualState: t,
    parent: i,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = u.current, d = Te(Lb);
  c && !c.projection && o && (c.type === "html" || c.type === "svg") && AM(u.current, n, o, d);
  const h = me(!1);
  sx(() => {
    c && h.current && c.update(n, a);
  });
  const p = n[$b], y = me(!!p && !((g = window.MotionHandoffIsComplete) != null && g.call(window, p)) && ((v = window.MotionHasOptimisedAnimation) == null ? void 0 : v.call(window, p)));
  return _y(() => {
    c && (h.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), c.scheduleRenderMicrotask(), y.current && c.animationState && c.animationState.animateChanges());
  }), fe(() => {
    c && (!y.current && c.animationState && c.animationState.animateChanges(), y.current && (queueMicrotask(() => {
      var b;
      (b = window.MotionHandoffMarkAsComplete) == null || b.call(window, p);
    }), y.current = !1), c.enteringChildren = void 0);
  }), c;
}
function AM(e, t, n, r) {
  const { layoutId: o, layout: i, drag: s, dragConstraints: a, layoutScroll: l, layoutRoot: u, layoutCrossfade: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Fb(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!s || a && Mr(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u
  });
}
function Fb(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Fb(e.parent);
}
function _a(e, { forwardMotionProps: t = !1 } = {}, n, r) {
  n && iM(n);
  const o = qu(e) ? DM : EM;
  function i(a, l) {
    let u;
    const c = {
      ...Te(Uu),
      ...a,
      layoutId: OM(a)
    }, { isStatic: d } = c, h = uM(a), p = o(a, d);
    if (!d && Cu) {
      IM(c, n);
      const y = _M(c);
      u = y.MeasureLayout, h.visualElement = MM(e, p, c, r, y.ProjectionNode);
    }
    return L(Qs.Provider, { value: h, children: [u && h.visualElement ? f(u, { visualElement: h.visualElement, ...c }) : null, SM(e, a, NM(p, h.visualElement, l), p, d, t)] });
  }
  i.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const s = Ke(i);
  return s[kM] = e, s;
}
function OM({ layoutId: e }) {
  const t = Te(Iy).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function IM(e, t) {
  const n = Te(Eb).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? io(!1, r, "lazy-strict-mode") : Kt(!1, r, "lazy-strict-mode");
  }
}
function _M(e) {
  const { drag: t, layout: n } = Yr;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function $M(e, t) {
  if (typeof Proxy > "u")
    return _a;
  const n = /* @__PURE__ */ new Map(), r = (i, s) => _a(i, s, e, t), o = (i, s) => (process.env.NODE_ENV !== "production" && ku(!1, "motion() is deprecated. Use motion.create() instead."), r(i, s));
  return new Proxy(o, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, s) => s === "create" ? r : (n.has(s) || n.set(s, _a(s, void 0, e, t)), n.get(s))
  });
}
function Vb({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function LM({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function FM(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function $a(e) {
  return e === void 0 || e === 1;
}
function ec({ scale: e, scaleX: t, scaleY: n }) {
  return !$a(e) || !$a(t) || !$a(n);
}
function zn(e) {
  return ec(e) || Bb(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Bb(e) {
  return lh(e.x) || lh(e.y);
}
function lh(e) {
  return e && e !== "0%";
}
function hs(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function ch(e, t, n, r, o) {
  return o !== void 0 && (e = hs(e, o, r)), hs(e, n, r) + t;
}
function tc(e, t = 0, n = 1, r, o) {
  e.min = ch(e.min, t, n, r, o), e.max = ch(e.max, t, n, r, o);
}
function Wb(e, { x: t, y: n }) {
  tc(e.x, t.translate, t.scale, t.originPoint), tc(e.y, n.translate, n.scale, n.originPoint);
}
const uh = 0.999999999999, dh = 1.0000000000001;
function VM(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, s;
  for (let a = 0; a < o; a++) {
    i = n[a], s = i.projectionDelta;
    const { visualElement: l } = i.options;
    l && l.props.style && l.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && Or(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, Wb(e, s)), r && zn(i.latestValues) && Or(e, i.latestValues));
  }
  t.x < dh && t.x > uh && (t.x = 1), t.y < dh && t.y > uh && (t.y = 1);
}
function Ar(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function fh(e, t, n, r, o = 0.5) {
  const i = ze(e.min, e.max, o);
  tc(e, t, n, i, r);
}
function Or(e, t) {
  fh(e.x, t.x, t.scaleX, t.scale, t.originX), fh(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function zb(e, t) {
  return Vb(FM(e.getBoundingClientRect(), t));
}
function BM(e, t, n) {
  const r = zb(e, n), { scroll: o } = t;
  return o && (Ar(r.x, o.offset.x), Ar(r.y, o.offset.y)), r;
}
const hh = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Ir = () => ({
  x: hh(),
  y: hh()
}), mh = () => ({ min: 0, max: 0 }), Xe = () => ({
  x: mh(),
  y: mh()
}), nc = { current: null }, jb = { current: !1 };
function WM() {
  if (jb.current = !0, !!Cu)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => nc.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      nc.current = !1;
}
const zM = /* @__PURE__ */ new WeakMap();
function jM(e, t, n) {
  for (const r in t) {
    const o = t[r], i = n[r];
    if (lt(o))
      e.addValue(r, o);
    else if (lt(i))
      e.addValue(r, ir(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(o) : s.hasAnimated || s.set(o);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, ir(s !== void 0 ? s : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const ph = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class HM {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, blockInitialAnimation: i, visualState: s }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Bu, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = wt.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, Be.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = s;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.blockInitialAnimation = !!i, this.isControllingVariants = Js(n), this.isVariantNode = kb(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: c, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in d) {
      const p = d[h];
      l[h] !== void 0 && lt(p) && p.set(l[h]);
    }
  }
  mount(t) {
    var n;
    this.current = t, zM.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, o) => this.bindToMotionValue(o, r)), jb.current || WM(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : nc.current, process.env.NODE_ENV !== "production" && ku(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (n = this.parent) == null || n.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), bn(this.notifyUpdate), bn(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = lo.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const o = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && Be.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let i;
    window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), i && i(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Yr) {
      const n = Yr[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Xe();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < ph.length; r++) {
      const o = ph[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, s = t[i];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = jM(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = ir(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && ($y(r) || Fy(r)) ? r = parseFloat(r) : !rM(r) && In.test(n) && (r = wb(t, n)), this.setBaseTarget(t, lt(r) ? r.get() : r)), lt(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var i;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const s = Qu(this.props, n, (i = this.presenceContext) == null ? void 0 : i.custom);
      s && (r = s[t]);
    }
    if (n && r !== void 0)
      return r;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !lt(o) ? o : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Du()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    ju.render(this.render);
  }
}
class Hb extends HM {
  constructor() {
    super(...arguments), this.KeyframeResolver = jR;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    lt(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Ub(e, { style: t, vars: n }, r, o) {
  const i = e.style;
  let s;
  for (s in t)
    i[s] = t[s];
  o == null || o.applyProjectionStyles(i, r);
  for (s in n)
    i.setProperty(s, n[s]);
}
function UM(e) {
  return window.getComputedStyle(e);
}
class YM extends Hb {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Ub;
  }
  readValueFromInstance(t, n) {
    var r;
    if (lo.has(n))
      return (r = this.projection) != null && r.isProjecting ? Gl(n) : aR(t, n);
    {
      const o = UM(t), i = (Mu(n) ? o.getPropertyValue(n) : o[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return zb(t, n);
  }
  build(t, n, r) {
    Ku(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Zu(t, n, r);
  }
}
const Yb = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function GM(e, t, n, r) {
  Ub(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Yb.has(o) ? o : Ju(o), t.attrs[o]);
}
class KM extends Hb {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Xe;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (lo.has(n)) {
      const r = bb(n);
      return r && r.default || 0;
    }
    return n = Yb.has(n) ? n : Ju(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return _b(t, n, r);
  }
  build(t, n, r) {
    Mb(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, o) {
    GM(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = Ob(t.tagName), super.mount(t);
  }
}
const XM = (e, t) => qu(e) ? new KM(t) : new YM(t, {
  allowProjection: e !== ys
});
function Fr(e, t, n) {
  const r = e.getProps();
  return Qu(r, t, n !== void 0 ? n : r.custom, e);
}
const rc = (e) => Array.isArray(e);
function qM(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, ir(n));
}
function QM(e) {
  return rc(e) ? e[e.length - 1] || 0 : e;
}
function ZM(e, t) {
  const n = Fr(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const s in i) {
    const a = QM(i[s]);
    qM(e, s, a);
  }
}
function JM(e) {
  return !!(lt(e) && e.add);
}
function oc(e, t) {
  const n = e.getValue("willChange");
  if (JM(n))
    return n.add(t);
  if (!n && yn.WillChange) {
    const r = new yn.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Gb(e) {
  return e.props[$b];
}
const eA = (e) => e !== null;
function tA(e, { repeat: t, repeatType: n = "loop" }, r) {
  const o = e.filter(eA), i = t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return o[i];
}
const nA = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, rA = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), oA = {
  type: "keyframes",
  duration: 0.8
}, iA = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, sA = (e, { keyframes: t }) => t.length > 2 ? oA : lo.has(e) ? e.startsWith("scale") ? rA(t[1]) : nA : iA;
function aA({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: i, repeatType: s, repeatDelay: a, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const ed = (e, t, n, r = {}, o, i) => (s) => {
  const a = Wu(r, e) || {}, l = a.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ Ut(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (h) => {
      t.set(h), a.onUpdate && a.onUpdate(h);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  aA(a) || Object.assign(c, sA(e, c)), c.duration && (c.duration = /* @__PURE__ */ Ut(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ Ut(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let d = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (Zl(c), c.delay === 0 && (d = !0)), (yn.instantAnimations || yn.skipAnimations) && (d = !0, Zl(c), c.delay = 0), c.allowFlatten = !a.type && !a.ease, d && !i && t.get() !== void 0) {
    const h = tA(c.keyframes, a);
    if (h !== void 0) {
      Be.update(() => {
        c.onUpdate(h), c.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new Vu(c) : new RR(c);
};
function lA({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Kb(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: s, ...a } = t;
  r && (i = r);
  const l = [], u = o && e.animationState && e.animationState.getState()[o];
  for (const c in a) {
    const d = e.getValue(c, e.latestValues[c] ?? null), h = a[c];
    if (h === void 0 || u && lA(u, c))
      continue;
    const p = {
      delay: n,
      ...Wu(i || {}, c)
    }, y = d.get();
    if (y !== void 0 && !d.isAnimating && !Array.isArray(h) && h === y && !p.velocity)
      continue;
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const b = Gb(e);
      if (b) {
        const x = window.MotionHandoffAnimation(b, c, Be);
        x !== null && (p.startTime = x, g = !0);
      }
    }
    oc(e, c), d.start(ed(c, d, h, e.shouldReduceMotion && gb.has(c) ? { type: !1 } : p, e, g));
    const v = d.animation;
    v && l.push(v);
  }
  return s && Promise.all(l).then(() => {
    Be.update(() => {
      s && ZM(e, s);
    });
  }), l;
}
function Xb(e, t, n, r = 0, o = 1) {
  const i = Array.from(e).sort((u, c) => u.sortNodePosition(c)).indexOf(t), s = e.size, a = (s - 1) * r;
  return typeof n == "function" ? n(i, s) : o === 1 ? i * r : a - i * r;
}
function ic(e, t, n = {}) {
  var l;
  const r = Fr(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const i = r ? () => Promise.all(Kb(e, r, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: d, staggerDirection: h } = o;
    return cA(e, t, u, c, d, h, n);
  } : () => Promise.resolve(), { when: a } = o;
  if (a) {
    const [u, c] = a === "beforeChildren" ? [i, s] : [s, i];
    return u().then(() => c());
  } else
    return Promise.all([i(), s(n.delay)]);
}
function cA(e, t, n = 0, r = 0, o = 0, i = 1, s) {
  const a = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), a.push(ic(l, t, {
      ...s,
      delay: n + (typeof r == "function" ? 0 : r) + Xb(e.variantChildren, l, r, o, i)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(a);
}
function uA(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => ic(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = ic(e, t, n);
  else {
    const o = typeof t == "function" ? Fr(e, t, n.custom) : t;
    r = Promise.all(Kb(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function qb(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const dA = Gu.length;
function Qb(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Qb(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < dA; n++) {
    const r = Gu[n], o = e.props[r];
    (Uo(o) || o === !1) && (t[r] = o);
  }
  return t;
}
const fA = [...Yu].reverse(), hA = Yu.length;
function mA(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => uA(e, n, r)));
}
function pA(e) {
  let t = mA(e), n = gh(), r = !0;
  const o = (l) => (u, c) => {
    var h;
    const d = Fr(e, c, l === "exit" ? (h = e.presenceContext) == null ? void 0 : h.custom : void 0);
    if (d) {
      const { transition: p, transitionEnd: y, ...g } = d;
      u = { ...u, ...g, ...y };
    }
    return u;
  };
  function i(l) {
    t = l(e);
  }
  function s(l) {
    const { props: u } = e, c = Qb(e.parent) || {}, d = [], h = /* @__PURE__ */ new Set();
    let p = {}, y = 1 / 0;
    for (let v = 0; v < hA; v++) {
      const b = fA[v], x = n[b], w = u[b] !== void 0 ? u[b] : c[b], C = Uo(w), S = b === l ? x.isActive : null;
      S === !1 && (y = v);
      let T = w === c[b] && w !== u[b] && C;
      if (T && r && e.manuallyAnimateOnMount && (T = !1), x.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !x.isActive && S === null || // If we didn't and don't have any defined prop for this animation type
      !w && !x.prevProp || // Or if the prop doesn't define an animation
      Zs(w) || typeof w == "boolean")
        continue;
      const P = gA(x.prevProp, w);
      let E = P || // If we're making this variant active, we want to always make it active
      b === l && x.isActive && !T && C || // If we removed a higher-priority variant (i is in reverse order)
      v > y && C, D = !1;
      const A = Array.isArray(w) ? w : [w];
      let R = A.reduce(o(b), {});
      S === !1 && (R = {});
      const { prevResolvedValues: O = {} } = x, F = {
        ...O,
        ...R
      }, $ = (k) => {
        E = !0, h.has(k) && (D = !0, h.delete(k)), x.needsAnimating[k] = !0;
        const N = e.getValue(k);
        N && (N.liveStyle = !1);
      };
      for (const k in F) {
        const N = R[k], M = O[k];
        if (p.hasOwnProperty(k))
          continue;
        let B = !1;
        rc(N) && rc(M) ? B = !qb(N, M) : B = N !== M, B ? N != null ? $(k) : h.add(k) : N !== void 0 && h.has(k) ? $(k) : x.protectedKeys[k] = !0;
      }
      x.prevProp = w, x.prevResolvedValues = R, x.isActive && (p = { ...p, ...R }), r && e.blockInitialAnimation && (E = !1);
      const W = T && P;
      E && (!W || D) && d.push(...A.map((k) => {
        const N = { type: b };
        if (typeof k == "string" && r && !W && e.manuallyAnimateOnMount && e.parent) {
          const { parent: M } = e, B = Fr(M, k);
          if (M.enteringChildren && B) {
            const { delayChildren: G } = B.transition || {};
            N.delay = Xb(M.enteringChildren, e, G);
          }
        }
        return {
          animation: k,
          options: N
        };
      }));
    }
    if (h.size) {
      const v = {};
      if (typeof u.initial != "boolean") {
        const b = Fr(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        b && b.transition && (v.transition = b.transition);
      }
      h.forEach((b) => {
        const x = e.getBaseTarget(b), w = e.getValue(b);
        w && (w.liveStyle = !0), v[b] = x ?? null;
      }), d.push({ animation: v });
    }
    let g = !!d.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (g = !1), r = !1, g ? t(d) : Promise.resolve();
  }
  function a(l, u) {
    var d;
    if (n[l].isActive === u)
      return Promise.resolve();
    (d = e.variantChildren) == null || d.forEach((h) => {
      var p;
      return (p = h.animationState) == null ? void 0 : p.setActive(l, u);
    }), n[l].isActive = u;
    const c = s(l);
    for (const h in n)
      n[h].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: s,
    setActive: a,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = gh(), r = !0;
    }
  };
}
function gA(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !qb(t, e) : !1;
}
function Bn(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function gh() {
  return {
    animate: Bn(!0),
    whileInView: Bn(),
    whileHover: Bn(),
    whileTap: Bn(),
    whileDrag: Bn(),
    whileFocus: Bn(),
    exit: Bn()
  };
}
class Vn {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class vA extends Vn {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = pA(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Zs(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let yA = 0;
class bA extends Vn {
  constructor() {
    super(...arguments), this.id = yA++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const wA = {
  animation: {
    Feature: vA
  },
  exit: {
    Feature: bA
  }
};
function Go(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function mi(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const xA = (e) => (t) => Hu(t) && e(t, mi(t));
function ko(e, t, n, r) {
  return Go(e, t, xA(n), r);
}
const Zb = 1e-4, CA = 1 - Zb, SA = 1 + Zb, Jb = 0.01, TA = 0 - Jb, PA = 0 + Jb;
function gt(e) {
  return e.max - e.min;
}
function EA(e, t, n) {
  return Math.abs(e - t) <= n;
}
function vh(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = ze(t.min, t.max, e.origin), e.scale = gt(n) / gt(t), e.translate = ze(n.min, n.max, e.origin) - e.originPoint, (e.scale >= CA && e.scale <= SA || isNaN(e.scale)) && (e.scale = 1), (e.translate >= TA && e.translate <= PA || isNaN(e.translate)) && (e.translate = 0);
}
function No(e, t, n, r) {
  vh(e.x, t.x, n.x, r ? r.originX : void 0), vh(e.y, t.y, n.y, r ? r.originY : void 0);
}
function yh(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + gt(t);
}
function DA(e, t, n) {
  yh(e.x, t.x, n.x), yh(e.y, t.y, n.y);
}
function bh(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + gt(t);
}
function Ro(e, t, n) {
  bh(e.x, t.x, n.x), bh(e.y, t.y, n.y);
}
function It(e) {
  return [e("x"), e("y")];
}
const ew = ({ current: e }) => e ? e.ownerDocument.defaultView : null, wh = (e, t) => Math.abs(e - t);
function kA(e, t) {
  const n = wh(e.x, t.x), r = wh(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class tw {
  constructor(t, n, { transformPagePoint: r, contextWindow: o = window, dragSnapToOrigin: i = !1, distanceThreshold: s = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = Fa(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, y = kA(h.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!p && !y)
        return;
      const { point: g } = h, { timestamp: v } = st;
      this.history.push({ ...g, timestamp: v });
      const { onStart: b, onMove: x } = this.handlers;
      p || (b && b(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, p) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = La(p, this.transformPagePoint), Be.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, p) => {
      this.end();
      const { onEnd: y, onSessionEnd: g, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const b = Fa(h.type === "pointercancel" ? this.lastMoveEventInfo : La(p, this.transformPagePoint), this.history);
      this.startEvent && y && y(h, b), g && g(h, b);
    }, !Hu(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = s, this.contextWindow = o || window;
    const a = mi(t), l = La(a, this.transformPagePoint), { point: u } = l, { timestamp: c } = st;
    this.history = [{ ...u, timestamp: c }];
    const { onSessionStart: d } = n;
    d && d(t, Fa(l, this.history)), this.removeListeners = di(ko(this.contextWindow, "pointermove", this.handlePointerMove), ko(this.contextWindow, "pointerup", this.handlePointerUp), ko(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), bn(this.updatePoint);
  }
}
function La(e, t) {
  return t ? { point: t(e.point) } : e;
}
function xh(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Fa({ point: e }, t) {
  return {
    point: e,
    delta: xh(e, nw(t)),
    offset: xh(e, NA(t)),
    velocity: RA(t, 0.1)
  };
}
function NA(e) {
  return e[0];
}
function nw(e) {
  return e[e.length - 1];
}
function RA(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = nw(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > /* @__PURE__ */ Ut(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ sn(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function MA(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? ze(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? ze(n, e, r.max) : Math.min(e, n)), e;
}
function Ch(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function AA(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: Ch(e.x, n, o),
    y: Ch(e.y, t, r)
  };
}
function Sh(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function OA(e, t) {
  return {
    x: Sh(e.x, t.x),
    y: Sh(e.y, t.y)
  };
}
function IA(e, t) {
  let n = 0.5;
  const r = gt(e), o = gt(t);
  return o > r ? n = /* @__PURE__ */ zo(t.min, t.max - r, e.min) : r > o && (n = /* @__PURE__ */ zo(e.min, e.max - o, t.min)), vn(0, 1, n);
}
function _A(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const sc = 0.35;
function $A(e = sc) {
  return e === !1 ? e = 0 : e === !0 && (e = sc), {
    x: Th(e, "left", "right"),
    y: Th(e, "top", "bottom")
  };
}
function Th(e, t, n) {
  return {
    min: Ph(e, t),
    max: Ph(e, n)
  };
}
function Ph(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const LA = /* @__PURE__ */ new WeakMap();
class FA {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Xe(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: o } = this.visualElement;
    if (o && o.isPresent === !1)
      return;
    const i = (d) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(mi(d).point);
    }, s = (d, h) => {
      const { drag: p, dragPropagation: y, onDragStart: g } = this.getProps();
      if (p && !y && (this.openDragLock && this.openDragLock(), this.openDragLock = KR(p), !this.openDragLock))
        return;
      this.latestPointerEvent = d, this.latestPanInfo = h, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), It((b) => {
        let x = this.getAxisMotionValue(b).get() || 0;
        if (an.test(x)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const C = w.layout.layoutBox[b];
            C && (x = gt(C) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[b] = x;
      }), g && Be.postRender(() => g(d, h)), oc(this.visualElement, "transform");
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, a = (d, h) => {
      this.latestPointerEvent = d, this.latestPanInfo = h;
      const { dragPropagation: p, dragDirectionLock: y, onDirectionLock: g, onDrag: v } = this.getProps();
      if (!p && !this.openDragLock)
        return;
      const { offset: b } = h;
      if (y && this.currentDirection === null) {
        this.currentDirection = VA(b), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, b), this.updateAxis("y", h.point, b), this.visualElement.render(), v && v(d, h);
    }, l = (d, h) => {
      this.latestPointerEvent = d, this.latestPanInfo = h, this.stop(d, h), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => It((d) => {
      var h;
      return this.getAnimationState(d) === "paused" && ((h = this.getAxisMotionValue(d).animation) == null ? void 0 : h.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new tw(t, {
      onSessionStart: i,
      onStart: s,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: r,
      contextWindow: ew(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, o = n || this.latestPanInfo, i = this.isDragging;
    if (this.cancel(), !i || !o || !r)
      return;
    const { velocity: s } = o;
    this.startAnimation(s);
    const { onDragEnd: a } = this.getProps();
    a && Be.postRender(() => a(r, o));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !$i(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = MA(s, this.constraints[t], this.elastic[t])), i.set(s);
  }
  resolveConstraints() {
    var i;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (i = this.visualElement.projection) == null ? void 0 : i.layout, o = this.constraints;
    t && Mr(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = AA(r.layoutBox, t) : this.constraints = !1, this.elastic = $A(n), o !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && It((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = _A(r.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Mr(t))
      return !1;
    const r = t.current;
    Kt(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = BM(r, o.root, this.visualElement.getTransformPagePoint());
    let s = OA(o.layout.layoutBox, i);
    if (n) {
      const a = n(LM(s));
      this.hasMutatedConstraints = !!a, a && (s = Vb(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, u = It((c) => {
      if (!$i(c, n, this.currentDirection))
        return;
      let d = l && l[c] || {};
      s && (d = { min: 0, max: 0 });
      const h = o ? 200 : 1e6, p = o ? 40 : 1e7, y = {
        type: "inertia",
        velocity: r ? t[c] : 0,
        bounceStiffness: h,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...d
      };
      return this.startAxisValueAnimation(c, y);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return oc(this.visualElement, t), r.start(ed(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    It((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    It((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    It((n) => {
      const { drag: r } = this.getProps();
      if (!$i(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: s, max: a } = o.layout.layoutBox[n];
        i.set(t[n] - ze(s, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Mr(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    It((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const l = a.get();
        o[s] = IA({ min: l, max: l }, this.constraints[s]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), It((s) => {
      if (!$i(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: l, max: u } = this.constraints[s];
      a.set(ze(l, u, o[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    LA.set(this.visualElement, this);
    const t = this.visualElement.current, n = ko(t, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      Mr(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), Be.read(r);
    const s = Go(window, "resize", () => this.scalePositionWithinConstraints()), a = o.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && (It((c) => {
        const d = this.getAxisMotionValue(c);
        d && (this.originPoint[c] += l[c].translate, d.set(d.get() + l[c].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), i(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: s = sc, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function $i(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function VA(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class BA extends Vn {
  constructor(t) {
    super(t), this.removeGroupControls = Lt, this.removeListeners = Lt, this.controls = new FA(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Lt;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Eh = (e) => (t, n) => {
  e && Be.postRender(() => e(t, n));
};
class WA extends Vn {
  constructor() {
    super(...arguments), this.removePointerDownListener = Lt;
  }
  onPointerDown(t) {
    this.session = new tw(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: ew(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: Eh(t),
      onStart: Eh(n),
      onMove: r,
      onEnd: (i, s) => {
        delete this.session, o && Be.postRender(() => o(i, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ko(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Ui = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Dh(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const go = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ce.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Dh(e, t.target.x), r = Dh(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, zA = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = In.parse(e);
    if (o.length > 5)
      return r;
    const i = In.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + s] /= a, o[1 + s] /= l;
    const u = ze(a, l, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= u), typeof o[3 + s] == "number" && (o[3 + s] /= u), i(o);
  }
};
let Va = !1;
class jA extends ax {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    dM(HA), i && (n.group && n.group.add(i), r && r.register && o && r.register(i), Va && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Ui.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, { projection: s } = r;
    return s && (s.isPresent = i, Va = !0, o || t.layoutDependency !== n || n === void 0 || t.isPresent !== i ? s.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? s.promote() : s.relegate() || Be.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), ju.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    Va = !0, o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function rw(e) {
  const [t, n] = oM(), r = Te(Iy);
  return f(jA, { ...e, layoutGroup: r, switchLayoutGroup: Te(Lb), isPresent: t, safeToRemove: n });
}
const HA = {
  borderRadius: {
    ...go,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: go,
  borderTopRightRadius: go,
  borderBottomLeftRadius: go,
  borderBottomRightRadius: go,
  boxShadow: zA
};
function UA(e, t, n) {
  const r = lt(e) ? e : ir(e);
  return r.start(ed("", r, t, n)), r.animation;
}
const YA = (e, t) => e.depth - t.depth;
class GA {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Tu(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Pu(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(YA), this.isDirty = !1, this.children.forEach(t);
  }
}
function KA(e, t) {
  const n = wt.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (bn(r), e(i - t));
  };
  return Be.setup(r, !0), () => bn(r);
}
const ow = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], XA = ow.length, kh = (e) => typeof e == "string" ? parseFloat(e) : e, Nh = (e) => typeof e == "number" || ce.test(e);
function qA(e, t, n, r, o, i) {
  o ? (e.opacity = ze(0, n.opacity ?? 1, QA(r)), e.opacityExit = ze(t.opacity ?? 1, 0, ZA(r))) : i && (e.opacity = ze(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let s = 0; s < XA; s++) {
    const a = `border${ow[s]}Radius`;
    let l = Rh(t, a), u = Rh(n, a);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || Nh(l) === Nh(u) ? (e[a] = Math.max(ze(kh(l), kh(u), r), 0), (an.test(u) || an.test(l)) && (e[a] += "%")) : e[a] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = ze(t.rotate || 0, n.rotate || 0, r));
}
function Rh(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const QA = /* @__PURE__ */ iw(0, 0.5, Yy), ZA = /* @__PURE__ */ iw(0.5, 0.95, Lt);
function iw(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ zo(e, t, r));
}
function Mh(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ot(e, t) {
  Mh(e.x, t.x), Mh(e.y, t.y);
}
function Ah(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function Oh(e, t, n, r, o) {
  return e -= t, e = hs(e, 1 / n, r), o !== void 0 && (e = hs(e, 1 / o, r)), e;
}
function JA(e, t = 0, n = 1, r = 0.5, o, i = e, s = e) {
  if (an.test(t) && (t = parseFloat(t), t = ze(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = ze(i.min, i.max, r);
  e === i && (a -= t), e.min = Oh(e.min, t, n, a, o), e.max = Oh(e.max, t, n, a, o);
}
function Ih(e, t, [n, r, o], i, s) {
  JA(e, t[n], t[r], t[o], t.scale, i, s);
}
const eO = ["x", "scaleX", "originX"], tO = ["y", "scaleY", "originY"];
function _h(e, t, n, r) {
  Ih(e.x, t, eO, n ? n.x : void 0, r ? r.x : void 0), Ih(e.y, t, tO, n ? n.y : void 0, r ? r.y : void 0);
}
function $h(e) {
  return e.translate === 0 && e.scale === 1;
}
function sw(e) {
  return $h(e.x) && $h(e.y);
}
function Lh(e, t) {
  return e.min === t.min && e.max === t.max;
}
function nO(e, t) {
  return Lh(e.x, t.x) && Lh(e.y, t.y);
}
function Fh(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function aw(e, t) {
  return Fh(e.x, t.x) && Fh(e.y, t.y);
}
function Vh(e) {
  return gt(e.x) / gt(e.y);
}
function Bh(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class rO {
  constructor() {
    this.members = [];
  }
  add(t) {
    Tu(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Pu(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function oO(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((o || i || s) && (r = `translate3d(${o}px, ${i}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: u, rotate: c, rotateX: d, rotateY: h, skewX: p, skewY: y } = n;
    u && (r = `perspective(${u}px) ${r}`), c && (r += `rotate(${c}deg) `), d && (r += `rotateX(${d}deg) `), h && (r += `rotateY(${h}deg) `), p && (r += `skewX(${p}deg) `), y && (r += `skewY(${y}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const Ba = ["", "X", "Y", "Z"], iO = 1e3;
let sO = 0;
function Wa(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function lw(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Gb(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Be, !(o || i));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && lw(r);
}
function cw({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = sO++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(cO), this.nodes.forEach(hO), this.nodes.forEach(mO), this.nodes.forEach(uO);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new GA());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Du()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const l = this.eventHandlers.get(s);
      l && l.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s) {
      if (this.instance)
        return;
      this.isSVG = Pb(s) && !eM(s), this.instance = s;
      const { layoutId: a, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), e) {
        let c, d = 0;
        const h = () => this.root.updateBlockedByResize = !1;
        Be.read(() => {
          d = window.innerWidth;
        }), e(s, () => {
          const p = window.innerWidth;
          p !== d && (d = p, this.root.updateBlockedByResize = !0, c && c(), c = KA(h, 250), Ui.hasAnimatedSinceResize && (Ui.hasAnimatedSinceResize = !1, this.nodes.forEach(jh)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: d, hasRelativeLayoutChanged: h, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || bO, { onLayoutAnimationStart: g, onLayoutAnimationComplete: v } = u.getProps(), b = !this.targetLayout || !aw(this.targetLayout, p), x = !d && h;
        if (this.options.layoutRoot || this.resumeFrom || x || d && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const w = {
            ...Wu(y, "layout"),
            onPlay: g,
            onComplete: v
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w), this.setAnimationOrigin(c, x);
        } else
          d || jh(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), bn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(pO), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && lw(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Wh);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(zh);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(fO), this.nodes.forEach(aO), this.nodes.forEach(lO)) : this.nodes.forEach(zh), this.clearAllSnapshots();
      const a = wt.now();
      st.delta = vn(0, 1e3 / 60, a - st.timestamp), st.timestamp = a, st.isProcessing = !0, Ra.update.process(st), Ra.preRender.process(st), Ra.render.process(st), st.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, ju.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(dO), this.sharedNodes.forEach(gO);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Be.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Be.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !gt(this.snapshot.measuredBox.x) && !gt(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Xe(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !sw(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      s && this.instance && (a || zn(this.latestValues) || c) && (o(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return s && (l = this.removeTransform(l)), wO(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: s } = this.options;
      if (!s)
        return Xe();
      const a = s.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(xO))) {
        const { scroll: c } = this.root;
        c && (Ar(a.x, c.offset.x), Ar(a.y, c.offset.y));
      }
      return a;
    }
    removeElementScroll(s) {
      var l;
      const a = Xe();
      if (Ot(a, s), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: d, options: h } = c;
        c !== this.root && d && h.layoutScroll && (d.wasRoot && Ot(a, s), Ar(a.x, d.offset.x), Ar(a.y, d.offset.y));
      }
      return a;
    }
    applyTransform(s, a = !1) {
      const l = Xe();
      Ot(l, s);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !a && c.options.layoutScroll && c.scroll && c !== c.root && Or(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), zn(c.latestValues) && Or(l, c.latestValues);
      }
      return zn(this.latestValues) && Or(l, this.latestValues), l;
    }
    removeTransform(s) {
      const a = Xe();
      Ot(a, s);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !zn(u.latestValues))
          continue;
        ec(u.latestValues) && u.updateSnapshot();
        const c = Xe(), d = u.measurePageBox();
        Ot(c, d), _h(a, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return zn(this.latestValues) && _h(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== st.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var h;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(s || l && this.isSharedProjectionDirty || this.isProjectionDirty || (h = this.parent) != null && h.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: d } = this.options;
      if (!(!this.layout || !(c || d))) {
        if (this.resolvedRelativeTargetAt = st.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Xe(), this.relativeTargetOrigin = Xe(), Ro(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), Ot(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Xe(), this.targetWithTransforms = Xe()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), DA(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ot(this.target, this.layout.layoutBox), Wb(this.target, this.targetDelta)) : Ot(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const p = this.getClosestProjectingParent();
          p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Xe(), this.relativeTargetOrigin = Xe(), Ro(this.relativeTargetOrigin, this.target, p.target), Ot(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || ec(this.parent.latestValues) || Bb(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var y;
      const s = this.getLead(), a = !!this.resumingFrom || this !== s;
      let l = !0;
      if ((this.isProjectionDirty || (y = this.parent) != null && y.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === st.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      Ot(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, h = this.treeScale.y;
      VM(this.layoutCorrected, this.treeScale, this.path, a), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = Xe());
      const { target: p } = s;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Ah(this.prevProjectionDelta.x, this.projectionDelta.x), Ah(this.prevProjectionDelta.y, this.projectionDelta.y)), No(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== h || !Bh(this.projectionDelta.x, this.prevProjectionDelta.x) || !Bh(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), s) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Ir(), this.projectionDelta = Ir(), this.projectionDeltaWithTransform = Ir();
    }
    setAnimationOrigin(s, a = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, d = Ir();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const h = Xe(), p = l ? l.source : void 0, y = this.layout ? this.layout.source : void 0, g = p !== y, v = this.getStack(), b = !v || v.members.length <= 1, x = !!(g && !b && this.options.crossfade === !0 && !this.path.some(yO));
      this.animationProgress = 0;
      let w;
      this.mixTargetDelta = (C) => {
        const S = C / 1e3;
        Hh(d.x, s.x, S), Hh(d.y, s.y, S), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Ro(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), vO(this.relativeTarget, this.relativeTargetOrigin, h, S), w && nO(this.relativeTarget, w) && (this.isProjectionDirty = !1), w || (w = Xe()), Ot(w, this.relativeTarget)), g && (this.animationValues = c, qA(c, u, this.latestValues, S, x, b)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = S;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      var a, l, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || u.stop(), this.pendingAnimation && (bn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Be.update(() => {
        Ui.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = ir(0)), this.currentAnimation = UA(this.motionValue, [0, 1e3], {
          ...s,
          velocity: 0,
          isSync: !0,
          onUpdate: (c) => {
            this.mixTargetDelta(c), s.onUpdate && s.onUpdate(c);
          },
          onStop: () => {
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(iO), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: l, layout: u, latestValues: c } = s;
      if (!(!a || !l || !u)) {
        if (this !== s && this.layout && u && uw(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || Xe();
          const d = gt(this.layout.layoutBox.x);
          l.x.min = s.target.x.min, l.x.max = l.x.min + d;
          const h = gt(this.layout.layoutBox.y);
          l.y.min = s.target.y.min, l.y.max = l.y.min + h;
        }
        Ot(a, l), Or(a, c), No(this.projectionDeltaWithTransform, this.layoutCorrected, a, c);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new rO()), this.sharedNodes.get(s).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: l } = s;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const u = {};
      l.z && Wa("z", s, u, this.animationValues);
      for (let c = 0; c < Ba.length; c++)
        Wa(`rotate${Ba[c]}`, s, u, this.animationValues), Wa(`skew${Ba[c]}`, s, u, this.animationValues);
      s.render();
      for (const c in u)
        s.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      s.scheduleRender();
    }
    applyProjectionStyles(s, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        s.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, s.visibility = "", s.opacity = "", s.pointerEvents = Hi(a == null ? void 0 : a.pointerEvents) || "", s.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (s.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, s.pointerEvents = Hi(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !zn(this.latestValues) && (s.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      s.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let d = oO(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (d = l(c, d)), s.transform = d;
      const { x: h, y: p } = this.projectionDelta;
      s.transformOrigin = `${h.origin * 100}% ${p.origin * 100}% 0`, u.animationValues ? s.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : s.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const y in Yo) {
        if (c[y] === void 0)
          continue;
        const { correct: g, applyTo: v, isCSSVariable: b } = Yo[y], x = d === "none" ? c[y] : g(c[y], u);
        if (v) {
          const w = v.length;
          for (let C = 0; C < w; C++)
            s[v[C]] = x;
        } else
          b ? this.options.visualElement.renderState.vars[y] = x : s[y] = x;
      }
      this.options.layoutId && (s.pointerEvents = u === this ? Hi(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Wh), this.root.sharedNodes.clear();
    }
  };
}
function aO(e) {
  e.updateLayout();
}
function lO(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, s = t.source !== e.layout.source;
    i === "size" ? It((d) => {
      const h = s ? t.measuredBox[d] : t.layoutBox[d], p = gt(h);
      h.min = r[d].min, h.max = h.min + p;
    }) : uw(i, t.layoutBox, r) && It((d) => {
      const h = s ? t.measuredBox[d] : t.layoutBox[d], p = gt(r[d]);
      h.max = h.min + p, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + p);
    });
    const a = Ir();
    No(a, r, t.layoutBox);
    const l = Ir();
    s ? No(l, e.applyTransform(o, !0), t.measuredBox) : No(l, r, t.layoutBox);
    const u = !sw(a);
    let c = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: h, layout: p } = d;
        if (h && p) {
          const y = Xe();
          Ro(y, t.layoutBox, h.layoutBox);
          const g = Xe();
          Ro(g, r, p.layoutBox), aw(y, g) || (c = !0), d.options.layoutRoot && (e.relativeTarget = g, e.relativeTargetOrigin = y, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: c
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function cO(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function uO(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function dO(e) {
  e.clearSnapshot();
}
function Wh(e) {
  e.clearMeasurements();
}
function zh(e) {
  e.isLayoutDirty = !1;
}
function fO(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function jh(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function hO(e) {
  e.resolveTargetDelta();
}
function mO(e) {
  e.calcProjection();
}
function pO(e) {
  e.resetSkewAndRotation();
}
function gO(e) {
  e.removeLeadSnapshot();
}
function Hh(e, t, n) {
  e.translate = ze(t.translate, 0, n), e.scale = ze(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Uh(e, t, n, r) {
  e.min = ze(t.min, n.min, r), e.max = ze(t.max, n.max, r);
}
function vO(e, t, n, r) {
  Uh(e.x, t.x, n.x, r), Uh(e.y, t.y, n.y, r);
}
function yO(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const bO = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Yh = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Gh = Yh("applewebkit/") && !Yh("chrome/") ? Math.round : Lt;
function Kh(e) {
  e.min = Gh(e.min), e.max = Gh(e.max);
}
function wO(e) {
  Kh(e.x), Kh(e.y);
}
function uw(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !EA(Vh(t), Vh(n), 0.2);
}
function xO(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const CO = cw({
  attachResizeListener: (e, t) => Go(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), za = {
  current: void 0
}, dw = cw({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!za.current) {
      const e = new CO({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), za.current = e;
    }
    return za.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), SO = {
  pan: {
    Feature: WA
  },
  drag: {
    Feature: BA,
    ProjectionNode: dw,
    MeasureLayout: rw
  }
};
function Xh(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const o = "onHover" + n, i = r[o];
  i && Be.postRender(() => i(t, mi(t)));
}
class TO extends Vn {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = XR(t, (n, r) => (Xh(this.node, r, "Start"), (o) => Xh(this.node, o, "End"))));
  }
  unmount() {
  }
}
class PO extends Vn {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = di(Go(this.node.current, "focus", () => this.onFocus()), Go(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function qh(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const o = "onTap" + (n === "End" ? "" : n), i = r[o];
  i && Be.postRender(() => i(t, mi(t)));
}
class EO extends Vn {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = JR(t, (n, r) => (qh(this.node, r, "Start"), (o, { success: i }) => qh(this.node, o, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const ac = /* @__PURE__ */ new WeakMap(), ja = /* @__PURE__ */ new WeakMap(), DO = (e) => {
  const t = ac.get(e.target);
  t && t(e);
}, kO = (e) => {
  e.forEach(DO);
};
function NO({ root: e, ...t }) {
  const n = e || document;
  ja.has(n) || ja.set(n, {});
  const r = ja.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(kO, { root: e, ...t })), r[o];
}
function RO(e, t, n) {
  const r = NO(t);
  return ac.set(e, n), r.observe(e), () => {
    ac.delete(e), r.unobserve(e);
  };
}
const MO = {
  some: 0,
  all: 1
};
class AO extends Vn {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : MO[o]
    }, a = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, i && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: d } = this.node.getProps(), h = u ? c : d;
      h && h(l);
    };
    return RO(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(OO(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function OO({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const IO = {
  inView: {
    Feature: AO
  },
  tap: {
    Feature: EO
  },
  focus: {
    Feature: PO
  },
  hover: {
    Feature: TO
  }
}, _O = {
  layout: {
    ProjectionNode: dw,
    MeasureLayout: rw
  }
}, $O = {
  ...wA,
  ...IO,
  ...SO,
  ..._O
}, Ko = /* @__PURE__ */ $M($O, XM);
function fw(e) {
  const t = ui(() => ir(e)), { isStatic: n } = Te(Uu);
  if (n) {
    const [, r] = de(e);
    fe(() => t.on("change", r), []);
  }
  return t;
}
function hw(e, t) {
  const n = fw(t()), r = () => n.set(t());
  return r(), _y(() => {
    const o = () => Be.preRender(r, !1, !0), i = e.map((s) => s.on("change", o));
    return () => {
      i.forEach((s) => s()), bn(r);
    };
  }), n;
}
function LO(e) {
  Do.current = [], e();
  const t = hw(Do.current, e);
  return Do.current = void 0, t;
}
function FO(e, t, n, r) {
  if (typeof e == "function")
    return LO(e);
  const o = typeof t == "function" ? t : tM(t, n, r);
  return Array.isArray(e) ? Qh(e, o) : Qh([e], ([i]) => o(i));
}
function Qh(e, t) {
  const n = ui(() => []);
  return hw(e, () => {
    n.length = 0;
    const r = e.length;
    for (let o = 0; o < r; o++)
      n[o] = e[o].get();
    return t(n);
  });
}
const mw = je(null);
function VO(e, t, n, r) {
  if (!r)
    return e;
  const o = e.findIndex((c) => c.value === t);
  if (o === -1)
    return e;
  const i = r > 0 ? 1 : -1, s = e[o + i];
  if (!s)
    return e;
  const a = e[o], l = s.layout, u = ze(l.min, l.max, 0.5);
  return i === 1 && a.layout.max + n > u || i === -1 && a.layout.min + n < u ? sN(e, o, o + i) : e;
}
function BO({ children: e, as: t = "ul", axis: n = "y", onReorder: r, values: o, ...i }, s) {
  const a = ui(() => Ko[t]), l = [], u = me(!1);
  Kt(!!o, "Reorder.Group must be provided a values prop", "reorder-values");
  const c = {
    axis: n,
    registerItem: (d, h) => {
      const p = l.findIndex((y) => d === y.value);
      p !== -1 ? l[p].layout = h[n] : l.push({ value: d, layout: h[n] }), l.sort(jO);
    },
    updateOrder: (d, h, p) => {
      if (u.current)
        return;
      const y = VO(l, d, h, p);
      l !== y && (u.current = !0, r(y.map(zO).filter((g) => o.indexOf(g) !== -1)));
    }
  };
  return fe(() => {
    u.current = !1;
  }), f(a, { ...i, ref: s, ignoreStrict: !0, children: f(mw.Provider, { value: c, children: e }) });
}
const WO = /* @__PURE__ */ Ke(BO);
function zO(e) {
  return e.value;
}
function jO(e, t) {
  return e.layout.min - t.layout.min;
}
function Zh(e, t = 0) {
  return lt(e) ? e : fw(t);
}
function HO({ children: e, style: t = {}, value: n, as: r = "li", onDrag: o, layout: i = !0, ...s }, a) {
  const l = ui(() => Ko[r]), u = Te(mw), c = {
    x: Zh(t.x),
    y: Zh(t.y)
  }, d = FO([c.x, c.y], ([g, v]) => g || v ? 1 : "unset");
  Kt(!!u, "Reorder.Item must be a child of Reorder.Group", "reorder-item-child");
  const { axis: h, registerItem: p, updateOrder: y } = u;
  return f(l, { drag: h, ...s, dragSnapToOrigin: !0, style: { ...t, x: c.x, y: c.y, zIndex: d }, layout: i, onDrag: (g, v) => {
    const { velocity: b } = v;
    b[h] && y(n, c[h].get(), b[h]), o && o(g, v);
  }, onLayoutMeasure: (g) => p(n, g), ref: a, ignoreStrict: !0, children: e });
}
const UO = /* @__PURE__ */ Ke(HO);
function aB({ id: e, children: t, className: n = "" }) {
  const {
    attributes: r,
    listeners: o,
    setNodeRef: i,
    transform: s,
    transition: a,
    isDragging: l
  } = oN({ id: e }), u = {
    transform: Wo.Transform.toString(s),
    transition: a
  };
  return /* @__PURE__ */ f(
    Ko.div,
    {
      ref: i,
      style: u,
      ...r,
      ...o,
      className: n,
      layout: !0,
      initial: { opacity: 0, y: 20 },
      animate: {
        opacity: l ? 0.5 : 1,
        y: 0,
        scale: l ? 1.05 : 1,
        rotateZ: l ? 2 : 0
      },
      exit: { opacity: 0, y: -20 },
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
        opacity: { duration: 0.2 }
      },
      whileHover: {
        scale: l ? 1.05 : 1.02,
        transition: { duration: 0.2 }
      },
      whileTap: {
        scale: 0.98,
        transition: { duration: 0.1 }
      },
      drag: !0,
      dragConstraints: { left: 0, right: 0, top: 0, bottom: 0 },
      dragElastic: 0.1,
      children: t
    }
  );
}
function lB({
  options: e,
  onReorder: t,
  renderOption: n,
  showDragHandle: r = !0,
  showHeader: o = !0,
  customHeader: i,
  className: s = "",
  itemClassName: a = "",
  disabled: l = !1
}) {
  const u = (c, d) => /* @__PURE__ */ L(
    Ko.div,
    {
      className: `grid grid-cols-3 gap-4 p-4 hover:bg-muted/50 transition-colors ${d % 2 === 0 ? "bg-card" : "bg-muted/30"}`,
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      children: [
        r && /* @__PURE__ */ f(Ko.div, { className: "flex-shrink-0 cursor-grab active:cursor-grabbing p-1", children: /* @__PURE__ */ f(Dx, { size: 16, className: "text-muted-foreground" }) }),
        /* @__PURE__ */ f("div", { className: "text-sm font-medium text-foreground", children: c.name }),
        /* @__PURE__ */ f("div", { className: "text-sm text-muted-foreground", children: c.description || "No description" })
      ]
    }
  );
  return l ? /* @__PURE__ */ L("div", { className: `${s} bg-card border border-border rounded-lg overflow-hidden`, children: [
    o && (i || /* @__PURE__ */ L("div", { className: "grid grid-cols-3 gap-4 p-3 bg-muted border-b border-border font-medium text-sm text-muted-foreground", children: [
      /* @__PURE__ */ f("div", { children: "Product Name" }),
      /* @__PURE__ */ f("div", { children: "Description" }),
      /* @__PURE__ */ f("div", { children: "Actions" })
    ] })),
    /* @__PURE__ */ f("div", { className: "divide-y divide-border", children: e.map((c, d) => /* @__PURE__ */ f("div", { className: a, children: n ? n(c, d) : u(c, d) }, c.id)) })
  ] }) : /* @__PURE__ */ L("div", { className: `${s} bg-card border border-border rounded-lg overflow-hidden`, children: [
    o && (i || /* @__PURE__ */ L("div", { className: "grid grid-cols-3 gap-4 p-3 bg-muted border-b border-border font-medium text-sm text-muted-foreground", children: [
      /* @__PURE__ */ f("div", { children: "Product Name" }),
      /* @__PURE__ */ f("div", { children: "Description" }),
      /* @__PURE__ */ f("div", { children: "Actions" })
    ] })),
    /* @__PURE__ */ f(WO, { axis: "y", values: e, onReorder: t, className: "divide-y divide-border", children: e.map((c, d) => /* @__PURE__ */ f(
      UO,
      {
        value: c,
        className: "cursor-move",
        whileDrag: {
          scale: 1.02,
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          zIndex: 10
        },
        children: n ? n(c, d) : u(c, d)
      },
      c.id
    )) })
  ] });
}
const YO = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: t,
  minimumFractionDigits: t
}).format(e), GO = [
  // Percentage mask x 100
  {
    mask: /100#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e, e *= 100;
      const n = t.match(/100#\.(#+)%$/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Percentage mask
  {
    mask: /#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/#\.(#+)%/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Dollar mask
  {
    mask: /\$#(\.#*)?$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/\$#(\.(#*))?$/)[2], r = n ? n.length : 0;
      return YO(e, r);
    }
  },
  // Millions mask,
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e6).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" M");
      }
      return "";
    }
  },
  // TODO: Validate this
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e12).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" T");
      }
      return "";
    }
  },
  // Thousands mask,
  {
    mask: /#\.#+K$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e3).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" K");
      }
      return "";
    }
  },
  {
    mask: ["#.#", "#.##", "#.###", "#.####"],
    apply: (e, t) => {
      if (e) {
        e = Number(e);
        const n = t.split("."), r = n && n[1] ? n[1].length : 0;
        return `${e.toFixed(r)}`;
      }
      return "";
    }
  },
  {
    mask: ["#"],
    apply: (e, t) => e ? (e = Number(e), `${e.toFixed(0)}`) : ""
  },
  {
    mask: ["#th"],
    // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    apply: (e, t) => {
      e = Number(e);
      const n = e % 10, r = e % 100;
      return n === 1 && r !== 11 ? e + "st" : n === 2 && r !== 12 ? e + "nd" : n === 3 && r !== 13 ? e + "rd" : e + "th";
    }
  }
];
function Jh(e, t) {
  const n = GO.find(
    (r) => Array.isArray(r.mask) && r.mask.includes(t) || !Array.isArray(r.mask) && t.match(r.mask)
  );
  return n ? n.apply(e, t) : "Invalid Mask";
}
const KO = (e, t, n) => t && (typeof t == "function" ? t(e) : t[e]) || e;
function pw(e, t, n) {
  const r = t.filter(({ split: d }) => !d), o = r.map(({ key: d }) => d);
  let i = e;
  const s = i.columnNames(), a = t.filter(({ key: d }) => !s.includes(d)).map(({ key: d }) => d), l = r.filter(({ lookup: d }) => !!d), u = r.filter(({ componentProps: d }) => !!(d != null && d.options)), c = r.reduce((d, h) => {
    var p;
    if (h.group) {
      const y = (p = h.group) == null ? void 0 : p.filter(({ label: b }) => !!b), g = y == null ? void 0 : y.map(({ label: b }) => b), v = (g == null ? void 0 : g.join(" - ")) || "";
      d[`${h.key}`] = v != null && v.length ? `${v} - ${h.name}` : h.name;
    } else
      d[`${h.key}`] = h.name;
    return d;
  }, {});
  for (const d of a)
    i = i.derive({
      [d]: (h) => ""
    });
  if (i.print(), i = i.select(o), n) {
    const d = r.filter(({ mask: h, conditionalMask: p }) => !!h || !!p);
    for (const h of d)
      i = i.derive({
        [h.key]: Kn((p) => {
          let y = p[h.key] || "-";
          const g = h.dataType === "number" ? p[h.key] && p[h.key] < 0 : !1, v = h.negativeFormat ?? "brackets";
          return h.conditionalMask && (typeof p[h.key] == "number" || typeof p[h.key] == "string") && y !== "-" ? y = Jh(Math.abs(+p[h.key]), h.conditionalMask(h.key, h.name, p)) : h.mask && (typeof p[h.key] == "number" || typeof p[h.key] == "string") && y !== "-" && (y = Jh(Math.abs(+p[h.key]), h.mask)), y = `${h.prefix ?? ""}${y}${h.suffix ?? ""}`, v === "brackets" && g && y !== "-" && (y = `(${y})`), v === "minus" && g && y !== "-" && (y = `-${y}`), y;
        })
      });
  }
  for (const d of l)
    i = i.derive({
      [d.key]: Kn((h) => KO(h[d.key], d.lookup))
    });
  for (const d of u)
    i = i.derive({
      [d.key]: Kn((h) => {
        const p = d.componentProps.options, y = typeof p == "function" ? p(h.key, d, h) : p;
        if (!Array.isArray(y))
          return h[d.key];
        const g = y.find(({ key: v }) => v === h[d.key]);
        return (g == null ? void 0 : g.label) || h[d.key];
      })
    });
  return i = i.rename(c), i;
}
function XO({ tbl: e, columns: t, fileName: n, applyMasks: r }) {
  const o = pw(e, t, r), i = /* @__PURE__ */ new Date(), s = new Blob([o.toCSV()], { type: "text/csv" }), a = URL.createObjectURL(s), l = document.createElement("a");
  l.href = a, l.download = `${i.toISOString()}-${n || "exported.csv"}`, l.click(), l.remove();
}
function qO({ tables: e, fileName: t, applyMasks: n }) {
  if (!e || e.length === 0) {
    console.warn("No tables provided for export");
    return;
  }
  const r = [];
  for (let u = 0; u < e.length; u++) {
    const c = e[u];
    if (!c)
      continue;
    const { table: d, columns: h, sectionName: p } = c, y = typeof d == "function" ? d() : d;
    if (!y || !h || y.size === 0)
      continue;
    const g = pw(y, h, n), v = g.toCSV();
    if (p) {
      const b = g.columnNames().length, x = `"${p}",${",".repeat(b - 1)}`;
      r.push(x);
    }
    r.push(v), u < e.length - 1 && r.push("");
  }
  const o = r.join(`
`), i = /* @__PURE__ */ new Date(), s = new Blob([o], { type: "text/csv" }), a = URL.createObjectURL(s), l = document.createElement("a");
  l.href = a, l.download = `${i.toISOString()}-${t || "exported.csv"}`, l.click(), l.remove();
}
const cB = ({ tbl: e, columns: t, tables: n, fileName: r, applyMasks: o, disabled: i, iconOnly: s = !1, overrideMask: a }) => {
  const [l, u] = de(!1), c = hu(), d = async () => {
    u(!0);
    try {
      if (n && n.length > 0) {
        const g = n.filter(({ table: b, columns: x }) => {
          const w = typeof b == "function" ? b() : b;
          return (w == null ? void 0 : w.size) && (x == null ? void 0 : x.length);
        });
        if (g.length === 0)
          return;
        const v = g.map(({ table: b, columns: x, sectionName: w }) => {
          const C = x.map((S) => ({
            ...S,
            mask: (a == null ? void 0 : a(S)) ?? S.mask
          }));
          return {
            table: typeof b == "function" ? b() : b,
            columns: (c == null ? void 0 : c.applyLookups(C)) ?? C,
            sectionName: w
          };
        });
        qO({ tables: v, fileName: r, applyMasks: o });
      } else {
        const g = typeof e == "function" ? e() : e;
        if (!(g != null && g.size) || !(t != null && t.length))
          return;
        const v = t.map((x) => ({
          ...x,
          mask: (a == null ? void 0 : a(x)) ?? x.mask
        })), b = (c == null ? void 0 : c.applyLookups(v)) ?? v;
        XO({ tbl: g, columns: b, fileName: r, applyMasks: o });
      }
    } catch (g) {
      console.error("ExportTableButton - Error trying to export csv", g);
    } finally {
      u(!1);
    }
  }, h = l || i || (() => {
    if (n && n.length > 0)
      return !n.some(({ table: g, columns: v }) => {
        const b = typeof g == "function" ? g() : g;
        return (b == null ? void 0 : b.size) && (v == null ? void 0 : v.length);
      });
    {
      const g = typeof e == "function" ? e() : e;
      return !(g != null && g.size) || !(t != null && t.length);
    }
  })(), y = /* @__PURE__ */ f(
    Pe,
    {
      className: s ? "" : "icon-left",
      size: s ? "sm" : "default",
      variant: "outline",
      onClick: d,
      disabled: h,
      children: l ? /* @__PURE__ */ f(Om, { className: "animate-spin size-5" }) : /* @__PURE__ */ L(ke, { children: [
        /* @__PURE__ */ f(kx, {}),
        !s && /* @__PURE__ */ f("span", { children: "Export" })
      ] })
    }
  );
  return /* @__PURE__ */ L(ke, { children: [
    s ? /* @__PURE__ */ f(Zc, { children: /* @__PURE__ */ L(Ms, { children: [
      /* @__PURE__ */ f(As, { asChild: !0, children: y }),
      /* @__PURE__ */ f(oi, { children: "Export" })
    ] }) }) : y,
    !s && /* @__PURE__ */ f(Oo, { orientation: "vertical", className: "h-auto" })
  ] });
};
function we(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function $e(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function at(e, t) {
  const n = we(e);
  return isNaN(t) ? $e(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Vt(e, t) {
  const n = we(e);
  if (isNaN(t)) return $e(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = $e(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const i = o.getDate();
  return r >= i ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
const td = 6048e5, QO = 864e5, ZO = 6e4, JO = 36e5, eI = 1e3;
let tI = {};
function pr() {
  return tI;
}
function Rt(e, t) {
  var a, l, u, c;
  const n = pr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = we(e), i = o.getDay(), s = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function wn(e) {
  return Rt(e, { weekStartsOn: 1 });
}
function gw(e) {
  const t = we(e), n = t.getFullYear(), r = $e(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = wn(r), i = $e(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = wn(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function Gr(e) {
  const t = we(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Kr(e) {
  const t = we(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function rn(e, t) {
  const n = Gr(e), r = Gr(t), o = +n - Kr(n), i = +r - Kr(r);
  return Math.round((o - i) / QO);
}
function nI(e) {
  const t = gw(e), n = $e(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), wn(n);
}
function lc(e, t) {
  const n = t * 7;
  return at(e, n);
}
function rI(e, t) {
  return Vt(e, t * 12);
}
function oI(e) {
  let t;
  return e.forEach(function(n) {
    const r = we(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function iI(e) {
  let t;
  return e.forEach((n) => {
    const r = we(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function xt(e, t) {
  const n = Gr(e), r = Gr(t);
  return +n == +r;
}
function nd(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function sI(e) {
  if (!nd(e) && typeof e != "number")
    return !1;
  const t = we(e);
  return !isNaN(Number(t));
}
function Xo(e, t) {
  const n = we(e), r = we(t), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
function aI(e, t, n) {
  const r = Rt(e, n), o = Rt(t, n), i = +r - Kr(r), s = +o - Kr(o);
  return Math.round((i - s) / td);
}
function rd(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Ct(e) {
  const t = we(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function vw(e) {
  const t = we(e), n = $e(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function od(e, t) {
  var a, l, u, c;
  const n = pr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = we(e), i = o.getDay(), s = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + s), o.setHours(23, 59, 59, 999), o;
}
function yw(e) {
  return od(e, { weekStartsOn: 1 });
}
const lI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, cI = (e, t, n) => {
  let r;
  const o = lI[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Ha(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const uI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, dI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fI = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hI = {
  date: Ha({
    formats: uI,
    defaultWidth: "full"
  }),
  time: Ha({
    formats: dI,
    defaultWidth: "full"
  }),
  dateTime: Ha({
    formats: fI,
    defaultWidth: "full"
  })
}, mI = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, pI = (e, t, n, r) => mI[e];
function vo(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[a] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[a] || e.values[s];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const gI = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, vI = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, yI = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, bI = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, wI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, xI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, CI = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, SI = {
  ordinalNumber: CI,
  era: vo({
    values: gI,
    defaultWidth: "wide"
  }),
  quarter: vo({
    values: vI,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: vo({
    values: yI,
    defaultWidth: "wide"
  }),
  day: vo({
    values: bI,
    defaultWidth: "wide"
  }),
  dayPeriod: vo({
    values: wI,
    defaultWidth: "wide",
    formattingValues: xI,
    defaultFormattingWidth: "wide"
  })
};
function yo(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const s = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? PI(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      TI(a, (d) => d.test(s))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const c = t.slice(s.length);
    return { value: u, rest: c };
  };
}
function TI(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function PI(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function EI(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = t.slice(o.length);
    return { value: s, rest: a };
  };
}
const DI = /^(\d+)(th|st|nd|rd)?/i, kI = /\d+/i, NI = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, RI = {
  any: [/^b/i, /^(a|c)/i]
}, MI = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, AI = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, OI = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, II = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, _I = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $I = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, LI = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, FI = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, VI = {
  ordinalNumber: EI({
    matchPattern: DI,
    parsePattern: kI,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: yo({
    matchPatterns: NI,
    defaultMatchWidth: "wide",
    parsePatterns: RI,
    defaultParseWidth: "any"
  }),
  quarter: yo({
    matchPatterns: MI,
    defaultMatchWidth: "wide",
    parsePatterns: AI,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: yo({
    matchPatterns: OI,
    defaultMatchWidth: "wide",
    parsePatterns: II,
    defaultParseWidth: "any"
  }),
  day: yo({
    matchPatterns: _I,
    defaultMatchWidth: "wide",
    parsePatterns: $I,
    defaultParseWidth: "any"
  }),
  dayPeriod: yo({
    matchPatterns: LI,
    defaultMatchWidth: "any",
    parsePatterns: FI,
    defaultParseWidth: "any"
  })
}, id = {
  code: "en-US",
  formatDistance: cI,
  formatLong: hI,
  formatRelative: pI,
  localize: SI,
  match: VI,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function BI(e) {
  const t = we(e);
  return rn(t, vw(t)) + 1;
}
function sd(e) {
  const t = we(e), n = +wn(t) - +nI(t);
  return Math.round(n / td) + 1;
}
function ad(e, t) {
  var c, d, h, p;
  const n = we(e), r = n.getFullYear(), o = pr(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, s = $e(e, 0);
  s.setFullYear(r + 1, 0, i), s.setHours(0, 0, 0, 0);
  const a = Rt(s, t), l = $e(e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const u = Rt(l, t);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function WI(e, t) {
  var a, l, u, c;
  const n = pr(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, o = ad(e, t), i = $e(e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Rt(i, t);
}
function ld(e, t) {
  const n = we(e), r = +Rt(n, t) - +WI(n, t);
  return Math.round(r / td) + 1;
}
function Re(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Tn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Re(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Re(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Re(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Re(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Re(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Re(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Re(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Re(o, t.length);
  }
}, Tr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, em = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Tn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = ad(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = i % 100;
      return Re(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Re(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = gw(e);
    return Re(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Re(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Re(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Re(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Tn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Re(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = ld(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Re(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = sd(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Re(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Tn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = BI(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Re(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Re(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Re(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Re(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Tr.noon : r === 0 ? o = Tr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Tr.evening : r >= 12 ? o = Tr.afternoon : r >= 4 ? o = Tr.morning : o = Tr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Tn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Tn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Re(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Re(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Tn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Tn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Tn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return nm(r);
      case "XXXX":
      case "XX":
        return jn(r);
      case "XXXXX":
      case "XXX":
      default:
        return jn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return nm(r);
      case "xxxx":
      case "xx":
        return jn(r);
      case "xxxxx":
      case "xxx":
      default:
        return jn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + tm(r, ":");
      case "OOOO":
      default:
        return "GMT" + jn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + tm(r, ":");
      case "zzzz":
      default:
        return "GMT" + jn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Re(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Re(r, t.length);
  }
};
function tm(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Re(i, 2);
}
function nm(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Re(Math.abs(e) / 60, 2) : jn(e, t);
}
function jn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Re(Math.trunc(r / 60), 2), i = Re(r % 60, 2);
  return n + o + t + i;
}
const rm = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, bw = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, zI = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return rm(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", rm(r, t)).replace("{{time}}", bw(o, t));
}, cc = {
  p: bw,
  P: zI
}, jI = /^D+$/, HI = /^Y+$/, UI = ["D", "DD", "YY", "YYYY"];
function ww(e) {
  return jI.test(e);
}
function xw(e) {
  return HI.test(e);
}
function uc(e, t, n) {
  const r = YI(e, t, n);
  if (console.warn(r), UI.includes(e)) throw new RangeError(r);
}
function YI(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const GI = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, KI = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, XI = /^'([^]*?)'?$/, qI = /''/g, QI = /[a-zA-Z]/;
function un(e, t, n) {
  var c, d, h, p, y, g, v, b;
  const r = pr(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? id, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : b.weekStartsOn) ?? 0, a = we(e);
  if (!sI(a))
    throw new RangeError("Invalid time value");
  let l = t.match(KI).map((x) => {
    const w = x[0];
    if (w === "p" || w === "P") {
      const C = cc[w];
      return C(x, o.formatLong);
    }
    return x;
  }).join("").match(GI).map((x) => {
    if (x === "''")
      return { isToken: !1, value: "'" };
    const w = x[0];
    if (w === "'")
      return { isToken: !1, value: ZI(x) };
    if (em[w])
      return { isToken: !0, value: x };
    if (w.match(QI))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: x };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(a, l));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  };
  return l.map((x) => {
    if (!x.isToken) return x.value;
    const w = x.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && xw(w) || !(n != null && n.useAdditionalDayOfYearTokens) && ww(w)) && uc(w, t, String(e));
    const C = em[w[0]];
    return C(a, w, o.localize, u);
  }).join("");
}
function ZI(e) {
  const t = e.match(XI);
  return t ? t[1].replace(qI, "'") : e;
}
function JI(e) {
  const t = we(e), n = t.getFullYear(), r = t.getMonth(), o = $e(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function e_() {
  return Object.assign({}, pr());
}
function t_(e) {
  let n = we(e).getDay();
  return n === 0 && (n = 7), n;
}
function n_(e) {
  return Math.trunc(+we(e) / 1e3);
}
function r_(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function o_(e, t) {
  return aI(
    r_(e),
    Ct(e),
    t
  ) + 1;
}
function dc(e, t) {
  const n = we(e), r = we(t);
  return n.getTime() > r.getTime();
}
function Cw(e, t) {
  const n = we(e), r = we(t);
  return +n < +r;
}
function i_(e, t) {
  const n = t instanceof Date ? $e(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const s_ = 10;
class Sw {
  constructor() {
    J(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class a_ extends Sw {
  constructor(t, n, r, o, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class l_ extends Sw {
  constructor() {
    super(...arguments);
    J(this, "priority", s_);
    J(this, "subPriority", -1);
  }
  set(n, r) {
    return r.timestampIsSet ? n : $e(n, i_(n, Date));
  }
}
class Ee {
  run(t, n, r, o) {
    const i = this.parse(t, n, r, o);
    return i ? {
      setter: new a_(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class c_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 140);
    J(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const qe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, tn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Qe(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ye(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function nn(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * JO + i * ZO + s * eI),
    rest: t.slice(n[0].length)
  };
}
function Tw(e) {
  return Ye(qe.anyDigitsSigned, e);
}
function Ge(e, t) {
  switch (e) {
    case 1:
      return Ye(qe.singleDigit, t);
    case 2:
      return Ye(qe.twoDigits, t);
    case 3:
      return Ye(qe.threeDigits, t);
    case 4:
      return Ye(qe.fourDigits, t);
    default:
      return Ye(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function ms(e, t) {
  switch (e) {
    case 1:
      return Ye(qe.singleDigitSigned, t);
    case 2:
      return Ye(qe.twoDigitsSigned, t);
    case 3:
      return Ye(qe.threeDigitsSigned, t);
    case 4:
      return Ye(qe.fourDigitsSigned, t);
    default:
      return Ye(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function cd(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Pw(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const i = r + 50, s = Math.trunc(i / 100) * 100, a = e >= i % 100;
    o = e + s - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Ew(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class u_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return Qe(Ge(4, n), i);
      case "yo":
        return Qe(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return Qe(Ge(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const i = n.getFullYear();
    if (o.isTwoDigitYear) {
      const a = Pw(
        o.year,
        i
      );
      return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const s = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class d_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return Qe(Ge(4, n), i);
      case "Yo":
        return Qe(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return Qe(Ge(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, i) {
    const s = ad(n, i);
    if (o.isTwoDigitYear) {
      const l = Pw(
        o.year,
        s
      );
      return n.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Rt(n, i);
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(a, 0, i.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Rt(n, i);
  }
}
class f_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return ms(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const i = $e(n, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), wn(i);
  }
}
class h_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 130);
    J(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return ms(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class m_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 120);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return Ge(r.length, n);
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class p_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 120);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return Ge(r.length, n);
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class g_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    J(this, "priority", 110);
  }
  parse(n, r, o) {
    const i = (s) => s - 1;
    switch (r) {
      case "M":
        return Qe(
          Ye(qe.month, n),
          i
        );
      case "MM":
        return Qe(Ge(2, n), i);
      case "Mo":
        return Qe(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class v_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 110);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => s - 1;
    switch (r) {
      case "L":
        return Qe(
          Ye(qe.month, n),
          i
        );
      case "LL":
        return Qe(Ge(2, n), i);
      case "Lo":
        return Qe(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function y_(e, t, n) {
  const r = we(e), o = ld(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class b_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 100);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return Ye(qe.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, i) {
    return Rt(y_(n, o, i), i);
  }
}
function w_(e, t) {
  const n = we(e), r = sd(n) - t;
  return n.setDate(n.getDate() - r * 7), n;
}
class x_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 100);
    J(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return Ye(qe.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return wn(w_(n, o));
  }
}
const C_ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], S_ = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class T_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "subPriority", 1);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return Ye(qe.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), i = Ew(o), s = n.getMonth();
    return i ? r >= 1 && r <= S_[s] : r >= 1 && r <= C_[s];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class P_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "subpriority", 1);
    J(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return Ye(qe.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return Ew(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function ud(e, t, n) {
  var d, h, p, y;
  const r = pr(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((h = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? r.weekStartsOn ?? ((y = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = we(e), s = i.getDay(), l = (t % 7 + 7) % 7, u = 7 - o, c = t < 0 || t > 6 ? t - (s + u) % 7 : (l + u) % 7 - (s + u) % 7;
  return at(i, c);
}
class E_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = ud(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class D_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const s = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "e":
      case "ee":
        return Qe(Ge(r.length, n), s);
      case "eo":
        return Qe(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = ud(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class k_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const s = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "c":
      case "cc":
        return Qe(Ge(r.length, n), s);
      case "co":
        return Qe(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = ud(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
function N_(e, t) {
  const n = we(e), r = t_(n), o = t - r;
  return at(n, o);
}
class R_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 90);
    J(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => s === 0 ? 7 : s;
    switch (r) {
      case "i":
      case "ii":
        return Ge(r.length, n);
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      case "iii":
        return Qe(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return Qe(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return Qe(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return Qe(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = N_(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class M_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 80);
    J(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(cd(o), 0, 0, 0), n;
  }
}
class A_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 80);
    J(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(cd(o), 0, 0, 0), n;
  }
}
class O_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 80);
    J(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(cd(o), 0, 0, 0), n;
  }
}
class I_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return Ye(qe.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const i = n.getHours() >= 12;
    return i && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class __ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return Ye(qe.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class $_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return Ye(qe.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class L_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 70);
    J(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return Ye(qe.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const i = o <= 24 ? o % 24 : o;
    return n.setHours(i, 0, 0, 0), n;
  }
}
class F_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 60);
    J(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return Ye(qe.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class V_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 50);
    J(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return Ye(qe.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class B_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 30);
    J(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return Qe(Ge(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class W_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 10);
    J(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return nn(
          tn.basicOptionalMinutes,
          n
        );
      case "XX":
        return nn(tn.basic, n);
      case "XXXX":
        return nn(
          tn.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return nn(
          tn.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return nn(tn.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : $e(
      n,
      n.getTime() - Kr(n) - o
    );
  }
}
class z_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 10);
    J(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return nn(
          tn.basicOptionalMinutes,
          n
        );
      case "xx":
        return nn(tn.basic, n);
      case "xxxx":
        return nn(
          tn.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return nn(
          tn.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return nn(tn.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : $e(
      n,
      n.getTime() - Kr(n) - o
    );
  }
}
class j_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 40);
    J(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Tw(n);
  }
  set(n, r, o) {
    return [$e(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class H_ extends Ee {
  constructor() {
    super(...arguments);
    J(this, "priority", 20);
    J(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Tw(n);
  }
  set(n, r, o) {
    return [$e(n, o), { timestampIsSet: !0 }];
  }
}
const U_ = {
  G: new c_(),
  y: new u_(),
  Y: new d_(),
  R: new f_(),
  u: new h_(),
  Q: new m_(),
  q: new p_(),
  M: new g_(),
  L: new v_(),
  w: new b_(),
  I: new x_(),
  d: new T_(),
  D: new P_(),
  E: new E_(),
  e: new D_(),
  c: new k_(),
  i: new R_(),
  a: new M_(),
  b: new A_(),
  B: new O_(),
  h: new I_(),
  H: new __(),
  K: new $_(),
  k: new L_(),
  m: new F_(),
  s: new V_(),
  S: new B_(),
  X: new W_(),
  x: new z_(),
  t: new j_(),
  T: new H_()
}, Y_ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, G_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, K_ = /^'([^]*?)'?$/, X_ = /''/g, q_ = /\S/, Q_ = /[a-zA-Z]/;
function Z_(e, t, n, r) {
  var g, v, b, x;
  const o = e_(), i = o.locale ?? id, s = o.firstWeekContainsDate ?? ((v = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, a = o.weekStartsOn ?? ((x = (b = o.locale) == null ? void 0 : b.options) == null ? void 0 : x.weekStartsOn) ?? 0, l = {
    firstWeekContainsDate: s,
    weekStartsOn: a,
    locale: i
  }, u = [new l_()], c = t.match(G_).map((w) => {
    const C = w[0];
    if (C in cc) {
      const S = cc[C];
      return S(w, i.formatLong);
    }
    return w;
  }).join("").match(Y_), d = [];
  for (let w of c) {
    xw(w) && uc(w, t, e), ww(w) && uc(w, t, e);
    const C = w[0], S = U_[C];
    if (S) {
      const { incompatibleTokens: T } = S;
      if (Array.isArray(T)) {
        const E = d.find(
          (D) => T.includes(D.token) || D.token === C
        );
        if (E)
          throw new RangeError(
            `The format string mustn't contain \`${E.fullToken}\` and \`${w}\` at the same time`
          );
      } else if (S.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${w}\` and any other token at the same time`
        );
      d.push({ token: C, fullToken: w });
      const P = S.run(
        e,
        w,
        i.match,
        l
      );
      if (!P)
        return $e(n, NaN);
      u.push(P.setter), e = P.rest;
    } else {
      if (C.match(Q_))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + C + "`"
        );
      if (w === "''" ? w = "'" : C === "'" && (w = J_(w)), e.indexOf(w) === 0)
        e = e.slice(w.length);
      else
        return $e(n, NaN);
    }
  }
  if (e.length > 0 && q_.test(e))
    return $e(n, NaN);
  const h = u.map((w) => w.priority).sort((w, C) => C - w).filter((w, C, S) => S.indexOf(w) === C).map(
    (w) => u.filter((C) => C.priority === w).sort((C, S) => S.subPriority - C.subPriority)
  ).map((w) => w[0]);
  let p = we(n);
  if (isNaN(p.getTime()))
    return $e(n, NaN);
  const y = {};
  for (const w of h) {
    if (!w.validate(p, l))
      return $e(n, NaN);
    const C = w.set(p, y, l);
    Array.isArray(C) ? (p = C[0], Object.assign(y, C[1])) : p = C;
  }
  return $e(n, p);
}
function J_(e) {
  return e.match(K_)[1].replace(X_, "'");
}
function dd(e, t) {
  const n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function e$(e, t) {
  const n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear();
}
function Ua(e, t) {
  return at(e, -t);
}
function Ya(e, t) {
  const n = we(e), r = n.getFullYear(), o = n.getDate(), i = $e(e, 0);
  i.setFullYear(r, t, 15), i.setHours(0, 0, 0, 0);
  const s = JI(i);
  return n.setMonth(t, Math.min(o, s)), n;
}
function om(e, t) {
  const n = we(e);
  return isNaN(+n) ? $e(e, NaN) : (n.setFullYear(t), n);
}
var ue = function() {
  return ue = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ue.apply(this, arguments);
};
function t$(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Dw(e, t, n) {
  for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function pi(e) {
  return e.mode === "multiple";
}
function gi(e) {
  return e.mode === "range";
}
function ea(e) {
  return e.mode === "single";
}
var n$ = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function r$(e, t) {
  return un(e, "LLLL y", t);
}
function o$(e, t) {
  return un(e, "d", t);
}
function i$(e, t) {
  return un(e, "LLLL", t);
}
function s$(e) {
  return "".concat(e);
}
function a$(e, t) {
  return un(e, "cccccc", t);
}
function l$(e, t) {
  return un(e, "yyyy", t);
}
var c$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: r$,
  formatDay: o$,
  formatMonthCaption: i$,
  formatWeekNumber: s$,
  formatWeekdayName: a$,
  formatYearCaption: l$
}), u$ = function(e, t, n) {
  return un(e, "do MMMM (EEEE)", n);
}, d$ = function() {
  return "Month: ";
}, f$ = function() {
  return "Go to next month";
}, h$ = function() {
  return "Go to previous month";
}, m$ = function(e, t) {
  return un(e, "cccc", t);
}, p$ = function(e) {
  return "Week n. ".concat(e);
}, g$ = function() {
  return "Year: ";
}, v$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: u$,
  labelMonthDropdown: d$,
  labelNext: f$,
  labelPrevious: h$,
  labelWeekNumber: p$,
  labelWeekday: m$,
  labelYearDropdown: g$
});
function y$() {
  var e = "buttons", t = n$, n = id, r = {}, o = {}, i = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: c$,
    labels: v$,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: i,
    styles: s,
    today: a,
    mode: "default"
  };
}
function b$(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, i = e.fromDate, s = e.toDate;
  return r ? i = Ct(r) : t && (i = new Date(t, 0, 1)), o ? s = rd(o) : n && (s = new Date(n, 11, 31)), {
    fromDate: i ? Gr(i) : void 0,
    toDate: s ? Gr(s) : void 0
  };
}
var kw = je(void 0);
function w$(e) {
  var t, n = e.initialProps, r = y$(), o = b$(n), i = o.fromDate, s = o.toDate, a = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  a !== "buttons" && (!i || !s) && (a = "buttons");
  var l;
  (ea(n) || pi(n) || gi(n)) && (l = n.onSelect);
  var u = ue(ue(ue({}, r), n), { captionLayout: a, classNames: ue(ue({}, r.classNames), n.classNames), components: ue({}, n.components), formatters: ue(ue({}, r.formatters), n.formatters), fromDate: i, labels: ue(ue({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: ue(ue({}, r.modifiers), n.modifiers), modifiersClassNames: ue(ue({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: ue(ue({}, r.styles), n.styles), toDate: s });
  return f(kw.Provider, { value: u, children: e.children });
}
function Fe() {
  var e = Te(kw);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Nw(e) {
  var t = Fe(), n = t.locale, r = t.classNames, o = t.styles, i = t.formatters.formatCaption;
  return f("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: n }) });
}
function x$(e) {
  return f("svg", ue({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: f("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Rw(e) {
  var t, n, r = e.onChange, o = e.value, i = e.children, s = e.caption, a = e.className, l = e.style, u = Fe(), c = (n = (t = u.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : x$;
  return L("div", { className: a, style: l, children: [f("span", { className: u.classNames.vhidden, children: e["aria-label"] }), f("select", { name: e.name, "aria-label": e["aria-label"], className: u.classNames.dropdown, style: u.styles.dropdown, value: o, onChange: r, children: i }), L("div", { className: u.classNames.caption_label, style: u.styles.caption_label, "aria-hidden": "true", children: [s, f(c, { className: u.classNames.dropdown_icon, style: u.styles.dropdown_icon })] })] });
}
function C$(e) {
  var t, n = Fe(), r = n.fromDate, o = n.toDate, i = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, u = n.components, c = n.labels.labelMonthDropdown;
  if (!r)
    return f(ke, {});
  if (!o)
    return f(ke, {});
  var d = [];
  if (e$(r, o))
    for (var h = Ct(r), p = r.getMonth(); p <= o.getMonth(); p++)
      d.push(Ya(h, p));
  else
    for (var h = Ct(/* @__PURE__ */ new Date()), p = 0; p <= 11; p++)
      d.push(Ya(h, p));
  var y = function(v) {
    var b = Number(v.target.value), x = Ya(Ct(e.displayMonth), b);
    e.onChange(x);
  }, g = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : Rw;
  return f(g, { name: "months", "aria-label": c(), className: l.dropdown_month, style: i.dropdown_month, onChange: y, value: e.displayMonth.getMonth(), caption: a(e.displayMonth, { locale: s }), children: d.map(function(v) {
    return f("option", { value: v.getMonth(), children: a(v, { locale: s }) }, v.getMonth());
  }) });
}
function S$(e) {
  var t, n = e.displayMonth, r = Fe(), o = r.fromDate, i = r.toDate, s = r.locale, a = r.styles, l = r.classNames, u = r.components, c = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, h = [];
  if (!o)
    return f(ke, {});
  if (!i)
    return f(ke, {});
  for (var p = o.getFullYear(), y = i.getFullYear(), g = p; g <= y; g++)
    h.push(om(vw(/* @__PURE__ */ new Date()), g));
  var v = function(x) {
    var w = om(Ct(n), Number(x.target.value));
    e.onChange(w);
  }, b = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : Rw;
  return f(b, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: v, value: n.getFullYear(), caption: c(n, { locale: s }), children: h.map(function(x) {
    return f("option", { value: x.getFullYear(), children: c(x, { locale: s }) }, x.getFullYear());
  }) });
}
function T$(e, t) {
  var n = de(e), r = n[0], o = n[1], i = t === void 0 ? r : t;
  return [i, o];
}
function P$(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), i = e.toDate, s = e.fromDate, a = e.numberOfMonths, l = a === void 0 ? 1 : a;
  if (i && Xo(i, o) < 0) {
    var u = -1 * (l - 1);
    o = Vt(i, u);
  }
  return s && Xo(o, s) < 0 && (o = s), Ct(o);
}
function E$() {
  var e = Fe(), t = P$(e), n = T$(t, e.month), r = n[0], o = n[1], i = function(s) {
    var a;
    if (!e.disableNavigation) {
      var l = Ct(s);
      o(l), (a = e.onMonthChange) === null || a === void 0 || a.call(e, l);
    }
  };
  return [r, i];
}
function D$(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = Ct(e), i = Ct(Vt(o, r)), s = Xo(i, o), a = [], l = 0; l < s; l++) {
    var u = Vt(o, l);
    a.push(u);
  }
  return n && (a = a.reverse()), a;
}
function k$(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = Ct(e);
    if (!n)
      return Vt(a, s);
    var l = Xo(n, e);
    if (!(l < i))
      return Vt(a, s);
  }
}
function N$(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = Ct(e);
    if (!n)
      return Vt(a, -s);
    var l = Xo(a, n);
    if (!(l <= 0))
      return Vt(a, -s);
  }
}
var Mw = je(void 0);
function R$(e) {
  var t = Fe(), n = E$(), r = n[0], o = n[1], i = D$(r, t), s = k$(r, t), a = N$(r, t), l = function(d) {
    return i.some(function(h) {
      return dd(d, h);
    });
  }, u = function(d, h) {
    l(d) || (h && Cw(d, h) ? o(Vt(d, 1 + t.numberOfMonths * -1)) : o(d));
  }, c = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: o,
    goToDate: u,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return f(Mw.Provider, { value: c, children: e.children });
}
function vi() {
  var e = Te(Mw);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function im(e) {
  var t, n = Fe(), r = n.classNames, o = n.styles, i = n.components, s = vi().goToMonth, a = function(c) {
    s(Vt(c, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : Nw, u = f(l, { id: e.id, displayMonth: e.displayMonth });
  return L("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [f("div", { className: r.vhidden, children: u }), f(C$, { onChange: a, displayMonth: e.displayMonth }), f(S$, { onChange: a, displayMonth: e.displayMonth })] });
}
function M$(e) {
  return f("svg", ue({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: f("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function A$(e) {
  return f("svg", ue({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: f("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var ps = Ke(function(e, t) {
  var n = Fe(), r = n.classNames, o = n.styles, i = [r.button_reset, r.button];
  e.className && i.push(e.className);
  var s = i.join(" "), a = ue(ue({}, o.button_reset), o.button);
  return e.style && Object.assign(a, e.style), f("button", ue({}, e, { ref: t, type: "button", className: s, style: a }));
});
function O$(e) {
  var t, n, r = Fe(), o = r.dir, i = r.locale, s = r.classNames, a = r.styles, l = r.labels, u = l.labelPrevious, c = l.labelNext, d = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return f(ke, {});
  var h = u(e.previousMonth, { locale: i }), p = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), y = c(e.nextMonth, { locale: i }), g = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), v = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : A$, b = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : M$;
  return L("div", { className: s.nav, style: a.nav, children: [!e.hidePrevious && f(ps, { name: "previous-month", "aria-label": h, className: p, style: a.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? f(v, { className: s.nav_icon, style: a.nav_icon }) : f(b, { className: s.nav_icon, style: a.nav_icon }) }), !e.hideNext && f(ps, { name: "next-month", "aria-label": y, className: g, style: a.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? f(b, { className: s.nav_icon, style: a.nav_icon }) : f(v, { className: s.nav_icon, style: a.nav_icon }) })] });
}
function sm(e) {
  var t = Fe().numberOfMonths, n = vi(), r = n.previousMonth, o = n.nextMonth, i = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(y) {
    return dd(e.displayMonth, y);
  }), l = a === 0, u = a === s.length - 1, c = t > 1 && (l || !u), d = t > 1 && (u || !l), h = function() {
    r && i(r);
  }, p = function() {
    o && i(o);
  };
  return f(O$, { displayMonth: e.displayMonth, hideNext: c, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: h, onNextClick: p });
}
function I$(e) {
  var t, n = Fe(), r = n.classNames, o = n.disableNavigation, i = n.styles, s = n.captionLayout, a = n.components, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : Nw, u;
  return o ? u = f(l, { id: e.id, displayMonth: e.displayMonth }) : s === "dropdown" ? u = f(im, { displayMonth: e.displayMonth, id: e.id }) : s === "dropdown-buttons" ? u = L(ke, { children: [f(im, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), f(sm, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : u = L(ke, { children: [f(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), f(sm, { displayMonth: e.displayMonth, id: e.id })] }), f("div", { className: r.caption, style: i.caption, children: u });
}
function _$(e) {
  var t = Fe(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? f("tfoot", { className: o, style: r.tfoot, children: f("tr", { children: f("td", { colSpan: 8, children: n }) }) }) : f(ke, {});
}
function $$(e, t, n) {
  for (var r = n ? wn(/* @__PURE__ */ new Date()) : Rt(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], i = 0; i < 7; i++) {
    var s = at(r, i);
    o.push(s);
  }
  return o;
}
function L$() {
  var e = Fe(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, i = e.weekStartsOn, s = e.ISOWeek, a = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, u = $$(o, i, s);
  return L("tr", { style: n.head_row, className: t.head_row, children: [r && f("td", { style: n.head_cell, className: t.head_cell }), u.map(function(c, d) {
    return f("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(c, { locale: o }), children: a(c, { locale: o }) }, d);
  })] });
}
function F$() {
  var e, t = Fe(), n = t.classNames, r = t.styles, o = t.components, i = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : L$;
  return f("thead", { style: r.head, className: n.head, children: f(i, {}) });
}
function V$(e) {
  var t = Fe(), n = t.locale, r = t.formatters.formatDay;
  return f(ke, { children: r(e.date, { locale: n }) });
}
var fd = je(void 0);
function B$(e) {
  if (!pi(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return f(fd.Provider, { value: t, children: e.children });
  }
  return f(W$, { initialProps: e.initialProps, children: e.children });
}
function W$(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, i = t.max, s = function(u, c, d) {
    var h, p;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, u, c, d);
    var y = !!(c.selected && o && (r == null ? void 0 : r.length) === o);
    if (!y) {
      var g = !!(!c.selected && i && (r == null ? void 0 : r.length) === i);
      if (!g) {
        var v = r ? Dw([], r) : [];
        if (c.selected) {
          var b = v.findIndex(function(x) {
            return xt(u, x);
          });
          v.splice(b, 1);
        } else
          v.push(u);
        (p = t.onSelect) === null || p === void 0 || p.call(t, v, u, c, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(u) {
    var c = i && r.length > i - 1, d = r.some(function(h) {
      return xt(h, u);
    });
    return !!(c && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return f(fd.Provider, { value: l, children: n });
}
function hd() {
  var e = Te(fd);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function z$(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? xt(o, e) && xt(r, e) ? void 0 : xt(o, e) ? { from: o, to: void 0 } : xt(r, e) ? void 0 : dc(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? dc(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? Cw(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var md = je(void 0);
function j$(e) {
  if (!gi(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return f(md.Provider, { value: t, children: e.children });
  }
  return f(H$, { initialProps: e.initialProps, children: e.children });
}
function H$(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, i = o.from, s = o.to, a = t.min, l = t.max, u = function(p, y, g) {
    var v, b;
    (v = t.onDayClick) === null || v === void 0 || v.call(t, p, y, g);
    var x = z$(p, r);
    (b = t.onSelect) === null || b === void 0 || b.call(t, x, p, y, g);
  }, c = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (c.range_start = [i], s ? (c.range_end = [s], xt(i, s) || (c.range_middle = [
    {
      after: i,
      before: s
    }
  ])) : c.range_end = [i]) : s && (c.range_start = [s], c.range_end = [s]), a && (i && !s && c.disabled.push({
    after: Ua(i, a - 1),
    before: at(i, a - 1)
  }), i && s && c.disabled.push({
    after: i,
    before: at(i, a - 1)
  }), !i && s && c.disabled.push({
    after: Ua(s, a - 1),
    before: at(s, a - 1)
  })), l) {
    if (i && !s && (c.disabled.push({
      before: at(i, -l + 1)
    }), c.disabled.push({
      after: at(i, l - 1)
    })), i && s) {
      var d = rn(s, i) + 1, h = l - d;
      c.disabled.push({
        before: Ua(i, h)
      }), c.disabled.push({
        after: at(s, h)
      });
    }
    !i && s && (c.disabled.push({
      before: at(s, -l + 1)
    }), c.disabled.push({
      after: at(s, l - 1)
    }));
  }
  return f(md.Provider, { value: { selected: r, onDayClick: u, modifiers: c }, children: n });
}
function pd() {
  var e = Te(md);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function Yi(e) {
  return Array.isArray(e) ? Dw([], e) : e !== void 0 ? [e] : [];
}
function U$(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = Yi(o);
  }), t;
}
var Xt;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(Xt || (Xt = {}));
var Y$ = Xt.Selected, hn = Xt.Disabled, G$ = Xt.Hidden, K$ = Xt.Today, Ga = Xt.RangeEnd, Ka = Xt.RangeMiddle, Xa = Xt.RangeStart, X$ = Xt.Outside;
function q$(e, t, n) {
  var r, o = (r = {}, r[Y$] = Yi(e.selected), r[hn] = Yi(e.disabled), r[G$] = Yi(e.hidden), r[K$] = [e.today], r[Ga] = [], r[Ka] = [], r[Xa] = [], r[X$] = [], r);
  return e.fromDate && o[hn].push({ before: e.fromDate }), e.toDate && o[hn].push({ after: e.toDate }), pi(e) ? o[hn] = o[hn].concat(t.modifiers[hn]) : gi(e) && (o[hn] = o[hn].concat(n.modifiers[hn]), o[Xa] = n.modifiers[Xa], o[Ka] = n.modifiers[Ka], o[Ga] = n.modifiers[Ga]), o;
}
var Aw = je(void 0);
function Q$(e) {
  var t = Fe(), n = hd(), r = pd(), o = q$(t, n, r), i = U$(t.modifiers), s = ue(ue({}, o), i);
  return f(Aw.Provider, { value: s, children: e.children });
}
function Ow() {
  var e = Te(Aw);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function Z$(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function J$(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function eL(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function tL(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function nL(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function rL(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var i = rn(o, r) < 0;
    i && (n = [o, r], r = n[0], o = n[1]);
    var s = rn(e, r) >= 0 && rn(o, e) >= 0;
    return s;
  }
  return o ? xt(o, e) : r ? xt(r, e) : !1;
}
function oL(e) {
  return nd(e);
}
function iL(e) {
  return Array.isArray(e) && e.every(nd);
}
function sL(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (oL(n))
      return xt(e, n);
    if (iL(n))
      return n.includes(e);
    if (J$(n))
      return rL(e, n);
    if (nL(n))
      return n.dayOfWeek.includes(e.getDay());
    if (Z$(n)) {
      var r = rn(n.before, e), o = rn(n.after, e), i = r > 0, s = o < 0, a = dc(n.before, n.after);
      return a ? s && i : i || s;
    }
    return eL(n) ? rn(e, n.after) > 0 : tL(n) ? rn(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function gd(e, t, n) {
  var r = Object.keys(t).reduce(function(i, s) {
    var a = t[s];
    return sL(e, a) && i.push(s), i;
  }, []), o = {};
  return r.forEach(function(i) {
    return o[i] = !0;
  }), n && !dd(e, n) && (o.outside = !0), o;
}
function aL(e, t) {
  for (var n = Ct(e[0]), r = rd(e[e.length - 1]), o, i, s = n; s <= r; ) {
    var a = gd(s, t), l = !a.disabled && !a.hidden;
    if (!l) {
      s = at(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !i && (i = s), o || (o = s), s = at(s, 1);
  }
  return i || o;
}
var lL = 365;
function Iw(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, i = t.modifiers, s = t.retry, a = s === void 0 ? { count: 0, lastFocused: e } : s, l = o.weekStartsOn, u = o.fromDate, c = o.toDate, d = o.locale, h = {
    day: at,
    week: lc,
    month: Vt,
    year: rI,
    startOfWeek: function(v) {
      return o.ISOWeek ? wn(v) : Rt(v, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(v) {
      return o.ISOWeek ? yw(v) : od(v, { locale: d, weekStartsOn: l });
    }
  }, p = h[n](e, r === "after" ? 1 : -1);
  r === "before" && u ? p = oI([u, p]) : r === "after" && c && (p = iI([c, p]));
  var y = !0;
  if (i) {
    var g = gd(p, i);
    y = !g.disabled && !g.hidden;
  }
  return y ? p : a.count > lL ? a.lastFocused : Iw(p, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: i,
    retry: ue(ue({}, a), { count: a.count + 1 })
  });
}
var _w = je(void 0);
function cL(e) {
  var t = vi(), n = Ow(), r = de(), o = r[0], i = r[1], s = de(), a = s[0], l = s[1], u = aL(t.displayMonths, n), c = o ?? (a && t.isDateDisplayed(a)) ? a : u, d = function() {
    l(o), i(void 0);
  }, h = function(v) {
    i(v);
  }, p = Fe(), y = function(v, b) {
    if (o) {
      var x = Iw(o, {
        moveBy: v,
        direction: b,
        context: p,
        modifiers: n
      });
      xt(o, x) || (t.goToDate(x, o), h(x));
    }
  }, g = {
    focusedDay: o,
    focusTarget: c,
    blur: d,
    focus: h,
    focusDayAfter: function() {
      return y("day", "after");
    },
    focusDayBefore: function() {
      return y("day", "before");
    },
    focusWeekAfter: function() {
      return y("week", "after");
    },
    focusWeekBefore: function() {
      return y("week", "before");
    },
    focusMonthBefore: function() {
      return y("month", "before");
    },
    focusMonthAfter: function() {
      return y("month", "after");
    },
    focusYearBefore: function() {
      return y("year", "before");
    },
    focusYearAfter: function() {
      return y("year", "after");
    },
    focusStartOfWeek: function() {
      return y("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return y("endOfWeek", "after");
    }
  };
  return f(_w.Provider, { value: g, children: e.children });
}
function vd() {
  var e = Te(_w);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function uL(e, t) {
  var n = Ow(), r = gd(e, n, t);
  return r;
}
var yd = je(void 0);
function dL(e) {
  if (!ea(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return f(yd.Provider, { value: t, children: e.children });
  }
  return f(fL, { initialProps: e.initialProps, children: e.children });
}
function fL(e) {
  var t = e.initialProps, n = e.children, r = function(i, s, a) {
    var l, u, c;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, i, s, a), s.selected && !t.required) {
      (u = t.onSelect) === null || u === void 0 || u.call(t, void 0, i, s, a);
      return;
    }
    (c = t.onSelect) === null || c === void 0 || c.call(t, i, i, s, a);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return f(yd.Provider, { value: o, children: n });
}
function $w() {
  var e = Te(yd);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function hL(e, t) {
  var n = Fe(), r = $w(), o = hd(), i = pd(), s = vd(), a = s.focusDayAfter, l = s.focusDayBefore, u = s.focusWeekAfter, c = s.focusWeekBefore, d = s.blur, h = s.focus, p = s.focusMonthBefore, y = s.focusMonthAfter, g = s.focusYearBefore, v = s.focusYearAfter, b = s.focusStartOfWeek, x = s.focusEndOfWeek, w = function(k) {
    var N, M, B, G;
    ea(n) ? (N = r.onDayClick) === null || N === void 0 || N.call(r, e, t, k) : pi(n) ? (M = o.onDayClick) === null || M === void 0 || M.call(o, e, t, k) : gi(n) ? (B = i.onDayClick) === null || B === void 0 || B.call(i, e, t, k) : (G = n.onDayClick) === null || G === void 0 || G.call(n, e, t, k);
  }, C = function(k) {
    var N;
    h(e), (N = n.onDayFocus) === null || N === void 0 || N.call(n, e, t, k);
  }, S = function(k) {
    var N;
    d(), (N = n.onDayBlur) === null || N === void 0 || N.call(n, e, t, k);
  }, T = function(k) {
    var N;
    (N = n.onDayMouseEnter) === null || N === void 0 || N.call(n, e, t, k);
  }, P = function(k) {
    var N;
    (N = n.onDayMouseLeave) === null || N === void 0 || N.call(n, e, t, k);
  }, E = function(k) {
    var N;
    (N = n.onDayPointerEnter) === null || N === void 0 || N.call(n, e, t, k);
  }, D = function(k) {
    var N;
    (N = n.onDayPointerLeave) === null || N === void 0 || N.call(n, e, t, k);
  }, A = function(k) {
    var N;
    (N = n.onDayTouchCancel) === null || N === void 0 || N.call(n, e, t, k);
  }, R = function(k) {
    var N;
    (N = n.onDayTouchEnd) === null || N === void 0 || N.call(n, e, t, k);
  }, O = function(k) {
    var N;
    (N = n.onDayTouchMove) === null || N === void 0 || N.call(n, e, t, k);
  }, F = function(k) {
    var N;
    (N = n.onDayTouchStart) === null || N === void 0 || N.call(n, e, t, k);
  }, $ = function(k) {
    var N;
    (N = n.onDayKeyUp) === null || N === void 0 || N.call(n, e, t, k);
  }, W = function(k) {
    var N;
    switch (k.key) {
      case "ArrowLeft":
        k.preventDefault(), k.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        k.preventDefault(), k.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        k.preventDefault(), k.stopPropagation(), u();
        break;
      case "ArrowUp":
        k.preventDefault(), k.stopPropagation(), c();
        break;
      case "PageUp":
        k.preventDefault(), k.stopPropagation(), k.shiftKey ? g() : p();
        break;
      case "PageDown":
        k.preventDefault(), k.stopPropagation(), k.shiftKey ? v() : y();
        break;
      case "Home":
        k.preventDefault(), k.stopPropagation(), b();
        break;
      case "End":
        k.preventDefault(), k.stopPropagation(), x();
        break;
    }
    (N = n.onDayKeyDown) === null || N === void 0 || N.call(n, e, t, k);
  }, V = {
    onClick: w,
    onFocus: C,
    onBlur: S,
    onKeyDown: W,
    onKeyUp: $,
    onMouseEnter: T,
    onMouseLeave: P,
    onPointerEnter: E,
    onPointerLeave: D,
    onTouchCancel: A,
    onTouchEnd: R,
    onTouchMove: O,
    onTouchStart: F
  };
  return V;
}
function mL() {
  var e = Fe(), t = $w(), n = hd(), r = pd(), o = ea(e) ? t.selected : pi(e) ? n.selected : gi(e) ? r.selected : void 0;
  return o;
}
function pL(e) {
  return Object.values(Xt).includes(e);
}
function gL(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (pL(r)) {
      var i = e.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function vL(e, t) {
  var n = ue({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = ue(ue({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function yL(e, t, n) {
  var r, o, i, s = Fe(), a = vd(), l = uL(e, t), u = hL(e, l), c = mL(), d = !!(s.onDayClick || s.mode !== "default");
  fe(function() {
    var T;
    l.outside || a.focusedDay && d && xt(a.focusedDay, e) && ((T = n.current) === null || T === void 0 || T.focus());
  }, [
    a.focusedDay,
    e,
    n,
    d,
    l.outside
  ]);
  var h = gL(s, l).join(" "), p = vL(s, l), y = !!(l.outside && !s.showOutsideDays || l.hidden), g = (i = (o = s.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : V$, v = f(g, { date: e, displayMonth: t, activeModifiers: l }), b = {
    style: p,
    className: h,
    children: v,
    role: "gridcell"
  }, x = a.focusTarget && xt(a.focusTarget, e) && !l.outside, w = a.focusedDay && xt(a.focusedDay, e), C = ue(ue(ue({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = w || x ? 0 : -1, r)), u), S = {
    isButton: d,
    isHidden: y,
    activeModifiers: l,
    selectedDays: c,
    buttonProps: C,
    divProps: b
  };
  return S;
}
function bL(e) {
  var t = me(null), n = yL(e.date, e.displayMonth, t);
  return n.isHidden ? f("div", { role: "gridcell" }) : n.isButton ? f(ps, ue({ name: "day", ref: t }, n.buttonProps)) : f("div", ue({}, n.divProps));
}
function wL(e) {
  var t = e.number, n = e.dates, r = Fe(), o = r.onWeekNumberClick, i = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, u = r.formatters.formatWeekNumber, c = u(Number(t), { locale: a });
  if (!o)
    return f("span", { className: s.weeknumber, style: i.weeknumber, children: c });
  var d = l(Number(t), { locale: a }), h = function(p) {
    o(t, n, p);
  };
  return f(ps, { name: "week-number", "aria-label": d, className: s.weeknumber, style: i.weeknumber, onClick: h, children: c });
}
function xL(e) {
  var t, n, r = Fe(), o = r.styles, i = r.classNames, s = r.showWeekNumber, a = r.components, l = (t = a == null ? void 0 : a.Day) !== null && t !== void 0 ? t : bL, u = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : wL, c;
  return s && (c = f("td", { className: i.cell, style: o.cell, children: f(u, { number: e.weekNumber, dates: e.dates }) })), L("tr", { className: i.row, style: o.row, children: [c, e.dates.map(function(d) {
    return f("td", { className: i.cell, style: o.cell, role: "presentation", children: f(l, { displayMonth: e.displayMonth, date: d }) }, n_(d));
  })] });
}
function am(e, t, n) {
  for (var r = n != null && n.ISOWeek ? yw(t) : od(t, n), o = n != null && n.ISOWeek ? wn(e) : Rt(e, n), i = rn(r, o), s = [], a = 0; a <= i; a++)
    s.push(at(o, a));
  var l = s.reduce(function(u, c) {
    var d = n != null && n.ISOWeek ? sd(c) : ld(c, n), h = u.find(function(p) {
      return p.weekNumber === d;
    });
    return h ? (h.dates.push(c), u) : (u.push({
      weekNumber: d,
      dates: [c]
    }), u);
  }, []);
  return l;
}
function CL(e, t) {
  var n = am(Ct(e), rd(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = o_(e, t);
    if (r < 6) {
      var o = n[n.length - 1], i = o.dates[o.dates.length - 1], s = lc(i, 6 - r), a = am(lc(i, 1), s, t);
      n.push.apply(n, a);
    }
  }
  return n;
}
function SL(e) {
  var t, n, r, o = Fe(), i = o.locale, s = o.classNames, a = o.styles, l = o.hideHead, u = o.fixedWeeks, c = o.components, d = o.weekStartsOn, h = o.firstWeekContainsDate, p = o.ISOWeek, y = CL(e.displayMonth, {
    useFixedWeeks: !!u,
    ISOWeek: p,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: h
  }), g = (t = c == null ? void 0 : c.Head) !== null && t !== void 0 ? t : F$, v = (n = c == null ? void 0 : c.Row) !== null && n !== void 0 ? n : xL, b = (r = c == null ? void 0 : c.Footer) !== null && r !== void 0 ? r : _$;
  return L("table", { id: e.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && f(g, {}), f("tbody", { className: s.tbody, style: a.tbody, children: y.map(function(x) {
    return f(v, { displayMonth: e.displayMonth, dates: x.dates, weekNumber: x.weekNumber }, x.weekNumber);
  }) }), f(b, { displayMonth: e.displayMonth })] });
}
function TL() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var PL = TL() ? cr : fe, qa = !1, EL = 0;
function lm() {
  return "react-day-picker-".concat(++EL);
}
function DL(e) {
  var t, n = e ?? (qa ? lm() : null), r = de(n), o = r[0], i = r[1];
  return PL(function() {
    o === null && i(lm());
  }, []), fe(function() {
    qa === !1 && (qa = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function kL(e) {
  var t, n, r = Fe(), o = r.dir, i = r.classNames, s = r.styles, a = r.components, l = vi().displayMonths, u = DL(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), c = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], h = s.month, p = e.displayIndex === 0, y = e.displayIndex === l.length - 1, g = !p && !y;
  o === "rtl" && (t = [p, y], y = t[0], p = t[1]), p && (d.push(i.caption_start), h = ue(ue({}, h), s.caption_start)), y && (d.push(i.caption_end), h = ue(ue({}, h), s.caption_end)), g && (d.push(i.caption_between), h = ue(ue({}, h), s.caption_between));
  var v = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : I$;
  return L("div", { className: d.join(" "), style: h, children: [f(v, { id: u, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), f(SL, { id: c, "aria-labelledby": u, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function NL(e) {
  var t = Fe(), n = t.classNames, r = t.styles;
  return f("div", { className: n.months, style: r.months, children: e.children });
}
function RL(e) {
  var t, n, r = e.initialProps, o = Fe(), i = vd(), s = vi(), a = de(!1), l = a[0], u = a[1];
  fe(function() {
    o.initialFocus && i.focusTarget && (l || (i.focus(i.focusTarget), u(!0)));
  }, [
    o.initialFocus,
    l,
    i.focus,
    i.focusTarget,
    i
  ]);
  var c = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && c.push(o.classNames.multiple_months), o.showWeekNumber && c.push(o.classNames.with_weeknumber);
  var d = ue(ue({}, o.styles.root), o.style), h = Object.keys(r).filter(function(y) {
    return y.startsWith("data-");
  }).reduce(function(y, g) {
    var v;
    return ue(ue({}, y), (v = {}, v[g] = r[g], v));
  }, {}), p = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : NL;
  return f("div", ue({ className: c.join(" "), style: d, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, h, { children: f(p, { children: s.displayMonths.map(function(y, g) {
    return f(kL, { displayIndex: g, displayMonth: y }, g);
  }) }) }));
}
function ML(e) {
  var t = e.children, n = t$(e, ["children"]);
  return f(w$, { initialProps: n, children: f(R$, { children: f(dL, { initialProps: n, children: f(B$, { initialProps: n, children: f(j$, { initialProps: n, children: f(Q$, { children: f(cL, { children: t }) }) }) }) }) }) });
}
function AL(e) {
  return f(ML, ue({}, e, { children: f(RL, { initialProps: e }) }));
}
function OL(e, t) {
  return m.useReducer((n, r) => t[n][r] ?? n, e);
}
var bd = "ScrollArea", [Lw, uB] = Bt(bd), [IL, Wt] = Lw(bd), Fw = m.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...s
    } = e, [a, l] = m.useState(null), [u, c] = m.useState(null), [d, h] = m.useState(null), [p, y] = m.useState(null), [g, v] = m.useState(null), [b, x] = m.useState(0), [w, C] = m.useState(0), [S, T] = m.useState(!1), [P, E] = m.useState(!1), D = ye(t, (R) => l(R)), A = Jc(o);
    return /* @__PURE__ */ f(
      IL,
      {
        scope: n,
        type: r,
        dir: A,
        scrollHideDelay: i,
        scrollArea: a,
        viewport: u,
        onViewportChange: c,
        content: d,
        onContentChange: h,
        scrollbarX: p,
        onScrollbarXChange: y,
        scrollbarXEnabled: S,
        onScrollbarXEnabledChange: T,
        scrollbarY: g,
        onScrollbarYChange: v,
        scrollbarYEnabled: P,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: x,
        onCornerHeightChange: C,
        children: /* @__PURE__ */ f(
          se.div,
          {
            dir: A,
            ...s,
            ref: D,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": w + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Fw.displayName = bd;
var Vw = "ScrollAreaViewport", Bw = m.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...i } = e, s = Wt(Vw, n), a = m.useRef(null), l = ye(t, a, s.onViewportChange);
    return /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ f(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ f(
        se.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ f("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Bw.displayName = Vw;
var dn = "ScrollAreaScrollbar", wd = m.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Wt(dn, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: s } = o, a = e.orientation === "horizontal";
    return m.useEffect(() => (a ? i(!0) : s(!0), () => {
      a ? i(!1) : s(!1);
    }), [a, i, s]), o.type === "hover" ? /* @__PURE__ */ f(_L, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ f($L, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ f(Ww, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ f(xd, { ...r, ref: t }) : null;
  }
);
wd.displayName = dn;
var _L = m.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Wt(dn, e.__scopeScrollArea), [i, s] = m.useState(!1);
  return m.useEffect(() => {
    const a = o.scrollArea;
    let l = 0;
    if (a) {
      const u = () => {
        window.clearTimeout(l), s(!0);
      }, c = () => {
        l = window.setTimeout(() => s(!1), o.scrollHideDelay);
      };
      return a.addEventListener("pointerenter", u), a.addEventListener("pointerleave", c), () => {
        window.clearTimeout(l), a.removeEventListener("pointerenter", u), a.removeEventListener("pointerleave", c);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ f(ct, { present: n || i, children: /* @__PURE__ */ f(
    Ww,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), $L = m.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Wt(dn, e.__scopeScrollArea), i = e.orientation === "horizontal", s = na(() => l("SCROLL_END"), 100), [a, l] = OL("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return m.useEffect(() => {
    if (a === "idle") {
      const u = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [a, o.scrollHideDelay, l]), m.useEffect(() => {
    const u = o.viewport, c = i ? "scrollLeft" : "scrollTop";
    if (u) {
      let d = u[c];
      const h = () => {
        const p = u[c];
        d !== p && (l("SCROLL"), s()), d = p;
      };
      return u.addEventListener("scroll", h), () => u.removeEventListener("scroll", h);
    }
  }, [o.viewport, i, l, s]), /* @__PURE__ */ f(ct, { present: n || a !== "hidden", children: /* @__PURE__ */ f(
    xd,
    {
      "data-state": a === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: j(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: j(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Ww = m.forwardRef((e, t) => {
  const n = Wt(dn, e.__scopeScrollArea), { forceMount: r, ...o } = e, [i, s] = m.useState(!1), a = e.orientation === "horizontal", l = na(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, c = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(a ? u : c);
    }
  }, 10);
  return Xr(n.viewport, l), Xr(n.content, l), /* @__PURE__ */ f(ct, { present: r || i, children: /* @__PURE__ */ f(
    xd,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), xd = m.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Wt(dn, e.__scopeScrollArea), i = m.useRef(null), s = m.useRef(0), [a, l] = m.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = Yw(a.viewport, a.content), c = {
    ...r,
    sizes: a,
    onSizesChange: l,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (h) => i.current = h,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (h) => s.current = h
  };
  function d(h, p) {
    return zL(h, s.current, a, p);
  }
  return n === "horizontal" ? /* @__PURE__ */ f(
    LL,
    {
      ...c,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const h = o.viewport.scrollLeft, p = cm(h, a, o.dir);
          i.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = d(h, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ f(
    FL,
    {
      ...c,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const h = o.viewport.scrollTop, p = cm(h, a);
          i.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), LL = m.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = Wt(dn, e.__scopeScrollArea), [s, a] = m.useState(), l = m.useRef(null), u = ye(t, l, i.onScrollbarXChange);
  return m.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ f(
    jw,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: u,
      sizes: n,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ta(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (c) => e.onThumbPointerDown(c.x),
      onDragScroll: (c) => e.onDragScroll(c.x),
      onWheelScroll: (c, d) => {
        if (i.viewport) {
          const h = i.viewport.scrollLeft + c.deltaX;
          e.onWheelScroll(h), Kw(h, d) && c.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && s && r({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: vs(s.paddingLeft),
            paddingEnd: vs(s.paddingRight)
          }
        });
      }
    }
  );
}), FL = m.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = Wt(dn, e.__scopeScrollArea), [s, a] = m.useState(), l = m.useRef(null), u = ye(t, l, i.onScrollbarYChange);
  return m.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ f(
    jw,
    {
      "data-orientation": "vertical",
      ...o,
      ref: u,
      sizes: n,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ta(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (c) => e.onThumbPointerDown(c.y),
      onDragScroll: (c) => e.onDragScroll(c.y),
      onWheelScroll: (c, d) => {
        if (i.viewport) {
          const h = i.viewport.scrollTop + c.deltaY;
          e.onWheelScroll(h), Kw(h, d) && c.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && s && r({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: vs(s.paddingTop),
            paddingEnd: vs(s.paddingBottom)
          }
        });
      }
    }
  );
}), [VL, zw] = Lw(dn), jw = m.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: s,
    onThumbPointerDown: a,
    onThumbPositionChange: l,
    onDragScroll: u,
    onWheelScroll: c,
    onResize: d,
    ...h
  } = e, p = Wt(dn, n), [y, g] = m.useState(null), v = ye(t, (D) => g(D)), b = m.useRef(null), x = m.useRef(""), w = p.viewport, C = r.content - r.viewport, S = Je(c), T = Je(l), P = na(d, 10);
  function E(D) {
    if (b.current) {
      const A = D.clientX - b.current.left, R = D.clientY - b.current.top;
      u({ x: A, y: R });
    }
  }
  return m.useEffect(() => {
    const D = (A) => {
      const R = A.target;
      (y == null ? void 0 : y.contains(R)) && S(A, C);
    };
    return document.addEventListener("wheel", D, { passive: !1 }), () => document.removeEventListener("wheel", D, { passive: !1 });
  }, [w, y, C, S]), m.useEffect(T, [r, T]), Xr(y, P), Xr(p.content, P), /* @__PURE__ */ f(
    VL,
    {
      scope: n,
      scrollbar: y,
      hasThumb: o,
      onThumbChange: Je(i),
      onThumbPointerUp: Je(s),
      onThumbPositionChange: T,
      onThumbPointerDown: Je(a),
      children: /* @__PURE__ */ f(
        se.div,
        {
          ...h,
          ref: v,
          style: { position: "absolute", ...h.style },
          onPointerDown: j(e.onPointerDown, (D) => {
            D.button === 0 && (D.target.setPointerCapture(D.pointerId), b.current = y.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), E(D));
          }),
          onPointerMove: j(e.onPointerMove, E),
          onPointerUp: j(e.onPointerUp, (D) => {
            const A = D.target;
            A.hasPointerCapture(D.pointerId) && A.releasePointerCapture(D.pointerId), document.body.style.webkitUserSelect = x.current, p.viewport && (p.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), gs = "ScrollAreaThumb", Hw = m.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = zw(gs, e.__scopeScrollArea);
    return /* @__PURE__ */ f(ct, { present: n || o.hasThumb, children: /* @__PURE__ */ f(BL, { ref: t, ...r }) });
  }
), BL = m.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, i = Wt(gs, n), s = zw(gs, n), { onThumbPositionChange: a } = s, l = ye(
      t,
      (d) => s.onThumbChange(d)
    ), u = m.useRef(void 0), c = na(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return m.useEffect(() => {
      const d = i.viewport;
      if (d) {
        const h = () => {
          if (c(), !u.current) {
            const p = jL(d, a);
            u.current = p, a();
          }
        };
        return a(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [i.viewport, c, a]), /* @__PURE__ */ f(
      se.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: j(e.onPointerDownCapture, (d) => {
          const p = d.target.getBoundingClientRect(), y = d.clientX - p.left, g = d.clientY - p.top;
          s.onThumbPointerDown({ x: y, y: g });
        }),
        onPointerUp: j(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
Hw.displayName = gs;
var Cd = "ScrollAreaCorner", Uw = m.forwardRef(
  (e, t) => {
    const n = Wt(Cd, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ f(WL, { ...e, ref: t }) : null;
  }
);
Uw.displayName = Cd;
var WL = m.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = Wt(Cd, n), [i, s] = m.useState(0), [a, l] = m.useState(0), u = !!(i && a);
  return Xr(o.scrollbarX, () => {
    var d;
    const c = ((d = o.scrollbarX) == null ? void 0 : d.offsetHeight) || 0;
    o.onCornerHeightChange(c), l(c);
  }), Xr(o.scrollbarY, () => {
    var d;
    const c = ((d = o.scrollbarY) == null ? void 0 : d.offsetWidth) || 0;
    o.onCornerWidthChange(c), s(c);
  }), u ? /* @__PURE__ */ f(
    se.div,
    {
      ...r,
      ref: t,
      style: {
        width: i,
        height: a,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function vs(e) {
  return e ? parseInt(e, 10) : 0;
}
function Yw(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function ta(e) {
  const t = Yw(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function zL(e, t, n, r = "ltr") {
  const o = ta(n), i = o / 2, s = t || i, a = o - s, l = n.scrollbar.paddingStart + s, u = n.scrollbar.size - n.scrollbar.paddingEnd - a, c = n.content - n.viewport, d = r === "ltr" ? [0, c] : [c * -1, 0];
  return Gw([l, u], d)(e);
}
function cm(e, t, n = "ltr") {
  const r = ta(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, s = t.content - t.viewport, a = i - r, l = n === "ltr" ? [0, s] : [s * -1, 0], u = bl(e, l);
  return Gw([0, s], [0, a])(u);
}
function Gw(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Kw(e, t) {
  return e > 0 && e < t;
}
var jL = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== i.left, a = n.top !== i.top;
    (s || a) && t(), n = i, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function na(e, t) {
  const n = Je(e), r = m.useRef(0);
  return m.useEffect(() => () => window.clearTimeout(r.current), []), m.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Xr(e, t) {
  const n = Je(t);
  it(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var Xw = Fw, HL = Bw, UL = Uw;
const qw = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(Xw, { ref: r, className: q("relative overflow-hidden", e), ...n, children: [
  /* @__PURE__ */ f(HL, { className: "h-full w-full rounded-[inherit]", children: t }),
  /* @__PURE__ */ f(Qw, {}),
  /* @__PURE__ */ f(UL, {})
] }));
qw.displayName = Xw.displayName;
const Qw = m.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ f(
  wd,
  {
    ref: r,
    orientation: t,
    className: q(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ f(Hw, { className: "relative flex-1 rounded-full bg-button-primary-bg" })
  }
));
Qw.displayName = wd.displayName;
function Sd({ className: e, classNames: t, showOutsideDays: n = !0, ...r }) {
  return /* @__PURE__ */ f(
    AL,
    {
      showOutsideDays: n,
      className: q("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        caption_dropdowns: "flex justify-center gap-1 w-48",
        nav: "space-x-1 flex items-center",
        nav_button: q(dl({ variant: "minimal" }), "icon bg-transparent p-0"),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: q(dl({ variant: "ghost" }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-30 cursor-not-allowed pointer-events-none",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        vhidden: "vhidden hidden",
        ...t
      },
      components: {
        Dropdown: ({ value: o, onChange: i, children: s, ...a }) => {
          var d;
          const l = m.Children.toArray(s), u = l.find((h) => h.props.value === o), c = (h) => {
            const p = {
              target: { value: h }
            };
            i == null || i(p);
          };
          return /* @__PURE__ */ L(
            Ls,
            {
              value: o == null ? void 0 : o.toString(),
              onValueChange: (h) => {
                c(h);
              },
              children: [
                /* @__PURE__ */ f(Fs, { className: "pr-1.5 focus:ring-0", children: /* @__PURE__ */ f(iu, { children: (d = u == null ? void 0 : u.props) == null ? void 0 : d.children }) }),
                /* @__PURE__ */ f(Vs, { position: "popper", children: /* @__PURE__ */ f(qw, { className: "h-80", children: l.map((h, p) => {
                  var y;
                  return /* @__PURE__ */ f(Bs, { value: ((y = h.props.value) == null ? void 0 : y.toString()) ?? "", children: h.props.children }, `${h.props.value}-${p}`);
                }) }) })
              ]
            }
          );
        },
        IconLeft: ({ ...o }) => /* @__PURE__ */ f(Rx, { className: "h-4 w-4" }),
        IconRight: ({ ...o }) => /* @__PURE__ */ f(Nx, { className: "h-4 w-4" })
      },
      ...r
    }
  );
}
Sd.displayName = "Calendar";
function YL(e, t) {
  if (!e || !(e instanceof Date) || isNaN(e.getTime()))
    return t;
  try {
    return un(e, "PPP");
  } catch {
    return t;
  }
}
function um(e) {
  const t = e.selected ? YL(e.selected, e.placeholder || "Pick a date") : e.placeholder || "Pick a date";
  return /* @__PURE__ */ L(
    Pe,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.selected || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: t
          }
        ),
        /* @__PURE__ */ f(Pc, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function dB(e) {
  const [t, n] = de(!1), r = (i, s, a, l) => {
    var u;
    (u = e.onSelect) == null || u.call(e, i, s, a, l), i && n(!1);
  }, o = (i) => {
    n(i), i && window.dispatchEvent(new CustomEvent("datepicker-opening", { detail: { source: e.label } }));
  };
  return Y.useEffect(() => {
    const i = (a) => {
      var l;
      ((l = a.detail) == null ? void 0 : l.source) !== e.label && t && n(!1);
    }, s = () => {
      console.log("LabeledDatePicker: Received force-close-all-popovers event, current open state:", t), t && (console.log("LabeledDatePicker: Closing picker for label:", e.label), n(!1), setTimeout(() => {
        document.querySelectorAll("[data-radix-popper-content-wrapper]").forEach((u) => {
          const c = u;
          c.style.pointerEvents !== "none" && (c.style.display = "none", c.style.pointerEvents = "none");
        }), document.querySelectorAll("[data-radix-portal]").forEach((u) => {
          const c = u;
          c.contains(document.querySelector("[data-radix-popper-content-wrapper]")) && (c.style.display = "none", c.style.pointerEvents = "none");
        });
      }, 50));
    };
    return window.addEventListener("datepicker-opening", i), window.addEventListener("force-close-all-popovers", s), () => {
      window.removeEventListener("datepicker-opening", i), window.removeEventListener("force-close-all-popovers", s);
    };
  }, [t, e.label]), Y.useEffect(() => {
    var i;
    (i = e.onOpenChange) == null || i.call(e, t);
  }, [t, e.onOpenChange]), e.disabled ? /* @__PURE__ */ f(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ f(um, { ...e })
    }
  ) : /* @__PURE__ */ L(or, { modal: e.modal, open: t, onOpenChange: o, children: [
    /* @__PURE__ */ f(ro, { asChild: !0, children: /* @__PURE__ */ f("div", { className: e.className, children: /* @__PURE__ */ f(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ f(no, { children: /* @__PURE__ */ f(um, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ f(
      hr,
      {
        className: q("w-auto min-w-[280px] p-0", e.modal && "z-[100]"),
        renderOnBody: !e.modal,
        onInteractOutside: e.modal && !e.allowOutsideClose ? (i) => i.preventDefault() : void 0,
        onPointerDownOutside: e.modal && !e.allowOutsideClose ? (i) => i.preventDefault() : void 0,
        children: /* @__PURE__ */ f(
          Sd,
          {
            ...e,
            onSelect: r,
            disabled: e.disabledDate,
            className: q("bg-input-bg", e.className),
            mode: "single",
            initialFocus: !0,
            captionLayout: "dropdown-buttons",
            fromYear: 2e3,
            toYear: (/* @__PURE__ */ new Date()).getFullYear() + 5,
            defaultMonth: e.selected || void 0
          }
        )
      }
    )
  ] });
}
function dm(e) {
  if (!e || !(e instanceof Date) || isNaN(e.getTime()))
    return "";
  try {
    return un(e, "MM/dd/yyyy");
  } catch {
    return "";
  }
}
function fm(e) {
  const { from: t, to: n } = (e == null ? void 0 : e.selected) || {}, r = dm(t), o = dm(n), i = r ? `${r} ${o ? `to ${o}` : ""}` : e.placeholder || "Pick a range";
  return /* @__PURE__ */ L(
    Pe,
    {
      disabled: !!e.disabled,
      variant: "ghost",
      className: "input group justify-between text-left w-full border-0 ",
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.selected || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: i
          }
        ),
        /* @__PURE__ */ f(Mx, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function fB(e) {
  return e.disabled ? /* @__PURE__ */ f(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ f(fm, { ...e })
    }
  ) : /* @__PURE__ */ L(or, { children: [
    /* @__PURE__ */ f(ro, { asChild: !0, children: /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ f(no, { children: /* @__PURE__ */ f(fm, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ f(hr, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ f(
      Sd,
      {
        mode: "range",
        className: q("bg-input-bg", e.className),
        disabled: e.disabledDate,
        initialFocus: !0,
        selected: e.selected,
        onSelect: e.onSelect,
        numberOfMonths: 2,
        captionLayout: "dropdown-buttons",
        fromYear: 2e3,
        toYear: (/* @__PURE__ */ new Date()).getFullYear()
      }
    ) })
  ] });
}
const GL = "text-xxs px-4 py-0 font-normal", KL = ur(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 cursor-pointer min-h-[18px]",
  {
    variants: {
      variant: {
        default: "border border-button-primary-bg text-button-primary-txt bg-button-primary-bg hover:bg-button-primary-hover hover:border-button-primary-hover ",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        disabled: "border bg-button-primary-disabled border-button-primary-disabled cursor-not-allowed text-neutral-text-secondary/50",
        outline: "text-foreground",
        "scenario-count": `${GL} px-2 border-status-primary-border bg-status-primary-bg text-status-primary-text`
        // [`scenario-${ScenarioStatusSchema.enum.DRAFT}`]: `${scenarioStatusVariatsCommonStyles} border-status-grey-border bg-status-grey-bg text-status-grey-text`,
        // [`scenario-${ScenarioStatusSchema.enum.GENERATING}`]: `${scenarioStatusVariatsCommonStyles} border-status-yellow-border bg-status-yellow-bg text-status-yellow-text`,
        // [`scenario-${ScenarioStatusSchema.enum.FAILED}`]: `${scenarioStatusVariatsCommonStyles} border-status-danger-border bg-status-danger-bg text-status-danger-text`,
        // [`scenario-${ScenarioStatusSchema.enum.WORKING}`]: `${scenarioStatusVariatsCommonStyles} border-status-primary-border bg-status-primary-bg text-status-primary-text`,
        // [`scenario-${ScenarioStatusSchema.enum.READY}`]: `${scenarioStatusVariatsCommonStyles} border-status-primary-border-2 bg-status-primary-bg-2 text-status-primary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['PRE ALIGNMENT']}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['SENT FOR APPROVAL']}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['ALIGNED.PROCESSING']}`]: `${scenarioStatusVariatsCommonStyles} border-status-yellow-border bg-status-yellow-bg text-status-yellow-text`,
        // [`scenario-${ScenarioStatusSchema.enum.ALIGNED}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum.APPROVED}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Zw = Ke(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f("div", { ref: r, className: q(KL({ variant: t }), e), ...n }));
Zw.displayName = "Badge";
var hm = 1, XL = 0.9, qL = 0.8, QL = 0.17, Qa = 0.1, Za = 0.999, ZL = 0.9999, JL = 0.99, eF = /[\\\/_+.#"@\[\(\{&]/, tF = /[\\\/_+.#"@\[\(\{&]/g, nF = /[\s-]/, Jw = /[\s-]/g;
function fc(e, t, n, r, o, i, s) {
  if (i === t.length) return o === e.length ? hm : JL;
  var a = `${o},${i}`;
  if (s[a] !== void 0) return s[a];
  for (var l = r.charAt(i), u = n.indexOf(l, o), c = 0, d, h, p, y; u >= 0; ) d = fc(e, t, n, r, u + 1, i + 1, s), d > c && (u === o ? d *= hm : eF.test(e.charAt(u - 1)) ? (d *= qL, p = e.slice(o, u - 1).match(tF), p && o > 0 && (d *= Math.pow(Za, p.length))) : nF.test(e.charAt(u - 1)) ? (d *= XL, y = e.slice(o, u - 1).match(Jw), y && o > 0 && (d *= Math.pow(Za, y.length))) : (d *= QL, o > 0 && (d *= Math.pow(Za, u - o))), e.charAt(u) !== t.charAt(i) && (d *= ZL)), (d < Qa && n.charAt(u - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(u - 1) !== r.charAt(i)) && (h = fc(e, t, n, r, u + 1, i + 2, s), h * Qa > d && (d = h * Qa)), d > c && (c = d), u = n.indexOf(l, u + 1);
  return s[a] = c, c;
}
function mm(e) {
  return e.toLowerCase().replace(Jw, " ");
}
function rF(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, fc(e, t, mm(e), mm(t), 0, 0, {});
}
function vt() {
  return vt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vt.apply(null, arguments);
}
function Vr(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function oF(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function e0(...e) {
  return (t) => e.forEach(
    (n) => oF(n, t)
  );
}
function yi(...e) {
  return Ie(e0(...e), e);
}
function iF(e, t) {
  const n = /* @__PURE__ */ je(t);
  function r(i) {
    const { children: s, ...a } = i, l = ve(
      () => a,
      Object.values(a)
    );
    return /* @__PURE__ */ Le(n.Provider, {
      value: l
    }, s);
  }
  function o(i) {
    const s = Te(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    o
  ];
}
function sF(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = /* @__PURE__ */ je(s), l = n.length;
    n = [
      ...n,
      s
    ];
    function u(d) {
      const { scope: h, children: p, ...y } = d, g = (h == null ? void 0 : h[e][l]) || a, v = ve(
        () => y,
        Object.values(y)
      );
      return /* @__PURE__ */ Le(g.Provider, {
        value: v
      }, p);
    }
    function c(d, h) {
      const p = (h == null ? void 0 : h[e][l]) || a, y = Te(p);
      if (y) return y;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      c
    ];
  }
  const o = () => {
    const i = n.map((s) => /* @__PURE__ */ je(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return ve(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    aF(o, ...t)
  ];
}
function aF(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: u }) => {
        const d = l(i)[`__scope${u}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return ve(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const hc = globalThis != null && globalThis.document ? cr : () => {
}, lF = m.useId || (() => {
});
let cF = 0;
function Ja(e) {
  const [t, n] = m.useState(lF());
  return hc(() => {
    n(
      (r) => r ?? String(cF++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function sr(e) {
  const t = me(e);
  return fe(() => {
    t.current = e;
  }), ve(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function uF({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = dF({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = sr(n), l = Ie((u) => {
    if (i) {
      const d = typeof u == "function" ? u(e) : u;
      d !== e && a(d);
    } else o(u);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function dF({ defaultProp: e, onChange: t }) {
  const n = de(e), [r] = n, o = me(r), i = sr(t);
  return fe(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const Td = /* @__PURE__ */ Ke((e, t) => {
  const { children: n, ...r } = e, o = Gn.toArray(n), i = o.find(hF);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? Gn.count(s) > 1 ? Gn.only(null) : /* @__PURE__ */ Xi(s) ? s.props.children : null : l);
    return /* @__PURE__ */ Le(mc, vt({}, r, {
      ref: t
    }), /* @__PURE__ */ Xi(s) ? /* @__PURE__ */ Cc(s, void 0, a) : null);
  }
  return /* @__PURE__ */ Le(mc, vt({}, r, {
    ref: t
  }), n);
});
Td.displayName = "Slot";
const mc = /* @__PURE__ */ Ke((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Xi(n) ? /* @__PURE__ */ Cc(n, {
    ...mF(r, n.props),
    ref: t ? e0(t, n.ref) : n.ref
  }) : Gn.count(n) > 1 ? Gn.only(null) : null;
});
mc.displayName = "SlotClone";
const fF = ({ children: e }) => /* @__PURE__ */ Le(ys, null, e);
function hF(e) {
  return /* @__PURE__ */ Xi(e) && e.type === fF;
}
function mF(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const pF = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], zt = pF.reduce((e, t) => {
  const n = /* @__PURE__ */ Ke((r, o) => {
    const { asChild: i, ...s } = r, a = i ? Td : t;
    return fe(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Le(a, vt({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function gF(e, t) {
  e && Ec(
    () => e.dispatchEvent(t)
  );
}
function vF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = sr(e);
  fe(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const pc = "dismissableLayer.update", yF = "dismissableLayer.pointerDownOutside", bF = "dismissableLayer.focusOutside";
let pm;
const wF = /* @__PURE__ */ je({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), xF = /* @__PURE__ */ Ke((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...u } = e, c = Te(wF), [d, h] = de(null), p = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, y] = de({}), g = yi(
    t,
    (E) => h(E)
  ), v = Array.from(c.layers), [b] = [
    ...c.layersWithOutsidePointerEventsDisabled
  ].slice(-1), x = v.indexOf(b), w = d ? v.indexOf(d) : -1, C = c.layersWithOutsidePointerEventsDisabled.size > 0, S = w >= x, T = CF((E) => {
    const D = E.target, A = [
      ...c.branches
    ].some(
      (R) => R.contains(D)
    );
    !S || A || (i == null || i(E), a == null || a(E), E.defaultPrevented || l == null || l());
  }, p), P = SF((E) => {
    const D = E.target;
    [
      ...c.branches
    ].some(
      (R) => R.contains(D)
    ) || (s == null || s(E), a == null || a(E), E.defaultPrevented || l == null || l());
  }, p);
  return vF((E) => {
    w === c.layers.size - 1 && (o == null || o(E), !E.defaultPrevented && l && (E.preventDefault(), l()));
  }, p), fe(() => {
    if (d)
      return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (pm = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), gm(), () => {
        r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = pm);
      };
  }, [
    d,
    p,
    r,
    c
  ]), fe(() => () => {
    d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), gm());
  }, [
    d,
    c
  ]), fe(() => {
    const E = () => y({});
    return document.addEventListener(pc, E), () => document.removeEventListener(pc, E);
  }, []), /* @__PURE__ */ Le(zt.div, vt({}, u, {
    ref: g,
    style: {
      pointerEvents: C ? S ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Vr(e.onFocusCapture, P.onFocusCapture),
    onBlurCapture: Vr(e.onBlurCapture, P.onBlurCapture),
    onPointerDownCapture: Vr(e.onPointerDownCapture, T.onPointerDownCapture)
  }));
});
function CF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = sr(e), r = me(!1), o = me(() => {
  });
  return fe(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          t0(yF, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function SF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = sr(e), r = me(!1);
  return fe(() => {
    const o = (i) => {
      i.target && !r.current && t0(bF, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function gm() {
  const e = new CustomEvent(pc);
  document.dispatchEvent(e);
}
function t0(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? gF(o, i) : o.dispatchEvent(i);
}
const el = "focusScope.autoFocusOnMount", tl = "focusScope.autoFocusOnUnmount", vm = {
  bubbles: !1,
  cancelable: !0
}, TF = /* @__PURE__ */ Ke((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = e, [a, l] = de(null), u = sr(o), c = sr(i), d = me(null), h = yi(
    t,
    (g) => l(g)
  ), p = me({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  fe(() => {
    if (r) {
      let g = function(w) {
        if (p.paused || !a) return;
        const C = w.target;
        a.contains(C) ? d.current = C : Dn(d.current, {
          select: !0
        });
      }, v = function(w) {
        if (p.paused || !a) return;
        const C = w.relatedTarget;
        C !== null && (a.contains(C) || Dn(d.current, {
          select: !0
        }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const S of w) S.removedNodes.length > 0 && Dn(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const x = new MutationObserver(b);
      return a && x.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), x.disconnect();
      };
    }
  }, [
    r,
    a,
    p.paused
  ]), fe(() => {
    if (a) {
      bm.add(p);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(el, vm);
        a.addEventListener(el, u), a.dispatchEvent(b), b.defaultPrevented || (PF(RF(n0(a)), {
          select: !0
        }), document.activeElement === g && Dn(a));
      }
      return () => {
        a.removeEventListener(el, u), setTimeout(() => {
          const b = new CustomEvent(tl, vm);
          a.addEventListener(tl, c), a.dispatchEvent(b), b.defaultPrevented || Dn(g ?? document.body, {
            select: !0
          }), a.removeEventListener(tl, c), bm.remove(p);
        }, 0);
      };
    }
  }, [
    a,
    u,
    c,
    p
  ]);
  const y = Ie((g) => {
    if (!n && !r || p.paused) return;
    const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (v && b) {
      const x = g.currentTarget, [w, C] = EF(x);
      w && C ? !g.shiftKey && b === C ? (g.preventDefault(), n && Dn(w, {
        select: !0
      })) : g.shiftKey && b === w && (g.preventDefault(), n && Dn(C, {
        select: !0
      })) : b === x && g.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ Le(zt.div, vt({
    tabIndex: -1
  }, s, {
    ref: h,
    onKeyDown: y
  }));
});
function PF(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Dn(r, {
      select: t
    }), document.activeElement !== n) return;
}
function EF(e) {
  const t = n0(e), n = ym(t, e), r = ym(t.reverse(), e);
  return [
    n,
    r
  ];
}
function n0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ym(e, t) {
  for (const n of e)
    if (!DF(n, {
      upTo: t
    })) return n;
}
function DF(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function kF(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Dn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && kF(e) && t && e.select();
  }
}
const bm = NF();
function NF() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = wm(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = wm(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function wm(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function RF(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const MF = /* @__PURE__ */ Ke((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ _m.createPortal(/* @__PURE__ */ Le(zt.div, vt({}, o, {
    ref: t
  })), r) : null;
});
function AF(e, t) {
  return lx((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const ra = (e) => {
  const { present: t, children: n } = e, r = OF(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Gn.only(n), i = yi(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Cc(o, {
    ref: i
  }) : null;
};
ra.displayName = "Presence";
function OF(e) {
  const [t, n] = de(), r = me({}), o = me(e), i = me("none"), s = e ? "mounted" : "unmounted", [a, l] = AF(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return fe(() => {
    const u = Li(r.current);
    i.current = a === "mounted" ? u : "none";
  }, [
    a
  ]), hc(() => {
    const u = r.current, c = o.current;
    if (c !== e) {
      const h = i.current, p = Li(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), hc(() => {
    if (t) {
      const u = (d) => {
        const p = Li(r.current).includes(d.animationName);
        d.target === t && p && Ec(
          () => l("ANIMATION_END")
        );
      }, c = (d) => {
        d.target === t && (i.current = Li(r.current));
      };
      return t.addEventListener("animationstart", c), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", c), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: Ie((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Li(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let nl = 0;
function IF() {
  fe(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : xm()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : xm()), nl++, () => {
      nl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), nl--;
    };
  }, []);
}
function xm() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var r0 = qm(), rl = function() {
}, oa = m.forwardRef(function(e, t) {
  var n = m.useRef(null), r = m.useState({
    onScrollCapture: rl,
    onWheelCapture: rl,
    onTouchMoveCapture: rl
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, d = e.shards, h = e.sideCar, p = e.noIsolation, y = e.inert, g = e.allowPinchZoom, v = e.as, b = v === void 0 ? "div" : v, x = Nc(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = h, C = Xm([n, t]), S = ft(ft({}, x), o);
  return m.createElement(
    m.Fragment,
    null,
    c && m.createElement(w, { sideCar: r0, removeScrollBar: u, shards: d, noIsolation: p, inert: y, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    s ? m.cloneElement(m.Children.only(a), ft(ft({}, S), { ref: C })) : m.createElement(b, ft({}, S, { className: l, ref: C }), a)
  );
});
oa.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
oa.classNames = {
  fullWidth: To,
  zeroRight: So
};
var gc = !1;
if (typeof window < "u")
  try {
    var Fi = Object.defineProperty({}, "passive", {
      get: function() {
        return gc = !0, !0;
      }
    });
    window.addEventListener("test", Fi, Fi), window.removeEventListener("test", Fi, Fi);
  } catch {
    gc = !1;
  }
var Pr = gc ? { passive: !1 } : !1, _F = function(e) {
  return e.tagName === "TEXTAREA";
}, o0 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !_F(e) && n[t] === "visible")
  );
}, $F = function(e) {
  return o0(e, "overflowY");
}, LF = function(e) {
  return o0(e, "overflowX");
}, Cm = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = i0(e, n);
    if (r) {
      var o = s0(e, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, FF = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, VF = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, i0 = function(e, t) {
  return e === "v" ? $F(t) : LF(t);
}, s0 = function(e, t) {
  return e === "v" ? FF(t) : VF(t);
}, BF = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, WF = function(e, t, n, r, o) {
  var i = BF(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), u = !1, c = s > 0, d = 0, h = 0;
  do {
    var p = s0(e, a), y = p[0], g = p[1], v = p[2], b = g - v - i * y;
    (y || b) && i0(e, a) && (d += b, h += y), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (c && d === 0 || !c && h === 0) && (u = !0), u;
}, Vi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Sm = function(e) {
  return [e.deltaX, e.deltaY];
}, Tm = function(e) {
  return e && "current" in e ? e.current : e;
}, zF = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, jF = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, HF = 0, Er = [];
function UF(e) {
  var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), o = m.useState(HF++)[0], i = m.useState(function() {
    return Rc();
  })[0], s = m.useRef(e);
  m.useEffect(function() {
    s.current = e;
  }, [e]), m.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = Km([e.lockRef.current], (e.shards || []).map(Tm), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = m.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var b = Vi(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - b[0], C = "deltaY" in g ? g.deltaY : x[1] - b[1], S, T = g.target, P = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && P === "h" && T.type === "range")
      return !1;
    var E = Cm(P, T);
    if (!E)
      return !0;
    if (E ? S = P : (S = P === "v" ? "h" : "v", E = Cm(P, T)), !E)
      return !1;
    if (!r.current && "changedTouches" in g && (w || C) && (r.current = S), !S)
      return !0;
    var D = r.current || S;
    return WF(D, v, g, D === "h" ? w : C);
  }, []), l = m.useCallback(function(g) {
    var v = g;
    if (!(!Er.length || Er[Er.length - 1] !== i)) {
      var b = "deltaY" in v ? Sm(v) : Vi(v), x = t.current.filter(function(S) {
        return S.name === v.type && S.target === v.target && zF(S.delta, b);
      })[0];
      if (x && x.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(Tm).filter(Boolean).filter(function(S) {
          return S.contains(v.target);
        }), C = w.length > 0 ? a(v, w[0]) : !s.current.noIsolation;
        C && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = m.useCallback(function(g, v, b, x) {
    var w = { name: g, delta: v, target: b, should: x };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), c = m.useCallback(function(g) {
    n.current = Vi(g), r.current = void 0;
  }, []), d = m.useCallback(function(g) {
    u(g.type, Sm(g), g.target, a(g, e.lockRef.current));
  }, []), h = m.useCallback(function(g) {
    u(g.type, Vi(g), g.target, a(g, e.lockRef.current));
  }, []);
  m.useEffect(function() {
    return Er.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Pr), document.addEventListener("touchmove", l, Pr), document.addEventListener("touchstart", c, Pr), function() {
      Er = Er.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Pr), document.removeEventListener("touchmove", l, Pr), document.removeEventListener("touchstart", c, Pr);
    };
  }, []);
  var p = e.removeScrollBar, y = e.inert;
  return m.createElement(
    m.Fragment,
    null,
    y ? m.createElement(i, { styles: jF(o) }) : null,
    p ? m.createElement(ep, { gapMode: "margin" }) : null
  );
}
const YF = Zm(r0, UF);
var a0 = m.forwardRef(function(e, t) {
  return m.createElement(oa, ft({}, e, { ref: t, sideCar: YF }));
});
a0.classNames = oa.classNames;
const l0 = "Dialog", [c0, hB] = sF(l0), [GF, gr] = c0(l0), KF = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: s = !0 } = e, a = me(null), l = me(null), [u = !1, c] = uF({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Le(GF, {
    scope: t,
    triggerRef: a,
    contentRef: l,
    contentId: Ja(),
    titleId: Ja(),
    descriptionId: Ja(),
    open: u,
    onOpenChange: c,
    onOpenToggle: Ie(
      () => c(
        (d) => !d
      ),
      [
        c
      ]
    ),
    modal: s
  }, n);
}, u0 = "DialogPortal", [XF, d0] = c0(u0, {
  forceMount: void 0
}), qF = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = gr(u0, t);
  return /* @__PURE__ */ Le(XF, {
    scope: t,
    forceMount: n
  }, Gn.map(
    r,
    (s) => /* @__PURE__ */ Le(ra, {
      present: n || i.open
    }, /* @__PURE__ */ Le(MF, {
      asChild: !0,
      container: o
    }, s))
  ));
}, vc = "DialogOverlay", QF = /* @__PURE__ */ Ke((e, t) => {
  const n = d0(vc, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = gr(vc, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ Le(ra, {
    present: r || i.open
  }, /* @__PURE__ */ Le(ZF, vt({}, o, {
    ref: t
  }))) : null;
}), ZF = /* @__PURE__ */ Ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = gr(vc, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Le(a0, {
      as: Td,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ Le(zt.div, vt({
      "data-state": h0(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), qr = "DialogContent", JF = /* @__PURE__ */ Ke((e, t) => {
  const n = d0(qr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = gr(qr, e.__scopeDialog);
  return /* @__PURE__ */ Le(ra, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Le(e2, vt({}, o, {
    ref: t
  })) : /* @__PURE__ */ Le(t2, vt({}, o, {
    ref: t
  })));
}), e2 = /* @__PURE__ */ Ke((e, t) => {
  const n = gr(qr, e.__scopeDialog), r = me(null), o = yi(t, n.contentRef, r);
  return fe(() => {
    const i = r.current;
    if (i) return ei(i);
  }, []), /* @__PURE__ */ Le(f0, vt({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Vr(e.onCloseAutoFocus, (i) => {
      var s;
      i.preventDefault(), (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Vr(e.onPointerDownOutside, (i) => {
      const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
      (s.button === 2 || a) && i.preventDefault();
    }),
    onFocusOutside: Vr(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), t2 = /* @__PURE__ */ Ke((e, t) => {
  const n = gr(qr, e.__scopeDialog), r = me(!1), o = me(!1);
  return /* @__PURE__ */ Le(f0, vt({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, i), !i.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var s, a;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), f0 = /* @__PURE__ */ Ke((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = gr(qr, n), l = me(null), u = yi(t, l);
  return IF(), /* @__PURE__ */ Le(ys, null, /* @__PURE__ */ Le(TF, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Le(xF, vt({
    role: "dialog",
    id: a.contentId,
    "aria-describedby": a.descriptionId,
    "aria-labelledby": a.titleId,
    "data-state": h0(a.open)
  }, s, {
    ref: u,
    onDismiss: () => a.onOpenChange(!1)
  }))), !1);
}), n2 = "DialogTitle";
function h0(e) {
  return e ? "open" : "closed";
}
const r2 = "DialogTitleWarning";
iF(r2, {
  contentName: qr,
  titleName: n2,
  docsSlug: "dialog"
});
const o2 = KF, i2 = qF, s2 = QF, a2 = JF;
var bo = '[cmdk-group=""]', ol = '[cmdk-group-items=""]', l2 = '[cmdk-group-heading=""]', Pd = '[cmdk-item=""]', Pm = `${Pd}:not([aria-disabled="true"])`, yc = "cmdk-item-select", Hn = "data-value", c2 = (e, t, n) => rF(e, t, n), m0 = m.createContext(void 0), bi = () => m.useContext(m0), p0 = m.createContext(void 0), Ed = () => m.useContext(p0), g0 = m.createContext(void 0), v0 = m.forwardRef((e, t) => {
  let n = Dr(() => {
    var _, U;
    return { search: "", value: (U = (_ = e.value) != null ? _ : e.defaultValue) != null ? U : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Dr(() => /* @__PURE__ */ new Set()), o = Dr(() => /* @__PURE__ */ new Map()), i = Dr(() => /* @__PURE__ */ new Map()), s = Dr(() => /* @__PURE__ */ new Set()), a = y0(e), { label: l, children: u, value: c, onValueChange: d, filter: h, shouldFilter: p, loop: y, disablePointerSelection: g = !1, vimBindings: v = !0, ...b } = e, x = m.useId(), w = m.useId(), C = m.useId(), S = m.useRef(null), T = w2();
  ar(() => {
    if (c !== void 0) {
      let _ = c.trim();
      n.current.value = _, P.emit();
    }
  }, [c]), ar(() => {
    T(6, F);
  }, []);
  let P = m.useMemo(() => ({ subscribe: (_) => (s.current.add(_), () => s.current.delete(_)), snapshot: () => n.current, setState: (_, U, te) => {
    var X, Q, H;
    if (!Object.is(n.current[_], U)) {
      if (n.current[_] = U, _ === "search") O(), A(), T(1, R);
      else if (_ === "value" && (te || T(5, F), ((X = a.current) == null ? void 0 : X.value) !== void 0)) {
        let oe = U ?? "";
        (H = (Q = a.current).onValueChange) == null || H.call(Q, oe);
        return;
      }
      P.emit();
    }
  }, emit: () => {
    s.current.forEach((_) => _());
  } }), []), E = m.useMemo(() => ({ value: (_, U, te) => {
    var X;
    U !== ((X = i.current.get(_)) == null ? void 0 : X.value) && (i.current.set(_, { value: U, keywords: te }), n.current.filtered.items.set(_, D(U, te)), T(2, () => {
      A(), P.emit();
    }));
  }, item: (_, U) => (r.current.add(_), U && (o.current.has(U) ? o.current.get(U).add(_) : o.current.set(U, /* @__PURE__ */ new Set([_]))), T(3, () => {
    O(), A(), n.current.value || R(), P.emit();
  }), () => {
    i.current.delete(_), r.current.delete(_), n.current.filtered.items.delete(_);
    let te = $();
    T(4, () => {
      O(), (te == null ? void 0 : te.getAttribute("id")) === _ && R(), P.emit();
    });
  }), group: (_) => (o.current.has(_) || o.current.set(_, /* @__PURE__ */ new Set()), () => {
    i.current.delete(_), o.current.delete(_);
  }), filter: () => a.current.shouldFilter, label: l || e["aria-label"], disablePointerSelection: g, listId: x, inputId: C, labelId: w, listInnerRef: S }), []);
  function D(_, U) {
    var te, X;
    let Q = (X = (te = a.current) == null ? void 0 : te.filter) != null ? X : c2;
    return _ ? Q(_, n.current.search, U) : 0;
  }
  function A() {
    if (!n.current.search || a.current.shouldFilter === !1) return;
    let _ = n.current.filtered.items, U = [];
    n.current.filtered.groups.forEach((X) => {
      let Q = o.current.get(X), H = 0;
      Q.forEach((oe) => {
        let he = _.get(oe);
        H = Math.max(he, H);
      }), U.push([X, H]);
    });
    let te = S.current;
    W().sort((X, Q) => {
      var H, oe;
      let he = X.getAttribute("id"), ne = Q.getAttribute("id");
      return ((H = _.get(ne)) != null ? H : 0) - ((oe = _.get(he)) != null ? oe : 0);
    }).forEach((X) => {
      let Q = X.closest(ol);
      Q ? Q.appendChild(X.parentElement === Q ? X : X.closest(`${ol} > *`)) : te.appendChild(X.parentElement === te ? X : X.closest(`${ol} > *`));
    }), U.sort((X, Q) => Q[1] - X[1]).forEach((X) => {
      let Q = S.current.querySelector(`${bo}[${Hn}="${encodeURIComponent(X[0])}"]`);
      Q == null || Q.parentElement.appendChild(Q);
    });
  }
  function R() {
    let _ = W().find((te) => te.getAttribute("aria-disabled") !== "true"), U = _ == null ? void 0 : _.getAttribute(Hn);
    P.setState("value", U || void 0);
  }
  function O() {
    var _, U, te, X;
    if (!n.current.search || a.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let Q = 0;
    for (let H of r.current) {
      let oe = (U = (_ = i.current.get(H)) == null ? void 0 : _.value) != null ? U : "", he = (X = (te = i.current.get(H)) == null ? void 0 : te.keywords) != null ? X : [], ne = D(oe, he);
      n.current.filtered.items.set(H, ne), ne > 0 && Q++;
    }
    for (let [H, oe] of o.current) for (let he of oe) if (n.current.filtered.items.get(he) > 0) {
      n.current.filtered.groups.add(H);
      break;
    }
    n.current.filtered.count = Q;
  }
  function F() {
    var _, U, te;
    let X = $();
    X && (((_ = X.parentElement) == null ? void 0 : _.firstChild) === X && ((te = (U = X.closest(bo)) == null ? void 0 : U.querySelector(l2)) == null || te.scrollIntoView({ block: "nearest" })), X.scrollIntoView({ block: "nearest" }));
  }
  function $() {
    var _;
    return (_ = S.current) == null ? void 0 : _.querySelector(`${Pd}[aria-selected="true"]`);
  }
  function W() {
    var _;
    return Array.from((_ = S.current) == null ? void 0 : _.querySelectorAll(Pm));
  }
  function V(_) {
    let U = W()[_];
    U && P.setState("value", U.getAttribute(Hn));
  }
  function k(_) {
    var U;
    let te = $(), X = W(), Q = X.findIndex((oe) => oe === te), H = X[Q + _];
    (U = a.current) != null && U.loop && (H = Q + _ < 0 ? X[X.length - 1] : Q + _ === X.length ? X[0] : X[Q + _]), H && P.setState("value", H.getAttribute(Hn));
  }
  function N(_) {
    let U = $(), te = U == null ? void 0 : U.closest(bo), X;
    for (; te && !X; ) te = _ > 0 ? y2(te, bo) : b2(te, bo), X = te == null ? void 0 : te.querySelector(Pm);
    X ? P.setState("value", X.getAttribute(Hn)) : k(_);
  }
  let M = () => V(W().length - 1), B = (_) => {
    _.preventDefault(), _.metaKey ? M() : _.altKey ? N(1) : k(1);
  }, G = (_) => {
    _.preventDefault(), _.metaKey ? V(0) : _.altKey ? N(-1) : k(-1);
  };
  return m.createElement(zt.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (_) => {
    var U;
    if ((U = b.onKeyDown) == null || U.call(b, _), !_.defaultPrevented) switch (_.key) {
      case "n":
      case "j": {
        v && _.ctrlKey && B(_);
        break;
      }
      case "ArrowDown": {
        B(_);
        break;
      }
      case "p":
      case "k": {
        v && _.ctrlKey && G(_);
        break;
      }
      case "ArrowUp": {
        G(_);
        break;
      }
      case "Home": {
        _.preventDefault(), V(0);
        break;
      }
      case "End": {
        _.preventDefault(), M();
        break;
      }
      case "Enter":
        if (!_.nativeEvent.isComposing && _.keyCode !== 229) {
          _.preventDefault();
          let te = $();
          if (te) {
            let X = new Event(yc);
            te.dispatchEvent(X);
          }
        }
    }
  } }, m.createElement("label", { "cmdk-label": "", htmlFor: E.inputId, id: E.labelId, style: C2 }, l), ia(e, (_) => m.createElement(p0.Provider, { value: P }, m.createElement(m0.Provider, { value: E }, _))));
}), u2 = m.forwardRef((e, t) => {
  var n, r;
  let o = m.useId(), i = m.useRef(null), s = m.useContext(g0), a = bi(), l = y0(e), u = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : s == null ? void 0 : s.forceMount;
  ar(() => {
    if (!u) return a.item(o, s == null ? void 0 : s.id);
  }, [u]);
  let c = b0(o, i, [e.value, e.children, i], e.keywords), d = Ed(), h = lr((T) => T.value && T.value === c.current), p = lr((T) => u || a.filter() === !1 ? !0 : T.search ? T.filtered.items.get(o) > 0 : !0);
  m.useEffect(() => {
    let T = i.current;
    if (!(!T || e.disabled)) return T.addEventListener(yc, y), () => T.removeEventListener(yc, y);
  }, [p, e.onSelect, e.disabled]);
  function y() {
    var T, P;
    g(), (P = (T = l.current).onSelect) == null || P.call(T, c.current);
  }
  function g() {
    d.setState("value", c.current, !0);
  }
  if (!p) return null;
  let { disabled: v, value: b, onSelect: x, forceMount: w, keywords: C, ...S } = e;
  return m.createElement(zt.div, { ref: qo([i, t]), ...S, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!v, "aria-selected": !!h, "data-disabled": !!v, "data-selected": !!h, onPointerMove: v || a.disablePointerSelection ? void 0 : g, onClick: v ? void 0 : y }, e.children);
}), d2 = m.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, s = m.useId(), a = m.useRef(null), l = m.useRef(null), u = m.useId(), c = bi(), d = lr((p) => o || c.filter() === !1 ? !0 : p.search ? p.filtered.groups.has(s) : !0);
  ar(() => c.group(s), []), b0(s, a, [e.value, e.heading, l]);
  let h = m.useMemo(() => ({ id: s, forceMount: o }), [o]);
  return m.createElement(zt.div, { ref: qo([a, t]), ...i, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && m.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: u }, n), ia(e, (p) => m.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? u : void 0 }, m.createElement(g0.Provider, { value: h }, p))));
}), f2 = m.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = m.useRef(null), i = lr((s) => !s.search);
  return !n && !i ? null : m.createElement(zt.div, { ref: qo([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), h2 = m.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = Ed(), s = lr((c) => c.search), a = lr((c) => c.value), l = bi(), u = m.useMemo(() => {
    var c;
    let d = (c = l.listInnerRef.current) == null ? void 0 : c.querySelector(`${Pd}[${Hn}="${encodeURIComponent(a)}"]`);
    return d == null ? void 0 : d.getAttribute("id");
  }, []);
  return m.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), m.createElement(zt.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": u, id: l.inputId, type: "text", value: o ? e.value : s, onChange: (c) => {
    o || i.setState("search", c.target.value), n == null || n(c.target.value);
  } });
}), m2 = m.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = m.useRef(null), s = m.useRef(null), a = bi();
  return m.useEffect(() => {
    if (s.current && i.current) {
      let l = s.current, u = i.current, c, d = new ResizeObserver(() => {
        c = requestAnimationFrame(() => {
          let h = l.offsetHeight;
          u.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(c), d.unobserve(l);
      };
    }
  }, []), m.createElement(zt.div, { ref: qo([i, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: a.listId }, ia(e, (l) => m.createElement("div", { ref: qo([s, a.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), p2 = m.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: s, ...a } = e;
  return m.createElement(o2, { open: n, onOpenChange: r }, m.createElement(i2, { container: s }, m.createElement(s2, { "cmdk-overlay": "", className: o }), m.createElement(a2, { "aria-label": e.label, "cmdk-dialog": "", className: i }, m.createElement(v0, { ref: t, ...a }))));
}), g2 = m.forwardRef((e, t) => lr((n) => n.filtered.count === 0) ? m.createElement(zt.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), v2 = m.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return m.createElement(zt.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, ia(e, (s) => m.createElement("div", { "aria-hidden": !0 }, s)));
}), yt = Object.assign(v0, { List: m2, Item: u2, Input: h2, Group: d2, Separator: f2, Dialog: p2, Empty: g2, Loading: v2 });
function y2(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function b2(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function y0(e) {
  let t = m.useRef(e);
  return ar(() => {
    t.current = e;
  }), t;
}
var ar = typeof window > "u" ? m.useEffect : m.useLayoutEffect;
function Dr(e) {
  let t = m.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function qo(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function lr(e) {
  let t = Ed(), n = () => e(t.snapshot());
  return m.useSyncExternalStore(t.subscribe, n, n);
}
function b0(e, t, n, r = []) {
  let o = m.useRef(), i = bi();
  return ar(() => {
    var s;
    let a = (() => {
      var u;
      for (let c of n) {
        if (typeof c == "string") return c.trim();
        if (typeof c == "object" && "current" in c) return c.current ? (u = c.current.textContent) == null ? void 0 : u.trim() : o.current;
      }
    })(), l = r.map((u) => u.trim());
    i.value(e, a, l), (s = t.current) == null || s.setAttribute(Hn, a), o.current = a;
  }), o;
}
var w2 = () => {
  let [e, t] = m.useState(), n = Dr(() => /* @__PURE__ */ new Map());
  return ar(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function x2(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function ia({ asChild: e, children: t }, n) {
  return e && m.isValidElement(t) ? m.cloneElement(x2(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var C2 = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Dd = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  yt,
  {
    ref: n,
    className: q(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
Dd.displayName = yt.displayName;
const mB = ({ children: e, ...t }) => /* @__PURE__ */ f(Tp, { ...t, children: /* @__PURE__ */ f(Vc, { className: "overflow-hidden p-0 shadow-lg", children: /* @__PURE__ */ f(Dd, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), S2 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ L("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ f(Ax, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ f(
    yt.Input,
    {
      ref: n,
      className: q(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
S2.displayName = yt.Input.displayName;
const w0 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  yt.List,
  {
    ref: n,
    className: q("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
w0.displayName = yt.List.displayName;
const x0 = m.forwardRef((e, t) => /* @__PURE__ */ f(yt.Empty, { ref: t, className: "py-6 text-center text-sm", ...e }));
x0.displayName = yt.Empty.displayName;
const T2 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  yt.Group,
  {
    ref: n,
    className: q(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
T2.displayName = yt.Group.displayName;
const P2 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(yt.Separator, { ref: n, className: q("-mx-1 h-px bg-border", e), ...t }));
P2.displayName = yt.Separator.displayName;
const C0 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  yt.Item,
  {
    ref: n,
    className: q(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50",
      e
    ),
    ...t
  }
));
C0.displayName = yt.Item.displayName;
const E2 = ({ className: e, ...t }) => /* @__PURE__ */ f("span", { className: q("ml-auto text-xs tracking-widest text-muted-foreground", e), ...t });
E2.displayName = "CommandShortcut";
const S0 = je(null), sa = () => {
  const e = Te(S0);
  if (!e)
    throw new Error("useMultiSelect must be used within MultiSelectProvider");
  return e;
}, D2 = ({
  values: e,
  options: t,
  onValuesChange: n,
  loop: r = !1,
  className: o,
  children: i,
  dir: s,
  disabled: a,
  ...l
}) => {
  const [u, c] = de(""), [d, h] = de(!1), [p, y] = de(-1), g = Y.useRef(null), [v, b] = Y.useState(!1), [x, w] = Y.useState(""), C = Ie(
    (P) => {
      e.some((E) => E === P) ? n(e.filter((E) => E !== P)) : n([...e, P]);
    },
    [e]
  ), S = Y.useCallback(
    (P) => {
      P.preventDefault();
      const E = P.currentTarget, D = E.value.substring(E.selectionStart ?? 0, E.selectionEnd ?? 0);
      w(D), b(D === u);
    },
    [u]
  ), T = Ie(
    (P) => {
      P.stopPropagation();
      const E = g.current;
      if (!E) return;
      const D = () => {
        const O = p + 1;
        y(O > e.length - 1 ? r ? 0 : -1 : O);
      }, A = () => {
        const O = p - 1;
        y(O < 0 ? e.length - 1 : O);
      }, R = () => {
        const O = p - 1 <= 0 ? e.length - 1 === 0 ? -1 : 0 : p - 1;
        y(O);
      };
      switch (P.key) {
        case "ArrowLeft":
          s === "rtl" ? e.length > 0 && (p !== -1 || r) && D() : e.length > 0 && E.selectionStart === 0 && A();
          break;
        case "ArrowRight":
          s === "rtl" ? e.length > 0 && E.selectionStart === 0 && A() : e.length > 0 && (p !== -1 || r) && D();
          break;
        case "Backspace":
        case "Delete":
          e.length > 0 && (p !== -1 && p < e.length ? (C(e[p]), R()) : E.selectionStart === 0 && (x === u || v) && C(e[e.length - 1]));
          break;
        case "Enter":
          h(!0);
          break;
        case "Escape":
          p !== -1 ? y(-1) : d && h(!1);
          break;
      }
    },
    [e, u, p, r]
  );
  return /* @__PURE__ */ f(
    S0.Provider,
    {
      value: {
        value: e,
        options: t,
        onValueChange: C,
        open: d,
        setOpen: h,
        inputValue: u,
        setInputValue: c,
        activeIndex: p,
        setActiveIndex: y,
        ref: g,
        handleSelect: S,
        disabled: a
      },
      children: /* @__PURE__ */ f(Dd, { onKeyDown: T, className: q("flex flex-row bg-transparent", o), dir: s, ...l, children: i })
    }
  );
}, T0 = Ke(
  ({ className: e, children: t, ...n }, r) => {
    const { value: o, options: i, onValueChange: s, activeIndex: a, disabled: l } = sa(), [u, c] = de(!1), [d, h] = de(!1), p = me(null), y = Ie((b) => {
      b.preventDefault(), b.stopPropagation();
    }, []), g = (b) => {
      const x = b.currentTarget, w = x.scrollLeft, C = x.scrollWidth, S = x.clientWidth;
      w > 10 ? c(!0) : c(!1), w + S < C - 20 ? h(!0) : h(!1);
    }, v = () => {
      var b;
      (b = p.current) == null || b.scrollIntoView({ behavior: "smooth" });
    };
    return fe(() => {
      v();
    }, [o]), /* @__PURE__ */ L(
      "div",
      {
        ref: r,
        onScroll: g,
        className: q(
          "flex overflow-x-auto overflow-y-hidden rounded-lg max-w-[80%] relative pretty-scrollbar-thin",
          e,
          "before:opacity-0 before:block before:shrink-0 before:sticky before:w-4 before:-ml-4 before:h-full before:bg-gradient-to-r before:from-white before:-left-px before:transition-opacity before:duration-150",
          "after:opacity-0 after:block after:shrink-0 after:sticky after:w-4 after:-mr-4 after:h-full after:bg-gradient-to-l after:from-white after:-right-px after:transition-opacity after:duration-150",
          u && "before:opacity-100",
          d && "after:opacity-100"
        ),
        ...n,
        children: [
          o.map((b, x) => {
            const w = i.find((C) => C.value === b);
            return /* @__PURE__ */ L(
              Zw,
              {
                className: q(
                  "m-1 my-2 py-0 rounded-xl flex items-center gap-1",
                  a === x && "ring-2 ring-muted-foreground "
                ),
                variant: l ? "disabled" : "default",
                children: [
                  /* @__PURE__ */ f("span", { className: "text-xxs text-nowrap", children: w == null ? void 0 : w.label }),
                  /* @__PURE__ */ L(
                    "button",
                    {
                      "aria-label": `Remove ${w == null ? void 0 : w.label} option`,
                      "aria-roledescription": "button to remove option",
                      type: "button",
                      onMouseDown: y,
                      onClick: () => w && s(w.value),
                      disabled: l,
                      className: q(l && "cursor-not-allowed"),
                      children: [
                        /* @__PURE__ */ L("span", { className: "sr-only", children: [
                          "Remove ",
                          w == null ? void 0 : w.label,
                          " option"
                        ] }),
                        /* @__PURE__ */ f(Sc, { className: "h-4 w-4" })
                      ]
                    }
                  )
                ]
              },
              w == null ? void 0 : w.value
            );
          }),
          /* @__PURE__ */ f("div", { ref: p }),
          t
        ]
      }
    );
  }
);
T0.displayName = "MultiSelectorTrigger";
const P0 = Ke(({ className: e, ...t }, n) => {
  const {
    value: r,
    setOpen: o,
    inputValue: i,
    setInputValue: s,
    activeIndex: a,
    setActiveIndex: l,
    handleSelect: u,
    ref: c,
    disabled: d
  } = sa(), h = () => r.length === 0 ? t.placeholder : `${r.length.toString()} selected`;
  return /* @__PURE__ */ f(
    yt.Input,
    {
      ...t,
      placeholder: h(),
      tabIndex: 0,
      ref: c,
      value: i,
      onValueChange: a === -1 ? s : void 0,
      onSelect: u,
      onBlur: () => o(!1),
      onFocus: () => o(!0),
      onClick: () => l(-1),
      className: q(
        "w-24 shrink-0 text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50 outline-none aria-disabled:text-neutral-text-secondary/50",
        e,
        a !== -1 && "caret-transparent"
      ),
      "aria-disabled": d,
      disabled: d
    }
  );
});
P0.displayName = "MultiSelectorInput";
const E0 = Ke(({ children: e }, t) => {
  const { open: n } = sa();
  return /* @__PURE__ */ f("div", { ref: t, className: " absolute left-0 right-0 top-[calc(100%+.25rem)] z-40", children: n && e });
});
E0.displayName = "MultiSelectorContent";
const D0 = Ke(({ className: e, children: t }, n) => /* @__PURE__ */ L(
  w0,
  {
    ref: n,
    className: q(
      "bg-input-bg flex flex-col rounded-md scrollbar-thin scrollbar-track-transparent transition-colors scrollbar-thumb-muted-foreground dark:scrollbar-thumb-muted scrollbar-thumb-rounded-lg w-full absolute shadow-md z-10 border top-0",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ f(x0, { children: /* @__PURE__ */ f("span", { className: "text-muted-foreground", children: "No results found" }) })
    ]
  }
));
D0.displayName = "MultiSelectorList";
const k0 = Ke(({ className: e, value: t, children: n, ...r }, o) => {
  const { value: i, onValueChange: s, setInputValue: a } = sa(), l = Ie((c) => {
    c.preventDefault(), c.stopPropagation();
  }, []), u = i.includes(t);
  return /* @__PURE__ */ L(
    C0,
    {
      ref: o,
      ...r,
      onSelect: () => {
        s(t), a("");
      },
      className: q(
        "flex control cursor-default border select-none items-center text-sm outline-none rounded-none justify-between data-[selected=true]:bg-input-hover",
        e,
        u && "bg-input-active text-input-bg data-[selected=true]::bg-input-hover",
        r.disabled && "pointer-events-none opacity-50"
      ),
      onMouseDown: l,
      children: [
        n,
        u && /* @__PURE__ */ f(Tc, { className: "h-4 w-4" })
      ]
    }
  );
});
k0.displayName = "MultiSelectorItem";
const k2 = ur("", {
  variants: {
    size: {
      sm: "input-sm",
      default: "input",
      md: "input-md"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function N2({
  value: e,
  options: t,
  onChange: n,
  size: r,
  placeholder: o,
  disabled: i,
  className: s
}) {
  return /* @__PURE__ */ L(
    D2,
    {
      values: e,
      options: t,
      onValuesChange: n,
      loop: !0,
      disablePointerSelection: !0,
      disabled: i,
      className: q(s),
      children: [
        /* @__PURE__ */ f(T0, {}),
        /* @__PURE__ */ f(P0, { className: q("bg-transparent", k2({ size: r })), placeholder: o }),
        /* @__PURE__ */ f(E0, { children: /* @__PURE__ */ f(D0, { children: t.map((a) => /* @__PURE__ */ f(k0, { value: a.value, children: a.label }, a.value)) }) })
      ]
    }
  );
}
const pB = (e) => /* @__PURE__ */ f(Ft, { label: e.label, error: e.error, disabled: e.disabled, hideOverflow: !1, children: /* @__PURE__ */ f(N2, { placeholder: e.placeholder, ...e, className: q(e.className) }) }), R2 = ({ label: e, className: t, text: n }) => /* @__PURE__ */ f(
  Ft,
  {
    label: e,
    className: We("select-none cursor-pointer !flex w-full max-h-10 first:*:w-full first:*:flex"),
    children: /* @__PURE__ */ f("div", { className: We("p-2 whitespace-nowrap text-ellipsis overflow-hidden w-0 grow"), children: n })
  }
), gB = ({
  maxToShowInLabel: e,
  onSelect: t,
  options: n,
  allSelectedLabel: r,
  lookup: o,
  noneSelectedLabel: i,
  value: s,
  className: a,
  label: l,
  onClose: u
}) => {
  const c = (y) => {
    t(y);
  }, d = (s == null ? void 0 : s.length) || 0;
  let h;
  switch (!0) {
    case d === 0:
      h = i || "Please select";
      break;
    case d <= e:
      h = s.map((y) => (o == null ? void 0 : o[y]) || y).join(", ");
      break;
    case d === n.length:
      h = r || "All Selected";
      break;
    default:
      h = `${d} selected`;
      break;
  }
  const p = async (y) => n.filter((g) => g.label.toLocaleLowerCase().includes(y.toLocaleLowerCase())).map((g) => g.key);
  return /* @__PURE__ */ f("div", { className: a, children: /* @__PURE__ */ f(
    xv,
    {
      onClose: u,
      activeFilters: (s == null ? void 0 : s.map((y) => ({ key: y, label: (o == null ? void 0 : o[y]) || y }))) || [],
      onApply: (y) => c(y.map((g) => g.key)),
      onLoadFilters: p,
      lookup: (y) => (o == null ? void 0 : o[y]) || y,
      trigger: /* @__PURE__ */ f(R2, { text: h, label: l })
    }
  ) });
};
function kd(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ L("div", { className: "form-control w-full", children: [
    /* @__PURE__ */ f("div", { className: "label mb-[8px]", children: /* @__PURE__ */ f("span", { className: "label-text", children: e.label }) }),
    e.children,
    /* @__PURE__ */ f("div", { className: "label mt-[5px]", children: /* @__PURE__ */ f("span", { className: "label-text-alt text-error h-2", children: t.fieldErrors[e.name] }) })
  ] });
}
function vB(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ f(kd, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ f(
    si,
    {
      type: "text",
      name: e.name,
      defaultValue: e.initialValue,
      placeholder: e.placeholder,
      className: We("input", "input-bordered", "w-full", {
        "border-error": t.fieldErrors[e.name]
      })
    }
  ) });
}
function yB(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ f(kd, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ f(
    si,
    {
      type: "date",
      name: e.name,
      defaultValue: e.initialValue,
      className: We("input", "input-bordered", "w-full", {
        "border-error": t.fieldErrors[e.name]
      })
    }
  ) });
}
function bB(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ f(kd, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ L(Ls, { name: e.name, defaultValue: e.initialValue ?? "", children: [
    /* @__PURE__ */ f(eu, { className: "w-[180px]", children: /* @__PURE__ */ f(tu, { placeholder: "-- Select an option --" }) }),
    /* @__PURE__ */ f(nu, { children: e.options.map((n, r) => /* @__PURE__ */ f(ou, { value: n[0], children: n[1] }, r)) })
  ] }) });
}
const N0 = ({
  fullContractData: e,
  scenarioContractData: t
}) => {
  let n = "indeterminate";
  return e.forEach(({ id: r, children: o }) => {
    const i = t.find(({ id: s }) => s === r);
    o && (i != null && i.children) ? n = N0({ fullContractData: o, scenarioContractData: i.children }) : n = e.length === t.length || "indeterminate";
  }), n;
}, M2 = (e, t) => {
  const n = [];
  return e.forEach(({ id: r, label: o, children: i }) => {
    const s = { id: r, label: o, childrenNodes: [], checked: !1 }, a = t.find((l) => l.id === r);
    a && (s.checked = a.children && i ? N0({ fullContractData: i, scenarioContractData: a.children }) : !0), i && (s.childrenNodes = M2(i, a != null && a.children ? a.children : [])), n.push(s);
  }), n;
}, R0 = (e) => {
  var n;
  if (!((n = e.childrenNodes) != null && n.length))
    return e.checked ? { id: e.id } : void 0;
  const t = e.childrenNodes.map(R0).filter(Boolean);
  return t.length ? { id: e.id, children: t } : void 0;
}, wB = (e) => e.map(R0).filter(Boolean), M0 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], A0 = (e, t) => `${e}-${t < 10 ? `0${t}` : t}`, A2 = (e) => {
  try {
    const [t, n] = e.split("-");
    return `${M0[Number(n) - 1]} ${t == null ? void 0 : t.substring(2, 4)}`;
  } catch {
    return "-";
  }
};
function Em({
  mode: e,
  monthOrYear: t,
  index: n,
  selectedYearValue: r,
  onChange: o,
  currentYear: i,
  currentMonth: s,
  isDisabled: a
}) {
  const l = n + 1;
  return /* @__PURE__ */ f(
    Pe,
    {
      variant: (e === "year" || s === l) && i === r ? "default" : "minimal",
      size: "sm",
      value: e === "year" ? t : l,
      onClick: () => o(e === "year" ? t : A0(r, l)),
      disabled: a,
      children: t
    },
    e === "year" ? t : l
  );
}
const Dm = ({ mode: e, value: t, index: n, selectedYearOrDecadeValue: r, minDate: o, maxDate: i }) => {
  if (e === "month") {
    const s = A0(r, n + 1);
    return !!i && s > i || !!o && s < o;
  } else
    return !!(o && t < o || i && t > i);
};
function Nd({ mode: e, value: t = "", maxDate: n = "", minDate: r = "", onChange: o }) {
  const [i, s] = ve(() => {
    const p = t && e === "month" ? Number(t.split("-")[1]) : void 0;
    return t ? e === "year" ? [parseInt(t), p] : [Number(t.split("-")[0]), p] : [(/* @__PURE__ */ new Date()).getFullYear(), p];
  }, [t, e]), a = ve(() => parseInt(i.toString().slice(0, -1)), [i]), [l, u] = ve(() => {
    if (e === "year") {
      const g = "2024", v = (i + 10).toString();
      return [r || g, n || v];
    }
    const p = "2024-01", y = `${i + 10}-12`;
    return [r || p, n || y];
  }, [e, i, r, n]), [c, d] = de(
    e === "year" ? a : i
  ), h = ve(
    () => [...Array(10).keys()].map((p) => `${c}${p}`),
    [c]
  );
  return /* @__PURE__ */ L("div", { className: "flex flex-col gap-2 p-4 w-80", children: [
    /* @__PURE__ */ L("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ f(
        Pe,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => d((p) => p - 1),
          disabled: !!l && `${c}` <= l,
          children: /* @__PURE__ */ f(Ao, { size: "18" })
        }
      ),
      /* @__PURE__ */ L("span", { className: "text-xs font-medium text-button-primary-outline-default", children: [
        c,
        e === "year" && "0s"
      ] }),
      /* @__PURE__ */ f(
        Pe,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => d((p) => p + 1),
          disabled: !!u && `${c + 1}` > u,
          children: /* @__PURE__ */ f(Br, { size: "18" })
        }
      )
    ] }),
    /* @__PURE__ */ f("div", { className: `grid ${e === "year" ? "grid-cols-2" : "grid-cols-3"} gap-x-2`, children: e === "year" ? h.map((p, y) => /* @__PURE__ */ f(
      Em,
      {
        mode: e,
        monthOrYear: p,
        index: y,
        selectedYearValue: i,
        onChange: o,
        currentYear: parseInt(p),
        currentMonth: s,
        isDisabled: Dm({ mode: e, value: p, index: y, selectedYearOrDecadeValue: c, minDate: l, maxDate: u })
      },
      y
    )) : M0.map((p, y) => /* @__PURE__ */ f(
      Em,
      {
        mode: e,
        monthOrYear: p,
        index: y,
        selectedYearValue: c,
        onChange: o,
        currentYear: i,
        currentMonth: s,
        isDisabled: Dm({ mode: e, value: p, index: y, selectedYearOrDecadeValue: c, minDate: l, maxDate: u })
      },
      y
    )) })
  ] });
}
function km(e) {
  return /* @__PURE__ */ L(
    Pe,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.value || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: e.value ? A2(e.value) : e.placeholder || "Pick a date"
          }
        ),
        /* @__PURE__ */ f(Pc, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function O2(e) {
  const [t, n] = m.useState(!1), r = (o) => {
    e.onChange(o), n(!1);
  };
  return e.disabled ? /* @__PURE__ */ f(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ f(km, { ...e })
    }
  ) : /* @__PURE__ */ L(or, { open: t, onOpenChange: (o) => n(o), children: [
    /* @__PURE__ */ f(ro, { asChild: !0, children: /* @__PURE__ */ f("div", { className: e.className, children: /* @__PURE__ */ f(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ f(no, { children: /* @__PURE__ */ f(km, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ f(hr, { renderOnBody: !1, className: "w-auto p-0", children: /* @__PURE__ */ f(
      Nd,
      {
        mode: "month",
        onChange: r,
        value: e.value,
        maxDate: e.maxDate,
        minDate: e.minDate
      }
    ) })
  ] });
}
function xB({
  loading: e,
  onChange: t,
  value: n,
  minDate: r,
  maxDate: o
}) {
  const i = (s) => {
    if (n) {
      const a = un(Vt(Z_(n, "yyyy-MM", /* @__PURE__ */ new Date()), s), "yyyy-MM");
      t(a);
    }
  };
  return /* @__PURE__ */ L("div", { className: "flex gap-2 relative items-center", children: [
    /* @__PURE__ */ f(Pe, { variant: "minimal", size: "sm", onClick: () => i(-1), disabled: !!r && n <= r, children: /* @__PURE__ */ f(Ao, { size: "18" }) }),
    /* @__PURE__ */ f(
      O2,
      {
        label: "Date",
        value: n,
        onChange: t,
        disabled: e,
        minDate: r,
        maxDate: o
      }
    ),
    /* @__PURE__ */ f(Pe, { variant: "minimal", size: "sm", onClick: () => i(1), disabled: !!o && n >= o, children: /* @__PURE__ */ f(Br, { size: "18" }) }),
    e && /* @__PURE__ */ f(Zn, { cover: !0 })
  ] });
}
function Nm(e) {
  return /* @__PURE__ */ L(
    Pe,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.value || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: e.value ? e.value : e.placeholder || "Pick a date"
          }
        ),
        /* @__PURE__ */ f(Pc, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function I2(e) {
  const [t, n] = m.useState(!1), r = (o) => {
    e.onChange(o), n(!1);
  };
  return e.disabled ? /* @__PURE__ */ f(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ f(Nm, { ...e })
    }
  ) : /* @__PURE__ */ L(or, { open: t, onOpenChange: (o) => n(o), children: [
    /* @__PURE__ */ f(ro, { asChild: !0, children: /* @__PURE__ */ f("div", { className: e.className, children: /* @__PURE__ */ f(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ f(no, { children: /* @__PURE__ */ f(Nm, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ f(hr, { renderOnBody: !1, className: "w-auto p-0", children: /* @__PURE__ */ f(
      Nd,
      {
        mode: "year",
        onChange: r,
        value: e.value,
        maxDate: e.maxDate,
        minDate: e.minDate
      }
    ) })
  ] });
}
function CB({
  loading: e,
  onChange: t,
  value: n,
  minDate: r,
  maxDate: o
}) {
  return /* @__PURE__ */ L("div", { className: "flex gap-2 relative items-center", children: [
    /* @__PURE__ */ f(
      Pe,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n && t(`${parseInt(n) - 1}`),
        disabled: !!r && n <= r,
        children: /* @__PURE__ */ f(Ao, { size: "18" })
      }
    ),
    /* @__PURE__ */ f(
      I2,
      {
        label: "Date",
        value: n,
        onChange: t,
        disabled: e,
        minDate: r,
        maxDate: o
      }
    ),
    /* @__PURE__ */ f(
      Pe,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n && t(`${parseInt(n) + 1}`),
        disabled: !!o && n >= o,
        children: /* @__PURE__ */ f(Br, { size: "18" })
      }
    ),
    e && /* @__PURE__ */ f(Zn, { cover: !0 })
  ] });
}
const Rm = ({ disabled: e, value: t, placeholder: n, isOpen: r }) => /* @__PURE__ */ f(
  Pe,
  {
    disabled: !!e,
    size: "sm",
    variant: r ? "default" : "outline",
    className: "group justify-center text-left w-full min-w-20",
    children: t || n || "Pick a year"
  }
);
function SB(e) {
  const { disabled: t, onChange: n, maxDate: r, minDate: o, value: i } = e, [s, a] = m.useState(!1), u = i || (/* @__PURE__ */ new Date()).getFullYear().toString();
  return t ? /* @__PURE__ */ L("div", { className: "flex items-center justify-center gap-1", children: [
    /* @__PURE__ */ f(
      Pe,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n(`${parseInt(u) - 1}`),
        disabled: !!o && `${i}` <= o,
        children: /* @__PURE__ */ f(Ao, { size: "18" })
      }
    ),
    /* @__PURE__ */ f(Rm, { ...e, isOpen: s }),
    /* @__PURE__ */ f(
      Pe,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n(`${parseInt(u) + 1}`),
        disabled: !!r && `${parseInt(u) + 1}` > r,
        children: /* @__PURE__ */ f(Br, { size: "18" })
      }
    )
  ] }) : /* @__PURE__ */ L(or, { open: s, onOpenChange: a, children: [
    /* @__PURE__ */ L("div", { className: "flex items-center justify-center gap-2 relative", children: [
      /* @__PURE__ */ f(
        Pe,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => n(`${parseInt(u) - 1}`),
          disabled: !!o && `${i}` <= o,
          children: /* @__PURE__ */ f(Ao, { size: "18" })
        }
      ),
      /* @__PURE__ */ f(ro, { asChild: !0, children: /* @__PURE__ */ f(no, { children: /* @__PURE__ */ f(Rm, { ...e, isOpen: s }) }) }),
      /* @__PURE__ */ f(
        Pe,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => n(`${parseInt(u) + 1}`),
          disabled: !!r && `${parseInt(u) + 1}` > r,
          children: /* @__PURE__ */ f(Br, { size: "18" })
        }
      ),
      e.loading && /* @__PURE__ */ f(Zn, { cover: !0, iconSize: 30 })
    ] }),
    /* @__PURE__ */ f(hr, { className: "w-auto p-0", children: /* @__PURE__ */ f(Nd, { mode: "year", ...e }) })
  ] });
}
const _2 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  du,
  {
    ref: n,
    className: q(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(bv, { className: q("flex items-center justify-center text-current"), children: /* @__PURE__ */ f(Tc, { className: "h-4 w-4" }) })
  }
));
_2.displayName = du.displayName;
var Rd = "ToastProvider", [Md, $2, L2] = Os("Toast"), [O0, TB] = Bt("Toast", [L2]), [F2, aa] = O0(Rd), I0 = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: s
  } = e, [a, l] = m.useState(null), [u, c] = m.useState(0), d = m.useRef(!1), h = m.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Rd}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ f(Md.Provider, { scope: t, children: /* @__PURE__ */ f(
    F2,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: u,
      viewport: a,
      onViewportChange: l,
      onToastAdd: m.useCallback(() => c((p) => p + 1), []),
      onToastRemove: m.useCallback(() => c((p) => p - 1), []),
      isFocusedToastEscapeKeyDownRef: d,
      isClosePausedRef: h,
      children: s
    }
  ) });
};
I0.displayName = Rd;
var _0 = "ToastViewport", V2 = ["F8"], bc = "toast.viewportPause", wc = "toast.viewportResume", $0 = m.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = V2,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, s = aa(_0, n), a = $2(n), l = m.useRef(null), u = m.useRef(null), c = m.useRef(null), d = m.useRef(null), h = ye(t, d, s.onViewportChange), p = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), y = s.toastCount > 0;
    m.useEffect(() => {
      const v = (b) => {
        var w;
        r.length !== 0 && r.every((C) => b[C] || b.code === C) && ((w = d.current) == null || w.focus());
      };
      return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
    }, [r]), m.useEffect(() => {
      const v = l.current, b = d.current;
      if (y && v && b) {
        const x = () => {
          if (!s.isClosePausedRef.current) {
            const T = new CustomEvent(bc);
            b.dispatchEvent(T), s.isClosePausedRef.current = !0;
          }
        }, w = () => {
          if (s.isClosePausedRef.current) {
            const T = new CustomEvent(wc);
            b.dispatchEvent(T), s.isClosePausedRef.current = !1;
          }
        }, C = (T) => {
          !v.contains(T.relatedTarget) && w();
        }, S = () => {
          v.contains(document.activeElement) || w();
        };
        return v.addEventListener("focusin", x), v.addEventListener("focusout", C), v.addEventListener("pointermove", x), v.addEventListener("pointerleave", S), window.addEventListener("blur", x), window.addEventListener("focus", w), () => {
          v.removeEventListener("focusin", x), v.removeEventListener("focusout", C), v.removeEventListener("pointermove", x), v.removeEventListener("pointerleave", S), window.removeEventListener("blur", x), window.removeEventListener("focus", w);
        };
      }
    }, [y, s.isClosePausedRef]);
    const g = m.useCallback(
      ({ tabbingDirection: v }) => {
        const x = a().map((w) => {
          const C = w.ref.current, S = [C, ...Z2(C)];
          return v === "forwards" ? S : S.reverse();
        });
        return (v === "forwards" ? x.reverse() : x).flat();
      },
      [a]
    );
    return m.useEffect(() => {
      const v = d.current;
      if (v) {
        const b = (x) => {
          var S, T, P;
          const w = x.altKey || x.ctrlKey || x.metaKey;
          if (x.key === "Tab" && !w) {
            const E = document.activeElement, D = x.shiftKey;
            if (x.target === v && D) {
              (S = u.current) == null || S.focus();
              return;
            }
            const O = g({ tabbingDirection: D ? "backwards" : "forwards" }), F = O.findIndex(($) => $ === E);
            il(O.slice(F + 1)) ? x.preventDefault() : D ? (T = u.current) == null || T.focus() : (P = c.current) == null || P.focus();
          }
        };
        return v.addEventListener("keydown", b), () => v.removeEventListener("keydown", b);
      }
    }, [a, g]), /* @__PURE__ */ L(
      $C,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", p),
        tabIndex: -1,
        style: { pointerEvents: y ? void 0 : "none" },
        children: [
          y && /* @__PURE__ */ f(
            xc,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const v = g({
                  tabbingDirection: "forwards"
                });
                il(v);
              }
            }
          ),
          /* @__PURE__ */ f(Md.Slot, { scope: n, children: /* @__PURE__ */ f(se.ol, { tabIndex: -1, ...i, ref: h }) }),
          y && /* @__PURE__ */ f(
            xc,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const v = g({
                  tabbingDirection: "backwards"
                });
                il(v);
              }
            }
          )
        ]
      }
    );
  }
);
$0.displayName = _0;
var L0 = "ToastFocusProxy", xc = m.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = aa(L0, n);
    return /* @__PURE__ */ f(
      ks,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          var u;
          const a = s.relatedTarget;
          !((u = i.viewport) != null && u.contains(a)) && r();
        }
      }
    );
  }
);
xc.displayName = L0;
var wi = "Toast", B2 = "toast.swipeStart", W2 = "toast.swipeMove", z2 = "toast.swipeCancel", j2 = "toast.swipeEnd", F0 = m.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...s } = e, [a, l] = Rn({
      prop: r,
      defaultProp: o ?? !0,
      onChange: i,
      caller: wi
    });
    return /* @__PURE__ */ f(ct, { present: n || a, children: /* @__PURE__ */ f(
      Y2,
      {
        open: a,
        ...s,
        ref: t,
        onClose: () => l(!1),
        onPause: Je(e.onPause),
        onResume: Je(e.onResume),
        onSwipeStart: j(e.onSwipeStart, (u) => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: j(e.onSwipeMove, (u) => {
          const { x: c, y: d } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${c}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: j(e.onSwipeCancel, (u) => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: j(e.onSwipeEnd, (u) => {
          const { x: c, y: d } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${c}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
F0.displayName = wi;
var [H2, U2] = O0(wi, {
  onClose() {
  }
}), Y2 = m.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: s,
      onEscapeKeyDown: a,
      onPause: l,
      onResume: u,
      onSwipeStart: c,
      onSwipeMove: d,
      onSwipeCancel: h,
      onSwipeEnd: p,
      ...y
    } = e, g = aa(wi, n), [v, b] = m.useState(null), x = ye(t, ($) => b($)), w = m.useRef(null), C = m.useRef(null), S = o || g.duration, T = m.useRef(0), P = m.useRef(S), E = m.useRef(0), { onToastAdd: D, onToastRemove: A } = g, R = Je(() => {
      var W;
      (v == null ? void 0 : v.contains(document.activeElement)) && ((W = g.viewport) == null || W.focus()), s();
    }), O = m.useCallback(
      ($) => {
        !$ || $ === 1 / 0 || (window.clearTimeout(E.current), T.current = (/* @__PURE__ */ new Date()).getTime(), E.current = window.setTimeout(R, $));
      },
      [R]
    );
    m.useEffect(() => {
      const $ = g.viewport;
      if ($) {
        const W = () => {
          O(P.current), u == null || u();
        }, V = () => {
          const k = (/* @__PURE__ */ new Date()).getTime() - T.current;
          P.current = P.current - k, window.clearTimeout(E.current), l == null || l();
        };
        return $.addEventListener(bc, V), $.addEventListener(wc, W), () => {
          $.removeEventListener(bc, V), $.removeEventListener(wc, W);
        };
      }
    }, [g.viewport, S, l, u, O]), m.useEffect(() => {
      i && !g.isClosePausedRef.current && O(S);
    }, [i, S, g.isClosePausedRef, O]), m.useEffect(() => (D(), () => A()), [D, A]);
    const F = m.useMemo(() => v ? U0(v) : null, [v]);
    return g.viewport ? /* @__PURE__ */ L(ke, { children: [
      F && /* @__PURE__ */ f(
        G2,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: F
        }
      ),
      /* @__PURE__ */ f(H2, { scope: n, onClose: R, children: Qo.createPortal(
        /* @__PURE__ */ f(Md.ItemSlot, { scope: n, children: /* @__PURE__ */ f(
          _C,
          {
            asChild: !0,
            onEscapeKeyDown: j(a, () => {
              g.isFocusedToastEscapeKeyDownRef.current || R(), g.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ f(
              se.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": g.swipeDirection,
                ...y,
                ref: x,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: j(e.onKeyDown, ($) => {
                  $.key === "Escape" && (a == null || a($.nativeEvent), $.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, R()));
                }),
                onPointerDown: j(e.onPointerDown, ($) => {
                  $.button === 0 && (w.current = { x: $.clientX, y: $.clientY });
                }),
                onPointerMove: j(e.onPointerMove, ($) => {
                  if (!w.current) return;
                  const W = $.clientX - w.current.x, V = $.clientY - w.current.y, k = !!C.current, N = ["left", "right"].includes(g.swipeDirection), M = ["left", "up"].includes(g.swipeDirection) ? Math.min : Math.max, B = N ? M(0, W) : 0, G = N ? 0 : M(0, V), _ = $.pointerType === "touch" ? 10 : 2, U = { x: B, y: G }, te = { originalEvent: $, delta: U };
                  k ? (C.current = U, Bi(W2, d, te, {
                    discrete: !1
                  })) : Mm(U, g.swipeDirection, _) ? (C.current = U, Bi(B2, c, te, {
                    discrete: !1
                  }), $.target.setPointerCapture($.pointerId)) : (Math.abs(W) > _ || Math.abs(V) > _) && (w.current = null);
                }),
                onPointerUp: j(e.onPointerUp, ($) => {
                  const W = C.current, V = $.target;
                  if (V.hasPointerCapture($.pointerId) && V.releasePointerCapture($.pointerId), C.current = null, w.current = null, W) {
                    const k = $.currentTarget, N = { originalEvent: $, delta: W };
                    Mm(W, g.swipeDirection, g.swipeThreshold) ? Bi(j2, p, N, {
                      discrete: !0
                    }) : Bi(
                      z2,
                      h,
                      N,
                      {
                        discrete: !0
                      }
                    ), k.addEventListener("click", (M) => M.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        g.viewport
      ) })
    ] }) : null;
  }
), G2 = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = aa(wi, t), [i, s] = m.useState(!1), [a, l] = m.useState(!1);
  return q2(() => s(!0)), m.useEffect(() => {
    const u = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(u);
  }, []), a ? null : /* @__PURE__ */ f(Zr, { asChild: !0, children: /* @__PURE__ */ f(ks, { ...r, children: i && /* @__PURE__ */ L(ke, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, K2 = "ToastTitle", V0 = m.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ f(se.div, { ...r, ref: t });
  }
);
V0.displayName = K2;
var X2 = "ToastDescription", B0 = m.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ f(se.div, { ...r, ref: t });
  }
);
B0.displayName = X2;
var W0 = "ToastAction", z0 = m.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ f(H0, { altText: n, asChild: !0, children: /* @__PURE__ */ f(Ad, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${W0}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
z0.displayName = W0;
var j0 = "ToastClose", Ad = m.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = U2(j0, n);
    return /* @__PURE__ */ f(H0, { asChild: !0, children: /* @__PURE__ */ f(
      se.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: j(e.onClick, o.onClose)
      }
    ) });
  }
);
Ad.displayName = j0;
var H0 = m.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ f(
    se.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function U0(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), Q2(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...U0(r));
    }
  }), t;
}
function Bi(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? kc(o, i) : o.dispatchEvent(i);
}
var Mm = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function q2(e = () => {
}) {
  const t = Je(e);
  it(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function Q2(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Z2(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function il(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var J2 = I0, Y0 = $0, G0 = F0, K0 = V0, X0 = B0, q0 = z0, Q0 = Ad;
const eV = J2, Z0 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Y0,
  {
    ref: n,
    className: q(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
Z0.displayName = Y0.displayName;
const tV = ur(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), J0 = m.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f(G0, { ref: r, className: q(tV({ variant: t }), e), ...n }));
J0.displayName = G0.displayName;
const nV = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  q0,
  {
    ref: n,
    className: q(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
nV.displayName = q0.displayName;
const ex = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Q0,
  {
    ref: n,
    className: q(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ f(Sc, { className: "h-4 w-4" })
  }
));
ex.displayName = Q0.displayName;
const tx = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(K0, { ref: n, className: q("text-sm font-semibold", e), ...t }));
tx.displayName = K0.displayName;
const nx = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(X0, { ref: n, className: q("text-sm opacity-90", e), ...t }));
nx.displayName = X0.displayName;
const rV = 1, oV = 3e3;
let sl = 0;
function iV() {
  return sl = (sl + 1) % Number.MAX_SAFE_INTEGER, sl.toString();
}
const al = /* @__PURE__ */ new Map(), Am = (e) => {
  if (al.has(e))
    return;
  const t = setTimeout(() => {
    al.delete(e), Mo({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, oV);
  al.set(e, t);
}, sV = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, rV)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? Am(n) : e.toasts.forEach((r) => {
        Am(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, Gi = [];
let Ki = { toasts: [] };
function Mo(e) {
  Ki = sV(Ki, e), Gi.forEach((t) => {
    t(Ki);
  });
}
function aV({ ...e }) {
  const t = iV(), n = (o) => Mo({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => Mo({ type: "DISMISS_TOAST", toastId: t });
  return Mo({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function lV() {
  const [e, t] = m.useState(Ki);
  return m.useEffect(() => (Gi.push(t), () => {
    const n = Gi.indexOf(t);
    n > -1 && Gi.splice(n, 1);
  }), [e]), {
    ...e,
    toast: aV,
    dismiss: (n) => Mo({ type: "DISMISS_TOAST", toastId: n })
  };
}
function PB() {
  const { toasts: e } = lV();
  return /* @__PURE__ */ L(eV, { children: [
    e.map(function({ id: t, title: n, description: r, action: o, ...i }) {
      return /* @__PURE__ */ L(J0, { ...i, children: [
        /* @__PURE__ */ L("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ f(tx, { children: n }),
          r && /* @__PURE__ */ f(nx, { children: r })
        ] }),
        o,
        /* @__PURE__ */ f(ex, {})
      ] }, t);
    }),
    /* @__PURE__ */ f(Z0, {})
  ] });
}
export {
  Py as Alert,
  Dy as AlertDescription,
  Ey as AlertTitle,
  Zw as Badge,
  oB as BulkUpdateButton,
  kk as BulkUpdater,
  KD as BulkUpdaterColumnSelectBox,
  XD as BulkUpdaterOptionBox,
  Pe as Button,
  Sd as Calendar,
  _2 as Checkbox,
  fr as ClipedValueRenderer,
  TV as ColumnSplit,
  Dd as Command,
  mB as CommandDialog,
  x0 as CommandEmpty,
  T2 as CommandGroup,
  S2 as CommandInput,
  C0 as CommandItem,
  w0 as CommandList,
  P2 as CommandSeparator,
  E2 as CommandShortcut,
  CV as ConfirmationModalProvider,
  jS as ContractExpandBar,
  lg as CustomTooltip,
  DE as DATATABLE_MARGIN,
  EE as DEFAULT_MIN_COLUMN_WIDTH,
  LV as Datatable,
  VV as DatatableBooleanInput,
  i1 as DatatableColumnFilter,
  p1 as DatatableColumnSort,
  FV as DatatableFixedHeightLoader,
  zV as DatatableHeader,
  BV as DatatableHeaderLeft,
  WV as DatatableHeaderRight,
  YV as DatatableHideColumnButton,
  OE as DatatableHideGroupButton,
  jV as DatatableInput,
  kE as DatatableKeyAction,
  $V as DatatableLabelProvider,
  GV as DatatableMoveColumnButton,
  g1 as DatatableNumberInput,
  KV as DatatableOrderColumnButton,
  v1 as DatatablePercentageInput,
  dE as DatatableRow,
  rs as DatatableSelectInput,
  h1 as DatatableSpacerRow,
  Cv as DatatableStatus,
  XV as DatatableStickyToggle,
  xf as DatatableTr,
  Nd as DatePickerContent,
  Em as DatePickerContentButton,
  Tp as Dialog,
  wV as DialogClose,
  Vc as DialogContent,
  VS as DialogDescription,
  Ep as DialogFooter,
  FS as DialogHeader,
  Pp as DialogOverlay,
  LS as DialogPortal,
  Dp as DialogTitle,
  bV as DialogTrigger,
  xy as Drawer,
  rB as DrawerClose,
  Sy as DrawerContent,
  Ek as DrawerDescription,
  Pk as DrawerFooter,
  Tk as DrawerHeader,
  Cy as DrawerOverlay,
  Sk as DrawerPortal,
  Ty as DrawerTitle,
  nB as DrawerTrigger,
  cB as ExportTableButton,
  xv as FilterPopover,
  bP as GroupColumn,
  s1 as GroupTh,
  XE as HoverInfo,
  si as Input,
  hv as Label,
  Ft as LabeledContainer,
  dB as LabeledDatePicker,
  fB as LabeledDateRangePicker,
  uu as LabeledInput,
  O2 as LabeledMonthPicker,
  xB as LabeledMonthPickerWithButtons,
  pB as LabeledMultiselect,
  gB as LabeledOptionPopoverPicker,
  Pf as LabeledSelect,
  I2 as LabeledYearPicker,
  CB as LabeledYearPickerWithButtons,
  yB as LabelledFormDateInput,
  kd as LabelledFormInput,
  bB as LabelledFormSelectInput,
  vB as LabelledFormTextInput,
  Zn as LoadingOverlay,
  PV as LockedColumnSplit,
  D2 as MultiSelector,
  E0 as MultiSelectorContent,
  P0 as MultiSelectorInput,
  k0 as MultiSelectorItem,
  D0 as MultiSelectorList,
  T0 as MultiSelectorTrigger,
  Pv as NestedCheckbox,
  y1 as NestedCheckboxItem,
  ly as NestedCheckboxes,
  fE as NoopRender,
  or as Popover,
  hr as PopoverContent,
  ro as PopoverTrigger,
  HV as ResizeableTd,
  AP as ResizeableTh,
  qw as ScrollArea,
  Qw as ScrollBar,
  Ls as Select,
  Vs as SelectContent,
  zg as SelectGroup,
  Bs as SelectItem,
  lE as SelectLabel,
  Hg as SelectScrollDownButton,
  jg as SelectScrollUpButton,
  cE as SelectSeparator,
  Fs as SelectTrigger,
  iu as SelectValue,
  R2 as SelectionLabelBox,
  Oo as Separator,
  lB as SortList,
  aB as SortableItem,
  a1 as SplitterTh,
  gV as TestBtn,
  J0 as Toast,
  nV as ToastAction,
  ex as ToastClose,
  nx as ToastDescription,
  eV as ToastProvider,
  tx as ToastTitle,
  Z0 as ToastViewport,
  PB as Toaster,
  Ms as Tooltip,
  oi as TooltipContent,
  Zc as TooltipProvider,
  As as TooltipTrigger,
  fu as TriStateCheckbox,
  UV as ValueRenderer,
  SB as YearPicker,
  ME as areAllSubgroupsCollapsed,
  RE as areGroupPathEquals,
  KL as badgeVariants,
  pV as bigNumFormat,
  bf as blockSelect,
  _V as buildFilterLoaderFromTable,
  dl as buttonVariants,
  Sv as cellsToChanges,
  q as cn,
  t1 as filterTable,
  R0 as filterUncheckedNodes,
  cl as format,
  Gs as formatText,
  ho as generateChangesFromEditingCell,
  M2 as getCheckboxesFromData,
  n1 as getLength,
  cy as getMinHeightClass,
  wB as getPartialDataFromCheckboxes,
  Ml as getRow,
  Zg as getTopLevelCollapsedGroupPathIfExists,
  YE as inputVariants,
  fo as isCellDisabledByValidation,
  yP as isCellRefEqual,
  vP as isCellRefEqualAtIndex,
  wv as isRecordDisabledByValidation,
  IV as maskLookupFromColumns,
  AV as maxFn,
  OV as minFn,
  Sr as moveSelectedCell,
  e1 as onLoadFiltersByColumn,
  MV as onSortColumn,
  sV as reducer,
  _x as roundWithPrecision,
  r1 as shouldCharEnableEditing,
  o1 as shouldIgnoreGroupBecauseRowspan,
  aV as toast,
  d1 as useAdvancedCopy,
  u1 as useCellValidations,
  xV as useConfirmationModal,
  DV as useDatableFilters,
  kV as useDatatable,
  hu as useDatatableLabels,
  WD as useDebounceCallback,
  iB as usePersistentFilters,
  f1 as usePersistentSelection,
  lV as useToast
};
